(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2f72"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2f72"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6ObR8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $4f509bf21ce2142e$export$ffb0004e005737fa; }, function (v) { return $4f509bf21ce2142e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $4f509bf21ce2142e$export$34b9dba7ce09269b; }, function (v) { return $4f509bf21ce2142e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $4f509bf21ce2142e$export$25062201e9e25d76; }, function (v) { return $4f509bf21ce2142e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4f509bf21ce2142e$export$ffb0004e005737fa;
var $4f509bf21ce2142e$export$34b9dba7ce09269b;
var $4f509bf21ce2142e$export$25062201e9e25d76;
"use strict";

var $exYeM = parcelRequire("exYeM");
var $4f509bf21ce2142e$var$k = Symbol.for("react.element"), $4f509bf21ce2142e$var$l = Symbol.for("react.fragment"), $4f509bf21ce2142e$var$m = Object.prototype.hasOwnProperty, $4f509bf21ce2142e$var$n = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $4f509bf21ce2142e$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4f509bf21ce2142e$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$4f509bf21ce2142e$var$m.call(a, b) && !$4f509bf21ce2142e$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $4f509bf21ce2142e$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $4f509bf21ce2142e$var$n.current
    };
}
$4f509bf21ce2142e$export$ffb0004e005737fa = $4f509bf21ce2142e$var$l;
$4f509bf21ce2142e$export$34b9dba7ce09269b = $4f509bf21ce2142e$var$q;
$4f509bf21ce2142e$export$25062201e9e25d76 = $4f509bf21ce2142e$var$q;

});
parcelRegister("exYeM", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bzfnW"));

});
parcelRegister("bzfnW", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $86bee5c140ae1e47$export$dca3b0875bd9a954; }, function (v) { return $86bee5c140ae1e47$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $86bee5c140ae1e47$export$16fa2f45be04daa8; }, function (v) { return $86bee5c140ae1e47$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $86bee5c140ae1e47$export$ffb0004e005737fa; }, function (v) { return $86bee5c140ae1e47$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $86bee5c140ae1e47$export$e2c29f18771995cb; }, function (v) { return $86bee5c140ae1e47$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $86bee5c140ae1e47$export$221d75b3f55bb0bd; }, function (v) { return $86bee5c140ae1e47$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $86bee5c140ae1e47$export$5f8d39834fd61797; }, function (v) { return $86bee5c140ae1e47$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $86bee5c140ae1e47$export$74bf444e3cd11ea5; }, function (v) { return $86bee5c140ae1e47$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $86bee5c140ae1e47$export$ae55be85d98224ed; }, function (v) { return $86bee5c140ae1e47$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $86bee5c140ae1e47$export$e530037191fcd5d7; }, function (v) { return $86bee5c140ae1e47$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $86bee5c140ae1e47$export$fd42f52fd3ae1109; }, function (v) { return $86bee5c140ae1e47$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $86bee5c140ae1e47$export$c8a8987d4410bf2d; }, function (v) { return $86bee5c140ae1e47$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $86bee5c140ae1e47$export$d38cd72104c1f0e9; }, function (v) { return $86bee5c140ae1e47$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43; }, function (v) { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $86bee5c140ae1e47$export$257a8862b851cb5b; }, function (v) { return $86bee5c140ae1e47$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $86bee5c140ae1e47$export$a8257692ac88316c; }, function (v) { return $86bee5c140ae1e47$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $86bee5c140ae1e47$export$488013bae63b21da; }, function (v) { return $86bee5c140ae1e47$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $86bee5c140ae1e47$export$7c73462e0d25e514; }, function (v) { return $86bee5c140ae1e47$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $86bee5c140ae1e47$export$7568632d0d33d16d; }, function (v) { return $86bee5c140ae1e47$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $86bee5c140ae1e47$export$88948ce120ea2619; }, function (v) { return $86bee5c140ae1e47$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $86bee5c140ae1e47$export$35808ee640e87ca7; }, function (v) { return $86bee5c140ae1e47$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $86bee5c140ae1e47$export$fae74005e78b1a27; }, function (v) { return $86bee5c140ae1e47$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e; }, function (v) { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf; }, function (v) { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $86bee5c140ae1e47$export$6d9c69b0de29b591; }, function (v) { return $86bee5c140ae1e47$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $86bee5c140ae1e47$export$f680877a34711e37; }, function (v) { return $86bee5c140ae1e47$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $86bee5c140ae1e47$export$d5a552a76deda3c2; }, function (v) { return $86bee5c140ae1e47$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $86bee5c140ae1e47$export$aaabe4eda9ed9969; }, function (v) { return $86bee5c140ae1e47$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $86bee5c140ae1e47$export$e5c5a5f917a5871c; }, function (v) { return $86bee5c140ae1e47$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $86bee5c140ae1e47$export$1538c33de8887b59; }, function (v) { return $86bee5c140ae1e47$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $86bee5c140ae1e47$export$13e3392192263954; }, function (v) { return $86bee5c140ae1e47$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $86bee5c140ae1e47$export$b8f5890fc79d6aca; }, function (v) { return $86bee5c140ae1e47$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $86bee5c140ae1e47$export$60241385465d0a34; }, function (v) { return $86bee5c140ae1e47$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $86bee5c140ae1e47$export$306c0aa65ff9ec16; }, function (v) { return $86bee5c140ae1e47$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $86bee5c140ae1e47$export$7b286972b8d8ccbf; }, function (v) { return $86bee5c140ae1e47$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $86bee5c140ae1e47$export$83d89fbfd8236492; }, function (v) { return $86bee5c140ae1e47$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $86bee5c140ae1e47$export$dca3b0875bd9a954;
var $86bee5c140ae1e47$export$16fa2f45be04daa8;
var $86bee5c140ae1e47$export$ffb0004e005737fa;
var $86bee5c140ae1e47$export$e2c29f18771995cb;
var $86bee5c140ae1e47$export$221d75b3f55bb0bd;
var $86bee5c140ae1e47$export$5f8d39834fd61797;
var $86bee5c140ae1e47$export$74bf444e3cd11ea5;
var $86bee5c140ae1e47$export$ae55be85d98224ed;
var $86bee5c140ae1e47$export$e530037191fcd5d7;
var $86bee5c140ae1e47$export$fd42f52fd3ae1109;
var $86bee5c140ae1e47$export$c8a8987d4410bf2d;
var $86bee5c140ae1e47$export$d38cd72104c1f0e9;
var $86bee5c140ae1e47$export$7d1e3a5e95ceca43;
var $86bee5c140ae1e47$export$257a8862b851cb5b;
var $86bee5c140ae1e47$export$a8257692ac88316c;
var $86bee5c140ae1e47$export$488013bae63b21da;
var $86bee5c140ae1e47$export$7c73462e0d25e514;
var $86bee5c140ae1e47$export$7568632d0d33d16d;
var $86bee5c140ae1e47$export$88948ce120ea2619;
var $86bee5c140ae1e47$export$35808ee640e87ca7;
var $86bee5c140ae1e47$export$fae74005e78b1a27;
var $86bee5c140ae1e47$export$dc8fbce3eb94dc1e;
var $86bee5c140ae1e47$export$6a7bc4e911dc01cf;
var $86bee5c140ae1e47$export$6d9c69b0de29b591;
var $86bee5c140ae1e47$export$f680877a34711e37;
var $86bee5c140ae1e47$export$d5a552a76deda3c2;
var $86bee5c140ae1e47$export$aaabe4eda9ed9969;
var $86bee5c140ae1e47$export$e5c5a5f917a5871c;
var $86bee5c140ae1e47$export$1538c33de8887b59;
var $86bee5c140ae1e47$export$13e3392192263954;
var $86bee5c140ae1e47$export$b8f5890fc79d6aca;
var $86bee5c140ae1e47$export$60241385465d0a34;
var $86bee5c140ae1e47$export$306c0aa65ff9ec16;
var $86bee5c140ae1e47$export$7b286972b8d8ccbf;
var $86bee5c140ae1e47$export$83d89fbfd8236492;
"use strict";
var $86bee5c140ae1e47$var$l = Symbol.for("react.element"), $86bee5c140ae1e47$var$n = Symbol.for("react.portal"), $86bee5c140ae1e47$var$p = Symbol.for("react.fragment"), $86bee5c140ae1e47$var$q = Symbol.for("react.strict_mode"), $86bee5c140ae1e47$var$r = Symbol.for("react.profiler"), $86bee5c140ae1e47$var$t = Symbol.for("react.provider"), $86bee5c140ae1e47$var$u = Symbol.for("react.context"), $86bee5c140ae1e47$var$v = Symbol.for("react.forward_ref"), $86bee5c140ae1e47$var$w = Symbol.for("react.suspense"), $86bee5c140ae1e47$var$x = Symbol.for("react.memo"), $86bee5c140ae1e47$var$y = Symbol.for("react.lazy"), $86bee5c140ae1e47$var$z = Symbol.iterator;
function $86bee5c140ae1e47$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $86bee5c140ae1e47$var$z && a[$86bee5c140ae1e47$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $86bee5c140ae1e47$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $86bee5c140ae1e47$var$C = Object.assign, $86bee5c140ae1e47$var$D = {};
function $86bee5c140ae1e47$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
$86bee5c140ae1e47$var$E.prototype.isReactComponent = {};
$86bee5c140ae1e47$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$86bee5c140ae1e47$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $86bee5c140ae1e47$var$F() {}
$86bee5c140ae1e47$var$F.prototype = $86bee5c140ae1e47$var$E.prototype;
function $86bee5c140ae1e47$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
var $86bee5c140ae1e47$var$H = $86bee5c140ae1e47$var$G.prototype = new $86bee5c140ae1e47$var$F;
$86bee5c140ae1e47$var$H.constructor = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$var$C($86bee5c140ae1e47$var$H, $86bee5c140ae1e47$var$E.prototype);
$86bee5c140ae1e47$var$H.isPureReactComponent = !0;
var $86bee5c140ae1e47$var$I = Array.isArray, $86bee5c140ae1e47$var$J = Object.prototype.hasOwnProperty, $86bee5c140ae1e47$var$K = {
    current: null
}, $86bee5c140ae1e47$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $86bee5c140ae1e47$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$86bee5c140ae1e47$var$J.call(b, d) && !$86bee5c140ae1e47$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $86bee5c140ae1e47$var$K.current
    };
}
function $86bee5c140ae1e47$var$N(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $86bee5c140ae1e47$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $86bee5c140ae1e47$var$l;
}
function $86bee5c140ae1e47$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $86bee5c140ae1e47$var$P = /\/+/g;
function $86bee5c140ae1e47$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $86bee5c140ae1e47$var$escape("" + a.key) : b.toString(36);
}
function $86bee5c140ae1e47$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $86bee5c140ae1e47$var$l:
                case $86bee5c140ae1e47$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $86bee5c140ae1e47$var$Q(h, 0) : d, $86bee5c140ae1e47$var$I(c) ? (e = "", null != a && (e = a.replace($86bee5c140ae1e47$var$P, "$&/") + "/"), $86bee5c140ae1e47$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($86bee5c140ae1e47$var$O(c) && (c = $86bee5c140ae1e47$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($86bee5c140ae1e47$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($86bee5c140ae1e47$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $86bee5c140ae1e47$var$Q(k, g);
        h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    }
    else if (f = $86bee5c140ae1e47$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $86bee5c140ae1e47$var$Q(k, g++), h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $86bee5c140ae1e47$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $86bee5c140ae1e47$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $86bee5c140ae1e47$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $86bee5c140ae1e47$var$U = {
    current: null
}, $86bee5c140ae1e47$var$V = {
    transition: null
}, $86bee5c140ae1e47$var$W = {
    ReactCurrentDispatcher: $86bee5c140ae1e47$var$U,
    ReactCurrentBatchConfig: $86bee5c140ae1e47$var$V,
    ReactCurrentOwner: $86bee5c140ae1e47$var$K
};
$86bee5c140ae1e47$export$dca3b0875bd9a954 = {
    map: $86bee5c140ae1e47$var$S,
    forEach: function(a, b, e) {
        $86bee5c140ae1e47$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $86bee5c140ae1e47$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $86bee5c140ae1e47$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$86bee5c140ae1e47$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$86bee5c140ae1e47$export$16fa2f45be04daa8 = $86bee5c140ae1e47$var$E;
$86bee5c140ae1e47$export$ffb0004e005737fa = $86bee5c140ae1e47$var$p;
$86bee5c140ae1e47$export$e2c29f18771995cb = $86bee5c140ae1e47$var$r;
$86bee5c140ae1e47$export$221d75b3f55bb0bd = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$export$5f8d39834fd61797 = $86bee5c140ae1e47$var$q;
$86bee5c140ae1e47$export$74bf444e3cd11ea5 = $86bee5c140ae1e47$var$w;
$86bee5c140ae1e47$export$ae55be85d98224ed = $86bee5c140ae1e47$var$W;
$86bee5c140ae1e47$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $86bee5c140ae1e47$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $86bee5c140ae1e47$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$86bee5c140ae1e47$var$J.call(b, f) && !$86bee5c140ae1e47$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$86bee5c140ae1e47$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $86bee5c140ae1e47$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $86bee5c140ae1e47$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$86bee5c140ae1e47$export$c8a8987d4410bf2d = $86bee5c140ae1e47$var$M;
$86bee5c140ae1e47$export$d38cd72104c1f0e9 = function(a) {
    var b = $86bee5c140ae1e47$var$M.bind(null, a);
    b.type = a;
    return b;
};
$86bee5c140ae1e47$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$86bee5c140ae1e47$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$v,
        render: a
    };
};
$86bee5c140ae1e47$export$a8257692ac88316c = $86bee5c140ae1e47$var$O;
$86bee5c140ae1e47$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $86bee5c140ae1e47$var$T
    };
};
$86bee5c140ae1e47$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$86bee5c140ae1e47$export$7568632d0d33d16d = function(a) {
    var b = $86bee5c140ae1e47$var$V.transition;
    $86bee5c140ae1e47$var$V.transition = {};
    try {
        a();
    } finally{
        $86bee5c140ae1e47$var$V.transition = b;
    }
};
$86bee5c140ae1e47$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$86bee5c140ae1e47$export$35808ee640e87ca7 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useCallback(a, b);
};
$86bee5c140ae1e47$export$fae74005e78b1a27 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useContext(a);
};
$86bee5c140ae1e47$export$dc8fbce3eb94dc1e = function() {};
$86bee5c140ae1e47$export$6a7bc4e911dc01cf = function(a) {
    return $86bee5c140ae1e47$var$U.current.useDeferredValue(a);
};
$86bee5c140ae1e47$export$6d9c69b0de29b591 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useEffect(a, b);
};
$86bee5c140ae1e47$export$f680877a34711e37 = function() {
    return $86bee5c140ae1e47$var$U.current.useId();
};
$86bee5c140ae1e47$export$d5a552a76deda3c2 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useImperativeHandle(a, b, e);
};
$86bee5c140ae1e47$export$aaabe4eda9ed9969 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useInsertionEffect(a, b);
};
$86bee5c140ae1e47$export$e5c5a5f917a5871c = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useLayoutEffect(a, b);
};
$86bee5c140ae1e47$export$1538c33de8887b59 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useMemo(a, b);
};
$86bee5c140ae1e47$export$13e3392192263954 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useReducer(a, b, e);
};
$86bee5c140ae1e47$export$b8f5890fc79d6aca = function(a) {
    return $86bee5c140ae1e47$var$U.current.useRef(a);
};
$86bee5c140ae1e47$export$60241385465d0a34 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useState(a);
};
$86bee5c140ae1e47$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useSyncExternalStore(a, b, e);
};
$86bee5c140ae1e47$export$7b286972b8d8ccbf = function() {
    return $86bee5c140ae1e47$var$U.current.useTransition();
};
$86bee5c140ae1e47$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("h8vP0", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c79bde28d689cb05$export$ae55be85d98224ed; }, function (v) { return $c79bde28d689cb05$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $c79bde28d689cb05$export$d39a5bbd09211389; }, function (v) { return $c79bde28d689cb05$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $c79bde28d689cb05$export$882461b6382ed46c; }, function (v) { return $c79bde28d689cb05$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $c79bde28d689cb05$export$466bfc07425424d5; }, function (v) { return $c79bde28d689cb05$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c79bde28d689cb05$export$cd75ccfd720a3cd4; }, function (v) { return $c79bde28d689cb05$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $c79bde28d689cb05$export$fa8d919ba61d84db; }, function (v) { return $c79bde28d689cb05$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c79bde28d689cb05$export$757ceba2d55c277e; }, function (v) { return $c79bde28d689cb05$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $c79bde28d689cb05$export$b3890eb0ae9dca99; }, function (v) { return $c79bde28d689cb05$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $c79bde28d689cb05$export$502457920280e6be; }, function (v) { return $c79bde28d689cb05$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c79bde28d689cb05$export$c78a37762a8d58e1; }, function (v) { return $c79bde28d689cb05$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $c79bde28d689cb05$export$dc54d992c10e8a18; }, function (v) { return $c79bde28d689cb05$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $c79bde28d689cb05$export$83d89fbfd8236492; }, function (v) { return $c79bde28d689cb05$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c79bde28d689cb05$export$ae55be85d98224ed;
var $c79bde28d689cb05$export$d39a5bbd09211389;
var $c79bde28d689cb05$export$882461b6382ed46c;
var $c79bde28d689cb05$export$466bfc07425424d5;
var $c79bde28d689cb05$export$cd75ccfd720a3cd4;
var $c79bde28d689cb05$export$fa8d919ba61d84db;
var $c79bde28d689cb05$export$757ceba2d55c277e;
var $c79bde28d689cb05$export$b3890eb0ae9dca99;
var $c79bde28d689cb05$export$502457920280e6be;
var $c79bde28d689cb05$export$c78a37762a8d58e1;
var $c79bde28d689cb05$export$dc54d992c10e8a18;
var $c79bde28d689cb05$export$83d89fbfd8236492;
"use strict";

var $exYeM = parcelRequire("exYeM");

var $ibqfJ = parcelRequire("ibqfJ");
function $c79bde28d689cb05$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c79bde28d689cb05$var$da = new Set, $c79bde28d689cb05$var$ea = {};
function $c79bde28d689cb05$var$fa(a, b) {
    $c79bde28d689cb05$var$ha(a, b);
    $c79bde28d689cb05$var$ha(a + "Capture", b);
}
function $c79bde28d689cb05$var$ha(a, b) {
    $c79bde28d689cb05$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$da.add(b[a]);
}
var $c79bde28d689cb05$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c79bde28d689cb05$var$ja = Object.prototype.hasOwnProperty, $c79bde28d689cb05$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c79bde28d689cb05$var$la = {}, $c79bde28d689cb05$var$ma = {};
function $c79bde28d689cb05$var$oa(a) {
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$ma, a)) return !0;
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$la, a)) return !1;
    if ($c79bde28d689cb05$var$ka.test(a)) return $c79bde28d689cb05$var$ma[a] = !0;
    $c79bde28d689cb05$var$la[a] = !0;
    return !1;
}
function $c79bde28d689cb05$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c79bde28d689cb05$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c79bde28d689cb05$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c79bde28d689cb05$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c79bde28d689cb05$var$ra = /[\-:]([a-z])/g;
function $c79bde28d689cb05$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c79bde28d689cb05$var$z.xlinkHref = new $c79bde28d689cb05$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c79bde28d689cb05$var$ta(a, b, c, d) {
    var e = $c79bde28d689cb05$var$z.hasOwnProperty(b) ? $c79bde28d689cb05$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c79bde28d689cb05$var$qa(b, c, e, d) && (c = null), d || null === e ? $c79bde28d689cb05$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c79bde28d689cb05$var$ua = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c79bde28d689cb05$var$va = Symbol.for("react.element"), $c79bde28d689cb05$var$wa = Symbol.for("react.portal"), $c79bde28d689cb05$var$ya = Symbol.for("react.fragment"), $c79bde28d689cb05$var$za = Symbol.for("react.strict_mode"), $c79bde28d689cb05$var$Aa = Symbol.for("react.profiler"), $c79bde28d689cb05$var$Ba = Symbol.for("react.provider"), $c79bde28d689cb05$var$Ca = Symbol.for("react.context"), $c79bde28d689cb05$var$Da = Symbol.for("react.forward_ref"), $c79bde28d689cb05$var$Ea = Symbol.for("react.suspense"), $c79bde28d689cb05$var$Fa = Symbol.for("react.suspense_list"), $c79bde28d689cb05$var$Ga = Symbol.for("react.memo"), $c79bde28d689cb05$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c79bde28d689cb05$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c79bde28d689cb05$var$Ja = Symbol.iterator;
function $c79bde28d689cb05$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c79bde28d689cb05$var$Ja && a[$c79bde28d689cb05$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c79bde28d689cb05$var$A = Object.assign, $c79bde28d689cb05$var$La;
function $c79bde28d689cb05$var$Ma(a) {
    if (void 0 === $c79bde28d689cb05$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c79bde28d689cb05$var$La = b && b[1] || "";
    }
    return "\n" + $c79bde28d689cb05$var$La + a;
}
var $c79bde28d689cb05$var$Na = !1;
function $c79bde28d689cb05$var$Oa(a, b) {
    if (!a || $c79bde28d689cb05$var$Na) return "";
    $c79bde28d689cb05$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c79bde28d689cb05$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c79bde28d689cb05$var$Ma(a) : "";
}
function $c79bde28d689cb05$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c79bde28d689cb05$var$Ma(a.type);
        case 16:
            return $c79bde28d689cb05$var$Ma("Lazy");
        case 13:
            return $c79bde28d689cb05$var$Ma("Suspense");
        case 19:
            return $c79bde28d689cb05$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c79bde28d689cb05$var$Oa(a.type, !1), a;
        case 11:
            return a = $c79bde28d689cb05$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c79bde28d689cb05$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c79bde28d689cb05$var$ya:
            return "Fragment";
        case $c79bde28d689cb05$var$wa:
            return "Portal";
        case $c79bde28d689cb05$var$Aa:
            return "Profiler";
        case $c79bde28d689cb05$var$za:
            return "StrictMode";
        case $c79bde28d689cb05$var$Ea:
            return "Suspense";
        case $c79bde28d689cb05$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c79bde28d689cb05$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c79bde28d689cb05$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c79bde28d689cb05$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c79bde28d689cb05$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c79bde28d689cb05$var$Qa(a.type) || "Memo";
        case $c79bde28d689cb05$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c79bde28d689cb05$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c79bde28d689cb05$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c79bde28d689cb05$var$Qa(b);
        case 8:
            return b === $c79bde28d689cb05$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c79bde28d689cb05$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c79bde28d689cb05$var$Ua(a) {
    var b = $c79bde28d689cb05$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c79bde28d689cb05$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c79bde28d689cb05$var$Ua(a));
}
function $c79bde28d689cb05$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c79bde28d689cb05$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c79bde28d689cb05$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c79bde28d689cb05$var$Ya(a, b) {
    var c = b.checked;
    return $c79bde28d689cb05$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c79bde28d689cb05$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c79bde28d689cb05$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c79bde28d689cb05$var$ab(a, b) {
    b = b.checked;
    null != b && $c79bde28d689cb05$var$ta(a, "checked", b, !1);
}
function $c79bde28d689cb05$var$bb(a, b) {
    $c79bde28d689cb05$var$ab(a, b);
    var c = $c79bde28d689cb05$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c79bde28d689cb05$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c79bde28d689cb05$var$cb(a, b.type, $c79bde28d689cb05$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c79bde28d689cb05$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c79bde28d689cb05$var$cb(a, b, c) {
    if ("number" !== b || $c79bde28d689cb05$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c79bde28d689cb05$var$eb = Array.isArray;
function $c79bde28d689cb05$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c79bde28d689cb05$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c79bde28d689cb05$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c79bde28d689cb05$var$p(91));
    return $c79bde28d689cb05$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c79bde28d689cb05$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c79bde28d689cb05$var$p(92));
            if ($c79bde28d689cb05$var$eb(c)) {
                if (1 < c.length) throw Error($c79bde28d689cb05$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c79bde28d689cb05$var$Sa(c)
    };
}
function $c79bde28d689cb05$var$ib(a, b) {
    var c = $c79bde28d689cb05$var$Sa(b.value), d = $c79bde28d689cb05$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c79bde28d689cb05$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c79bde28d689cb05$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c79bde28d689cb05$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c79bde28d689cb05$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c79bde28d689cb05$var$mb, $c79bde28d689cb05$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c79bde28d689cb05$var$mb = $c79bde28d689cb05$var$mb || document.createElement("div");
        $c79bde28d689cb05$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c79bde28d689cb05$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c79bde28d689cb05$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c79bde28d689cb05$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c79bde28d689cb05$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c79bde28d689cb05$var$pb).forEach(function(a) {
    $c79bde28d689cb05$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c79bde28d689cb05$var$pb[b] = $c79bde28d689cb05$var$pb[a];
    });
});
function $c79bde28d689cb05$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c79bde28d689cb05$var$pb.hasOwnProperty(a) && $c79bde28d689cb05$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c79bde28d689cb05$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c79bde28d689cb05$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c79bde28d689cb05$var$tb = $c79bde28d689cb05$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c79bde28d689cb05$var$ub(a, b) {
    if (b) {
        if ($c79bde28d689cb05$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c79bde28d689cb05$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c79bde28d689cb05$var$p(62));
    }
}
function $c79bde28d689cb05$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c79bde28d689cb05$var$wb = null;
function $c79bde28d689cb05$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c79bde28d689cb05$var$yb = null, $c79bde28d689cb05$var$zb = null, $c79bde28d689cb05$var$Ab = null;
function $c79bde28d689cb05$var$Bb(a) {
    if (a = $c79bde28d689cb05$var$Cb(a)) {
        if ("function" !== typeof $c79bde28d689cb05$var$yb) throw Error($c79bde28d689cb05$var$p(280));
        var b = a.stateNode;
        b && (b = $c79bde28d689cb05$var$Db(b), $c79bde28d689cb05$var$yb(a.stateNode, a.type, b));
    }
}
function $c79bde28d689cb05$var$Eb(a) {
    $c79bde28d689cb05$var$zb ? $c79bde28d689cb05$var$Ab ? $c79bde28d689cb05$var$Ab.push(a) : $c79bde28d689cb05$var$Ab = [
        a
    ] : $c79bde28d689cb05$var$zb = a;
}
function $c79bde28d689cb05$var$Fb() {
    if ($c79bde28d689cb05$var$zb) {
        var a = $c79bde28d689cb05$var$zb, b = $c79bde28d689cb05$var$Ab;
        $c79bde28d689cb05$var$Ab = $c79bde28d689cb05$var$zb = null;
        $c79bde28d689cb05$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$Bb(b[a]);
    }
}
function $c79bde28d689cb05$var$Gb(a, b) {
    return a(b);
}
function $c79bde28d689cb05$var$Hb() {}
var $c79bde28d689cb05$var$Ib = !1;
function $c79bde28d689cb05$var$Jb(a, b, c) {
    if ($c79bde28d689cb05$var$Ib) return a(b, c);
    $c79bde28d689cb05$var$Ib = !0;
    try {
        return $c79bde28d689cb05$var$Gb(a, b, c);
    } finally{
        if ($c79bde28d689cb05$var$Ib = !1, null !== $c79bde28d689cb05$var$zb || null !== $c79bde28d689cb05$var$Ab) $c79bde28d689cb05$var$Hb(), $c79bde28d689cb05$var$Fb();
    }
}
function $c79bde28d689cb05$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c79bde28d689cb05$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c79bde28d689cb05$var$p(231, b, typeof c));
    return c;
}
var $c79bde28d689cb05$var$Lb = !1;
if ($c79bde28d689cb05$var$ia) try {
    var $c79bde28d689cb05$var$Mb = {};
    Object.defineProperty($c79bde28d689cb05$var$Mb, "passive", {
        get: function() {
            $c79bde28d689cb05$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
    window.removeEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
} catch (a) {
    $c79bde28d689cb05$var$Lb = !1;
}
function $c79bde28d689cb05$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c79bde28d689cb05$var$Ob = !1, $c79bde28d689cb05$var$Pb = null, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, $c79bde28d689cb05$var$Sb = {
    onError: function(a) {
        $c79bde28d689cb05$var$Ob = !0;
        $c79bde28d689cb05$var$Pb = a;
    }
};
function $c79bde28d689cb05$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Ob = !1;
    $c79bde28d689cb05$var$Pb = null;
    $c79bde28d689cb05$var$Nb.apply($c79bde28d689cb05$var$Sb, arguments);
}
function $c79bde28d689cb05$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Tb.apply(this, arguments);
    if ($c79bde28d689cb05$var$Ob) {
        if ($c79bde28d689cb05$var$Ob) {
            var l = $c79bde28d689cb05$var$Pb;
            $c79bde28d689cb05$var$Ob = !1;
            $c79bde28d689cb05$var$Pb = null;
        } else throw Error($c79bde28d689cb05$var$p(198));
        $c79bde28d689cb05$var$Qb || ($c79bde28d689cb05$var$Qb = !0, $c79bde28d689cb05$var$Rb = l);
    }
}
function $c79bde28d689cb05$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c79bde28d689cb05$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c79bde28d689cb05$var$Xb(a) {
    if ($c79bde28d689cb05$var$Vb(a) !== a) throw Error($c79bde28d689cb05$var$p(188));
}
function $c79bde28d689cb05$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c79bde28d689cb05$var$Vb(a);
        if (null === b) throw Error($c79bde28d689cb05$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c79bde28d689cb05$var$Xb(e), a;
                if (f === d) return $c79bde28d689cb05$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c79bde28d689cb05$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c79bde28d689cb05$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c79bde28d689cb05$var$p(190));
    }
    if (3 !== c.tag) throw Error($c79bde28d689cb05$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c79bde28d689cb05$var$Zb(a) {
    a = $c79bde28d689cb05$var$Yb(a);
    return null !== a ? $c79bde28d689cb05$var$$b(a) : null;
}
function $c79bde28d689cb05$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c79bde28d689cb05$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$ac = $ibqfJ.unstable_scheduleCallback, $c79bde28d689cb05$var$bc = $ibqfJ.unstable_cancelCallback, $c79bde28d689cb05$var$cc = $ibqfJ.unstable_shouldYield, $c79bde28d689cb05$var$dc = $ibqfJ.unstable_requestPaint, $c79bde28d689cb05$var$B = $ibqfJ.unstable_now, $c79bde28d689cb05$var$ec = $ibqfJ.unstable_getCurrentPriorityLevel, $c79bde28d689cb05$var$fc = $ibqfJ.unstable_ImmediatePriority, $c79bde28d689cb05$var$gc = $ibqfJ.unstable_UserBlockingPriority, $c79bde28d689cb05$var$hc = $ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$ic = $ibqfJ.unstable_LowPriority, $c79bde28d689cb05$var$jc = $ibqfJ.unstable_IdlePriority, $c79bde28d689cb05$var$kc = null, $c79bde28d689cb05$var$lc = null;
function $c79bde28d689cb05$var$mc(a) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberRoot) try {
        $c79bde28d689cb05$var$lc.onCommitFiberRoot($c79bde28d689cb05$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c79bde28d689cb05$var$oc = Math.clz32 ? Math.clz32 : $c79bde28d689cb05$var$nc, $c79bde28d689cb05$var$pc = Math.log, $c79bde28d689cb05$var$qc = Math.LN2;
function $c79bde28d689cb05$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c79bde28d689cb05$var$pc(a) / $c79bde28d689cb05$var$qc | 0) | 0;
}
var $c79bde28d689cb05$var$rc = 64, $c79bde28d689cb05$var$sc = 4194304;
function $c79bde28d689cb05$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c79bde28d689cb05$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c79bde28d689cb05$var$tc(h) : (f &= g, 0 !== f && (d = $c79bde28d689cb05$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c79bde28d689cb05$var$tc(g) : 0 !== f && (d = $c79bde28d689cb05$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c79bde28d689cb05$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c79bde28d689cb05$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c79bde28d689cb05$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c79bde28d689cb05$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c79bde28d689cb05$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c79bde28d689cb05$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c79bde28d689cb05$var$yc() {
    var a = $c79bde28d689cb05$var$rc;
    $c79bde28d689cb05$var$rc <<= 1;
    0 === ($c79bde28d689cb05$var$rc & 4194240) && ($c79bde28d689cb05$var$rc = 64);
    return a;
}
function $c79bde28d689cb05$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c79bde28d689cb05$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c79bde28d689cb05$var$oc(b);
    a[b] = c;
}
function $c79bde28d689cb05$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c79bde28d689cb05$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c79bde28d689cb05$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c79bde28d689cb05$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c79bde28d689cb05$var$C = 0;
function $c79bde28d689cb05$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c79bde28d689cb05$var$Ec, $c79bde28d689cb05$var$Fc, $c79bde28d689cb05$var$Gc, $c79bde28d689cb05$var$Hc, $c79bde28d689cb05$var$Ic, $c79bde28d689cb05$var$Jc = !1, $c79bde28d689cb05$var$Kc = [], $c79bde28d689cb05$var$Lc = null, $c79bde28d689cb05$var$Mc = null, $c79bde28d689cb05$var$Nc = null, $c79bde28d689cb05$var$Oc = new Map, $c79bde28d689cb05$var$Pc = new Map, $c79bde28d689cb05$var$Qc = [], $c79bde28d689cb05$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c79bde28d689cb05$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c79bde28d689cb05$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c79bde28d689cb05$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c79bde28d689cb05$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c79bde28d689cb05$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c79bde28d689cb05$var$Pc.delete(b.pointerId);
    }
}
function $c79bde28d689cb05$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c79bde28d689cb05$var$Cb(b), null !== b && $c79bde28d689cb05$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c79bde28d689cb05$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c79bde28d689cb05$var$Lc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c79bde28d689cb05$var$Mc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c79bde28d689cb05$var$Nc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c79bde28d689cb05$var$Oc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c79bde28d689cb05$var$Pc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c79bde28d689cb05$var$Vc(a) {
    var b = $c79bde28d689cb05$var$Wc(a.target);
    if (null !== b) {
        var c = $c79bde28d689cb05$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c79bde28d689cb05$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c79bde28d689cb05$var$Ic(a.priority, function() {
                        $c79bde28d689cb05$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c79bde28d689cb05$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c79bde28d689cb05$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c79bde28d689cb05$var$wb = d;
            c.target.dispatchEvent(d);
            $c79bde28d689cb05$var$wb = null;
        } else return b = $c79bde28d689cb05$var$Cb(c), null !== b && $c79bde28d689cb05$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c79bde28d689cb05$var$Zc(a, b, c) {
    $c79bde28d689cb05$var$Xc(a) && c.delete(b);
}
function $c79bde28d689cb05$var$$c() {
    $c79bde28d689cb05$var$Jc = !1;
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Lc) && ($c79bde28d689cb05$var$Lc = null);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Mc) && ($c79bde28d689cb05$var$Mc = null);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Nc) && ($c79bde28d689cb05$var$Nc = null);
    $c79bde28d689cb05$var$Oc.forEach($c79bde28d689cb05$var$Zc);
    $c79bde28d689cb05$var$Pc.forEach($c79bde28d689cb05$var$Zc);
}
function $c79bde28d689cb05$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c79bde28d689cb05$var$Jc || ($c79bde28d689cb05$var$Jc = !0, $ibqfJ.unstable_scheduleCallback($ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$$c)));
}
function $c79bde28d689cb05$var$bd(a) {
    function b(b) {
        return $c79bde28d689cb05$var$ad(b, a);
    }
    if (0 < $c79bde28d689cb05$var$Kc.length) {
        $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Kc[0], a);
        for(var c = 1; c < $c79bde28d689cb05$var$Kc.length; c++){
            var d = $c79bde28d689cb05$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Lc, a);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Mc, a);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Nc, a);
    $c79bde28d689cb05$var$Oc.forEach(b);
    $c79bde28d689cb05$var$Pc.forEach(b);
    for(c = 0; c < $c79bde28d689cb05$var$Qc.length; c++)d = $c79bde28d689cb05$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c79bde28d689cb05$var$Qc.length && (c = $c79bde28d689cb05$var$Qc[0], null === c.blockedOn);)$c79bde28d689cb05$var$Vc(c), null === c.blockedOn && $c79bde28d689cb05$var$Qc.shift();
}
var $c79bde28d689cb05$var$cd = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$dd = !0;
function $c79bde28d689cb05$var$ed(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$gd(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 4, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$fd(a, b, c, d) {
    if ($c79bde28d689cb05$var$dd) {
        var e = $c79bde28d689cb05$var$Yc(a, b, c, d);
        if (null === e) $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c), $c79bde28d689cb05$var$Sc(a, d);
        else if ($c79bde28d689cb05$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c79bde28d689cb05$var$Sc(a, d), b & 4 && -1 < $c79bde28d689cb05$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c79bde28d689cb05$var$Cb(e);
                null !== f && $c79bde28d689cb05$var$Ec(f);
                f = $c79bde28d689cb05$var$Yc(a, b, c, d);
                null === f && $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c79bde28d689cb05$var$hd(a, b, d, null, c);
    }
}
var $c79bde28d689cb05$var$id = null;
function $c79bde28d689cb05$var$Yc(a, b, c, d) {
    $c79bde28d689cb05$var$id = null;
    a = $c79bde28d689cb05$var$xb(d);
    a = $c79bde28d689cb05$var$Wc(a);
    if (null !== a) {
        if (b = $c79bde28d689cb05$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c79bde28d689cb05$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c79bde28d689cb05$var$id = a;
    return null;
}
function $c79bde28d689cb05$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c79bde28d689cb05$var$ec()){
                case $c79bde28d689cb05$var$fc:
                    return 1;
                case $c79bde28d689cb05$var$gc:
                    return 4;
                case $c79bde28d689cb05$var$hc:
                case $c79bde28d689cb05$var$ic:
                    return 16;
                case $c79bde28d689cb05$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ld = null, $c79bde28d689cb05$var$md = null;
function $c79bde28d689cb05$var$nd() {
    if ($c79bde28d689cb05$var$md) return $c79bde28d689cb05$var$md;
    var a, b = $c79bde28d689cb05$var$ld, c = b.length, d, e = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c79bde28d689cb05$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c79bde28d689cb05$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c79bde28d689cb05$var$pd() {
    return !0;
}
function $c79bde28d689cb05$var$qd() {
    return !1;
}
function $c79bde28d689cb05$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c79bde28d689cb05$var$pd : $c79bde28d689cb05$var$qd;
        this.isPropagationStopped = $c79bde28d689cb05$var$qd;
        return this;
    }
    $c79bde28d689cb05$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c79bde28d689cb05$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c79bde28d689cb05$var$pd);
        },
        persist: function() {},
        isPersistent: $c79bde28d689cb05$var$pd
    });
    return b;
}
var $c79bde28d689cb05$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c79bde28d689cb05$var$td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$sd), $c79bde28d689cb05$var$ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    view: 0,
    detail: 0
}), $c79bde28d689cb05$var$vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$ud), $c79bde28d689cb05$var$wd, $c79bde28d689cb05$var$xd, $c79bde28d689cb05$var$yd, $c79bde28d689cb05$var$Ad = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c79bde28d689cb05$var$yd && ($c79bde28d689cb05$var$yd && "mousemove" === a.type ? ($c79bde28d689cb05$var$wd = a.screenX - $c79bde28d689cb05$var$yd.screenX, $c79bde28d689cb05$var$xd = a.screenY - $c79bde28d689cb05$var$yd.screenY) : $c79bde28d689cb05$var$xd = $c79bde28d689cb05$var$wd = 0, $c79bde28d689cb05$var$yd = a);
        return $c79bde28d689cb05$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $c79bde28d689cb05$var$xd;
    }
}), $c79bde28d689cb05$var$Bd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ad), $c79bde28d689cb05$var$Cd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    dataTransfer: 0
}), $c79bde28d689cb05$var$Dd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Cd), $c79bde28d689cb05$var$Ed = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    relatedTarget: 0
}), $c79bde28d689cb05$var$Fd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ed), $c79bde28d689cb05$var$Gd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Hd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Gd), $c79bde28d689cb05$var$Id = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c79bde28d689cb05$var$Jd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Id), $c79bde28d689cb05$var$Kd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    data: 0
}), $c79bde28d689cb05$var$Ld = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Kd), $c79bde28d689cb05$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c79bde28d689cb05$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c79bde28d689cb05$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c79bde28d689cb05$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c79bde28d689cb05$var$Od[a]) ? !!b[a] : !1;
}
function $c79bde28d689cb05$var$zd() {
    return $c79bde28d689cb05$var$Pd;
}
var $c79bde28d689cb05$var$Qd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $c79bde28d689cb05$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c79bde28d689cb05$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c79bde28d689cb05$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c79bde28d689cb05$var$Rd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Qd), $c79bde28d689cb05$var$Sd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c79bde28d689cb05$var$Td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Sd), $c79bde28d689cb05$var$Ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd
}), $c79bde28d689cb05$var$Vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ud), $c79bde28d689cb05$var$Wd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Xd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Wd), $c79bde28d689cb05$var$Yd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c79bde28d689cb05$var$Zd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Yd), $c79bde28d689cb05$var$$d = [
    9,
    13,
    27,
    32
], $c79bde28d689cb05$var$ae = $c79bde28d689cb05$var$ia && "CompositionEvent" in window, $c79bde28d689cb05$var$be = null;
$c79bde28d689cb05$var$ia && "documentMode" in document && ($c79bde28d689cb05$var$be = document.documentMode);
var $c79bde28d689cb05$var$ce = $c79bde28d689cb05$var$ia && "TextEvent" in window && !$c79bde28d689cb05$var$be, $c79bde28d689cb05$var$de = $c79bde28d689cb05$var$ia && (!$c79bde28d689cb05$var$ae || $c79bde28d689cb05$var$be && 8 < $c79bde28d689cb05$var$be && 11 >= $c79bde28d689cb05$var$be), $c79bde28d689cb05$var$ee = String.fromCharCode(32), $c79bde28d689cb05$var$fe = !1;
function $c79bde28d689cb05$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c79bde28d689cb05$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c79bde28d689cb05$var$ie = !1;
function $c79bde28d689cb05$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c79bde28d689cb05$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c79bde28d689cb05$var$fe = !0;
            return $c79bde28d689cb05$var$ee;
        case "textInput":
            return a = b.data, a === $c79bde28d689cb05$var$ee && $c79bde28d689cb05$var$fe ? null : a;
        default:
            return null;
    }
}
function $c79bde28d689cb05$var$ke(a, b) {
    if ($c79bde28d689cb05$var$ie) return "compositionend" === a || !$c79bde28d689cb05$var$ae && $c79bde28d689cb05$var$ge(a, b) ? (a = $c79bde28d689cb05$var$nd(), $c79bde28d689cb05$var$md = $c79bde28d689cb05$var$ld = $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c79bde28d689cb05$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c79bde28d689cb05$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c79bde28d689cb05$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c79bde28d689cb05$var$ne(a, b, c, d) {
    $c79bde28d689cb05$var$Eb(d);
    b = $c79bde28d689cb05$var$oe(b, "onChange");
    0 < b.length && (c = new $c79bde28d689cb05$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c79bde28d689cb05$var$pe = null, $c79bde28d689cb05$var$qe = null;
function $c79bde28d689cb05$var$re(a) {
    $c79bde28d689cb05$var$se(a, 0);
}
function $c79bde28d689cb05$var$te(a) {
    var b = $c79bde28d689cb05$var$ue(a);
    if ($c79bde28d689cb05$var$Wa(b)) return a;
}
function $c79bde28d689cb05$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c79bde28d689cb05$var$we = !1;
if ($c79bde28d689cb05$var$ia) {
    var $c79bde28d689cb05$var$xe;
    if ($c79bde28d689cb05$var$ia) {
        var $c79bde28d689cb05$var$ye = "oninput" in document;
        if (!$c79bde28d689cb05$var$ye) {
            var $c79bde28d689cb05$var$ze = document.createElement("div");
            $c79bde28d689cb05$var$ze.setAttribute("oninput", "return;");
            $c79bde28d689cb05$var$ye = "function" === typeof $c79bde28d689cb05$var$ze.oninput;
        }
        $c79bde28d689cb05$var$xe = $c79bde28d689cb05$var$ye;
    } else $c79bde28d689cb05$var$xe = !1;
    $c79bde28d689cb05$var$we = $c79bde28d689cb05$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c79bde28d689cb05$var$Ae() {
    $c79bde28d689cb05$var$pe && ($c79bde28d689cb05$var$pe.detachEvent("onpropertychange", $c79bde28d689cb05$var$Be), $c79bde28d689cb05$var$qe = $c79bde28d689cb05$var$pe = null);
}
function $c79bde28d689cb05$var$Be(a) {
    if ("value" === a.propertyName && $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe)) {
        var b = [];
        $c79bde28d689cb05$var$ne(b, $c79bde28d689cb05$var$qe, a, $c79bde28d689cb05$var$xb(a));
        $c79bde28d689cb05$var$Jb($c79bde28d689cb05$var$re, b);
    }
}
function $c79bde28d689cb05$var$Ce(a, b, c) {
    "focusin" === a ? ($c79bde28d689cb05$var$Ae(), $c79bde28d689cb05$var$pe = b, $c79bde28d689cb05$var$qe = c, $c79bde28d689cb05$var$pe.attachEvent("onpropertychange", $c79bde28d689cb05$var$Be)) : "focusout" === a && $c79bde28d689cb05$var$Ae();
}
function $c79bde28d689cb05$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe);
}
function $c79bde28d689cb05$var$Ee(a, b) {
    if ("click" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c79bde28d689cb05$var$He = "function" === typeof Object.is ? Object.is : $c79bde28d689cb05$var$Ge;
function $c79bde28d689cb05$var$Ie(a, b) {
    if ($c79bde28d689cb05$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c79bde28d689cb05$var$ja.call(b, e) || !$c79bde28d689cb05$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c79bde28d689cb05$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c79bde28d689cb05$var$Ke(a, b) {
    var c = $c79bde28d689cb05$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c79bde28d689cb05$var$Je(c);
    }
}
function $c79bde28d689cb05$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c79bde28d689cb05$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c79bde28d689cb05$var$Me() {
    for(var a = window, b = $c79bde28d689cb05$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c79bde28d689cb05$var$Xa(a.document);
    }
    return b;
}
function $c79bde28d689cb05$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c79bde28d689cb05$var$Oe(a) {
    var b = $c79bde28d689cb05$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c79bde28d689cb05$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c79bde28d689cb05$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c79bde28d689cb05$var$Ke(c, f);
                var g = $c79bde28d689cb05$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c79bde28d689cb05$var$Pe = $c79bde28d689cb05$var$ia && "documentMode" in document && 11 >= document.documentMode, $c79bde28d689cb05$var$Qe = null, $c79bde28d689cb05$var$Re = null, $c79bde28d689cb05$var$Se = null, $c79bde28d689cb05$var$Te = !1;
function $c79bde28d689cb05$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c79bde28d689cb05$var$Te || null == $c79bde28d689cb05$var$Qe || $c79bde28d689cb05$var$Qe !== $c79bde28d689cb05$var$Xa(d) || (d = $c79bde28d689cb05$var$Qe, "selectionStart" in d && $c79bde28d689cb05$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c79bde28d689cb05$var$Se && $c79bde28d689cb05$var$Ie($c79bde28d689cb05$var$Se, d) || ($c79bde28d689cb05$var$Se = d, d = $c79bde28d689cb05$var$oe($c79bde28d689cb05$var$Re, "onSelect"), 0 < d.length && (b = new $c79bde28d689cb05$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c79bde28d689cb05$var$Qe)));
}
function $c79bde28d689cb05$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c79bde28d689cb05$var$We = {
    animationend: $c79bde28d689cb05$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c79bde28d689cb05$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c79bde28d689cb05$var$Ve("Animation", "AnimationStart"),
    transitionend: $c79bde28d689cb05$var$Ve("Transition", "TransitionEnd")
}, $c79bde28d689cb05$var$Xe = {}, $c79bde28d689cb05$var$Ye = {};
$c79bde28d689cb05$var$ia && ($c79bde28d689cb05$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c79bde28d689cb05$var$We.animationend.animation, delete $c79bde28d689cb05$var$We.animationiteration.animation, delete $c79bde28d689cb05$var$We.animationstart.animation), "TransitionEvent" in window || delete $c79bde28d689cb05$var$We.transitionend.transition);
function $c79bde28d689cb05$var$Ze(a) {
    if ($c79bde28d689cb05$var$Xe[a]) return $c79bde28d689cb05$var$Xe[a];
    if (!$c79bde28d689cb05$var$We[a]) return a;
    var b = $c79bde28d689cb05$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c79bde28d689cb05$var$Ye) return $c79bde28d689cb05$var$Xe[a] = b[c];
    return a;
}
var $c79bde28d689cb05$var$$e = $c79bde28d689cb05$var$Ze("animationend"), $c79bde28d689cb05$var$af = $c79bde28d689cb05$var$Ze("animationiteration"), $c79bde28d689cb05$var$bf = $c79bde28d689cb05$var$Ze("animationstart"), $c79bde28d689cb05$var$cf = $c79bde28d689cb05$var$Ze("transitionend"), $c79bde28d689cb05$var$df = new Map, $c79bde28d689cb05$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c79bde28d689cb05$var$ff(a, b) {
    $c79bde28d689cb05$var$df.set(a, b);
    $c79bde28d689cb05$var$fa(b, [
        a
    ]);
}
for(var $c79bde28d689cb05$var$gf = 0; $c79bde28d689cb05$var$gf < $c79bde28d689cb05$var$ef.length; $c79bde28d689cb05$var$gf++){
    var $c79bde28d689cb05$var$hf = $c79bde28d689cb05$var$ef[$c79bde28d689cb05$var$gf], $c79bde28d689cb05$var$jf = $c79bde28d689cb05$var$hf.toLowerCase(), $c79bde28d689cb05$var$kf = $c79bde28d689cb05$var$hf[0].toUpperCase() + $c79bde28d689cb05$var$hf.slice(1);
    $c79bde28d689cb05$var$ff($c79bde28d689cb05$var$jf, "on" + $c79bde28d689cb05$var$kf);
}
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$$e, "onAnimationEnd");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$af, "onAnimationIteration");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$bf, "onAnimationStart");
$c79bde28d689cb05$var$ff("dblclick", "onDoubleClick");
$c79bde28d689cb05$var$ff("focusin", "onFocus");
$c79bde28d689cb05$var$ff("focusout", "onBlur");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$cf, "onTransitionEnd");
$c79bde28d689cb05$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c79bde28d689cb05$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c79bde28d689cb05$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c79bde28d689cb05$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c79bde28d689cb05$var$lf));
function $c79bde28d689cb05$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c79bde28d689cb05$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c79bde28d689cb05$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c79bde28d689cb05$var$Qb) throw a = $c79bde28d689cb05$var$Rb, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, a;
}
function $c79bde28d689cb05$var$D(a, b) {
    var c = b[$c79bde28d689cb05$var$of];
    void 0 === c && (c = b[$c79bde28d689cb05$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c79bde28d689cb05$var$pf(b, a, 2, !1), c.add(d));
}
function $c79bde28d689cb05$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c79bde28d689cb05$var$pf(c, a, d, b);
}
var $c79bde28d689cb05$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c79bde28d689cb05$var$sf(a) {
    if (!a[$c79bde28d689cb05$var$rf]) {
        a[$c79bde28d689cb05$var$rf] = !0;
        $c79bde28d689cb05$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c79bde28d689cb05$var$mf.has(b) || $c79bde28d689cb05$var$qf(b, !1, a), $c79bde28d689cb05$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c79bde28d689cb05$var$rf] || (b[$c79bde28d689cb05$var$rf] = !0, $c79bde28d689cb05$var$qf("selectionchange", !1, b));
    }
}
function $c79bde28d689cb05$var$pf(a, b, c, d) {
    switch($c79bde28d689cb05$var$jd(b)){
        case 1:
            var e = $c79bde28d689cb05$var$ed;
            break;
        case 4:
            e = $c79bde28d689cb05$var$gd;
            break;
        default:
            e = $c79bde28d689cb05$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c79bde28d689cb05$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c79bde28d689cb05$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c79bde28d689cb05$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c79bde28d689cb05$var$Jb(function() {
        var d = f, e = $c79bde28d689cb05$var$xb(c), g = [];
        a: {
            var h = $c79bde28d689cb05$var$df.get(a);
            if (void 0 !== h) {
                var k = $c79bde28d689cb05$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c79bde28d689cb05$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c79bde28d689cb05$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c79bde28d689cb05$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c79bde28d689cb05$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c79bde28d689cb05$var$Vd;
                        break;
                    case $c79bde28d689cb05$var$$e:
                    case $c79bde28d689cb05$var$af:
                    case $c79bde28d689cb05$var$bf:
                        k = $c79bde28d689cb05$var$Hd;
                        break;
                    case $c79bde28d689cb05$var$cf:
                        k = $c79bde28d689cb05$var$Xd;
                        break;
                    case "scroll":
                        k = $c79bde28d689cb05$var$vd;
                        break;
                    case "wheel":
                        k = $c79bde28d689cb05$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c79bde28d689cb05$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c79bde28d689cb05$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c79bde28d689cb05$var$Kb(w, x), null != F && t.push($c79bde28d689cb05$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c79bde28d689cb05$var$wb && (n = c.relatedTarget || c.fromElement) && ($c79bde28d689cb05$var$Wc(n) || n[$c79bde28d689cb05$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $c79bde28d689cb05$var$Wc(n) : null, null !== n && (J = $c79bde28d689cb05$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $c79bde28d689cb05$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c79bde28d689cb05$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c79bde28d689cb05$var$ue(k);
                        u = null == n ? h : $c79bde28d689cb05$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c79bde28d689cb05$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c79bde28d689cb05$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c79bde28d689cb05$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c79bde28d689cb05$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c79bde28d689cb05$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c79bde28d689cb05$var$vf(t);
                                x = $c79bde28d689cb05$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c79bde28d689cb05$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c79bde28d689cb05$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $c79bde28d689cb05$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c79bde28d689cb05$var$ve;
                else if ($c79bde28d689cb05$var$me(h)) {
                    if ($c79bde28d689cb05$var$we) na = $c79bde28d689cb05$var$Fe;
                    else {
                        na = $c79bde28d689cb05$var$De;
                        var xa = $c79bde28d689cb05$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c79bde28d689cb05$var$Ee);
                if (na && (na = na(a, d))) {
                    $c79bde28d689cb05$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c79bde28d689cb05$var$cb(h, "number", h.value);
            }
            xa = d ? $c79bde28d689cb05$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($c79bde28d689cb05$var$me(xa) || "true" === xa.contentEditable) $c79bde28d689cb05$var$Qe = xa, $c79bde28d689cb05$var$Re = d, $c79bde28d689cb05$var$Se = null;
                    break;
                case "focusout":
                    $c79bde28d689cb05$var$Se = $c79bde28d689cb05$var$Re = $c79bde28d689cb05$var$Qe = null;
                    break;
                case "mousedown":
                    $c79bde28d689cb05$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c79bde28d689cb05$var$Te = !1;
                    $c79bde28d689cb05$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($c79bde28d689cb05$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c79bde28d689cb05$var$Ue(g, c, e);
            }
            var $a;
            if ($c79bde28d689cb05$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c79bde28d689cb05$var$ie ? $c79bde28d689cb05$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c79bde28d689cb05$var$de && "ko" !== c.locale && ($c79bde28d689cb05$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c79bde28d689cb05$var$ie && ($a = $c79bde28d689cb05$var$nd()) : ($c79bde28d689cb05$var$kd = e, $c79bde28d689cb05$var$ld = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, $c79bde28d689cb05$var$ie = !0)), xa = $c79bde28d689cb05$var$oe(d, ba), 0 < xa.length && (ba = new $c79bde28d689cb05$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c79bde28d689cb05$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c79bde28d689cb05$var$ce ? $c79bde28d689cb05$var$je(a, c) : $c79bde28d689cb05$var$ke(a, c)) d = $c79bde28d689cb05$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $c79bde28d689cb05$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $c79bde28d689cb05$var$se(g, b);
    });
}
function $c79bde28d689cb05$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c79bde28d689cb05$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c79bde28d689cb05$var$Kb(a, c), null != f && d.unshift($c79bde28d689cb05$var$tf(a, f, e)), f = $c79bde28d689cb05$var$Kb(a, b), null != f && d.push($c79bde28d689cb05$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c79bde28d689cb05$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c79bde28d689cb05$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.unshift($c79bde28d689cb05$var$tf(c, k, h))) : e || (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.push($c79bde28d689cb05$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c79bde28d689cb05$var$xf = /\r\n?/g, $c79bde28d689cb05$var$yf = /\u0000|\uFFFD/g;
function $c79bde28d689cb05$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c79bde28d689cb05$var$xf, "\n").replace($c79bde28d689cb05$var$yf, "");
}
function $c79bde28d689cb05$var$Af(a, b, c) {
    b = $c79bde28d689cb05$var$zf(b);
    if ($c79bde28d689cb05$var$zf(a) !== b && c) throw Error($c79bde28d689cb05$var$p(425));
}
function $c79bde28d689cb05$var$Bf() {}
var $c79bde28d689cb05$var$Cf = null, $c79bde28d689cb05$var$Df = null;
function $c79bde28d689cb05$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c79bde28d689cb05$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c79bde28d689cb05$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c79bde28d689cb05$var$Hf = "function" === typeof Promise ? Promise : void 0, $c79bde28d689cb05$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c79bde28d689cb05$var$Hf ? function(a) {
    return $c79bde28d689cb05$var$Hf.resolve(null).then(a).catch($c79bde28d689cb05$var$If);
} : $c79bde28d689cb05$var$Ff;
function $c79bde28d689cb05$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c79bde28d689cb05$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c79bde28d689cb05$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c79bde28d689cb05$var$bd(b);
}
function $c79bde28d689cb05$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c79bde28d689cb05$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nf = Math.random().toString(36).slice(2), $c79bde28d689cb05$var$Of = "__reactFiber$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Pf = "__reactProps$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$uf = "__reactContainer$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$of = "__reactEvents$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Qf = "__reactListeners$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Rf = "__reactHandles$" + $c79bde28d689cb05$var$Nf;
function $c79bde28d689cb05$var$Wc(a) {
    var b = a[$c79bde28d689cb05$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c79bde28d689cb05$var$uf] || c[$c79bde28d689cb05$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c79bde28d689cb05$var$Mf(a); null !== a;){
                if (c = a[$c79bde28d689cb05$var$Of]) return c;
                a = $c79bde28d689cb05$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c79bde28d689cb05$var$Cb(a) {
    a = a[$c79bde28d689cb05$var$Of] || a[$c79bde28d689cb05$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c79bde28d689cb05$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c79bde28d689cb05$var$p(33));
}
function $c79bde28d689cb05$var$Db(a) {
    return a[$c79bde28d689cb05$var$Pf] || null;
}
var $c79bde28d689cb05$var$Sf = [], $c79bde28d689cb05$var$Tf = -1;
function $c79bde28d689cb05$var$Uf(a) {
    return {
        current: a
    };
}
function $c79bde28d689cb05$var$E(a) {
    0 > $c79bde28d689cb05$var$Tf || (a.current = $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf], $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = null, $c79bde28d689cb05$var$Tf--);
}
function $c79bde28d689cb05$var$G(a, b) {
    $c79bde28d689cb05$var$Tf++;
    $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = a.current;
    a.current = b;
}
var $c79bde28d689cb05$var$Vf = {}, $c79bde28d689cb05$var$H = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Vf), $c79bde28d689cb05$var$Wf = $c79bde28d689cb05$var$Uf(!1), $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$Vf;
function $c79bde28d689cb05$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c79bde28d689cb05$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c79bde28d689cb05$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c79bde28d689cb05$var$$f() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
}
function $c79bde28d689cb05$var$ag(a, b, c) {
    if ($c79bde28d689cb05$var$H.current !== $c79bde28d689cb05$var$Vf) throw Error($c79bde28d689cb05$var$p(168));
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
function $c79bde28d689cb05$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c79bde28d689cb05$var$p(108, $c79bde28d689cb05$var$Ra(a) || "Unknown", e));
    return $c79bde28d689cb05$var$A({}, c, d);
}
function $c79bde28d689cb05$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c79bde28d689cb05$var$Vf;
    $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$H.current;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, $c79bde28d689cb05$var$Wf.current);
    return !0;
}
function $c79bde28d689cb05$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c79bde28d689cb05$var$p(169));
    c ? (a = $c79bde28d689cb05$var$bg(a, b, $c79bde28d689cb05$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a)) : $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
var $c79bde28d689cb05$var$eg = null, $c79bde28d689cb05$var$fg = !1, $c79bde28d689cb05$var$gg = !1;
function $c79bde28d689cb05$var$hg(a) {
    null === $c79bde28d689cb05$var$eg ? $c79bde28d689cb05$var$eg = [
        a
    ] : $c79bde28d689cb05$var$eg.push(a);
}
function $c79bde28d689cb05$var$ig(a) {
    $c79bde28d689cb05$var$fg = !0;
    $c79bde28d689cb05$var$hg(a);
}
function $c79bde28d689cb05$var$jg() {
    if (!$c79bde28d689cb05$var$gg && null !== $c79bde28d689cb05$var$eg) {
        $c79bde28d689cb05$var$gg = !0;
        var a = 0, b = $c79bde28d689cb05$var$C;
        try {
            var c = $c79bde28d689cb05$var$eg;
            for($c79bde28d689cb05$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c79bde28d689cb05$var$eg = null;
            $c79bde28d689cb05$var$fg = !1;
        } catch (e) {
            throw null !== $c79bde28d689cb05$var$eg && ($c79bde28d689cb05$var$eg = $c79bde28d689cb05$var$eg.slice(a + 1)), $c79bde28d689cb05$var$ac($c79bde28d689cb05$var$fc, $c79bde28d689cb05$var$jg), e;
        } finally{
            $c79bde28d689cb05$var$C = b, $c79bde28d689cb05$var$gg = !1;
        }
    }
    return null;
}
var $c79bde28d689cb05$var$kg = [], $c79bde28d689cb05$var$lg = 0, $c79bde28d689cb05$var$mg = null, $c79bde28d689cb05$var$ng = 0, $c79bde28d689cb05$var$og = [], $c79bde28d689cb05$var$pg = 0, $c79bde28d689cb05$var$qg = null, $c79bde28d689cb05$var$rg = 1, $c79bde28d689cb05$var$sg = "";
function $c79bde28d689cb05$var$tg(a, b) {
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$ng;
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$mg;
    $c79bde28d689cb05$var$mg = a;
    $c79bde28d689cb05$var$ng = b;
}
function $c79bde28d689cb05$var$ug(a, b, c) {
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg;
    $c79bde28d689cb05$var$qg = a;
    var d = $c79bde28d689cb05$var$rg;
    a = $c79bde28d689cb05$var$sg;
    var e = 32 - $c79bde28d689cb05$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c79bde28d689cb05$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c79bde28d689cb05$var$rg = 1 << 32 - $c79bde28d689cb05$var$oc(b) + e | c << e | d;
        $c79bde28d689cb05$var$sg = f + a;
    } else $c79bde28d689cb05$var$rg = 1 << f | c << e | d, $c79bde28d689cb05$var$sg = a;
}
function $c79bde28d689cb05$var$vg(a) {
    null !== a.return && ($c79bde28d689cb05$var$tg(a, 1), $c79bde28d689cb05$var$ug(a, 1, 0));
}
function $c79bde28d689cb05$var$wg(a) {
    for(; a === $c79bde28d689cb05$var$mg;)$c79bde28d689cb05$var$mg = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null, $c79bde28d689cb05$var$ng = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null;
    for(; a === $c79bde28d689cb05$var$qg;)$c79bde28d689cb05$var$qg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$sg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$rg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null;
}
var $c79bde28d689cb05$var$xg = null, $c79bde28d689cb05$var$yg = null, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$zg = null;
function $c79bde28d689cb05$var$Ag(a, b) {
    var c = $c79bde28d689cb05$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c79bde28d689cb05$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c79bde28d689cb05$var$qg ? {
                id: $c79bde28d689cb05$var$rg,
                overflow: $c79bde28d689cb05$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c79bde28d689cb05$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c79bde28d689cb05$var$Eg(a) {
    if ($c79bde28d689cb05$var$I) {
        var b = $c79bde28d689cb05$var$yg;
        if (b) {
            var c = b;
            if (!$c79bde28d689cb05$var$Cg(a, b)) {
                if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
                b = $c79bde28d689cb05$var$Lf(c.nextSibling);
                var d = $c79bde28d689cb05$var$xg;
                b && $c79bde28d689cb05$var$Cg(a, b) ? $c79bde28d689cb05$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$xg = a);
            }
        } else {
            if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c79bde28d689cb05$var$I = !1;
            $c79bde28d689cb05$var$xg = a;
        }
    }
}
function $c79bde28d689cb05$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c79bde28d689cb05$var$xg = a;
}
function $c79bde28d689cb05$var$Gg(a) {
    if (a !== $c79bde28d689cb05$var$xg) return !1;
    if (!$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$Fg(a), $c79bde28d689cb05$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c79bde28d689cb05$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c79bde28d689cb05$var$yg)) {
        if ($c79bde28d689cb05$var$Dg(a)) throw $c79bde28d689cb05$var$Hg(), Error($c79bde28d689cb05$var$p(418));
        for(; b;)$c79bde28d689cb05$var$Ag(a, b), b = $c79bde28d689cb05$var$Lf(b.nextSibling);
    }
    $c79bde28d689cb05$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c79bde28d689cb05$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c79bde28d689cb05$var$yg = null;
        }
    } else $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg ? $c79bde28d689cb05$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c79bde28d689cb05$var$Hg() {
    for(var a = $c79bde28d689cb05$var$yg; a;)a = $c79bde28d689cb05$var$Lf(a.nextSibling);
}
function $c79bde28d689cb05$var$Ig() {
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg = null;
    $c79bde28d689cb05$var$I = !1;
}
function $c79bde28d689cb05$var$Jg(a) {
    null === $c79bde28d689cb05$var$zg ? $c79bde28d689cb05$var$zg = [
        a
    ] : $c79bde28d689cb05$var$zg.push(a);
}
var $c79bde28d689cb05$var$Kg = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig;
function $c79bde28d689cb05$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $c79bde28d689cb05$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $c79bde28d689cb05$var$Mg = $c79bde28d689cb05$var$Uf(null), $c79bde28d689cb05$var$Ng = null, $c79bde28d689cb05$var$Og = null, $c79bde28d689cb05$var$Pg = null;
function $c79bde28d689cb05$var$Qg() {
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Ng = null;
}
function $c79bde28d689cb05$var$Rg(a) {
    var b = $c79bde28d689cb05$var$Mg.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Mg);
    a._currentValue = b;
}
function $c79bde28d689cb05$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c79bde28d689cb05$var$Tg(a, b) {
    $c79bde28d689cb05$var$Ng = a;
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c79bde28d689cb05$var$Ug = !0), a.firstContext = null);
}
function $c79bde28d689cb05$var$Vg(a) {
    var b = a._currentValue;
    if ($c79bde28d689cb05$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c79bde28d689cb05$var$Og) {
            if (null === $c79bde28d689cb05$var$Ng) throw Error($c79bde28d689cb05$var$p(308));
            $c79bde28d689cb05$var$Og = a;
            $c79bde28d689cb05$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Og.next = a;
    }
    return b;
}
var $c79bde28d689cb05$var$Wg = null;
function $c79bde28d689cb05$var$Xg(a) {
    null === $c79bde28d689cb05$var$Wg ? $c79bde28d689cb05$var$Wg = [
        a
    ] : $c79bde28d689cb05$var$Wg.push(a);
}
function $c79bde28d689cb05$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c79bde28d689cb05$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c79bde28d689cb05$var$Zg(a, d);
}
function $c79bde28d689cb05$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c79bde28d689cb05$var$$g = !1;
function $c79bde28d689cb05$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c79bde28d689cb05$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c79bde28d689cb05$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c79bde28d689cb05$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c79bde28d689cb05$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c79bde28d689cb05$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c79bde28d689cb05$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c79bde28d689cb05$var$Zg(a, c);
}
function $c79bde28d689cb05$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
function $c79bde28d689cb05$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c79bde28d689cb05$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $c79bde28d689cb05$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c79bde28d689cb05$var$A({}, q, r);
                            break a;
                        case 2:
                            $c79bde28d689cb05$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c79bde28d689cb05$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c79bde28d689cb05$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c79bde28d689cb05$var$p(191, e));
            e.call(d);
        }
    }
}
var $c79bde28d689cb05$var$jh = (new $exYeM.Component).refs;
function $c79bde28d689cb05$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c79bde28d689cb05$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c79bde28d689cb05$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $c79bde28d689cb05$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $c79bde28d689cb05$var$L(), d = $c79bde28d689cb05$var$lh(a), e = $c79bde28d689cb05$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c79bde28d689cb05$var$dh(a, e, d);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, d, c), $c79bde28d689cb05$var$eh(b, a, d));
    }
};
function $c79bde28d689cb05$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c79bde28d689cb05$var$Ie(c, d) || !$c79bde28d689cb05$var$Ie(e, f) : !0;
}
function $c79bde28d689cb05$var$ph(a, b, c) {
    var d = !1, e = $c79bde28d689cb05$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c79bde28d689cb05$var$Vg(f) : (e = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c79bde28d689cb05$var$Yf(a, e) : $c79bde28d689cb05$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c79bde28d689cb05$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c79bde28d689cb05$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c79bde28d689cb05$var$nh.enqueueReplaceState(b, b.state, null);
}
function $c79bde28d689cb05$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $c79bde28d689cb05$var$jh;
    $c79bde28d689cb05$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c79bde28d689cb05$var$Vg(f) : (f = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, e.context = $c79bde28d689cb05$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c79bde28d689cb05$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c79bde28d689cb05$var$nh.enqueueReplaceState(e, e.state, null), $c79bde28d689cb05$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c79bde28d689cb05$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c79bde28d689cb05$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c79bde28d689cb05$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $c79bde28d689cb05$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c79bde28d689cb05$var$p(284));
        if (!c._owner) throw Error($c79bde28d689cb05$var$p(290, a));
    }
    return a;
}
function $c79bde28d689cb05$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c79bde28d689cb05$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c79bde28d689cb05$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $c79bde28d689cb05$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c79bde28d689cb05$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c79bde28d689cb05$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c79bde28d689cb05$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $c79bde28d689cb05$var$sh(a, b, c), d.return = a, d;
        d = $c79bde28d689cb05$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c79bde28d689cb05$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c79bde28d689cb05$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c79bde28d689cb05$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c79bde28d689cb05$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c = $c79bde28d689cb05$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $c79bde28d689cb05$var$sh(a, null, b), c.return = a, c;
                case $c79bde28d689cb05$var$wa:
                    return b = $c79bde28d689cb05$var$zh(b, a.mode, c), b.return = a, b;
                case $c79bde28d689cb05$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c79bde28d689cb05$var$eb(b) || $c79bde28d689cb05$var$Ka(b)) return b = $c79bde28d689cb05$var$Ah(b, a.mode, c, null), b.return = a, b;
            $c79bde28d689cb05$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c79bde28d689cb05$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c79bde28d689cb05$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c79bde28d689cb05$var$eb(c) || $c79bde28d689cb05$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c79bde28d689cb05$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c79bde28d689cb05$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c79bde28d689cb05$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c79bde28d689cb05$var$eb(d) || $c79bde28d689cb05$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c79bde28d689cb05$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c79bde28d689cb05$var$Ka(h);
        if ("function" !== typeof l) throw Error($c79bde28d689cb05$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c79bde28d689cb05$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c79bde28d689cb05$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c79bde28d689cb05$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c79bde28d689cb05$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c79bde28d689cb05$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c79bde28d689cb05$var$ya ? (d = $c79bde28d689cb05$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c79bde28d689cb05$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $c79bde28d689cb05$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c79bde28d689cb05$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c79bde28d689cb05$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c79bde28d689cb05$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c79bde28d689cb05$var$eb(f)) return n(a, d, f, h);
            if ($c79bde28d689cb05$var$Ka(f)) return t(a, d, f, h);
            $c79bde28d689cb05$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c79bde28d689cb05$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c79bde28d689cb05$var$Bh = $c79bde28d689cb05$var$vh(!0), $c79bde28d689cb05$var$Ch = $c79bde28d689cb05$var$vh(!1), $c79bde28d689cb05$var$Dh = {}, $c79bde28d689cb05$var$Eh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Fh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Gh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh);
function $c79bde28d689cb05$var$Hh(a) {
    if (a === $c79bde28d689cb05$var$Dh) throw Error($c79bde28d689cb05$var$p(174));
    return a;
}
function $c79bde28d689cb05$var$Ih(a, b) {
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Gh, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, $c79bde28d689cb05$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c79bde28d689cb05$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c79bde28d689cb05$var$lb(b, a);
    }
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, b);
}
function $c79bde28d689cb05$var$Jh() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Gh);
}
function $c79bde28d689cb05$var$Kh(a) {
    $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
    var b = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
    var c = $c79bde28d689cb05$var$lb(b, a.type);
    b !== c && ($c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, c));
}
function $c79bde28d689cb05$var$Lh(a) {
    $c79bde28d689cb05$var$Fh.current === a && ($c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh));
}
var $c79bde28d689cb05$var$M = $c79bde28d689cb05$var$Uf(0);
function $c79bde28d689cb05$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nh = [];
function $c79bde28d689cb05$var$Oh() {
    for(var a = 0; a < $c79bde28d689cb05$var$Nh.length; a++)$c79bde28d689cb05$var$Nh[a]._workInProgressVersionPrimary = null;
    $c79bde28d689cb05$var$Nh.length = 0;
}
var $c79bde28d689cb05$var$Ph = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$Qh = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$Rh = 0, $c79bde28d689cb05$var$N = null, $c79bde28d689cb05$var$O = null, $c79bde28d689cb05$var$P = null, $c79bde28d689cb05$var$Sh = !1, $c79bde28d689cb05$var$Th = !1, $c79bde28d689cb05$var$Uh = 0, $c79bde28d689cb05$var$Vh = 0;
function $c79bde28d689cb05$var$Q() {
    throw Error($c79bde28d689cb05$var$p(321));
}
function $c79bde28d689cb05$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c79bde28d689cb05$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c79bde28d689cb05$var$Xh(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$Rh = f;
    $c79bde28d689cb05$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c79bde28d689cb05$var$Ph.current = null === a || null === a.memoizedState ? $c79bde28d689cb05$var$Yh : $c79bde28d689cb05$var$Zh;
    a = c(d, e);
    if ($c79bde28d689cb05$var$Th) {
        f = 0;
        do {
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            if (25 <= f) throw Error($c79bde28d689cb05$var$p(301));
            f += 1;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = null;
            b.updateQueue = null;
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$$h;
            a = c(d, e);
        }while ($c79bde28d689cb05$var$Th);
    }
    $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
    b = null !== $c79bde28d689cb05$var$O && null !== $c79bde28d689cb05$var$O.next;
    $c79bde28d689cb05$var$Rh = 0;
    $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
    $c79bde28d689cb05$var$Sh = !1;
    if (b) throw Error($c79bde28d689cb05$var$p(300));
    return a;
}
function $c79bde28d689cb05$var$bi() {
    var a = 0 !== $c79bde28d689cb05$var$Uh;
    $c79bde28d689cb05$var$Uh = 0;
    return a;
}
function $c79bde28d689cb05$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$di() {
    if (null === $c79bde28d689cb05$var$O) {
        var a = $c79bde28d689cb05$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c79bde28d689cb05$var$O.next;
    var b = null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState : $c79bde28d689cb05$var$P.next;
    if (null !== b) $c79bde28d689cb05$var$P = b, $c79bde28d689cb05$var$O = a;
    else {
        if (null === a) throw Error($c79bde28d689cb05$var$p(310));
        $c79bde28d689cb05$var$O = a;
        a = {
            memoizedState: $c79bde28d689cb05$var$O.memoizedState,
            baseState: $c79bde28d689cb05$var$O.baseState,
            baseQueue: $c79bde28d689cb05$var$O.baseQueue,
            queue: $c79bde28d689cb05$var$O.queue,
            next: null
        };
        null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    }
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c79bde28d689cb05$var$fi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c79bde28d689cb05$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c79bde28d689cb05$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c79bde28d689cb05$var$N.lanes |= m;
                $c79bde28d689cb05$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c79bde28d689cb05$var$He(d, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c79bde28d689cb05$var$N.lanes |= f, $c79bde28d689cb05$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c79bde28d689cb05$var$gi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c79bde28d689cb05$var$He(f, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c79bde28d689cb05$var$hi() {}
function $c79bde28d689cb05$var$ii(a, b) {
    var c = $c79bde28d689cb05$var$N, d = $c79bde28d689cb05$var$di(), e = b(), f = !$c79bde28d689cb05$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c79bde28d689cb05$var$Ug = !0);
    d = d.queue;
    $c79bde28d689cb05$var$ji($c79bde28d689cb05$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c79bde28d689cb05$var$P && $c79bde28d689cb05$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
        0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(c, b, e);
    }
    return e;
}
function $c79bde28d689cb05$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c79bde28d689cb05$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
}
function $c79bde28d689cb05$var$ki(a, b, c) {
    return c(function() {
        $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
    });
}
function $c79bde28d689cb05$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c79bde28d689cb05$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c79bde28d689cb05$var$pi(a) {
    var b = $c79bde28d689cb05$var$Zg(a, 1);
    null !== b && $c79bde28d689cb05$var$mh(b, a, 1, -1);
}
function $c79bde28d689cb05$var$qi(a) {
    var b = $c79bde28d689cb05$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c79bde28d689cb05$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c79bde28d689cb05$var$ri.bind(null, $c79bde28d689cb05$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c79bde28d689cb05$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c79bde28d689cb05$var$si() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$ti(a, b, c, d) {
    var e = $c79bde28d689cb05$var$ci();
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c79bde28d689cb05$var$ui(a, b, c, d) {
    var e = $c79bde28d689cb05$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c79bde28d689cb05$var$O) {
        var g = $c79bde28d689cb05$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $c79bde28d689cb05$var$Wh(d, g.deps)) {
            e.memoizedState = $c79bde28d689cb05$var$li(b, c, f, d);
            return;
        }
    }
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, f, d);
}
function $c79bde28d689cb05$var$vi(a, b) {
    return $c79bde28d689cb05$var$ti(8390656, 8, a, b);
}
function $c79bde28d689cb05$var$ji(a, b) {
    return $c79bde28d689cb05$var$ui(2048, 8, a, b);
}
function $c79bde28d689cb05$var$wi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 2, a, b);
}
function $c79bde28d689cb05$var$xi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 4, a, b);
}
function $c79bde28d689cb05$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c79bde28d689cb05$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c79bde28d689cb05$var$ui(4, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
}
function $c79bde28d689cb05$var$Ai() {}
function $c79bde28d689cb05$var$Bi(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Ci(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Di(a, b, c) {
    if (0 === ($c79bde28d689cb05$var$Rh & 21)) return a.baseState && (a.baseState = !1, $c79bde28d689cb05$var$Ug = !0), a.memoizedState = c;
    $c79bde28d689cb05$var$He(c, b) || (c = $c79bde28d689cb05$var$yc(), $c79bde28d689cb05$var$N.lanes |= c, $c79bde28d689cb05$var$hh |= c, a.baseState = !0);
    return b;
}
function $c79bde28d689cb05$var$Ei(a, b) {
    var c = $c79bde28d689cb05$var$C;
    $c79bde28d689cb05$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c79bde28d689cb05$var$Qh.transition;
    $c79bde28d689cb05$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$Qh.transition = d;
    }
}
function $c79bde28d689cb05$var$Fi() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$Gi(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, c);
    else if (c = $c79bde28d689cb05$var$Yg(a, b, c, d), null !== c) {
        var e = $c79bde28d689cb05$var$L();
        $c79bde28d689cb05$var$mh(c, a, d, e);
        $c79bde28d689cb05$var$Ji(c, b, d);
    }
}
function $c79bde28d689cb05$var$ri(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c79bde28d689cb05$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c79bde28d689cb05$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c79bde28d689cb05$var$Yg(a, b, e, d);
        null !== c && (e = $c79bde28d689cb05$var$L(), $c79bde28d689cb05$var$mh(c, a, d, e), $c79bde28d689cb05$var$Ji(c, b, d));
    }
}
function $c79bde28d689cb05$var$Hi(a) {
    var b = a.alternate;
    return a === $c79bde28d689cb05$var$N || null !== b && b === $c79bde28d689cb05$var$N;
}
function $c79bde28d689cb05$var$Ii(a, b) {
    $c79bde28d689cb05$var$Th = $c79bde28d689cb05$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c79bde28d689cb05$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
var $c79bde28d689cb05$var$ai = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Q,
    useContext: $c79bde28d689cb05$var$Q,
    useEffect: $c79bde28d689cb05$var$Q,
    useImperativeHandle: $c79bde28d689cb05$var$Q,
    useInsertionEffect: $c79bde28d689cb05$var$Q,
    useLayoutEffect: $c79bde28d689cb05$var$Q,
    useMemo: $c79bde28d689cb05$var$Q,
    useReducer: $c79bde28d689cb05$var$Q,
    useRef: $c79bde28d689cb05$var$Q,
    useState: $c79bde28d689cb05$var$Q,
    useDebugValue: $c79bde28d689cb05$var$Q,
    useDeferredValue: $c79bde28d689cb05$var$Q,
    useTransition: $c79bde28d689cb05$var$Q,
    useMutableSource: $c79bde28d689cb05$var$Q,
    useSyncExternalStore: $c79bde28d689cb05$var$Q,
    useId: $c79bde28d689cb05$var$Q,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Yh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: function(a, b) {
        $c79bde28d689cb05$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c79bde28d689cb05$var$ti(4194308, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c79bde28d689cb05$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c79bde28d689cb05$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c79bde28d689cb05$var$Gi.bind(null, $c79bde28d689cb05$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c79bde28d689cb05$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c79bde28d689cb05$var$qi,
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        return $c79bde28d689cb05$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$qi(!1), b = a[0];
        a = $c79bde28d689cb05$var$Ei.bind(null, a[1]);
        $c79bde28d689cb05$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $c79bde28d689cb05$var$N, e = $c79bde28d689cb05$var$ci();
        if ($c79bde28d689cb05$var$I) {
            if (void 0 === c) throw Error($c79bde28d689cb05$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
            0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c79bde28d689cb05$var$vi($c79bde28d689cb05$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $c79bde28d689cb05$var$ci(), b = $c79bde28d689cb05$var$R.identifierPrefix;
        if ($c79bde28d689cb05$var$I) {
            var c = $c79bde28d689cb05$var$sg;
            var d = $c79bde28d689cb05$var$rg;
            c = (d & ~(1 << 32 - $c79bde28d689cb05$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c79bde28d689cb05$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c79bde28d689cb05$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Zh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$fi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$$h = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$gi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return null === $c79bde28d689cb05$var$O ? b.memoizedState = a : $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
};
function $c79bde28d689cb05$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $c79bde28d689cb05$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c79bde28d689cb05$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c79bde28d689cb05$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c79bde28d689cb05$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $c79bde28d689cb05$var$Oi(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c79bde28d689cb05$var$Pi || ($c79bde28d689cb05$var$Pi = !0, $c79bde28d689cb05$var$Qi = d);
        $c79bde28d689cb05$var$Mi(a, b);
    };
    return c;
}
function $c79bde28d689cb05$var$Ri(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c79bde28d689cb05$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c79bde28d689cb05$var$Mi(a, b);
        "function" !== typeof d && (null === $c79bde28d689cb05$var$Si ? $c79bde28d689cb05$var$Si = new Set([
            this
        ]) : $c79bde28d689cb05$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $c79bde28d689cb05$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c79bde28d689cb05$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c79bde28d689cb05$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $c79bde28d689cb05$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c79bde28d689cb05$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c79bde28d689cb05$var$ch(-1, 1), b.tag = 2, $c79bde28d689cb05$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c79bde28d689cb05$var$Xi = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$Ug = !1;
function $c79bde28d689cb05$var$Yi(a, b, c, d) {
    b.child = null === a ? $c79bde28d689cb05$var$Ch(b, null, c, d) : $c79bde28d689cb05$var$Bh(b, a.child, c, d);
}
function $c79bde28d689cb05$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c79bde28d689cb05$var$Tg(b, e);
    d = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    c = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && c && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, d, e);
    return b.child;
}
function $c79bde28d689cb05$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c79bde28d689cb05$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c79bde28d689cb05$var$cj(a, b, f, d, e);
        a = $c79bde28d689cb05$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c79bde28d689cb05$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c79bde28d689cb05$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $c79bde28d689cb05$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c79bde28d689cb05$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c79bde28d689cb05$var$Ie(f, d) && a.ref === b.ref) {
            if ($c79bde28d689cb05$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c79bde28d689cb05$var$Ug = !0);
            else return b.lanes = a.lanes, $c79bde28d689cb05$var$$i(a, b, e);
        }
    }
    return $c79bde28d689cb05$var$dj(a, b, c, d, e);
}
function $c79bde28d689cb05$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj);
            $c79bde28d689cb05$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= d;
    $c79bde28d689cb05$var$Yi(a, b, e, c);
    return b.child;
}
function $c79bde28d689cb05$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c79bde28d689cb05$var$dj(a, b, c, d, e) {
    var f = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current;
    f = $c79bde28d689cb05$var$Yf(b, f);
    $c79bde28d689cb05$var$Tg(b, e);
    c = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    d = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && d && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, c, e);
    return b.child;
}
function $c79bde28d689cb05$var$ij(a, b, c, d, e) {
    if ($c79bde28d689cb05$var$Zf(c)) {
        var f = !0;
        $c79bde28d689cb05$var$cg(b);
    } else f = !1;
    $c79bde28d689cb05$var$Tg(b, e);
    if (null === b.stateNode) $c79bde28d689cb05$var$jj(a, b), $c79bde28d689cb05$var$ph(b, c, d), $c79bde28d689cb05$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c79bde28d689cb05$var$Vg(l) : (l = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, l = $c79bde28d689cb05$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c79bde28d689cb05$var$qh(b, g, d, l);
        $c79bde28d689cb05$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof m && ($c79bde28d689cb05$var$kh(b, c, m, d), k = b.memoizedState), (h = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c79bde28d689cb05$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c79bde28d689cb05$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c79bde28d689cb05$var$Vg(k) : (k = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, k = $c79bde28d689cb05$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c79bde28d689cb05$var$qh(b, g, d, k);
        $c79bde28d689cb05$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof y && ($c79bde28d689cb05$var$kh(b, c, y, d), n = b.memoizedState), (l = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c79bde28d689cb05$var$kj(a, b, c, d, f, e);
}
function $c79bde28d689cb05$var$kj(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c79bde28d689cb05$var$dg(b, c, !1), $c79bde28d689cb05$var$$i(a, b, f);
    d = b.stateNode;
    $c79bde28d689cb05$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c79bde28d689cb05$var$Bh(b, a.child, null, f), b.child = $c79bde28d689cb05$var$Bh(b, null, h, f)) : $c79bde28d689cb05$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c79bde28d689cb05$var$dg(b, c, !0);
    return b.child;
}
function $c79bde28d689cb05$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c79bde28d689cb05$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c79bde28d689cb05$var$ag(a, b.context, !1);
    $c79bde28d689cb05$var$Ih(a, b.containerInfo);
}
function $c79bde28d689cb05$var$mj(a, b, c, d, e) {
    $c79bde28d689cb05$var$Ig();
    $c79bde28d689cb05$var$Jg(e);
    b.flags |= 256;
    $c79bde28d689cb05$var$Yi(a, b, c, d);
    return b.child;
}
var $c79bde28d689cb05$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c79bde28d689cb05$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c79bde28d689cb05$var$pj(a, b, c) {
    var d = b.pendingProps, e = $c79bde28d689cb05$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, e & 1);
    if (null === a) {
        $c79bde28d689cb05$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c79bde28d689cb05$var$qj(g, d, 0, null), a = $c79bde28d689cb05$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c79bde28d689cb05$var$oj(c), b.memoizedState = $c79bde28d689cb05$var$nj, a) : $c79bde28d689cb05$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c79bde28d689cb05$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c79bde28d689cb05$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c79bde28d689cb05$var$wh(h, f) : (f = $c79bde28d689cb05$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c79bde28d689cb05$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c79bde28d689cb05$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c79bde28d689cb05$var$rj(a, b) {
    b = $c79bde28d689cb05$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c79bde28d689cb05$var$tj(a, b, c, d) {
    null !== d && $c79bde28d689cb05$var$Jg(d);
    $c79bde28d689cb05$var$Bh(b, a.child, null, c);
    a = $c79bde28d689cb05$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c79bde28d689cb05$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(422))), $c79bde28d689cb05$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c79bde28d689cb05$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c79bde28d689cb05$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c79bde28d689cb05$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $c79bde28d689cb05$var$oj(g);
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c79bde28d689cb05$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c79bde28d689cb05$var$p(419));
        d = $c79bde28d689cb05$var$Li(f, d, void 0);
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c79bde28d689cb05$var$Ug || h) {
        d = $c79bde28d689cb05$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c79bde28d689cb05$var$Zg(a, e), $c79bde28d689cb05$var$mh(d, a, e, -1));
        }
        $c79bde28d689cb05$var$uj();
        d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(421)));
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c79bde28d689cb05$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(e.nextSibling);
    $c79bde28d689cb05$var$xg = b;
    $c79bde28d689cb05$var$I = !0;
    $c79bde28d689cb05$var$zg = null;
    null !== a && ($c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg, $c79bde28d689cb05$var$rg = a.id, $c79bde28d689cb05$var$sg = a.overflow, $c79bde28d689cb05$var$qg = b);
    b = $c79bde28d689cb05$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c79bde28d689cb05$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c79bde28d689cb05$var$Sg(a.return, b, c);
}
function $c79bde28d689cb05$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c79bde28d689cb05$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c79bde28d689cb05$var$Yi(a, b, d.children, c);
    d = $c79bde28d689cb05$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c79bde28d689cb05$var$wj(a, c, b);
            else if (19 === a.tag) $c79bde28d689cb05$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c79bde28d689cb05$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c79bde28d689cb05$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c79bde28d689cb05$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c79bde28d689cb05$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $c79bde28d689cb05$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c79bde28d689cb05$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c79bde28d689cb05$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c79bde28d689cb05$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c79bde28d689cb05$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c79bde28d689cb05$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $c79bde28d689cb05$var$lj(b);
            $c79bde28d689cb05$var$Ig();
            break;
        case 5:
            $c79bde28d689cb05$var$Kh(b);
            break;
        case 1:
            $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$cg(b);
            break;
        case 4:
            $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c79bde28d689cb05$var$pj(a, b, c);
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
                a = $c79bde28d689cb05$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c79bde28d689cb05$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c79bde28d689cb05$var$ej(a, b, c);
    }
    return $c79bde28d689cb05$var$$i(a, b, c);
}
var $c79bde28d689cb05$var$Aj, $c79bde28d689cb05$var$Bj, $c79bde28d689cb05$var$Cj, $c79bde28d689cb05$var$Dj;
$c79bde28d689cb05$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c79bde28d689cb05$var$Bj = function() {};
$c79bde28d689cb05$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c79bde28d689cb05$var$Ya(a, e);
                d = $c79bde28d689cb05$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c79bde28d689cb05$var$A({}, e, {
                    value: void 0
                });
                d = $c79bde28d689cb05$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c79bde28d689cb05$var$gb(a, e);
                d = $c79bde28d689cb05$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
        }
        $c79bde28d689cb05$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c79bde28d689cb05$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c79bde28d689cb05$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c79bde28d689cb05$var$Ej(a, b) {
    if (!$c79bde28d689cb05$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c79bde28d689cb05$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c79bde28d689cb05$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c79bde28d689cb05$var$S(b), null;
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c79bde28d689cb05$var$Jh();
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
            $c79bde28d689cb05$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c79bde28d689cb05$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null));
            $c79bde28d689cb05$var$Bj(a, b);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 5:
            $c79bde28d689cb05$var$Lh(b);
            var e = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c79bde28d689cb05$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                    $c79bde28d689cb05$var$S(b);
                    return null;
                }
                a = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    d[$c79bde28d689cb05$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c79bde28d689cb05$var$D("cancel", d);
                            $c79bde28d689cb05$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], d);
                            break;
                        case "source":
                            $c79bde28d689cb05$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c79bde28d689cb05$var$D("error", d);
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "details":
                            $c79bde28d689cb05$var$D("toggle", d);
                            break;
                        case "input":
                            $c79bde28d689cb05$var$Za(d, f);
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$hb(d, f), $c79bde28d689cb05$var$D("invalid", d);
                    }
                    $c79bde28d689cb05$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c79bde28d689cb05$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c79bde28d689cb05$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c79bde28d689cb05$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c79bde28d689cb05$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c79bde28d689cb05$var$Of] = b;
                    a[$c79bde28d689cb05$var$Pf] = d;
                    $c79bde28d689cb05$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c79bde28d689cb05$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c79bde28d689cb05$var$D("cancel", a);
                                $c79bde28d689cb05$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c79bde28d689cb05$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c79bde28d689cb05$var$D("error", a);
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c79bde28d689cb05$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c79bde28d689cb05$var$Za(a, d);
                                e = $c79bde28d689cb05$var$Ya(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c79bde28d689cb05$var$A({}, d, {
                                    value: void 0
                                });
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$hb(a, d);
                                e = $c79bde28d689cb05$var$gb(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c79bde28d689cb05$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c79bde28d689cb05$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c79bde28d689cb05$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c79bde28d689cb05$var$ob(a, k) : "number" === typeof k && $c79bde28d689cb05$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c79bde28d689cb05$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c79bde28d689cb05$var$D("scroll", a) : null != k && $c79bde28d689cb05$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c79bde28d689cb05$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c79bde28d689cb05$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c79bde28d689cb05$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c79bde28d689cb05$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                c = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
                $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c79bde28d689cb05$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c79bde28d689cb05$var$Of] = b, b.stateNode = d;
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c79bde28d689cb05$var$I && null !== $c79bde28d689cb05$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c79bde28d689cb05$var$Hg(), $c79bde28d689cb05$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c79bde28d689cb05$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c79bde28d689cb05$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c79bde28d689cb05$var$p(317));
                        f[$c79bde28d689cb05$var$Of] = b;
                    } else $c79bde28d689cb05$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c79bde28d689cb05$var$S(b);
                    f = !1;
                } else null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c79bde28d689cb05$var$M.current & 1) ? 0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 3) : $c79bde28d689cb05$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$Bj(a, b), null === a && $c79bde28d689cb05$var$sf(b.stateNode.containerInfo), $c79bde28d689cb05$var$S(b), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), $c79bde28d689cb05$var$S(b), null;
        case 17:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 19:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            f = b.memoizedState;
            if (null === f) return $c79bde28d689cb05$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c79bde28d689cb05$var$Ej(f, !1);
                else {
                    if (0 !== $c79bde28d689cb05$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c79bde28d689cb05$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c79bde28d689cb05$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c79bde28d689cb05$var$B() > $c79bde28d689cb05$var$Hj && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c79bde28d689cb05$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c79bde28d689cb05$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$S(b), null;
                    } else 2 * $c79bde28d689cb05$var$B() - f.renderingStartTime > $c79bde28d689cb05$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c79bde28d689cb05$var$B(), b.sibling = null, c = $c79bde28d689cb05$var$M.current, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d ? c & 1 | 2 : c & 1), b;
            $c79bde28d689cb05$var$S(b);
            return null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c79bde28d689cb05$var$gj & 1073741824) && ($c79bde28d689cb05$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c79bde28d689cb05$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
}
function $c79bde28d689cb05$var$Jj(a, b) {
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c79bde28d689cb05$var$Lh(b), null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c79bde28d689cb05$var$p(340));
                $c79bde28d689cb05$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M), null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$Kj = !1, $c79bde28d689cb05$var$U = !1, $c79bde28d689cb05$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $c79bde28d689cb05$var$V = null;
function $c79bde28d689cb05$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c79bde28d689cb05$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c79bde28d689cb05$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c79bde28d689cb05$var$W(a, b, d);
    }
}
var $c79bde28d689cb05$var$Oj = !1;
function $c79bde28d689cb05$var$Pj(a, b) {
    $c79bde28d689cb05$var$Cf = $c79bde28d689cb05$var$dd;
    a = $c79bde28d689cb05$var$Me();
    if ($c79bde28d689cb05$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c79bde28d689cb05$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c79bde28d689cb05$var$dd = !1;
    for($c79bde28d689cb05$var$V = b; null !== $c79bde28d689cb05$var$V;)if (b = $c79bde28d689cb05$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c79bde28d689cb05$var$V = a;
    else for(; null !== $c79bde28d689cb05$var$V;){
        b = $c79bde28d689cb05$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c79bde28d689cb05$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(163));
            }
        } catch (F) {
            $c79bde28d689cb05$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c79bde28d689cb05$var$V = a;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
    n = $c79bde28d689cb05$var$Oj;
    $c79bde28d689cb05$var$Oj = !1;
    return n;
}
function $c79bde28d689cb05$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c79bde28d689cb05$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c79bde28d689cb05$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c79bde28d689cb05$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c79bde28d689cb05$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c79bde28d689cb05$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c79bde28d689cb05$var$Of], delete b[$c79bde28d689cb05$var$Pf], delete b[$c79bde28d689cb05$var$of], delete b[$c79bde28d689cb05$var$Qf], delete b[$c79bde28d689cb05$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c79bde28d689cb05$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c79bde28d689cb05$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c79bde28d689cb05$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c79bde28d689cb05$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c79bde28d689cb05$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling;
}
function $c79bde28d689cb05$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling;
}
var $c79bde28d689cb05$var$X = null, $c79bde28d689cb05$var$Yj = !1;
function $c79bde28d689cb05$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$c79bde28d689cb05$var$ak(a, b, c), c = c.sibling;
}
function $c79bde28d689cb05$var$ak(a, b, c) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberUnmount) try {
        $c79bde28d689cb05$var$lc.onCommitFiberUnmount($c79bde28d689cb05$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Mj(c, b);
        case 6:
            var d = $c79bde28d689cb05$var$X, e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c79bde28d689cb05$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? $c79bde28d689cb05$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c79bde28d689cb05$var$Kf(a, c), $c79bde28d689cb05$var$bd(a)) : $c79bde28d689cb05$var$Kf($c79bde28d689cb05$var$X, c.stateNode));
            break;
        case 4:
            d = $c79bde28d689cb05$var$X;
            e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = c.stateNode.containerInfo;
            $c79bde28d689cb05$var$Yj = !0;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c79bde28d689cb05$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c79bde28d689cb05$var$Nj(c, b, g) : 0 !== (f & 4) && $c79bde28d689cb05$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 1:
            if (!$c79bde28d689cb05$var$U && ($c79bde28d689cb05$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c79bde28d689cb05$var$W(c, b, h);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 21:
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c79bde28d689cb05$var$U = (d = $c79bde28d689cb05$var$U) || null !== c.memoizedState, $c79bde28d689cb05$var$Zj(a, b, c), $c79bde28d689cb05$var$U = d) : $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        default:
            $c79bde28d689cb05$var$Zj(a, b, c);
    }
}
function $c79bde28d689cb05$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c79bde28d689cb05$var$Lj);
        b.forEach(function(b) {
            var d = $c79bde28d689cb05$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c79bde28d689cb05$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c79bde28d689cb05$var$X = h.stateNode;
                        $c79bde28d689cb05$var$Yj = !1;
                        break a;
                    case 3:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                    case 4:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c79bde28d689cb05$var$X) throw Error($c79bde28d689cb05$var$p(160));
            $c79bde28d689cb05$var$ak(f, g, e);
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c79bde28d689cb05$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c79bde28d689cb05$var$ek(b, a), b = b.sibling;
}
function $c79bde28d689cb05$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                try {
                    $c79bde28d689cb05$var$Qj(3, a, a.return), $c79bde28d689cb05$var$Rj(3, a);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
                try {
                    $c79bde28d689cb05$var$Qj(5, a, a.return);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            break;
        case 5:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c79bde28d689cb05$var$ob(e, "");
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c79bde28d689cb05$var$ab(e, f);
                    $c79bde28d689cb05$var$vb(h, g);
                    var l = $c79bde28d689cb05$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c79bde28d689cb05$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c79bde28d689cb05$var$nb(e, q) : "children" === m ? $c79bde28d689cb05$var$ob(e, q) : $c79bde28d689cb05$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c79bde28d689cb05$var$bb(e, f);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c79bde28d689cb05$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c79bde28d689cb05$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c79bde28d689cb05$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c79bde28d689cb05$var$Pf] = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c79bde28d689cb05$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c79bde28d689cb05$var$bd(b.containerInfo);
            } catch (t) {
                $c79bde28d689cb05$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            break;
        case 13:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c79bde28d689cb05$var$gk = $c79bde28d689cb05$var$B()));
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c79bde28d689cb05$var$U = (l = $c79bde28d689cb05$var$U) || m, $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$U = l) : $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c79bde28d689cb05$var$V = a, m = a.child; null !== m;){
                    for(q = $c79bde28d689cb05$var$V = m; null !== $c79bde28d689cb05$var$V;){
                        r = $c79bde28d689cb05$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c79bde28d689cb05$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c79bde28d689cb05$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c79bde28d689cb05$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c79bde28d689cb05$var$V = y) : $c79bde28d689cb05$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c79bde28d689cb05$var$rb("display", g));
                            } catch (t) {
                                $c79bde28d689cb05$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c79bde28d689cb05$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 21:
            break;
        default:
            $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$fk(a);
    }
}
function $c79bde28d689cb05$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c79bde28d689cb05$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c79bde28d689cb05$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c79bde28d689cb05$var$ob(e, ""), d.flags &= -33);
                    var f = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(161));
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c79bde28d689cb05$var$ik(a, b, c) {
    $c79bde28d689cb05$var$V = a;
    $c79bde28d689cb05$var$jk(a, b, c);
}
function $c79bde28d689cb05$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c79bde28d689cb05$var$V;){
        var e = $c79bde28d689cb05$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c79bde28d689cb05$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c79bde28d689cb05$var$U;
                h = $c79bde28d689cb05$var$Kj;
                var l = $c79bde28d689cb05$var$U;
                $c79bde28d689cb05$var$Kj = g;
                if (($c79bde28d689cb05$var$U = k) && !l) for($c79bde28d689cb05$var$V = e; null !== $c79bde28d689cb05$var$V;)g = $c79bde28d689cb05$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c79bde28d689cb05$var$kk(e) : null !== k ? (k.return = g, $c79bde28d689cb05$var$V = k) : $c79bde28d689cb05$var$kk(e);
                for(; null !== f;)$c79bde28d689cb05$var$V = f, $c79bde28d689cb05$var$jk(f, b, c), f = f.sibling;
                $c79bde28d689cb05$var$V = e;
                $c79bde28d689cb05$var$Kj = h;
                $c79bde28d689cb05$var$U = l;
            }
            $c79bde28d689cb05$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c79bde28d689cb05$var$V = f) : $c79bde28d689cb05$var$lk(a, b, c);
    }
}
function $c79bde28d689cb05$var$lk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c79bde28d689cb05$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c79bde28d689cb05$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c79bde28d689cb05$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c79bde28d689cb05$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c79bde28d689cb05$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c79bde28d689cb05$var$p(163));
                }
                $c79bde28d689cb05$var$U || b.flags & 512 && $c79bde28d689cb05$var$Sj(b);
            } catch (r) {
                $c79bde28d689cb05$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$hk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$kk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c79bde28d689cb05$var$Rj(4, b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c79bde28d689cb05$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(b, b.return, k);
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c79bde28d689cb05$var$V = h;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
var $c79bde28d689cb05$var$mk = Math.ceil, $c79bde28d689cb05$var$nk = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$ok = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$pk = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$K = 0, $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Y = null, $c79bde28d689cb05$var$Z = 0, $c79bde28d689cb05$var$gj = 0, $c79bde28d689cb05$var$fj = $c79bde28d689cb05$var$Uf(0), $c79bde28d689cb05$var$T = 0, $c79bde28d689cb05$var$qk = null, $c79bde28d689cb05$var$hh = 0, $c79bde28d689cb05$var$rk = 0, $c79bde28d689cb05$var$sk = 0, $c79bde28d689cb05$var$tk = null, $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$gk = 0, $c79bde28d689cb05$var$Hj = Infinity, $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Pi = !1, $c79bde28d689cb05$var$Qi = null, $c79bde28d689cb05$var$Si = null, $c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = null, $c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, $c79bde28d689cb05$var$Bk = -1, $c79bde28d689cb05$var$Ck = 0;
function $c79bde28d689cb05$var$L() {
    return 0 !== ($c79bde28d689cb05$var$K & 6) ? $c79bde28d689cb05$var$B() : -1 !== $c79bde28d689cb05$var$Bk ? $c79bde28d689cb05$var$Bk : $c79bde28d689cb05$var$Bk = $c79bde28d689cb05$var$B();
}
function $c79bde28d689cb05$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c79bde28d689cb05$var$K & 2) && 0 !== $c79bde28d689cb05$var$Z) return $c79bde28d689cb05$var$Z & -$c79bde28d689cb05$var$Z;
    if (null !== $c79bde28d689cb05$var$Kg.transition) return 0 === $c79bde28d689cb05$var$Ck && ($c79bde28d689cb05$var$Ck = $c79bde28d689cb05$var$yc()), $c79bde28d689cb05$var$Ck;
    a = $c79bde28d689cb05$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c79bde28d689cb05$var$jd(a.type);
    return a;
}
function $c79bde28d689cb05$var$mh(a, b, c, d) {
    if (50 < $c79bde28d689cb05$var$zk) throw $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, Error($c79bde28d689cb05$var$p(185));
    $c79bde28d689cb05$var$Ac(a, c, d);
    if (0 === ($c79bde28d689cb05$var$K & 2) || a !== $c79bde28d689cb05$var$R) a === $c79bde28d689cb05$var$R && (0 === ($c79bde28d689cb05$var$K & 2) && ($c79bde28d689cb05$var$rk |= c), 4 === $c79bde28d689cb05$var$T && $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$Z)), $c79bde28d689cb05$var$Ek(a, d), 1 === c && 0 === $c79bde28d689cb05$var$K && 0 === (b.mode & 1) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
}
function $c79bde28d689cb05$var$Ek(a, b) {
    var c = a.callbackNode;
    $c79bde28d689cb05$var$wc(a, b);
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) null !== c && $c79bde28d689cb05$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c79bde28d689cb05$var$bc(c);
        if (1 === b) 0 === a.tag ? $c79bde28d689cb05$var$ig($c79bde28d689cb05$var$Fk.bind(null, a)) : $c79bde28d689cb05$var$hg($c79bde28d689cb05$var$Fk.bind(null, a)), $c79bde28d689cb05$var$Jf(function() {
            0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
        }), c = null;
        else {
            switch($c79bde28d689cb05$var$Dc(d)){
                case 1:
                    c = $c79bde28d689cb05$var$fc;
                    break;
                case 4:
                    c = $c79bde28d689cb05$var$gc;
                    break;
                case 16:
                    c = $c79bde28d689cb05$var$hc;
                    break;
                case 536870912:
                    c = $c79bde28d689cb05$var$jc;
                    break;
                default:
                    c = $c79bde28d689cb05$var$hc;
            }
            c = $c79bde28d689cb05$var$Gk(c, $c79bde28d689cb05$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c79bde28d689cb05$var$Hk(a, b) {
    $c79bde28d689cb05$var$Bk = -1;
    $c79bde28d689cb05$var$Ck = 0;
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    var c = a.callbackNode;
    if ($c79bde28d689cb05$var$Ik() && a.callbackNode !== c) return null;
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c79bde28d689cb05$var$Jk(a, d);
    else {
        b = d;
        var e = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 2;
        var f = $c79bde28d689cb05$var$Kk();
        if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$Lk(a, b);
        for(;;)try {
            $c79bde28d689cb05$var$Mk();
            break;
        } catch (h) {
            $c79bde28d689cb05$var$Nk(a, h);
        }
        $c79bde28d689cb05$var$Qg();
        $c79bde28d689cb05$var$nk.current = f;
        $c79bde28d689cb05$var$K = e;
        null !== $c79bde28d689cb05$var$Y ? b = 0 : ($c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0, b = $c79bde28d689cb05$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c79bde28d689cb05$var$xc(a), 0 !== e && (d = e, b = $c79bde28d689cb05$var$Ok(a, e)));
        if (1 === b) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
        if (6 === b) $c79bde28d689cb05$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c79bde28d689cb05$var$Pk(e) && (b = $c79bde28d689cb05$var$Jk(a, d), 2 === b && (f = $c79bde28d689cb05$var$xc(a), 0 !== f && (d = f, b = $c79bde28d689cb05$var$Ok(a, f))), 1 === b)) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c79bde28d689cb05$var$p(345));
                case 2:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 3:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $c79bde28d689cb05$var$gk + 500 - $c79bde28d689cb05$var$B(), 10 < b)) {
                        if (0 !== $c79bde28d689cb05$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c79bde28d689cb05$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), b);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 4:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c79bde28d689cb05$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c79bde28d689cb05$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c79bde28d689cb05$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), d);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 5:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(329));
            }
        }
    }
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return a.callbackNode === c ? $c79bde28d689cb05$var$Hk.bind(null, a) : null;
}
function $c79bde28d689cb05$var$Ok(a, b) {
    var c = $c79bde28d689cb05$var$tk;
    a.current.memoizedState.isDehydrated && ($c79bde28d689cb05$var$Lk(a, b).flags |= 256);
    a = $c79bde28d689cb05$var$Jk(a, b);
    2 !== a && (b = $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$uk = c, null !== b && $c79bde28d689cb05$var$Gj(b));
    return a;
}
function $c79bde28d689cb05$var$Gj(a) {
    null === $c79bde28d689cb05$var$uk ? $c79bde28d689cb05$var$uk = a : $c79bde28d689cb05$var$uk.push.apply($c79bde28d689cb05$var$uk, a);
}
function $c79bde28d689cb05$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c79bde28d689cb05$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c79bde28d689cb05$var$Dk(a, b) {
    b &= ~$c79bde28d689cb05$var$sk;
    b &= ~$c79bde28d689cb05$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c79bde28d689cb05$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c79bde28d689cb05$var$Fk(a) {
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$uc(a, 0);
    if (0 === (b & 1)) return $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), null;
    var c = $c79bde28d689cb05$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c79bde28d689cb05$var$xc(a);
        0 !== d && (b = d, c = $c79bde28d689cb05$var$Ok(a, d));
    }
    if (1 === c) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, b), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
    if (6 === c) throw Error($c79bde28d689cb05$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return null;
}
function $c79bde28d689cb05$var$Rk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c79bde28d689cb05$var$K = c, 0 === $c79bde28d689cb05$var$K && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
    }
}
function $c79bde28d689cb05$var$Sk(a) {
    null !== $c79bde28d689cb05$var$xk && 0 === $c79bde28d689cb05$var$xk.tag && 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    var c = $c79bde28d689cb05$var$pk.transition, d = $c79bde28d689cb05$var$C;
    try {
        if ($c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, a) return a();
    } finally{
        $c79bde28d689cb05$var$C = d, $c79bde28d689cb05$var$pk.transition = c, $c79bde28d689cb05$var$K = b, 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
    }
}
function $c79bde28d689cb05$var$Ij() {
    $c79bde28d689cb05$var$gj = $c79bde28d689cb05$var$fj.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$fj);
}
function $c79bde28d689cb05$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c79bde28d689cb05$var$Gf(c));
    if (null !== $c79bde28d689cb05$var$Y) for(c = $c79bde28d689cb05$var$Y.return; null !== c;){
        var d = c;
        $c79bde28d689cb05$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c79bde28d689cb05$var$$f();
                break;
            case 3:
                $c79bde28d689cb05$var$Jh();
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
                $c79bde28d689cb05$var$Oh();
                break;
            case 5:
                $c79bde28d689cb05$var$Lh(d);
                break;
            case 4:
                $c79bde28d689cb05$var$Jh();
                break;
            case 13:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 19:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 10:
                $c79bde28d689cb05$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $c79bde28d689cb05$var$Ij();
        }
        c = c.return;
    }
    $c79bde28d689cb05$var$R = a;
    $c79bde28d689cb05$var$Y = a = $c79bde28d689cb05$var$wh(a.current, null);
    $c79bde28d689cb05$var$Z = $c79bde28d689cb05$var$gj = b;
    $c79bde28d689cb05$var$T = 0;
    $c79bde28d689cb05$var$qk = null;
    $c79bde28d689cb05$var$sk = $c79bde28d689cb05$var$rk = $c79bde28d689cb05$var$hh = 0;
    $c79bde28d689cb05$var$uk = $c79bde28d689cb05$var$tk = null;
    if (null !== $c79bde28d689cb05$var$Wg) {
        for(b = 0; b < $c79bde28d689cb05$var$Wg.length; b++)if (c = $c79bde28d689cb05$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c79bde28d689cb05$var$Wg = null;
    }
    return a;
}
function $c79bde28d689cb05$var$Nk(a, b) {
    do {
        var c = $c79bde28d689cb05$var$Y;
        try {
            $c79bde28d689cb05$var$Qg();
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
            if ($c79bde28d689cb05$var$Sh) {
                for(var d = $c79bde28d689cb05$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c79bde28d689cb05$var$Sh = !1;
            }
            $c79bde28d689cb05$var$Rh = 0;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            $c79bde28d689cb05$var$ok.current = null;
            if (null === c || null === c.return) {
                $c79bde28d689cb05$var$T = 1;
                $c79bde28d689cb05$var$qk = b;
                $c79bde28d689cb05$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c79bde28d689cb05$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c79bde28d689cb05$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c79bde28d689cb05$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $c79bde28d689cb05$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c79bde28d689cb05$var$Ti(f, l, b);
                            $c79bde28d689cb05$var$uj();
                            break a;
                        }
                        k = Error($c79bde28d689cb05$var$p(426));
                    }
                } else if ($c79bde28d689cb05$var$I && h.mode & 1) {
                    var J = $c79bde28d689cb05$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c79bde28d689cb05$var$Wi(J, g, h, f, b);
                        $c79bde28d689cb05$var$Jg($c79bde28d689cb05$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $c79bde28d689cb05$var$Ki(k, h);
                4 !== $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 2);
                null === $c79bde28d689cb05$var$tk ? $c79bde28d689cb05$var$tk = [
                    f
                ] : $c79bde28d689cb05$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c79bde28d689cb05$var$Oi(f, k, b);
                            $c79bde28d689cb05$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c79bde28d689cb05$var$Ri(f, h, b);
                                $c79bde28d689cb05$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c79bde28d689cb05$var$Tk(c);
        } catch (na) {
            b = na;
            $c79bde28d689cb05$var$Y === c && null !== c && ($c79bde28d689cb05$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c79bde28d689cb05$var$Kk() {
    var a = $c79bde28d689cb05$var$nk.current;
    $c79bde28d689cb05$var$nk.current = $c79bde28d689cb05$var$ai;
    return null === a ? $c79bde28d689cb05$var$ai : a;
}
function $c79bde28d689cb05$var$uj() {
    if (0 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T || 2 === $c79bde28d689cb05$var$T) $c79bde28d689cb05$var$T = 4;
    null === $c79bde28d689cb05$var$R || 0 === ($c79bde28d689cb05$var$hh & 268435455) && 0 === ($c79bde28d689cb05$var$rk & 268435455) || $c79bde28d689cb05$var$Dk($c79bde28d689cb05$var$R, $c79bde28d689cb05$var$Z);
}
function $c79bde28d689cb05$var$Jk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 2;
    var d = $c79bde28d689cb05$var$Kk();
    if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Lk(a, b);
    for(;;)try {
        $c79bde28d689cb05$var$Uk();
        break;
    } catch (e) {
        $c79bde28d689cb05$var$Nk(a, e);
    }
    $c79bde28d689cb05$var$Qg();
    $c79bde28d689cb05$var$K = c;
    $c79bde28d689cb05$var$nk.current = d;
    if (null !== $c79bde28d689cb05$var$Y) throw Error($c79bde28d689cb05$var$p(261));
    $c79bde28d689cb05$var$R = null;
    $c79bde28d689cb05$var$Z = 0;
    return $c79bde28d689cb05$var$T;
}
function $c79bde28d689cb05$var$Uk() {
    for(; null !== $c79bde28d689cb05$var$Y;)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Mk() {
    for(; null !== $c79bde28d689cb05$var$Y && !$c79bde28d689cb05$var$cc();)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Vk(a) {
    var b = $c79bde28d689cb05$var$Wk(a.alternate, a, $c79bde28d689cb05$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c79bde28d689cb05$var$Tk(a) : $c79bde28d689cb05$var$Y = b;
    $c79bde28d689cb05$var$ok.current = null;
}
function $c79bde28d689cb05$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c79bde28d689cb05$var$Fj(c, b, $c79bde28d689cb05$var$gj), null !== c) {
                $c79bde28d689cb05$var$Y = c;
                return;
            }
        } else {
            c = $c79bde28d689cb05$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c79bde28d689cb05$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c79bde28d689cb05$var$T = 6;
                $c79bde28d689cb05$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c79bde28d689cb05$var$Y = b;
            return;
        }
        $c79bde28d689cb05$var$Y = b = a;
    }while (null !== b);
    0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 5);
}
function $c79bde28d689cb05$var$Qk(a, b, c) {
    var d = $c79bde28d689cb05$var$C, e = $c79bde28d689cb05$var$pk.transition;
    try {
        $c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$Xk(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$pk.transition = e, $c79bde28d689cb05$var$C = d;
    }
    return null;
}
function $c79bde28d689cb05$var$Xk(a, b, c, d) {
    do $c79bde28d689cb05$var$Ik();
    while (null !== $c79bde28d689cb05$var$xk);
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c79bde28d689cb05$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c79bde28d689cb05$var$Bc(a, f);
    a === $c79bde28d689cb05$var$R && ($c79bde28d689cb05$var$Y = $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c79bde28d689cb05$var$wk || ($c79bde28d689cb05$var$wk = !0, $c79bde28d689cb05$var$Gk($c79bde28d689cb05$var$hc, function() {
        $c79bde28d689cb05$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c79bde28d689cb05$var$pk.transition;
        $c79bde28d689cb05$var$pk.transition = null;
        var g = $c79bde28d689cb05$var$C;
        $c79bde28d689cb05$var$C = 1;
        var h = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 4;
        $c79bde28d689cb05$var$ok.current = null;
        $c79bde28d689cb05$var$Pj(a, c);
        $c79bde28d689cb05$var$ek(c, a);
        $c79bde28d689cb05$var$Oe($c79bde28d689cb05$var$Df);
        $c79bde28d689cb05$var$dd = !!$c79bde28d689cb05$var$Cf;
        $c79bde28d689cb05$var$Df = $c79bde28d689cb05$var$Cf = null;
        a.current = c;
        $c79bde28d689cb05$var$ik(c, a, e);
        $c79bde28d689cb05$var$dc();
        $c79bde28d689cb05$var$K = h;
        $c79bde28d689cb05$var$C = g;
        $c79bde28d689cb05$var$pk.transition = f;
    } else a.current = c;
    $c79bde28d689cb05$var$wk && ($c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = a, $c79bde28d689cb05$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($c79bde28d689cb05$var$Si = null);
    $c79bde28d689cb05$var$mc(c.stateNode, d);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c79bde28d689cb05$var$Pi) throw $c79bde28d689cb05$var$Pi = !1, a = $c79bde28d689cb05$var$Qi, $c79bde28d689cb05$var$Qi = null, a;
    0 !== ($c79bde28d689cb05$var$yk & 1) && 0 !== a.tag && $c79bde28d689cb05$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c79bde28d689cb05$var$Ak ? $c79bde28d689cb05$var$zk++ : ($c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = a) : $c79bde28d689cb05$var$zk = 0;
    $c79bde28d689cb05$var$jg();
    return null;
}
function $c79bde28d689cb05$var$Ik() {
    if (null !== $c79bde28d689cb05$var$xk) {
        var a = $c79bde28d689cb05$var$Dc($c79bde28d689cb05$var$yk), b = $c79bde28d689cb05$var$pk.transition, c = $c79bde28d689cb05$var$C;
        try {
            $c79bde28d689cb05$var$pk.transition = null;
            $c79bde28d689cb05$var$C = 16 > a ? 16 : a;
            if (null === $c79bde28d689cb05$var$xk) var d = !1;
            else {
                a = $c79bde28d689cb05$var$xk;
                $c79bde28d689cb05$var$xk = null;
                $c79bde28d689cb05$var$yk = 0;
                if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(331));
                var e = $c79bde28d689cb05$var$K;
                $c79bde28d689cb05$var$K |= 4;
                for($c79bde28d689cb05$var$V = a.current; null !== $c79bde28d689cb05$var$V;){
                    var f = $c79bde28d689cb05$var$V, g = f.child;
                    if (0 !== ($c79bde28d689cb05$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c79bde28d689cb05$var$V = l; null !== $c79bde28d689cb05$var$V;){
                                    var m = $c79bde28d689cb05$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c79bde28d689cb05$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c79bde28d689cb05$var$V = q;
                                    else for(; null !== $c79bde28d689cb05$var$V;){
                                        m = $c79bde28d689cb05$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c79bde28d689cb05$var$Tj(m);
                                        if (m === l) {
                                            $c79bde28d689cb05$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c79bde28d689cb05$var$V = r;
                                            break;
                                        }
                                        $c79bde28d689cb05$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c79bde28d689cb05$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c79bde28d689cb05$var$V = g;
                    else b: for(; null !== $c79bde28d689cb05$var$V;){
                        f = $c79bde28d689cb05$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c79bde28d689cb05$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c79bde28d689cb05$var$V = x;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c79bde28d689cb05$var$V = w; null !== $c79bde28d689cb05$var$V;){
                    g = $c79bde28d689cb05$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c79bde28d689cb05$var$V = u;
                    else b: for(g = w; null !== $c79bde28d689cb05$var$V;){
                        h = $c79bde28d689cb05$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c79bde28d689cb05$var$Rj(9, h);
                            }
                        } catch (na) {
                            $c79bde28d689cb05$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c79bde28d689cb05$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c79bde28d689cb05$var$V = F;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = h.return;
                    }
                }
                $c79bde28d689cb05$var$K = e;
                $c79bde28d689cb05$var$jg();
                if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onPostCommitFiberRoot) try {
                    $c79bde28d689cb05$var$lc.onPostCommitFiberRoot($c79bde28d689cb05$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$pk.transition = b;
        }
    }
    return !1;
}
function $c79bde28d689cb05$var$Yk(a, b, c) {
    b = $c79bde28d689cb05$var$Ki(c, b);
    b = $c79bde28d689cb05$var$Oi(a, b, 1);
    a = $c79bde28d689cb05$var$dh(a, b, 1);
    b = $c79bde28d689cb05$var$L();
    null !== a && ($c79bde28d689cb05$var$Ac(a, 1, b), $c79bde28d689cb05$var$Ek(a, b));
}
function $c79bde28d689cb05$var$W(a, b, c) {
    if (3 === a.tag) $c79bde28d689cb05$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c79bde28d689cb05$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(d))) {
                a = $c79bde28d689cb05$var$Ki(c, a);
                a = $c79bde28d689cb05$var$Ri(b, a, 1);
                b = $c79bde28d689cb05$var$dh(b, a, 1);
                a = $c79bde28d689cb05$var$L();
                null !== b && ($c79bde28d689cb05$var$Ac(b, 1, a), $c79bde28d689cb05$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c79bde28d689cb05$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c79bde28d689cb05$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $c79bde28d689cb05$var$R === a && ($c79bde28d689cb05$var$Z & c) === c && (4 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$Z & 130023424) === $c79bde28d689cb05$var$Z && 500 > $c79bde28d689cb05$var$B() - $c79bde28d689cb05$var$gk ? $c79bde28d689cb05$var$Lk(a, 0) : $c79bde28d689cb05$var$sk |= c);
    $c79bde28d689cb05$var$Ek(a, b);
}
function $c79bde28d689cb05$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c79bde28d689cb05$var$sc, $c79bde28d689cb05$var$sc <<= 1, 0 === ($c79bde28d689cb05$var$sc & 130023424) && ($c79bde28d689cb05$var$sc = 4194304)));
    var c = $c79bde28d689cb05$var$L();
    a = $c79bde28d689cb05$var$Zg(a, b);
    null !== a && ($c79bde28d689cb05$var$Ac(a, b, c), $c79bde28d689cb05$var$Ek(a, c));
}
function $c79bde28d689cb05$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c79bde28d689cb05$var$Zk(a, c);
}
function $c79bde28d689cb05$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c79bde28d689cb05$var$p(314));
    }
    null !== d && d.delete(b);
    $c79bde28d689cb05$var$Zk(a, c);
}
var $c79bde28d689cb05$var$Wk;
$c79bde28d689cb05$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c79bde28d689cb05$var$Wf.current) $c79bde28d689cb05$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$zj(a, b, c);
            $c79bde28d689cb05$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$I && 0 !== (b.flags & 1048576) && $c79bde28d689cb05$var$ug(b, $c79bde28d689cb05$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c79bde28d689cb05$var$jj(a, b);
            a = b.pendingProps;
            var e = $c79bde28d689cb05$var$Yf(b, $c79bde28d689cb05$var$H.current);
            $c79bde28d689cb05$var$Tg(b, c);
            e = $c79bde28d689cb05$var$Xh(null, b, d, a, e, c);
            var f = $c79bde28d689cb05$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c79bde28d689cb05$var$Zf(d) ? (f = !0, $c79bde28d689cb05$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c79bde28d689cb05$var$ah(b), e.updater = $c79bde28d689cb05$var$nh, b.stateNode = e, e._reactInternals = b, $c79bde28d689cb05$var$rh(b, d, a, c), b = $c79bde28d689cb05$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $c79bde28d689cb05$var$I && f && $c79bde28d689cb05$var$vg(b), $c79bde28d689cb05$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c79bde28d689cb05$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c79bde28d689cb05$var$$k(d);
                a = $c79bde28d689cb05$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $c79bde28d689cb05$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c79bde28d689cb05$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c79bde28d689cb05$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c79bde28d689cb05$var$aj(null, b, d, $c79bde28d689cb05$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($c79bde28d689cb05$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $c79bde28d689cb05$var$lj(b);
                if (null === a) throw Error($c79bde28d689cb05$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c79bde28d689cb05$var$bh(a, b);
                $c79bde28d689cb05$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(423)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(424)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else for($c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.stateNode.containerInfo.firstChild), $c79bde28d689cb05$var$xg = b, $c79bde28d689cb05$var$I = !0, $c79bde28d689cb05$var$zg = null, c = $c79bde28d689cb05$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c79bde28d689cb05$var$Ig();
                    if (d === e) {
                        b = $c79bde28d689cb05$var$$i(a, b, c);
                        break a;
                    }
                    $c79bde28d689cb05$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c79bde28d689cb05$var$Kh(b), null === a && $c79bde28d689cb05$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c79bde28d689cb05$var$Ef(d, e) ? g = null : null !== f && $c79bde28d689cb05$var$Ef(d, f) && (b.flags |= 32), $c79bde28d689cb05$var$hj(a, b), $c79bde28d689cb05$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $c79bde28d689cb05$var$Eg(b), null;
        case 13:
            return $c79bde28d689cb05$var$pj(a, b, c);
        case 4:
            return $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c79bde28d689cb05$var$Bh(b, null, d, c) : $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$Zi(a, b, d, e, c);
        case 7:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c79bde28d689cb05$var$He(f.value, g)) {
                        if (f.children === e.children && !$c79bde28d689cb05$var$Wf.current) {
                            b = $c79bde28d689cb05$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c79bde28d689cb05$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c79bde28d689cb05$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c79bde28d689cb05$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c79bde28d689cb05$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c79bde28d689cb05$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c79bde28d689cb05$var$Tg(b, c), e = $c79bde28d689cb05$var$Vg(e), d = d(e), b.flags |= 1, $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c79bde28d689cb05$var$Lg(d, b.pendingProps), e = $c79bde28d689cb05$var$Lg(d.type, e), $c79bde28d689cb05$var$aj(a, b, d, e, c);
        case 15:
            return $c79bde28d689cb05$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$jj(a, b), b.tag = 1, $c79bde28d689cb05$var$Zf(d) ? (a = !0, $c79bde28d689cb05$var$cg(b)) : a = !1, $c79bde28d689cb05$var$Tg(b, c), $c79bde28d689cb05$var$ph(b, d, e), $c79bde28d689cb05$var$rh(b, d, e, c), $c79bde28d689cb05$var$kj(null, b, d, !0, a, c);
        case 19:
            return $c79bde28d689cb05$var$yj(a, b, c);
        case 22:
            return $c79bde28d689cb05$var$ej(a, b, c);
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
};
function $c79bde28d689cb05$var$Gk(a, b) {
    return $c79bde28d689cb05$var$ac(a, b);
}
function $c79bde28d689cb05$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c79bde28d689cb05$var$Bg(a, b, c, d) {
    return new $c79bde28d689cb05$var$al(a, b, c, d);
}
function $c79bde28d689cb05$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c79bde28d689cb05$var$$k(a) {
    if ("function" === typeof a) return $c79bde28d689cb05$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c79bde28d689cb05$var$Da) return 11;
        if (a === $c79bde28d689cb05$var$Ga) return 14;
    }
    return 2;
}
function $c79bde28d689cb05$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $c79bde28d689cb05$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c79bde28d689cb05$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c79bde28d689cb05$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c79bde28d689cb05$var$ya:
            return $c79bde28d689cb05$var$Ah(c.children, e, f, b);
        case $c79bde28d689cb05$var$za:
            g = 8;
            e |= 8;
            break;
        case $c79bde28d689cb05$var$Aa:
            return a = $c79bde28d689cb05$var$Bg(12, c, b, e | 2), a.elementType = $c79bde28d689cb05$var$Aa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ea:
            return a = $c79bde28d689cb05$var$Bg(13, c, b, e), a.elementType = $c79bde28d689cb05$var$Ea, a.lanes = f, a;
        case $c79bde28d689cb05$var$Fa:
            return a = $c79bde28d689cb05$var$Bg(19, c, b, e), a.elementType = $c79bde28d689cb05$var$Fa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ia:
            return $c79bde28d689cb05$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c79bde28d689cb05$var$Ba:
                    g = 10;
                    break a;
                case $c79bde28d689cb05$var$Ca:
                    g = 9;
                    break a;
                case $c79bde28d689cb05$var$Da:
                    g = 11;
                    break a;
                case $c79bde28d689cb05$var$Ga:
                    g = 14;
                    break a;
                case $c79bde28d689cb05$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c79bde28d689cb05$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $c79bde28d689cb05$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c79bde28d689cb05$var$Ah(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$qj(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(22, a, d, b);
    a.elementType = $c79bde28d689cb05$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c79bde28d689cb05$var$xh(a, b, c) {
    a = $c79bde28d689cb05$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$zh(a, b, c) {
    b = $c79bde28d689cb05$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c79bde28d689cb05$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c79bde28d689cb05$var$zc(0);
    this.expirationTimes = $c79bde28d689cb05$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c79bde28d689cb05$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c79bde28d689cb05$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $c79bde28d689cb05$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c79bde28d689cb05$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c79bde28d689cb05$var$ah(f);
    return a;
}
function $c79bde28d689cb05$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c79bde28d689cb05$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c79bde28d689cb05$var$el(a) {
    if (!a) return $c79bde28d689cb05$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c79bde28d689cb05$var$Vb(a) !== a || 1 !== a.tag) throw Error($c79bde28d689cb05$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c79bde28d689cb05$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c79bde28d689cb05$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c79bde28d689cb05$var$Zf(c)) return $c79bde28d689cb05$var$bg(a, c, b);
    }
    return b;
}
function $c79bde28d689cb05$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $c79bde28d689cb05$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $c79bde28d689cb05$var$el(null);
    c = a.current;
    d = $c79bde28d689cb05$var$L();
    e = $c79bde28d689cb05$var$lh(c);
    f = $c79bde28d689cb05$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c79bde28d689cb05$var$dh(c, f, e);
    a.current.lanes = e;
    $c79bde28d689cb05$var$Ac(a, e, d);
    $c79bde28d689cb05$var$Ek(a, d);
    return a;
}
function $c79bde28d689cb05$var$gl(a, b, c, d) {
    var e = b.current, f = $c79bde28d689cb05$var$L(), g = $c79bde28d689cb05$var$lh(e);
    c = $c79bde28d689cb05$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c79bde28d689cb05$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c79bde28d689cb05$var$dh(e, b, g);
    null !== a && ($c79bde28d689cb05$var$mh(a, e, g, f), $c79bde28d689cb05$var$eh(a, e, g));
    return g;
}
function $c79bde28d689cb05$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c79bde28d689cb05$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c79bde28d689cb05$var$jl(a, b) {
    $c79bde28d689cb05$var$il(a, b);
    (a = a.alternate) && $c79bde28d689cb05$var$il(a, b);
}
function $c79bde28d689cb05$var$kl() {
    return null;
}
var $c79bde28d689cb05$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $c79bde28d689cb05$var$ml(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.render = $c79bde28d689cb05$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c79bde28d689cb05$var$p(409));
    $c79bde28d689cb05$var$gl(a, b, null, null);
};
$c79bde28d689cb05$var$nl.prototype.unmount = $c79bde28d689cb05$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c79bde28d689cb05$var$Sk(function() {
            $c79bde28d689cb05$var$gl(null, a, null, null);
        });
        b[$c79bde28d689cb05$var$uf] = null;
    }
};
function $c79bde28d689cb05$var$nl(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c79bde28d689cb05$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c79bde28d689cb05$var$Qc.length && 0 !== b && b < $c79bde28d689cb05$var$Qc[c].priority; c++);
        $c79bde28d689cb05$var$Qc.splice(c, 0, a);
        0 === c && $c79bde28d689cb05$var$Vc(a);
    }
};
function $c79bde28d689cb05$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c79bde28d689cb05$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c79bde28d689cb05$var$ql() {}
function $c79bde28d689cb05$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                f.call(a);
            };
        }
        var g = $c79bde28d689cb05$var$fl(b, d, a, 0, null, !1, !1, "", $c79bde28d689cb05$var$ql);
        a._reactRootContainer = g;
        a[$c79bde28d689cb05$var$uf] = g.current;
        $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c79bde28d689cb05$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $c79bde28d689cb05$var$hl(k);
            h.call(a);
        };
    }
    var k = $c79bde28d689cb05$var$cl(a, 0, !1, null, null, !1, !1, "", $c79bde28d689cb05$var$ql);
    a._reactRootContainer = k;
    a[$c79bde28d689cb05$var$uf] = k.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$gl(b, k, c, d);
    });
    return k;
}
function $c79bde28d689cb05$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                h.call(a);
            };
        }
        $c79bde28d689cb05$var$gl(b, g, a, e);
    } else g = $c79bde28d689cb05$var$rl(c, b, a, e, d);
    return $c79bde28d689cb05$var$hl(g);
}
$c79bde28d689cb05$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c79bde28d689cb05$var$tc(b.pendingLanes);
                0 !== c && ($c79bde28d689cb05$var$Cc(b, c | 1), $c79bde28d689cb05$var$Ek(b, $c79bde28d689cb05$var$B()), 0 === ($c79bde28d689cb05$var$K & 6) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$jg()));
            }
            break;
        case 13:
            $c79bde28d689cb05$var$Sk(function() {
                var b = $c79bde28d689cb05$var$Zg(a, 1);
                if (null !== b) {
                    var c = $c79bde28d689cb05$var$L();
                    $c79bde28d689cb05$var$mh(b, a, 1, c);
                }
            }), $c79bde28d689cb05$var$jl(a, 1);
    }
};
$c79bde28d689cb05$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(b, a, 134217728, c);
        }
        $c79bde28d689cb05$var$jl(a, 134217728);
    }
};
$c79bde28d689cb05$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$lh(a), c = $c79bde28d689cb05$var$Zg(a, b);
        if (null !== c) {
            var d = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(c, a, b, d);
        }
        $c79bde28d689cb05$var$jl(a, b);
    }
};
$c79bde28d689cb05$var$Hc = function() {
    return $c79bde28d689cb05$var$C;
};
$c79bde28d689cb05$var$Ic = function(a, b) {
    var c = $c79bde28d689cb05$var$C;
    try {
        return $c79bde28d689cb05$var$C = a, b();
    } finally{
        $c79bde28d689cb05$var$C = c;
    }
};
$c79bde28d689cb05$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $c79bde28d689cb05$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c79bde28d689cb05$var$Db(d);
                        if (!e) throw Error($c79bde28d689cb05$var$p(90));
                        $c79bde28d689cb05$var$Wa(d);
                        $c79bde28d689cb05$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c79bde28d689cb05$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c79bde28d689cb05$var$fb(a, !!c.multiple, b, !1);
    }
};
$c79bde28d689cb05$var$Gb = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$var$Hb = $c79bde28d689cb05$var$Sk;
var $c79bde28d689cb05$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $c79bde28d689cb05$var$Cb,
        $c79bde28d689cb05$var$ue,
        $c79bde28d689cb05$var$Db,
        $c79bde28d689cb05$var$Eb,
        $c79bde28d689cb05$var$Fb,
        $c79bde28d689cb05$var$Rk
    ]
}, $c79bde28d689cb05$var$ul = {
    findFiberByHostInstance: $c79bde28d689cb05$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $c79bde28d689cb05$var$vl = {
    bundleType: $c79bde28d689cb05$var$ul.bundleType,
    version: $c79bde28d689cb05$var$ul.version,
    rendererPackageName: $c79bde28d689cb05$var$ul.rendererPackageName,
    rendererConfig: $c79bde28d689cb05$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c79bde28d689cb05$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $c79bde28d689cb05$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c79bde28d689cb05$var$ul.findFiberByHostInstance || $c79bde28d689cb05$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c79bde28d689cb05$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c79bde28d689cb05$var$wl.isDisabled && $c79bde28d689cb05$var$wl.supportsFiber) try {
        $c79bde28d689cb05$var$kc = $c79bde28d689cb05$var$wl.inject($c79bde28d689cb05$var$vl), $c79bde28d689cb05$var$lc = $c79bde28d689cb05$var$wl;
    } catch (a) {}
}
$c79bde28d689cb05$export$ae55be85d98224ed = $c79bde28d689cb05$var$tl;
$c79bde28d689cb05$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c79bde28d689cb05$var$ol(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$dl(a, b, null, c);
};
$c79bde28d689cb05$export$882461b6382ed46c = function(a, b) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(299));
    var c = !1, d = "", e = $c79bde28d689cb05$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c79bde28d689cb05$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c79bde28d689cb05$var$ml(b);
};
$c79bde28d689cb05$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c79bde28d689cb05$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c79bde28d689cb05$var$p(268, a));
    }
    a = $c79bde28d689cb05$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c79bde28d689cb05$export$cd75ccfd720a3cd4 = function(a) {
    return $c79bde28d689cb05$var$Sk(a);
};
$c79bde28d689cb05$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !0, c);
};
$c79bde28d689cb05$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c79bde28d689cb05$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c79bde28d689cb05$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c79bde28d689cb05$var$nl(b);
};
$c79bde28d689cb05$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !1, c);
};
$c79bde28d689cb05$export$502457920280e6be = function(a) {
    if (!$c79bde28d689cb05$var$pl(a)) throw Error($c79bde28d689cb05$var$p(40));
    return a._reactRootContainer ? ($c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c79bde28d689cb05$var$uf] = null;
        });
    }), !0) : !1;
};
$c79bde28d689cb05$export$c78a37762a8d58e1 = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c79bde28d689cb05$var$pl(c)) throw Error($c79bde28d689cb05$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c79bde28d689cb05$var$p(38));
    return $c79bde28d689cb05$var$sl(a, b, c, !1, d);
};
$c79bde28d689cb05$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("ibqfJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dnqd8"));

});
parcelRegister("dnqd8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9bd1c1496009b220$export$c4744153514ff05d; }, function (v) { return $9bd1c1496009b220$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7; }, function (v) { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9bd1c1496009b220$export$e26fe2ed2fa76875; }, function (v) { return $9bd1c1496009b220$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9bd1c1496009b220$export$502329bbf4b505b1; }, function (v) { return $9bd1c1496009b220$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9bd1c1496009b220$export$6e3807111c4874c4; }, function (v) { return $9bd1c1496009b220$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9bd1c1496009b220$export$c27134553091fb3a; }, function (v) { return $9bd1c1496009b220$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9bd1c1496009b220$export$33ee1acdc04fd2a2; }, function (v) { return $9bd1c1496009b220$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9bd1c1496009b220$export$b00a404bbd5edef2; }, function (v) { return $9bd1c1496009b220$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9bd1c1496009b220$export$8352ce38b91d0c62; }, function (v) { return $9bd1c1496009b220$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9bd1c1496009b220$export$d66a1c1c77bd778b; }, function (v) { return $9bd1c1496009b220$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9bd1c1496009b220$export$d3dfb8e4810cb555; }, function (v) { return $9bd1c1496009b220$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9bd1c1496009b220$export$839f9183b0465a69; }, function (v) { return $9bd1c1496009b220$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9bd1c1496009b220$export$72fdf0e06517287b; }, function (v) { return $9bd1c1496009b220$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9bd1c1496009b220$export$4b844e58a3e414b4; }, function (v) { return $9bd1c1496009b220$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9bd1c1496009b220$export$816d2913ae6b83b1; }, function (v) { return $9bd1c1496009b220$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9bd1c1496009b220$export$61bcfe829111a1d0; }, function (v) { return $9bd1c1496009b220$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9bd1c1496009b220$export$7ee8c9beb337bc3f; }, function (v) { return $9bd1c1496009b220$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9bd1c1496009b220$export$b5836b71941fa3ed; }, function (v) { return $9bd1c1496009b220$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9bd1c1496009b220$export$cf845f2c119da08a; }, function (v) { return $9bd1c1496009b220$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9bd1c1496009b220$export$c4744153514ff05d;
var $9bd1c1496009b220$export$3e506c1ccc9cc1a7;
var $9bd1c1496009b220$export$e26fe2ed2fa76875;
var $9bd1c1496009b220$export$502329bbf4b505b1;
var $9bd1c1496009b220$export$6e3807111c4874c4;
var $9bd1c1496009b220$export$c27134553091fb3a;
var $9bd1c1496009b220$export$33ee1acdc04fd2a2;
var $9bd1c1496009b220$export$b00a404bbd5edef2;
var $9bd1c1496009b220$export$8352ce38b91d0c62;
var $9bd1c1496009b220$export$d66a1c1c77bd778b;
var $9bd1c1496009b220$export$d3dfb8e4810cb555;
var $9bd1c1496009b220$export$839f9183b0465a69;
var $9bd1c1496009b220$export$72fdf0e06517287b;
var $9bd1c1496009b220$export$4b844e58a3e414b4;
var $9bd1c1496009b220$export$816d2913ae6b83b1;
var $9bd1c1496009b220$export$61bcfe829111a1d0;
var $9bd1c1496009b220$export$7ee8c9beb337bc3f;
var $9bd1c1496009b220$export$b5836b71941fa3ed;
var $9bd1c1496009b220$export$cf845f2c119da08a;
"use strict";
function $9bd1c1496009b220$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9bd1c1496009b220$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9bd1c1496009b220$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9bd1c1496009b220$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9bd1c1496009b220$var$g(C, c)) n < e && 0 > $9bd1c1496009b220$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9bd1c1496009b220$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9bd1c1496009b220$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9bd1c1496009b220$var$l = performance;
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$l.now();
    };
} else {
    var $9bd1c1496009b220$var$p = Date, $9bd1c1496009b220$var$q = $9bd1c1496009b220$var$p.now();
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$p.now() - $9bd1c1496009b220$var$q;
    };
}
var $9bd1c1496009b220$var$r = [], $9bd1c1496009b220$var$t = [], $9bd1c1496009b220$var$u = 1, $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = 3, $9bd1c1496009b220$var$z = !1, $9bd1c1496009b220$var$A = !1, $9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$D = "function" === typeof setTimeout ? setTimeout : null, $9bd1c1496009b220$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9bd1c1496009b220$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9bd1c1496009b220$var$G(a) {
    for(var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t); null !== b;){
        if (null === b.callback) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t);
        else if (b.startTime <= a) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t), b.sortIndex = b.expirationTime, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, b);
        else break;
        b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
    }
}
function $9bd1c1496009b220$var$H(a) {
    $9bd1c1496009b220$var$B = !1;
    $9bd1c1496009b220$var$G(a);
    if (!$9bd1c1496009b220$var$A) {
        if (null !== $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r)) $9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J);
        else {
            var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== b && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, b.startTime - a);
        }
    }
}
function $9bd1c1496009b220$var$J(a, b) {
    $9bd1c1496009b220$var$A = !1;
    $9bd1c1496009b220$var$B && ($9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1);
    $9bd1c1496009b220$var$z = !0;
    var c = $9bd1c1496009b220$var$y;
    try {
        $9bd1c1496009b220$var$G(b);
        for($9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r); null !== $9bd1c1496009b220$var$v && (!($9bd1c1496009b220$var$v.expirationTime > b) || a && !$9bd1c1496009b220$var$M());){
            var d = $9bd1c1496009b220$var$v.callback;
            if ("function" === typeof d) {
                $9bd1c1496009b220$var$v.callback = null;
                $9bd1c1496009b220$var$y = $9bd1c1496009b220$var$v.priorityLevel;
                var e = d($9bd1c1496009b220$var$v.expirationTime <= b);
                b = $9bd1c1496009b220$export$c4744153514ff05d();
                "function" === typeof e ? $9bd1c1496009b220$var$v.callback = e : $9bd1c1496009b220$var$v === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
                $9bd1c1496009b220$var$G(b);
            } else $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
            $9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
        }
        if (null !== $9bd1c1496009b220$var$v) var w = !0;
        else {
            var m = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== m && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = c, $9bd1c1496009b220$var$z = !1;
    }
}
var $9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null, $9bd1c1496009b220$var$L = -1, $9bd1c1496009b220$var$P = 5, $9bd1c1496009b220$var$Q = -1;
function $9bd1c1496009b220$var$M() {
    return $9bd1c1496009b220$export$c4744153514ff05d() - $9bd1c1496009b220$var$Q < $9bd1c1496009b220$var$P ? !1 : !0;
}
function $9bd1c1496009b220$var$R() {
    if (null !== $9bd1c1496009b220$var$O) {
        var a = $9bd1c1496009b220$export$c4744153514ff05d();
        $9bd1c1496009b220$var$Q = a;
        var b = !0;
        try {
            b = $9bd1c1496009b220$var$O(!0, a);
        } finally{
            b ? $9bd1c1496009b220$var$S() : ($9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null);
        }
    } else $9bd1c1496009b220$var$N = !1;
}
var $9bd1c1496009b220$var$S;
if ("function" === typeof $9bd1c1496009b220$var$F) $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$F($9bd1c1496009b220$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9bd1c1496009b220$var$T = new MessageChannel, $9bd1c1496009b220$var$U = $9bd1c1496009b220$var$T.port2;
    $9bd1c1496009b220$var$T.port1.onmessage = $9bd1c1496009b220$var$R;
    $9bd1c1496009b220$var$S = function() {
        $9bd1c1496009b220$var$U.postMessage(null);
    };
} else $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$D($9bd1c1496009b220$var$R, 0);
};
function $9bd1c1496009b220$var$I(a) {
    $9bd1c1496009b220$var$O = a;
    $9bd1c1496009b220$var$N || ($9bd1c1496009b220$var$N = !0, $9bd1c1496009b220$var$S());
}
function $9bd1c1496009b220$var$K(a, b) {
    $9bd1c1496009b220$var$L = $9bd1c1496009b220$var$D(function() {
        a($9bd1c1496009b220$export$c4744153514ff05d());
    }, b);
}
$9bd1c1496009b220$export$3e506c1ccc9cc1a7 = 5;
$9bd1c1496009b220$export$e26fe2ed2fa76875 = 1;
$9bd1c1496009b220$export$502329bbf4b505b1 = 4;
$9bd1c1496009b220$export$6e3807111c4874c4 = 3;
$9bd1c1496009b220$export$c27134553091fb3a = null;
$9bd1c1496009b220$export$33ee1acdc04fd2a2 = 2;
$9bd1c1496009b220$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9bd1c1496009b220$export$8352ce38b91d0c62 = function() {
    $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J));
};
$9bd1c1496009b220$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9bd1c1496009b220$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9bd1c1496009b220$export$d3dfb8e4810cb555 = function() {
    return $9bd1c1496009b220$var$y;
};
$9bd1c1496009b220$export$839f9183b0465a69 = function() {
    return $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
};
$9bd1c1496009b220$export$72fdf0e06517287b = function(a) {
    switch($9bd1c1496009b220$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9bd1c1496009b220$var$y;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = b;
    try {
        return a();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$4b844e58a3e414b4 = function() {};
$9bd1c1496009b220$export$816d2913ae6b83b1 = function() {};
$9bd1c1496009b220$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = a;
    try {
        return b();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9bd1c1496009b220$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9bd1c1496009b220$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$t, a), null === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && a === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t) && ($9bd1c1496009b220$var$B ? ($9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1) : $9bd1c1496009b220$var$B = !0, $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, c - d))) : (a.sortIndex = e, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, a), $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J)));
    return a;
};
$9bd1c1496009b220$export$b5836b71941fa3ed = $9bd1c1496009b220$var$M;
$9bd1c1496009b220$export$cf845f2c119da08a = function(a) {
    var b = $9bd1c1496009b220$var$y;
    return function() {
        var c = $9bd1c1496009b220$var$y;
        $9bd1c1496009b220$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9bd1c1496009b220$var$y = c;
        }
    };
};

});



parcelRegister("5Ab7O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4108f1be9398bcb3$export$2e2bcd8739ae039; });

var $1hzk8 = parcelRequire("1hzk8");
var $4108f1be9398bcb3$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $4108f1be9398bcb3$var$index = (0, $1hzk8.default)(function(prop) {
    return $4108f1be9398bcb3$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $4108f1be9398bcb3$export$2e2bcd8739ae039 = $4108f1be9398bcb3$var$index;

});
parcelRegister("1hzk8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ef2c7853016f282$export$2e2bcd8739ae039; });
function $0ef2c7853016f282$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $0ef2c7853016f282$export$2e2bcd8739ae039 = $0ef2c7853016f282$var$memoize;

});


parcelRegister("5NGut", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $43927d13b2c7fdbd$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $43927d13b2c7fdbd$export$2e2bcd8739ae039 = fn;

});

parcelRegister("eXtb5", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $ae3d3578c845e26a$export$bf730a2d8bf68b42; }, function (v) { return $ae3d3578c845e26a$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ae3d3578c845e26a$export$bf730a2d8bf68b42;
"use strict";

var $exYeM = parcelRequire("exYeM");

var $ePGDo = parcelRequire("ePGDo");
function $ae3d3578c845e26a$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $ae3d3578c845e26a$var$q = "function" === typeof Object.is ? Object.is : $ae3d3578c845e26a$var$p, $ae3d3578c845e26a$var$r = $ePGDo.useSyncExternalStore, $ae3d3578c845e26a$var$t = $exYeM.useRef, $ae3d3578c845e26a$var$u = $exYeM.useEffect, $ae3d3578c845e26a$var$v = $exYeM.useMemo, $ae3d3578c845e26a$var$w = $exYeM.useDebugValue;
$ae3d3578c845e26a$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $ae3d3578c845e26a$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $ae3d3578c845e26a$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($ae3d3578c845e26a$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $ae3d3578c845e26a$var$r(a, c[0], c[1]);
    $ae3d3578c845e26a$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $ae3d3578c845e26a$var$w(d);
    return d;
};

});
parcelRegister("ePGDo", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kvD72"));

});
parcelRegister("kvD72", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $eee50ad7e4fe08dc$export$306c0aa65ff9ec16; }, function (v) { return $eee50ad7e4fe08dc$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eee50ad7e4fe08dc$export$306c0aa65ff9ec16;
"use strict";

var $exYeM = parcelRequire("exYeM");
function $eee50ad7e4fe08dc$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $eee50ad7e4fe08dc$var$k = "function" === typeof Object.is ? Object.is : $eee50ad7e4fe08dc$var$h, $eee50ad7e4fe08dc$var$l = $exYeM.useState, $eee50ad7e4fe08dc$var$m = $exYeM.useEffect, $eee50ad7e4fe08dc$var$n = $exYeM.useLayoutEffect, $eee50ad7e4fe08dc$var$p = $exYeM.useDebugValue;
function $eee50ad7e4fe08dc$var$q(a, b) {
    var d = b(), f = $eee50ad7e4fe08dc$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $eee50ad7e4fe08dc$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $eee50ad7e4fe08dc$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $eee50ad7e4fe08dc$var$m(function() {
        $eee50ad7e4fe08dc$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $eee50ad7e4fe08dc$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $eee50ad7e4fe08dc$var$p(d);
    return d;
}
function $eee50ad7e4fe08dc$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$eee50ad7e4fe08dc$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $eee50ad7e4fe08dc$var$t(a, b) {
    return b();
}
var $eee50ad7e4fe08dc$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $eee50ad7e4fe08dc$var$t : $eee50ad7e4fe08dc$var$q;
$eee50ad7e4fe08dc$export$306c0aa65ff9ec16 = void 0 !== $exYeM.useSyncExternalStore ? $exYeM.useSyncExternalStore : $eee50ad7e4fe08dc$var$u;

});



parcelRegister("jpdgm", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $L7tyD = parcelRequire("L7tyD");
function $e20aa3d84dea372f$var$emptyFunction() {}
function $e20aa3d84dea372f$var$emptyFunctionWithReset() {}
$e20aa3d84dea372f$var$emptyFunctionWithReset.resetWarningCache = $e20aa3d84dea372f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $L7tyD) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $e20aa3d84dea372f$var$emptyFunctionWithReset,
        resetWarningCache: $e20aa3d84dea372f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("L7tyD", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $08da306d15728f79$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $08da306d15728f79$var$ReactPropTypesSecret;

});


var $7ead0b1397a835ed$exports = {};
"use strict";

$7ead0b1397a835ed$exports = (parcelRequire("6ObR8"));


var $7bd215913159ea08$export$882461b6382ed46c;
var $7bd215913159ea08$export$757ceba2d55c277e;
"use strict";
var $97dc602bd7e23afa$exports = {};
"use strict";
function $97dc602bd7e23afa$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($97dc602bd7e23afa$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$97dc602bd7e23afa$var$checkDCE();

$97dc602bd7e23afa$exports = (parcelRequire("h8vP0"));


var $7bd215913159ea08$var$i;
$7bd215913159ea08$export$882461b6382ed46c = $97dc602bd7e23afa$exports.createRoot;
$7bd215913159ea08$export$757ceba2d55c277e = $97dc602bd7e23afa$exports.hydrateRoot;



function $f2688159d9d799da$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $7176971acde7c738$var$MAX_ARRAY_LENGTH = 10;
const $7176971acde7c738$var$MAX_RECURSIVE_DEPTH = 2;
function $7176971acde7c738$export$9dec5d1b3b6a130d(value) {
    return $7176971acde7c738$var$formatValue(value, []);
}
function $7176971acde7c738$var$formatValue(value, seenValues) {
    switch(typeof value){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? `[function ${value.name}]` : "[function]";
        case "object":
            return $7176971acde7c738$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $7176971acde7c738$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($7176971acde7c738$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : $7176971acde7c738$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $7176971acde7c738$var$formatArray(value, seenValues);
    return $7176971acde7c738$var$formatObject(value, seenValues);
}
function $7176971acde7c738$var$isJSONable(value) {
    return typeof value.toJSON === "function";
}
function $7176971acde7c738$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > $7176971acde7c738$var$MAX_RECURSIVE_DEPTH) return "[" + $7176971acde7c738$var$getObjectTag(object) + "]";
    const properties = entries.map(([key, value])=>key + ": " + $7176971acde7c738$var$formatValue(value, seenValues));
    return "{ " + properties.join(", ") + " }";
}
function $7176971acde7c738$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $7176971acde7c738$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    const len = Math.min($7176971acde7c738$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($7176971acde7c738$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return "[" + items.join(", ") + "]";
}
function $7176971acde7c738$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        const name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $35e6840e87686935$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return "Location";
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $35e6840e87686935$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return "Token";
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $35e6840e87686935$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
const $35e6840e87686935$var$kindValues = new Set(Object.keys($35e6840e87686935$export$4fcd777a40ccf407));
function $35e6840e87686935$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === "string" && $35e6840e87686935$var$kindValues.has(maybeKind);
}
/** Name */ var $35e6840e87686935$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})($35e6840e87686935$export$f58c50edb4aef9d4 || ($35e6840e87686935$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed kind values for AST nodes.
 */ var $91330b884e9db43f$export$a84bdc57c5122798;
(function(Kind) {
    Kind["NAME"] = "Name";
    Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    Kind["DIRECTIVE"] = "Directive";
    Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})($91330b884e9db43f$export$a84bdc57c5122798 || ($91330b884e9db43f$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 

const $3a3231b31fef9807$export$a89c95c098ac2a58 = Object.freeze({});
function $3a3231b31fef9807$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $35e6840e87686935$export$4fcd777a40ccf407)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $91330b884e9db43f$export$a84bdc57c5122798)))enterLeaveMap.set(kind, $3a3231b31fef9807$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $35e6840e87686935$export$8ee0fc9ee280b4ee)(node) || (0, $f2688159d9d799da$export$b6cb5906f04696c8)(false, `Invalid AST Node: ${(0, $7176971acde7c738$export$9dec5d1b3b6a130d)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $3a3231b31fef9807$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $35e6840e87686935$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $3a3231b31fef9807$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $91330b884e9db43f$export$a84bdc57c5122798))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $3a3231b31fef9807$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $3a3231b31fef9807$export$a89c95c098ac2a58) skipping[i] = $3a3231b31fef9807$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $3a3231b31fef9807$export$a89c95c098ac2a58) skipping[i] = $3a3231b31fef9807$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $3a3231b31fef9807$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === "object") // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === "function") // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $3a3231b31fef9807$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $3a3231b31fef9807$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}



/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $2c7247d709b73553$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $2c7247d709b73553$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $2c7247d709b73553$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $2c7247d709b73553$export$45a677ea7cb6d5c8(code) {
    return $2c7247d709b73553$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $2c7247d709b73553$export$d3f406ff46035894(code) {
    return $2c7247d709b73553$export$79c5d5217943d6a7(code) || $2c7247d709b73553$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $c60f20f97e79cff8$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $c60f20f97e79cff8$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $c60f20f97e79cff8$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $2c7247d709b73553$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $c60f20f97e79cff8$export$40862a63ef85e395(value) {
    if (value === "") return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $c60f20f97e79cff8$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $2c7247d709b73553$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith("\\");
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ""; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $2c7247d709b73553$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += "\n";
    return '"""' + result + '"""';
}


/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $45bda3d4df41a73f$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($45bda3d4df41a73f$var$escapedRegExp, $45bda3d4df41a73f$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $45bda3d4df41a73f$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $45bda3d4df41a73f$var$escapedReplacer(str) {
    return $45bda3d4df41a73f$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $45bda3d4df41a73f$var$escapeSequences = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
];



function $e122e6bb51d23ef1$export$c2d084dc44961371(ast) {
    return (0, $3a3231b31fef9807$export$bf638b60ea8b89b7)(ast, $e122e6bb51d23ef1$var$printDocASTReducer);
}
const $e122e6bb51d23ef1$var$MAX_LINE_LENGTH = 80;
const $e122e6bb51d23ef1$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>"$" + node.name
    },
    // Document
    Document: {
        leave: (node)=>$e122e6bb51d23ef1$var$join(node.definitions, "\n\n")
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $e122e6bb51d23ef1$var$wrap("(", $e122e6bb51d23ef1$var$join(node.variableDefinitions, ", "), ")");
            const prefix = $e122e6bb51d23ef1$var$join([
                node.operation,
                $e122e6bb51d23ef1$var$join([
                    node.name,
                    varDefs
                ]),
                $e122e6bb51d23ef1$var$join(node.directives, " ")
            ], " "); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ": " + type + $e122e6bb51d23ef1$var$wrap(" = ", defaultValue) + $e122e6bb51d23ef1$var$wrap(" ", $e122e6bb51d23ef1$var$join(directives, " "))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$e122e6bb51d23ef1$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $e122e6bb51d23ef1$var$wrap("", alias, ": ") + name;
            let argsLine = prefix + $e122e6bb51d23ef1$var$wrap("(", $e122e6bb51d23ef1$var$join(args, ", "), ")");
            if (argsLine.length > $e122e6bb51d23ef1$var$MAX_LINE_LENGTH) argsLine = prefix + $e122e6bb51d23ef1$var$wrap("(\n", $e122e6bb51d23ef1$var$indent($e122e6bb51d23ef1$var$join(args, "\n")), "\n)");
            return $e122e6bb51d23ef1$var$join([
                argsLine,
                $e122e6bb51d23ef1$var$join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>"..." + name + $e122e6bb51d23ef1$var$wrap(" ", $e122e6bb51d23ef1$var$join(directives, " "))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$e122e6bb51d23ef1$var$join([
                "...",
                $e122e6bb51d23ef1$var$wrap("on ", typeCondition),
                $e122e6bb51d23ef1$var$join(directives, " "),
                selectionSet
            ], " ")
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$e122e6bb51d23ef1$var$wrap("(", $e122e6bb51d23ef1$var$join(variableDefinitions, ", "), ")")} ` + `on ${typeCondition} ${$e122e6bb51d23ef1$var$wrap("", $e122e6bb51d23ef1$var$join(directives, " "), " ")}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $c60f20f97e79cff8$export$adb6ca997eeb1f45)(value) : (0, $45bda3d4df41a73f$export$3cdec7cf614a0ecc)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? "true" : "false"
    },
    NullValue: {
        leave: ()=>"null"
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>"[" + $e122e6bb51d23ef1$var$join(values, ", ") + "]"
    },
    ObjectValue: {
        leave: ({ fields: fields })=>"{" + $e122e6bb51d23ef1$var$join(fields, ", ") + "}"
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>"@" + name + $e122e6bb51d23ef1$var$wrap("(", $e122e6bb51d23ef1$var$join(args, ", "), ")")
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>"[" + type + "]"
    },
    NonNullType: {
        leave: ({ type: type })=>type + "!"
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$e122e6bb51d23ef1$var$wrap("", description, "\n") + $e122e6bb51d23ef1$var$join([
                "schema",
                $e122e6bb51d23ef1$var$join(directives, " "),
                $e122e6bb51d23ef1$var$block(operationTypes)
            ], " ")
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ": " + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$e122e6bb51d23ef1$var$wrap("", description, "\n") + $e122e6bb51d23ef1$var$join([
                "scalar",
                name,
                $e122e6bb51d23ef1$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e122e6bb51d23ef1$var$wrap("", description, "\n") + $e122e6bb51d23ef1$var$join([
                "type",
                name,
                $e122e6bb51d23ef1$var$wrap("implements ", $e122e6bb51d23ef1$var$join(interfaces, " & ")),
                $e122e6bb51d23ef1$var$join(directives, " "),
                $e122e6bb51d23ef1$var$block(fields)
            ], " ")
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$e122e6bb51d23ef1$var$wrap("", description, "\n") + name + ($e122e6bb51d23ef1$var$hasMultilineItems(args) ? $e122e6bb51d23ef1$var$wrap("(\n", $e122e6bb51d23ef1$var$indent($e122e6bb51d23ef1$var$join(args, "\n")), "\n)") : $e122e6bb51d23ef1$var$wrap("(", $e122e6bb51d23ef1$var$join(args, ", "), ")")) + ": " + type + $e122e6bb51d23ef1$var$wrap(" ", $e122e6bb51d23ef1$var$join(directives, " "))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$e122e6bb51d23ef1$var$wrap("", description, "\n") + $e122e6bb51d23ef1$var$join([
                name + ": " + type,
                $e122e6bb51d23ef1$var$wrap("= ", defaultValue),
                $e122e6bb51d23ef1$var$join(directives, " ")
            ], " ")
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e122e6bb51d23ef1$var$wrap("", description, "\n") + $e122e6bb51d23ef1$var$join([
                "interface",
                name,
                $e122e6bb51d23ef1$var$wrap("implements ", $e122e6bb51d23ef1$var$join(interfaces, " & ")),
                $e122e6bb51d23ef1$var$join(directives, " "),
                $e122e6bb51d23ef1$var$block(fields)
            ], " ")
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$e122e6bb51d23ef1$var$wrap("", description, "\n") + $e122e6bb51d23ef1$var$join([
                "union",
                name,
                $e122e6bb51d23ef1$var$join(directives, " "),
                $e122e6bb51d23ef1$var$wrap("= ", $e122e6bb51d23ef1$var$join(types, " | "))
            ], " ")
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$e122e6bb51d23ef1$var$wrap("", description, "\n") + $e122e6bb51d23ef1$var$join([
                "enum",
                name,
                $e122e6bb51d23ef1$var$join(directives, " "),
                $e122e6bb51d23ef1$var$block(values)
            ], " ")
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$e122e6bb51d23ef1$var$wrap("", description, "\n") + $e122e6bb51d23ef1$var$join([
                name,
                $e122e6bb51d23ef1$var$join(directives, " ")
            ], " ")
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$e122e6bb51d23ef1$var$wrap("", description, "\n") + $e122e6bb51d23ef1$var$join([
                "input",
                name,
                $e122e6bb51d23ef1$var$join(directives, " "),
                $e122e6bb51d23ef1$var$block(fields)
            ], " ")
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$e122e6bb51d23ef1$var$wrap("", description, "\n") + "directive @" + name + ($e122e6bb51d23ef1$var$hasMultilineItems(args) ? $e122e6bb51d23ef1$var$wrap("(\n", $e122e6bb51d23ef1$var$indent($e122e6bb51d23ef1$var$join(args, "\n")), "\n)") : $e122e6bb51d23ef1$var$wrap("(", $e122e6bb51d23ef1$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $e122e6bb51d23ef1$var$join(locations, " | ")
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$e122e6bb51d23ef1$var$join([
                "extend schema",
                $e122e6bb51d23ef1$var$join(directives, " "),
                $e122e6bb51d23ef1$var$block(operationTypes)
            ], " ")
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$e122e6bb51d23ef1$var$join([
                "extend scalar",
                name,
                $e122e6bb51d23ef1$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e122e6bb51d23ef1$var$join([
                "extend type",
                name,
                $e122e6bb51d23ef1$var$wrap("implements ", $e122e6bb51d23ef1$var$join(interfaces, " & ")),
                $e122e6bb51d23ef1$var$join(directives, " "),
                $e122e6bb51d23ef1$var$block(fields)
            ], " ")
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e122e6bb51d23ef1$var$join([
                "extend interface",
                name,
                $e122e6bb51d23ef1$var$wrap("implements ", $e122e6bb51d23ef1$var$join(interfaces, " & ")),
                $e122e6bb51d23ef1$var$join(directives, " "),
                $e122e6bb51d23ef1$var$block(fields)
            ], " ")
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$e122e6bb51d23ef1$var$join([
                "extend union",
                name,
                $e122e6bb51d23ef1$var$join(directives, " "),
                $e122e6bb51d23ef1$var$wrap("= ", $e122e6bb51d23ef1$var$join(types, " | "))
            ], " ")
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$e122e6bb51d23ef1$var$join([
                "extend enum",
                name,
                $e122e6bb51d23ef1$var$join(directives, " "),
                $e122e6bb51d23ef1$var$block(values)
            ], " ")
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$e122e6bb51d23ef1$var$join([
                "extend input",
                name,
                $e122e6bb51d23ef1$var$join(directives, " "),
                $e122e6bb51d23ef1$var$block(fields)
            ], " ")
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $e122e6bb51d23ef1$var$join(maybeArray, separator = "") {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $e122e6bb51d23ef1$var$block(array) {
    return $e122e6bb51d23ef1$var$wrap("{\n", $e122e6bb51d23ef1$var$indent($e122e6bb51d23ef1$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $e122e6bb51d23ef1$var$wrap(start, maybeString, end = "") {
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $e122e6bb51d23ef1$var$indent(str) {
    return $e122e6bb51d23ef1$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $e122e6bb51d23ef1$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes("\n"))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}


/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $54400933917ad444$export$c10d0b04eaa80a43(value) {
    return typeof value == "object" && value !== null;
}


function $fbea4d358238c9df$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}


const $54283b0dca023119$var$LineRegExp = /\r\n|[\n\r]/g;
function $54283b0dca023119$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($54283b0dca023119$var$LineRegExp)){
        typeof match.index === "number" || (0, $fbea4d358238c9df$export$f5708dca728d7177)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}



function $e5160058837f0419$export$96a9681e539deed(location) {
    return $e5160058837f0419$export$867940333fd9f869(location.source, (0, $54283b0dca023119$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $e5160058837f0419$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = "".padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $e5160058837f0419$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    "|",
                    subLine
                ]),
            [
                "|",
                "^".padStart(subLineColumnNum)
            ],
            [
                "|",
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $e5160058837f0419$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            "|",
            "^".padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $e5160058837f0419$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? " " + line : "")).join("\n");
}


function $8929bb59aa7984ca$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || "kind" in firstArg || "length" in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $8929bb59aa7984ca$export$92d6ed0888e7cb7f extends Error {
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $8929bb59aa7984ca$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = "GraphQLError";
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $8929bb59aa7984ca$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $8929bb59aa7984ca$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $54283b0dca023119$export$e7fd20fad3cf4b5f)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $54283b0dca023119$export$e7fd20fad3cf4b5f)(loc.source, loc.start));
        const originalExtensions = (0, $54400933917ad444$export$c10d0b04eaa80a43)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, "stack", {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $8929bb59aa7984ca$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    get [Symbol.toStringTag]() {
        return "GraphQLError";
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += "\n\n" + (0, $e5160058837f0419$export$96a9681e539deed)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += "\n\n" + (0, $e5160058837f0419$export$867940333fd9f869)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function $8929bb59aa7984ca$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $8929bb59aa7984ca$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $8929bb59aa7984ca$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}




function $e273b3662e8a4c1c$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $8929bb59aa7984ca$export$92d6ed0888e7cb7f)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}



/**
 * The set of allowed directive location values.
 */ var $bd071b6bde648746$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation["QUERY"] = "QUERY";
    DirectiveLocation["MUTATION"] = "MUTATION";
    DirectiveLocation["SUBSCRIPTION"] = "SUBSCRIPTION";
    DirectiveLocation["FIELD"] = "FIELD";
    DirectiveLocation["FRAGMENT_DEFINITION"] = "FRAGMENT_DEFINITION";
    DirectiveLocation["FRAGMENT_SPREAD"] = "FRAGMENT_SPREAD";
    DirectiveLocation["INLINE_FRAGMENT"] = "INLINE_FRAGMENT";
    DirectiveLocation["VARIABLE_DEFINITION"] = "VARIABLE_DEFINITION";
    DirectiveLocation["SCHEMA"] = "SCHEMA";
    DirectiveLocation["SCALAR"] = "SCALAR";
    DirectiveLocation["OBJECT"] = "OBJECT";
    DirectiveLocation["FIELD_DEFINITION"] = "FIELD_DEFINITION";
    DirectiveLocation["ARGUMENT_DEFINITION"] = "ARGUMENT_DEFINITION";
    DirectiveLocation["INTERFACE"] = "INTERFACE";
    DirectiveLocation["UNION"] = "UNION";
    DirectiveLocation["ENUM"] = "ENUM";
    DirectiveLocation["ENUM_VALUE"] = "ENUM_VALUE";
    DirectiveLocation["INPUT_OBJECT"] = "INPUT_OBJECT";
    DirectiveLocation["INPUT_FIELD_DEFINITION"] = "INPUT_FIELD_DEFINITION";
})($bd071b6bde648746$export$b45ffd2948484c41 || ($bd071b6bde648746$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 






/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $e5b7eda39c06a69b$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind["SOF"] = "<SOF>";
    TokenKind["EOF"] = "<EOF>";
    TokenKind["BANG"] = "!";
    TokenKind["DOLLAR"] = "$";
    TokenKind["AMP"] = "&";
    TokenKind["PAREN_L"] = "(";
    TokenKind["PAREN_R"] = ")";
    TokenKind["SPREAD"] = "...";
    TokenKind["COLON"] = ":";
    TokenKind["EQUALS"] = "=";
    TokenKind["AT"] = "@";
    TokenKind["BRACKET_L"] = "[";
    TokenKind["BRACKET_R"] = "]";
    TokenKind["BRACE_L"] = "{";
    TokenKind["PIPE"] = "|";
    TokenKind["BRACE_R"] = "}";
    TokenKind["NAME"] = "Name";
    TokenKind["INT"] = "Int";
    TokenKind["FLOAT"] = "Float";
    TokenKind["STRING"] = "String";
    TokenKind["BLOCK_STRING"] = "BlockString";
    TokenKind["COMMENT"] = "Comment";
})($e5b7eda39c06a69b$export$8b9d26ab11394711 || ($e5b7eda39c06a69b$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 

class $c42287bf5f69aa76$export$6168dc8908a6c652 {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $35e6840e87686935$export$50792b0e93539fde)((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
        return "Lexer";
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $c42287bf5f69aa76$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).COMMENT);
        }
        return token;
    }
}
function $c42287bf5f69aa76$export$59ac0f4da287406a(kind) {
    return kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BANG || kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).DOLLAR || kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).AMP || kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).PAREN_L || kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).PAREN_R || kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).SPREAD || kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).COLON || kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).EQUALS || kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).AT || kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACKET_L || kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACKET_R || kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_L || kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).PIPE || kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $c42287bf5f69aa76$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $c42287bf5f69aa76$var$isSupplementaryCodePoint(body, location) {
    return $c42287bf5f69aa76$var$isLeadingSurrogate(body.charCodeAt(location)) && $c42287bf5f69aa76$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $c42287bf5f69aa76$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $c42287bf5f69aa76$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function $c42287bf5f69aa76$var$printCodePointAt(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return "U+" + code.toString(16).toUpperCase().padStart(4, "0");
}
/**
 * Create a token with line and column location information.
 */ function $c42287bf5f69aa76$var$createToken(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $35e6840e87686935$export$50792b0e93539fde)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $c42287bf5f69aa76$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $c42287bf5f69aa76$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BANG, position, position + 1);
            case 0x0024:
                // $
                return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).AMP, position, position + 1);
            case 0x0028:
                // (
                return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x003d:
                // =
                return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).AT, position, position + 1);
            case 0x005b:
                // [
                return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $c42287bf5f69aa76$var$readBlockString(lexer, position);
                return $c42287bf5f69aa76$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $2c7247d709b73553$export$727d9dbc4fbb948f)(code) || code === 0x002d) return $c42287bf5f69aa76$var$readNumber(lexer, position, code);
         // Name
        if ((0, $2c7247d709b73553$export$45a677ea7cb6d5c8)(code)) return $c42287bf5f69aa76$var$readName(lexer, position);
        throw (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(lexer.source, position, code === 0x0027 ? "Unexpected single quote character ('), did you mean to use a double quote (\")?" : $c42287bf5f69aa76$var$isUnicodeScalarValue(code) || $c42287bf5f69aa76$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$c42287bf5f69aa76$var$printCodePointAt(lexer, position)}.` : `Invalid character: ${$c42287bf5f69aa76$var$printCodePointAt(lexer, position)}.`);
    }
    return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $c42287bf5f69aa76$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($c42287bf5f69aa76$var$isUnicodeScalarValue(code)) ++position;
        else if ($c42287bf5f69aa76$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $c42287bf5f69aa76$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $2c7247d709b73553$export$727d9dbc4fbb948f)(code)) throw (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$c42287bf5f69aa76$var$printCodePointAt(lexer, position)}.`);
    } else {
        position = $c42287bf5f69aa76$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $c42287bf5f69aa76$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $c42287bf5f69aa76$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $2c7247d709b73553$export$45a677ea7cb6d5c8)(code)) throw (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, expected digit but got: ${$c42287bf5f69aa76$var$printCodePointAt(lexer, position)}.`);
    return $c42287bf5f69aa76$var$createToken(lexer, isFloat ? (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).FLOAT : (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $c42287bf5f69aa76$var$readDigits(lexer, start, firstCode) {
    if (!(0, $2c7247d709b73553$export$727d9dbc4fbb948f)(firstCode)) throw (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(lexer.source, start, `Invalid number, expected digit but got: ${$c42287bf5f69aa76$var$printCodePointAt(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $2c7247d709b73553$export$727d9dbc4fbb948f)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $c42287bf5f69aa76$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = "";
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $c42287bf5f69aa76$var$readEscapedUnicodeVariableWidth(lexer, position) : $c42287bf5f69aa76$var$readEscapedUnicodeFixedWidth(lexer, position) : $c42287bf5f69aa76$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($c42287bf5f69aa76$var$isUnicodeScalarValue(code)) ++position;
        else if ($c42287bf5f69aa76$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$c42287bf5f69aa76$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(lexer.source, position, "Unterminated string.");
} // The string value and lexed size of an escape sequence.
function $c42287bf5f69aa76$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$c42287bf5f69aa76$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $c42287bf5f69aa76$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $c42287bf5f69aa76$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $c42287bf5f69aa76$var$read16BitHexCode(body, position + 2);
    if ($c42287bf5f69aa76$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($c42287bf5f69aa76$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $c42287bf5f69aa76$var$read16BitHexCode(body, position + 8);
            if ($c42287bf5f69aa76$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $c42287bf5f69aa76$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $c42287bf5f69aa76$var$readHexDigit(body.charCodeAt(position)) << 12 | $c42287bf5f69aa76$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $c42287bf5f69aa76$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $c42287bf5f69aa76$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $c42287bf5f69aa76$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $c42287bf5f69aa76$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '"',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: "\\",
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: "/",
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: "\b",
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: "\f",
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: "\n",
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: "\r",
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: "	",
                size: 2
            };
    }
    throw (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $c42287bf5f69aa76$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = "";
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, (0, $c60f20f97e79cff8$export$d5ee19b441e8d2ae)(blockLines).join("\n"));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = "";
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($c42287bf5f69aa76$var$isUnicodeScalarValue(code)) ++position;
        else if ($c42287bf5f69aa76$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$c42287bf5f69aa76$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(lexer.source, position, "Unterminated string.");
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function $c42287bf5f69aa76$var$readName(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $2c7247d709b73553$export$d3f406ff46035894)(code)) ++position;
        else break;
    }
    return $c42287bf5f69aa76$var$createToken(lexer, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).NAME, start, position, body.slice(start, position));
}





const $8b770ea58918af3d$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === "object" && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $7176971acde7c738$export$9dec5d1b3b6a130d)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};


class $22b40bae528cefc3$export$1d2df86270c81ecb {
    constructor(body, name = "GraphQL request", locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === "string" || (0, $f2688159d9d799da$export$b6cb5906f04696c8)(false, `Body must be a string. Received: ${(0, $7176971acde7c738$export$9dec5d1b3b6a130d)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $f2688159d9d799da$export$b6cb5906f04696c8)(false, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, $f2688159d9d799da$export$b6cb5906f04696c8)(false, "column in locationOffset is 1-indexed and must be positive.");
    }
    get [Symbol.toStringTag]() {
        return "Source";
    }
}
function $22b40bae528cefc3$export$75135ee9ed6e435b(source) {
    return (0, $8b770ea58918af3d$export$ca03416d6c9e029e)(source, $22b40bae528cefc3$export$1d2df86270c81ecb);
}



function $65896b1d71e63574$export$98e6a39c04603d36(source, options) {
    const parser = new $65896b1d71e63574$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $65896b1d71e63574$export$5303528d1070ff6f(source, options) {
    const parser = new $65896b1d71e63574$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).EOF);
    return value;
}
function $65896b1d71e63574$export$e14c466bd0916f7a(source, options) {
    const parser = new $65896b1d71e63574$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).EOF);
    return value;
}
function $65896b1d71e63574$export$28b8f402ccc88182(source, options) {
    const parser = new $65896b1d71e63574$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).EOF);
    return type;
}
class $65896b1d71e63574$export$7acfa6ed01010e37 {
    constructor(source, options = {}){
        const sourceObj = (0, $22b40bae528cefc3$export$75135ee9ed6e435b)(source) ? source : new (0, $22b40bae528cefc3$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $c42287bf5f69aa76$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).NAME);
        return this.node(token, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).NAME) {
            switch(keywordToken.value){
                case "schema":
                    return this.parseSchemaDefinition();
                case "scalar":
                    return this.parseScalarTypeDefinition();
                case "type":
                    return this.parseObjectTypeDefinition();
                case "interface":
                    return this.parseInterfaceTypeDefinition();
                case "union":
                    return this.parseUnionTypeDefinition();
                case "enum":
                    return this.parseEnumTypeDefinition();
                case "input":
                    return this.parseInputObjectTypeDefinition();
                case "directive":
                    return this.parseDirectiveDefinition();
            }
            if (hasDescription) throw (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, "Unexpected description, descriptions are supported only on type definitions.");
            switch(keywordToken.value){
                case "query":
                case "mutation":
                case "subscription":
                    return this.parseOperationDefinition();
                case "fragment":
                    return this.parseFragmentDefinition();
                case "extend":
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_L)) return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: (0, $35e6840e87686935$export$f58c50edb4aef9d4).QUERY,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case "query":
                return (0, $35e6840e87686935$export$f58c50edb4aef9d4).QUERY;
            case "mutation":
                return (0, $35e6840e87686935$export$f58c50edb4aef9d4).MUTATION;
            case "subscription":
                return (0, $35e6840e87686935$export$f58c50edb4aef9d4).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).DOLLAR);
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).PAREN_L, item, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).NAME)) return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        this.expectKeyword("fragment"); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).INT,
                    value: token.value
                });
            case (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).FLOAT,
                    value: token.value
                });
            case (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).STRING:
            case (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).NAME:
                this.advanceLexer();
                switch(token.value){
                    case "true":
                        return this.node(token, {
                            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).BOOLEAN,
                            value: true
                        });
                    case "false":
                        return this.node(token, {
                            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).BOOLEAN,
                            value: false
                        });
                    case "null":
                        return this.node(token, {
                            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).ENUM,
                            value: token.value
                        });
                }
            case (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).DOLLAR);
                    if (this._lexer.token.kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).LIST,
            values: this.any((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACKET_L, item, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_L, item, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).AT);
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACKET_R);
            type = this.node(start, {
                kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BANG)) return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).STRING) || this.peek((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_R);
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword("implements") ? this.delimitedMany((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null") throw (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, `${$65896b1d71e63574$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $e5b7eda39c06a69b$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $bd071b6bde648746$export$b45ffd2948484c41), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $35e6840e87686935$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected ${$65896b1d71e63574$var$getTokenKindDesc(kind)}, found ${$65896b1d71e63574$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).NAME && token.value === value) this.advanceLexer();
        else throw (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected "${value}", found ${$65896b1d71e63574$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected ${$65896b1d71e63574$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (maxTokens !== undefined && token.kind !== (0, $e5b7eda39c06a69b$export$8b9d26ab11394711).EOF) {
            ++this._tokenCounter;
            if (this._tokenCounter > maxTokens) throw (0, $e273b3662e8a4c1c$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $65896b1d71e63574$var$getTokenDesc(token) {
    const value = token.value;
    return $65896b1d71e63574$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $65896b1d71e63574$var$getTokenKindDesc(kind) {
    return (0, $c42287bf5f69aa76$export$59ac0f4da287406a)(kind) ? `"${kind}"` : kind;
}



function $3e6f5df673a67418$var$l(a, b) {
    b.tag = a;
    return b;
}
function $3e6f5df673a67418$var$m() {}
function $3e6f5df673a67418$export$571d59b505e6bb4e(a) {
    return function(b) {
        var c = a.length;
        let d = !1, e = !1, f = !1, g = 0;
        b($3e6f5df673a67418$var$l(0, [
            function(h) {
                if (h) d = !0;
                else if (e) f = !0;
                else {
                    for(e = f = !0; f && !d;)g < c ? (h = a[g], g = g + 1 | 0, f = !1, b($3e6f5df673a67418$var$l(1, [
                        h
                    ]))) : (d = !0, b(0));
                    e = !1;
                }
            }
        ]));
    };
}
function $3e6f5df673a67418$var$r() {}
function $3e6f5df673a67418$var$t(a) {
    a(0);
}
function $3e6f5df673a67418$export$6e22c362a0406a2c(a) {
    let b = !1;
    a($3e6f5df673a67418$var$l(0, [
        function(c) {
            c ? b = !0 : b || a(0);
        }
    ]));
}
function $3e6f5df673a67418$var$w(a) {
    if (void 0 === a) return (a = [
        $3e6f5df673a67418$var$v,
        0
    ]).tag = 256, a;
    if (null === a || a[0] !== $3e6f5df673a67418$var$v) return a;
    (a = [
        $3e6f5df673a67418$var$v,
        a[1] + 1 | 0
    ]).tag = 256;
    return a;
}
function $3e6f5df673a67418$var$x(a) {
    if (null === a || a[0] !== $3e6f5df673a67418$var$v) return a;
    if (0 !== (a = a[1])) return [
        $3e6f5df673a67418$var$v,
        a - 1 | 0
    ];
}
function $3e6f5df673a67418$export$c28c8388be0ab31a(a) {
    return function(b) {
        return function(c) {
            function d(b) {
                "number" == typeof b ? k && (k = !1, void 0 !== (b = e.shift()) ? (b = a($3e6f5df673a67418$var$x(b)), k = !0, b(d)) : q ? c(0) : g || (g = !0, f(0))) : b.tag ? k && (c(b), n ? n = !1 : h(0)) : (h = b = b[0], n = !1, b(0));
            }
            let e = [], f = $3e6f5df673a67418$var$m, g = !1, h = $3e6f5df673a67418$var$m, k = !1, n = !1, q = !1;
            b(function(b) {
                "number" == typeof b ? q || (q = !0, k || 0 !== e.length || c(0)) : b.tag ? q || (b = b[0], g = !1, k ? e.push(b) : (b = a(b), k = !0, b(d))) : f = b[0];
            });
            c($3e6f5df673a67418$var$l(0, [
                function(c) {
                    if (c) {
                        if (q || (q = !0, f(1)), k) return k = !1, h(1);
                    } else q || g || (g = !0, f(0)), k && !n && (n = !0, h(0));
                }
            ]));
        };
    };
}
function $3e6f5df673a67418$var$A(a) {
    return a;
}
function $3e6f5df673a67418$var$B(a) {
    return a;
}
function $3e6f5df673a67418$var$C(a) {
    return a(0);
}
function $3e6f5df673a67418$export$6b9f6c0d32c093f9(a) {
    return function(b) {
        return function(c) {
            let e = $3e6f5df673a67418$var$m, f = !1, g = [], h = !1;
            b(function(b) {
                "number" == typeof b ? h || (h = !0, 0 === g.length && c(0)) : b.tag ? h || (f = !1, function(a) {
                    function b(a) {
                        "number" == typeof a ? 0 !== g.length && (g = g.filter(d), a = 0 === g.length, h && a ? c(0) : !f && a && (f = !0, e(0))) : a.tag ? 0 !== g.length && (c($3e6f5df673a67418$var$l(1, [
                            a[0]
                        ])), k(0)) : (k = a = a[0], g = g.concat(a), a(0));
                    }
                    function d(a) {
                        return a !== k;
                    }
                    let k = $3e6f5df673a67418$var$m;
                    1 === a.length ? a(b) : a.bind(null, b);
                }(a(b[0])), f || (f = !0, e(0))) : e = b[0];
            });
            c($3e6f5df673a67418$var$l(0, [
                function(a) {
                    a ? (h || (h = !0, e(a)), g.forEach(function(c) {
                        return c(a);
                    }), g = []) : (f || h ? f = !1 : (f = !0, e(0)), g.forEach($3e6f5df673a67418$var$C));
                }
            ]));
        };
    };
}
function $3e6f5df673a67418$var$E(a) {
    return a;
}
function $3e6f5df673a67418$var$F(a) {
    return a;
}
function $3e6f5df673a67418$export$bffa455ba8c619a6(a) {
    return $3e6f5df673a67418$export$6b9f6c0d32c093f9($3e6f5df673a67418$var$F)(a);
}
function $3e6f5df673a67418$export$fff70a13d53402ec(a) {
    return function(b) {
        return function(c) {
            let d = !1;
            return b(function(e) {
                if ("number" == typeof e) d || (d = !0, c(e));
                else if (e.tag) d || (a(e[0]), c(e));
                else {
                    var g = e[0];
                    c($3e6f5df673a67418$var$l(0, [
                        function(a) {
                            if (!d) return a && (d = !0), g(a);
                        }
                    ]));
                }
            });
        };
    };
}
function $3e6f5df673a67418$var$J(a) {
    a(0);
}
function $3e6f5df673a67418$export$9f6ea8e48bc26eab(a) {
    return function(b) {
        return function(c) {
            function d(a) {
                h && ("number" == typeof a ? (h = !1, n ? c(a) : f || (f = !0, e(0))) : a.tag ? (c(a), k ? k = !1 : g(0)) : (g = a = a[0], k = !1, a(0)));
            }
            let e = $3e6f5df673a67418$var$m, f = !1, g = $3e6f5df673a67418$var$m, h = !1, k = !1, n = !1;
            b(function(b) {
                "number" == typeof b ? n || (n = !0, h || c(0)) : b.tag ? n || (h && (g(1), g = $3e6f5df673a67418$var$m), f ? f = !1 : (f = !0, e(0)), b = a(b[0]), h = !0, b(d)) : e = b[0];
            });
            c($3e6f5df673a67418$var$l(0, [
                function(a) {
                    if (a) {
                        if (n || (n = !0, e(1)), h) return h = !1, g(1);
                    } else n || f || (f = !0, e(0)), h && !k && (k = !0, g(0));
                }
            ]));
        };
    };
}
function $3e6f5df673a67418$var$L(a) {
    return a;
}
function $3e6f5df673a67418$export$1b47ad771ce5af5e(a) {
    return function(b) {
        return function(c) {
            let d = [], e = $3e6f5df673a67418$var$m;
            return b(function(b) {
                "number" == typeof b ? $3e6f5df673a67418$export$571d59b505e6bb4e(d)(c) : b.tag ? (d.length >= a && 0 < a && d.shift(), d.push(b[0]), e(0)) : (b = b[0], 0 >= a ? (b(1), $3e6f5df673a67418$export$6e22c362a0406a2c(c)) : (e = b, b(0)));
            });
        };
    };
}
function $3e6f5df673a67418$export$ec068583843480e7(a) {
    return function(b) {
        let c = $3e6f5df673a67418$var$m, d = !1;
        b(function(e) {
            "number" == typeof e ? d = !0 : e.tag ? d || (a(e[0]), c(0)) : (c = e = e[0], e(0));
        });
        return {
            unsubscribe: function() {
                if (!d) return d = !0, c(1);
            }
        };
    };
}
function $3e6f5df673a67418$var$O() {}
function $3e6f5df673a67418$var$Q() {}
function $3e6f5df673a67418$var$R() {}
function $3e6f5df673a67418$var$S() {}
function $3e6f5df673a67418$export$ab1029bcae9ddb4a(a) {
    return function(b) {
        return function(c) {
            function d(a) {
                "number" == typeof a ? k || (k = !0, f(1), 0 < e.length && c($3e6f5df673a67418$var$l(1, [
                    e
                ])), c(0)) : a.tag ? !k && 0 < e.length && (a = e, e = [], c($3e6f5df673a67418$var$l(1, [
                    a
                ]))) : g = a[0];
            }
            let e = [], f = $3e6f5df673a67418$var$m, g = $3e6f5df673a67418$var$m, h = !1, k = !1;
            b(function(b) {
                "number" == typeof b ? k || (k = !0, g(1), 0 < e.length && c($3e6f5df673a67418$var$l(1, [
                    e
                ])), c(0)) : b.tag ? k || (e.push(b[0]), h ? h = !1 : (h = !0, f(0), g(0))) : (f = b[0], a(d));
            });
            c($3e6f5df673a67418$var$l(0, [
                function(a) {
                    if (!k) {
                        if (a) return k = !0, f(1), g(1);
                        if (!h) return h = !0, f(0), g(0);
                    }
                }
            ]));
        };
    };
}
function $3e6f5df673a67418$export$1be1fc439b849fdf(a, b) {
    return function(a, b) {
        return function(c) {
            let d = $3e6f5df673a67418$var$m, e = $3e6f5df673a67418$var$m, f = void 0, g = void 0, h = !1, k = 0, n = !1;
            a(function(a) {
                var b = g;
                "number" == typeof a ? 1 > k ? k = k + 1 | 0 : n || (n = !0, c(0)) : a.tag ? (a = a[0], void 0 !== b ? n || (f = $3e6f5df673a67418$var$w(a), h = !1, c($3e6f5df673a67418$var$l(1, [
                    [
                        a,
                        $3e6f5df673a67418$var$x(b)
                    ]
                ]))) : (f = $3e6f5df673a67418$var$w(a), h ? h = !1 : e(0))) : d = a[0];
            });
            b(function(a) {
                var b = f;
                "number" == typeof a ? 1 > k ? k = k + 1 | 0 : n || (n = !0, c(0)) : a.tag ? (a = a[0], void 0 !== b ? n || (g = $3e6f5df673a67418$var$w(a), h = !1, c($3e6f5df673a67418$var$l(1, [
                    [
                        $3e6f5df673a67418$var$x(b),
                        a
                    ]
                ]))) : (g = $3e6f5df673a67418$var$w(a), h ? h = !1 : d(0))) : e = a[0];
            });
            c($3e6f5df673a67418$var$l(0, [
                function(c) {
                    if (!n) {
                        if (c) return n = !0, d(1), e(1);
                        if (!h) return h = !0, d(c), e(c);
                    }
                }
            ]));
        };
    }(a, b);
}
function $3e6f5df673a67418$export$ee1b3e54f0441b22(a) {
    return $3e6f5df673a67418$export$c28c8388be0ab31a($3e6f5df673a67418$var$B)($3e6f5df673a67418$export$571d59b505e6bb4e(a));
}
function $3e6f5df673a67418$export$b314777ae20abca9(a) {
    return $3e6f5df673a67418$export$c28c8388be0ab31a($3e6f5df673a67418$var$A)(a);
}
function $3e6f5df673a67418$export$61fc7d43ac8f84b0(a) {
    return function(b) {
        return function(c) {
            function d() {
                var a = e;
                void 0 !== a && (e = void 0, clearTimeout($3e6f5df673a67418$var$x(a)));
            }
            let e = void 0, f = !1, g = !1;
            return b(function(b) {
                if ("number" == typeof b) g || (g = !0, void 0 !== e ? f = !0 : c(0));
                else if (b.tag) g || (d(), e = $3e6f5df673a67418$var$w(setTimeout(function() {
                    e = void 0;
                    c(b);
                    f && c(0);
                }, a(b[0]))));
                else {
                    var n = b[0];
                    c($3e6f5df673a67418$var$l(0, [
                        function(a) {
                            if (!g) return a ? (g = !0, f = !1, d(), n(1)) : n(0);
                        }
                    ]));
                }
            });
        };
    };
}
function $3e6f5df673a67418$export$1391212d75b2ee65(a) {
    return function(b) {
        return function(c) {
            let d = 0;
            return b(function(b) {
                "number" == typeof b || b.tag ? (d = d + 1 | 0, setTimeout(function() {
                    0 !== d && (d = d - 1 | 0, c(b));
                }, a)) : c(b);
            });
        };
    };
}
function $3e6f5df673a67418$export$3dea766d36a8935f(a) {
    return function(b) {
        return function(c) {
            let d = $3e6f5df673a67418$var$m;
            return b(function(b) {
                "number" == typeof b ? c(b) : b.tag ? a(b[0]) ? c(b) : d(0) : (d = b[0], c(b));
            });
        };
    };
}
function $3e6f5df673a67418$export$4b80e395e36b5a56(a) {
    return function(b) {
        $3e6f5df673a67418$export$ec068583843480e7(a)(b);
    };
}
function $3e6f5df673a67418$export$24d5d3bb0066f63a(a) {
    return function(b) {
        function c(a, c) {
            switch(a){
                case 0:
                    b($3e6f5df673a67418$var$l(0, [
                        function(a) {
                            return a ? c(2) : c(1);
                        }
                    ]));
                    break;
                case 1:
                    b($3e6f5df673a67418$var$l(1, [
                        c
                    ]));
                    break;
                case 2:
                    b(0);
            }
        }
        return 2 === a.length ? a(0, c) : a.bind(null, 0, c);
    };
}
function $3e6f5df673a67418$export$abb8949c8e816a2c(a, b) {
    return function(a, b) {
        return function(c) {
            function d(a) {
                c($3e6f5df673a67418$var$l(1, [
                    a
                ]));
            }
            c($3e6f5df673a67418$var$l(0, [
                function(c) {
                    c && a.removeEventListener(b, d);
                }
            ]));
            a.addEventListener(b, d);
        };
    }(a, b);
}
function $3e6f5df673a67418$export$88e0dae599377b39(a) {
    return function(b) {
        let c = !1, d = !1, e = !1, f = a;
        b($3e6f5df673a67418$var$l(0, [
            function(a) {
                if (a) c = !0;
                else if (d) e = !0;
                else {
                    for(d = e = !0; e && !c;)(a = f) ? (f = a[1], e = !1, b($3e6f5df673a67418$var$l(1, [
                        a[0]
                    ]))) : (c = !0, b(0));
                    d = !1;
                }
            }
        ]));
    };
}
function $3e6f5df673a67418$export$4b2432e2d8723823(a) {
    var b = void 0 !== a[$3e6f5df673a67418$var$P] ? a[$3e6f5df673a67418$var$P]() : a;
    return function(a) {
        var c = b.subscribe({
            next: function(c) {
                a($3e6f5df673a67418$var$l(1, [
                    c
                ]));
            },
            complete: function() {
                a(0);
            },
            error: $3e6f5df673a67418$var$Q
        });
        a($3e6f5df673a67418$var$l(0, [
            function(a) {
                if (a) return c.unsubscribe();
            }
        ]));
    };
}
function $3e6f5df673a67418$export$60f45028237c39d1(a) {
    return function(b) {
        let c = !1;
        a.then(function(a) {
            c || (b($3e6f5df673a67418$var$l(1, [
                a
            ])), b(0));
            return Promise.resolve(void 0);
        });
        b($3e6f5df673a67418$var$l(0, [
            function(a) {
                a && (c = !0);
            }
        ]));
    };
}
function $3e6f5df673a67418$export$5f36b26c3833b3ba(a) {
    return function(b) {
        let c = !1;
        b($3e6f5df673a67418$var$l(0, [
            function(d) {
                d ? c = !0 : c || (c = !0, b($3e6f5df673a67418$var$l(1, [
                    a
                ])), b(0));
            }
        ]));
    };
}
function $3e6f5df673a67418$export$3174cdbf0a0cbc84(a) {
    return function(b) {
        let c = 0;
        var d = setInterval(function() {
            var a = c;
            c = c + 1 | 0;
            b($3e6f5df673a67418$var$l(1, [
                a
            ]));
        }, a);
        b($3e6f5df673a67418$var$l(0, [
            function(a) {
                a && clearInterval(d);
            }
        ]));
    };
}
function $3e6f5df673a67418$export$dd44f18ab656f3bb(a) {
    return function(b) {
        let c = $3e6f5df673a67418$var$r, d = !1;
        c = a({
            next: function(a) {
                d || b($3e6f5df673a67418$var$l(1, [
                    a
                ]));
            },
            complete: function() {
                d || (d = !0, b(0));
            }
        });
        b($3e6f5df673a67418$var$l(0, [
            function(a) {
                if (a && !d) return d = !0, c();
            }
        ]));
    };
}
function $3e6f5df673a67418$export$c4c2a35435b4a722() {
    let a = [], b = !1;
    return {
        source: function(c) {
            function b(a) {
                return a !== c;
            }
            a = a.concat(c);
            c($3e6f5df673a67418$var$l(0, [
                function(c) {
                    c && (a = a.filter(b));
                }
            ]));
        },
        next: function(c) {
            b || a.forEach(function(a) {
                a($3e6f5df673a67418$var$l(1, [
                    c
                ]));
            });
        },
        complete: function() {
            b || (b = !0, a.forEach($3e6f5df673a67418$var$t));
        }
    };
}
function $3e6f5df673a67418$export$871de8747c9eaa88(a) {
    return function(b) {
        return function(c) {
            return b(function(b) {
                b = "number" == typeof b ? 0 : b.tag ? $3e6f5df673a67418$var$l(1, [
                    a(b[0])
                ]) : $3e6f5df673a67418$var$l(0, [
                    b[0]
                ]);
                c(b);
            });
        };
    };
}
function $3e6f5df673a67418$export$4950aa0f605343fb(a) {
    return $3e6f5df673a67418$export$6b9f6c0d32c093f9($3e6f5df673a67418$var$E)($3e6f5df673a67418$export$571d59b505e6bb4e(a));
}
function $3e6f5df673a67418$export$b3e22bcfd64c1022(a) {
    a($3e6f5df673a67418$var$l(0, [
        $3e6f5df673a67418$var$m
    ]));
}
function $3e6f5df673a67418$export$db4d2a4aed77becf(a) {
    return function(b) {
        return function(c) {
            let d = !1;
            return b(function(b) {
                if ("number" == typeof b) {
                    if (d) return;
                    d = !0;
                    c(b);
                    return a();
                }
                if (b.tag) d || c(b);
                else {
                    var e = b[0];
                    c($3e6f5df673a67418$var$l(0, [
                        function(c) {
                            if (!d) return c ? (d = !0, e(c), a()) : e(c);
                        }
                    ]));
                }
            });
        };
    };
}
function $3e6f5df673a67418$export$aaa2d21dd8862419(a) {
    return function(b) {
        return function(c) {
            return b(function(b) {
                "number" == typeof b ? c(b) : b.tag ? c(b) : (c(b), a());
            });
        };
    };
}
function $3e6f5df673a67418$export$a4627e546088548d() {
    for(var a = arguments, b = arguments[0], c = 1, d = arguments.length; c < d; c++)b = a[c](b);
    return b;
}
function $3e6f5df673a67418$export$89b472e03be495df(a) {
    return $3e6f5df673a67418$export$ec068583843480e7($3e6f5df673a67418$var$O)(a);
}
function $3e6f5df673a67418$export$4812e460280c6ef2(a) {
    return function(b) {
        return function(c) {
            let d = $3e6f5df673a67418$var$m, e = $3e6f5df673a67418$var$m, f = void 0, g = !1, h = !1;
            b(function(a) {
                "number" == typeof a ? h || (h = !0, e(1), c(0)) : a.tag ? (f = $3e6f5df673a67418$var$w(a[0]), g ? g = !1 : (g = !0, e(0), d(0))) : d = a[0];
            });
            a(function(a) {
                var b = f;
                "number" == typeof a ? h || (h = !0, d(1), c(0)) : a.tag ? void 0 === b || h || (f = void 0, c($3e6f5df673a67418$var$l(1, [
                    $3e6f5df673a67418$var$x(b)
                ]))) : e = a[0];
            });
            c($3e6f5df673a67418$var$l(0, [
                function(a) {
                    if (!h) {
                        if (a) return h = !0, d(1), e(1);
                        if (!g) return g = !0, d(0), e(0);
                    }
                }
            ]));
        };
    };
}
function $3e6f5df673a67418$export$c87d910e63d22ed6(a, b) {
    return function(a, b) {
        return function(c) {
            return function(d) {
                let e = b;
                return c(function(c) {
                    "number" == typeof c ? c = 0 : c.tag ? (e = a(e, c[0]), c = $3e6f5df673a67418$var$l(1, [
                        e
                    ])) : c = $3e6f5df673a67418$var$l(0, [
                        c[0]
                    ]);
                    d(c);
                });
            };
        };
    }(a, b);
}
function $3e6f5df673a67418$export$ed80d9de1d9df928(a) {
    function b(a) {
        "number" == typeof a ? (c.forEach($3e6f5df673a67418$var$J), c = []) : a.tag ? (e = !1, c.forEach(function(b) {
            b(a);
        })) : d = a[0];
    }
    let c = [], d = $3e6f5df673a67418$var$m, e = !1;
    return function(f) {
        function g(a) {
            return a !== f;
        }
        c = c.concat(f);
        1 === c.length && a(b);
        f($3e6f5df673a67418$var$l(0, [
            function(a) {
                if (a) {
                    if (c = c.filter(g), 0 === c.length) return d(1);
                } else e || (e = !0, d(a));
            }
        ]));
    };
}
function $3e6f5df673a67418$export$955fc4a6c4be454d(a) {
    return function(b) {
        return function(c) {
            let d = $3e6f5df673a67418$var$m, e = a;
            return b(function(a) {
                "number" == typeof a ? c(a) : a.tag ? 0 < e ? (e = e - 1 | 0, d(0)) : c(a) : (d = a[0], c(a));
            });
        };
    };
}
function $3e6f5df673a67418$export$facc584867c26fde(a) {
    return function(b) {
        return function(c) {
            function d(a) {
                "number" == typeof a ? g && (k = !0, e(1)) : a.tag ? (g = !1, f(1)) : (f = a = a[0], a(0));
            }
            let e = $3e6f5df673a67418$var$m, f = $3e6f5df673a67418$var$m, g = !0, h = !1, k = !1;
            b(function(b) {
                "number" == typeof b ? (g && f(1), k = !0, c(0)) : b.tag ? g || k ? h ? h = !1 : (h = !0, e(0), f(0)) : (h = !1, c(b)) : (e = b[0], a(d));
            });
            c($3e6f5df673a67418$var$l(0, [
                function(a) {
                    if (!k) {
                        if (a) {
                            if (k = !0, e(1), g) return f(1);
                        } else h || (h = !0, g && f(0), e(0));
                    }
                }
            ]));
        };
    };
}
function $3e6f5df673a67418$export$175dedd748069215(a) {
    return function(b) {
        return function(c) {
            let d = $3e6f5df673a67418$var$m, e = !0;
            return b(function(b) {
                "number" == typeof b ? c(b) : b.tag ? e ? a(b[0]) ? d(0) : (e = !1, c(b)) : c(b) : (d = b[0], c(b));
            });
        };
    };
}
function $3e6f5df673a67418$export$6a45284a4b0bf33a(a) {
    return $3e6f5df673a67418$export$9f6ea8e48bc26eab($3e6f5df673a67418$var$L)(a);
}
function $3e6f5df673a67418$export$b7df5d561049483a(a) {
    return function(b) {
        return function(c) {
            let d = !1, e = 0, f = $3e6f5df673a67418$var$m;
            b(function(b) {
                "number" == typeof b ? d || (d = !0, c(0)) : b.tag ? e < a && !d && (e = e + 1 | 0, c(b), !d && e >= a && (d = !0, c(0), f(1))) : (b = b[0], 0 >= a ? (d = !0, c(0), b(1)) : f = b);
            });
            c($3e6f5df673a67418$var$l(0, [
                function(b) {
                    if (!d) {
                        if (b) return d = !0, f(1);
                        if (e < a) return f(0);
                    }
                }
            ]));
        };
    };
}
function $3e6f5df673a67418$export$ac8dfd3a7ad06e80(a) {
    return function(b) {
        return function(c) {
            function d(a) {
                "number" != typeof a && (a.tag ? (e = !0, f(1), c(0)) : (g = a = a[0], a(0)));
            }
            let e = !1, f = $3e6f5df673a67418$var$m, g = $3e6f5df673a67418$var$m;
            b(function(b) {
                "number" == typeof b ? e || (e = !0, g(1), c(0)) : b.tag ? e || c(b) : (f = b[0], a(d));
            });
            c($3e6f5df673a67418$var$l(0, [
                function(a) {
                    if (!e) return a ? (e = !0, f(1), g(1)) : f(0);
                }
            ]));
        };
    };
}
function $3e6f5df673a67418$export$9384c7afe4015e42(a) {
    return function(b) {
        return function(c) {
            let d = $3e6f5df673a67418$var$m, e = !1;
            return b(function(b) {
                "number" == typeof b ? e || (e = !0, c(0)) : b.tag ? e || (a(b[0]) ? c(b) : (e = !0, c(0), d(1))) : (d = b[0], c(b));
            });
        };
    };
}
function $3e6f5df673a67418$export$de363e709c412c8a(a) {
    return function(b) {
        return function(c) {
            function d() {
                void 0 !== g && clearTimeout($3e6f5df673a67418$var$x(g));
            }
            function e() {
                g = void 0;
                f = !1;
            }
            let f = !1, g = void 0;
            return b(function(b) {
                if ("number" == typeof b) d(), c(0);
                else if (b.tag) f || (f = !0, d(), g = $3e6f5df673a67418$var$w(setTimeout(e, a(b[0]))), c(b));
                else {
                    var h = b[0];
                    c($3e6f5df673a67418$var$l(0, [
                        function(a) {
                            return a ? (d(), h(1)) : h(a);
                        }
                    ]));
                }
            });
        };
    };
}
function $3e6f5df673a67418$export$45b10814cc054894(a) {
    let b = [], c = $3e6f5df673a67418$var$m, d = !1;
    a(function(a) {
        "number" == typeof a ? d = !0 : a.tag ? (b.push(a[0]), c(0)) : (c = a = a[0], a(0));
    });
    d || c(1);
    return b;
}
function $3e6f5df673a67418$export$95003814f91c442(a) {
    return function(b, c) {
        if (0 === b) return a(function(a) {
            function b(a) {
                switch(a){
                    case 1:
                        d(0);
                        break;
                    case 2:
                        d(1);
                }
            }
            if ("number" == typeof a) return 2 === c.length ? c(2, void 0) : c.bind(null, 2, void 0);
            if (a.tag) return a = a[0], 2 === c.length ? c(1, a) : c.bind(null, 1, a);
            var d = a[0];
            return 2 === c.length ? c(0, b) : c.bind(null, 0, b);
        });
    };
}
function $3e6f5df673a67418$export$b5a21352c348fea9(a) {
    var b = {
        subscribe: function(b, d, e) {
            var c = ("object" == typeof b ? b.next.bind(b) : b) || $3e6f5df673a67418$var$R, g = ("object" == typeof b ? b.complete.bind(b) : e) || $3e6f5df673a67418$var$S;
            let h = $3e6f5df673a67418$var$m, k = !1;
            a(function(a) {
                if ("number" == typeof a) return k = !0, g();
                if (a.tag) {
                    if (k) return;
                    c(a[0]);
                    return h(0);
                }
                h = a = a[0];
                a(0);
            });
            return {
                unsubscribe: function() {
                    if (!k) return this.closed = !1, k = !0, h(1);
                },
                closed: !1
            };
        }
    };
    b[$3e6f5df673a67418$var$P] = function() {
        return b;
    };
    return b;
}
function $3e6f5df673a67418$export$4dbaaf6c79705e6c(a) {
    return new Promise(function(b) {
        $3e6f5df673a67418$export$1b47ad771ce5af5e(1)(a)(function(a) {
            if ("number" != typeof a) {
                if (a.tag) b(a[0]);
                else a[0](0);
            }
        });
    });
}
var $3e6f5df673a67418$var$v = [], $3e6f5df673a67418$var$P = "function" == typeof Symbol ? Symbol.observable || (Symbol.observable = Symbol("observable")) : "@@observable";


function $ef0a7b6ad4b5eddb$var$rehydrateGraphQlError(r) {
    if ("string" == typeof r) return new (0, $8929bb59aa7984ca$export$92d6ed0888e7cb7f)(r);
    else if ("object" == typeof r && r.message) return new (0, $8929bb59aa7984ca$export$92d6ed0888e7cb7f)(r.message, r.nodes, r.source, r.positions, r.path, r, r.extensions || {});
    else return r;
}
var $ef0a7b6ad4b5eddb$export$e7094788287c5e9b = function(e) {
    function CombinedError(r) {
        var t = r.networkError;
        var n = r.response;
        var a = (r.graphQLErrors || []).map($ef0a7b6ad4b5eddb$var$rehydrateGraphQlError);
        var o = function generateErrorMessage(e, r) {
            var t = "";
            if (void 0 !== e) return t = "[Network] " + e.message;
            if (void 0 !== r) r.forEach(function(e) {
                t += "[GraphQL] " + e.message + "\n";
            });
            return t.trim();
        }(t, a);
        e.call(this, o);
        this.name = "CombinedError";
        this.message = o;
        this.graphQLErrors = a;
        this.networkError = t;
        this.response = n;
    }
    if (e) CombinedError.__proto__ = e;
    (CombinedError.prototype = Object.create(e && e.prototype)).constructor = CombinedError;
    CombinedError.prototype.toString = function toString() {
        return this.message;
    };
    return CombinedError;
}(Error);
function $ef0a7b6ad4b5eddb$var$phash(e, r) {
    e |= 0;
    for(var t = 0, n = 0 | r.length; t < n; t++)e = (e << 5) + e + r.charCodeAt(t);
    return e;
}
function $ef0a7b6ad4b5eddb$var$hash(e) {
    return $ef0a7b6ad4b5eddb$var$phash(5381, e) >>> 0;
}
var $ef0a7b6ad4b5eddb$var$i = new Set;
var $ef0a7b6ad4b5eddb$var$s = new WeakMap;
function $ef0a7b6ad4b5eddb$var$stringify(e) {
    if (null === e || $ef0a7b6ad4b5eddb$var$i.has(e)) return "null";
    else if ("object" != typeof e) return JSON.stringify(e) || "";
    else if (e.toJSON) return $ef0a7b6ad4b5eddb$var$stringify(e.toJSON());
    else if (Array.isArray(e)) {
        var r = "[";
        for(var t = 0, n = e.length; t < n; t++){
            if (t > 0) r += ",";
            var a = $ef0a7b6ad4b5eddb$var$stringify(e[t]);
            r += a.length > 0 ? a : "null";
        }
        return r += "]";
    }
    var o = Object.keys(e).sort();
    if (!o.length && e.constructor && e.constructor !== Object) {
        var u = $ef0a7b6ad4b5eddb$var$s.get(e) || Math.random().toString(36).slice(2);
        $ef0a7b6ad4b5eddb$var$s.set(e, u);
        return '{"__key":"' + u + '"}';
    }
    $ef0a7b6ad4b5eddb$var$i.add(e);
    var f = "{";
    for(var c = 0, l = o.length; c < l; c++){
        var p = o[c];
        var h = $ef0a7b6ad4b5eddb$var$stringify(e[p]);
        if (h) {
            if (f.length > 1) f += ",";
            f += $ef0a7b6ad4b5eddb$var$stringify(p) + ":" + h;
        }
    }
    $ef0a7b6ad4b5eddb$var$i.delete(e);
    return f += "}";
}
function $ef0a7b6ad4b5eddb$export$dda1d9f60106f0e9(e) {
    $ef0a7b6ad4b5eddb$var$i.clear();
    return $ef0a7b6ad4b5eddb$var$stringify(e);
}
var $ef0a7b6ad4b5eddb$var$u = /("{3}[\s\S]*"{3}|"(?:\\.|[^"])*")/g;
var $ef0a7b6ad4b5eddb$var$f = /([\s,]|#[^\n\r]+)+/g;
function $ef0a7b6ad4b5eddb$var$replaceOutsideStrings(e, r) {
    return r % 2 == 0 ? e.replace($ef0a7b6ad4b5eddb$var$f, " ").trim() : e;
}
function $ef0a7b6ad4b5eddb$export$2408f22a0fab9ae5(e) {
    var r = ("string" != typeof e ? e.loc && e.loc.source.body || (0, $e122e6bb51d23ef1$export$c2d084dc44961371)(e) : e).split($ef0a7b6ad4b5eddb$var$u).map($ef0a7b6ad4b5eddb$var$replaceOutsideStrings).join("");
    if ("string" != typeof e) {
        var t = "definitions" in e && $ef0a7b6ad4b5eddb$export$35e795649ee09318(e);
        if (t) r = "# " + t + "\n" + r;
        if (!e.loc) e.loc = {
            start: 0,
            end: r.length,
            source: {
                body: r,
                name: "gql",
                locationOffset: {
                    line: 1,
                    column: 1
                }
            }
        };
    }
    return r;
}
var $ef0a7b6ad4b5eddb$var$c = new Map;
function $ef0a7b6ad4b5eddb$export$342063e11d6c3cad(e) {
    var r;
    var n;
    if ("string" == typeof e) {
        r = $ef0a7b6ad4b5eddb$var$hash($ef0a7b6ad4b5eddb$export$2408f22a0fab9ae5(e));
        n = $ef0a7b6ad4b5eddb$var$c.get(r) || (0, $65896b1d71e63574$export$98e6a39c04603d36)(e, {
            noLocation: !0
        });
    } else {
        r = e.__key || $ef0a7b6ad4b5eddb$var$hash($ef0a7b6ad4b5eddb$export$2408f22a0fab9ae5(e));
        n = $ef0a7b6ad4b5eddb$var$c.get(r) || e;
    }
    if (!n.loc) $ef0a7b6ad4b5eddb$export$2408f22a0fab9ae5(n);
    n.__key = r;
    $ef0a7b6ad4b5eddb$var$c.set(r, n);
    return n;
}
function $ef0a7b6ad4b5eddb$export$2d1720544b23b823(e, r) {
    if (!r) r = {};
    var t = $ef0a7b6ad4b5eddb$export$342063e11d6c3cad(e);
    return {
        key: $ef0a7b6ad4b5eddb$var$phash(t.__key, $ef0a7b6ad4b5eddb$export$dda1d9f60106f0e9(r)) >>> 0,
        query: t,
        variables: r
    };
}
function $ef0a7b6ad4b5eddb$export$35e795649ee09318(e) {
    for(var t = 0, n = e.definitions.length; t < n; t++){
        var a = e.definitions[t];
        if (a.kind === (0, $91330b884e9db43f$export$a84bdc57c5122798).OPERATION_DEFINITION && a.name) return a.name.value;
    }
}
function $ef0a7b6ad4b5eddb$export$39b482c5e57630a8(e) {
    for(var t = 0, n = e.definitions.length; t < n; t++){
        var a = e.definitions[t];
        if (a.kind === (0, $91330b884e9db43f$export$a84bdc57c5122798).OPERATION_DEFINITION) return a.operation;
    }
}
function $ef0a7b6ad4b5eddb$export$71511d61b312f219() {
    $ef0a7b6ad4b5eddb$export$71511d61b312f219 = Object.assign || function(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = arguments[r];
            for(var n in t)if (Object.prototype.hasOwnProperty.call(t, n)) e[n] = t[n];
        }
        return e;
    };
    return $ef0a7b6ad4b5eddb$export$71511d61b312f219.apply(this, arguments);
}
function $ef0a7b6ad4b5eddb$export$953cecd6e717a553(e, r, t) {
    if (!("data" in r) && !("errors" in r) || "path" in r) throw new Error("No Content");
    return {
        operation: e,
        data: r.data,
        error: Array.isArray(r.errors) ? new $ef0a7b6ad4b5eddb$export$e7094788287c5e9b({
            graphQLErrors: r.errors,
            response: t
        }) : void 0,
        extensions: "object" == typeof r.extensions && r.extensions || void 0,
        hasNext: !!r.hasNext
    };
}
function $ef0a7b6ad4b5eddb$export$23f2a1d2818174ef(e, r, t) {
    var n = $ef0a7b6ad4b5eddb$export$71511d61b312f219({}, e);
    n.hasNext = !!r.hasNext;
    if (!("path" in r)) {
        if ("data" in r) n.data = r.data;
        return n;
    }
    if (Array.isArray(r.errors)) n.error = new $ef0a7b6ad4b5eddb$export$e7094788287c5e9b({
        graphQLErrors: n.error ? n.error.graphQLErrors.concat(r.errors) : r.errors,
        response: t
    });
    var a = n.data = $ef0a7b6ad4b5eddb$export$71511d61b312f219({}, n.data);
    var i = 0;
    var s;
    while(i < r.path.length)a = a[s = r.path[i++]] = Array.isArray(a[s]) ? [].concat(a[s]) : $ef0a7b6ad4b5eddb$export$71511d61b312f219({}, a[s]);
    $ef0a7b6ad4b5eddb$export$71511d61b312f219(a, r.data);
    return n;
}
function $ef0a7b6ad4b5eddb$export$407448d2b89b1813(e, r, t) {
    return {
        operation: e,
        data: void 0,
        error: new $ef0a7b6ad4b5eddb$export$e7094788287c5e9b({
            networkError: r,
            response: t
        }),
        extensions: void 0
    };
}
function $ef0a7b6ad4b5eddb$var$shouldUseGet(e) {
    return "query" === e.kind && !!e.context.preferGetMethod;
}
function $ef0a7b6ad4b5eddb$export$8b22cf2602fb60ce(e) {
    return {
        query: (0, $e122e6bb51d23ef1$export$c2d084dc44961371)(e.query),
        operationName: $ef0a7b6ad4b5eddb$export$35e795649ee09318(e.query),
        variables: e.variables || void 0,
        extensions: void 0
    };
}
function $ef0a7b6ad4b5eddb$export$db3b6bfb95261072(e, r) {
    var t = $ef0a7b6ad4b5eddb$var$shouldUseGet(e);
    var n = e.context.url;
    if (!t || !r) return n;
    var a = [];
    if (r.operationName) a.push("operationName=" + encodeURIComponent(r.operationName));
    if (r.query) a.push("query=" + encodeURIComponent(r.query.replace(/#[^\n\r]+/g, " ").trim()));
    if (r.variables) a.push("variables=" + encodeURIComponent($ef0a7b6ad4b5eddb$export$dda1d9f60106f0e9(r.variables)));
    if (r.extensions) a.push("extensions=" + encodeURIComponent($ef0a7b6ad4b5eddb$export$dda1d9f60106f0e9(r.extensions)));
    var o = n + "?" + a.join("&");
    if (o.length > 2047) {
        e.context.preferGetMethod = !1;
        return n;
    }
    return o;
}
function $ef0a7b6ad4b5eddb$export$4368d992c4eafac0(e, r) {
    var t = $ef0a7b6ad4b5eddb$var$shouldUseGet(e);
    var n = {
        accept: "application/graphql+json, application/json"
    };
    if (!t) n["content-type"] = "application/json";
    var a = ("function" == typeof e.context.fetchOptions ? e.context.fetchOptions() : e.context.fetchOptions) || {};
    if (a.headers) for(var o in a.headers)n[o.toLowerCase()] = a.headers[o];
    return $ef0a7b6ad4b5eddb$export$71511d61b312f219({}, a, {
        body: !t && r ? JSON.stringify(r) : void 0,
        method: t ? "GET" : "POST",
        headers: n
    });
}
var $ef0a7b6ad4b5eddb$var$l = "undefined" != typeof Symbol ? Symbol.asyncIterator : null;
var $ef0a7b6ad4b5eddb$var$p = "undefined" != typeof TextDecoder ? new TextDecoder : null;
var $ef0a7b6ad4b5eddb$var$h = /content-type:[^\r\n]*application\/json/i;
var $ef0a7b6ad4b5eddb$var$d = /boundary="?([^=";]+)"?/i;
function $ef0a7b6ad4b5eddb$export$f1e1789686576879(e, r, t) {
    var n = "manual" === t.redirect ? 400 : 300;
    var o = e.context.fetch;
    return (0, $3e6f5df673a67418$export$dd44f18ab656f3bb)(function(a) {
        var i = a.next;
        var s = a.complete;
        var u = "undefined" != typeof AbortController ? new AbortController : null;
        if (u) t.signal = u.signal;
        var f = !1;
        function executeIncrementalFetch(e, r, t) {
            var n = t.headers && t.headers.get("Content-Type") || "";
            if (/text\//i.test(n)) return t.text().then(function(n) {
                e($ef0a7b6ad4b5eddb$export$407448d2b89b1813(r, new Error(n), t));
            });
            else if (!/multipart\/mixed/i.test(n)) return t.text().then(function(n) {
                e($ef0a7b6ad4b5eddb$export$953cecd6e717a553(r, JSON.parse(n), t));
            });
            var a = "---";
            var o = n.match($ef0a7b6ad4b5eddb$var$d);
            if (o) a = "--" + o[1];
            var i;
            var cancel = function() {};
            if ($ef0a7b6ad4b5eddb$var$l && t[$ef0a7b6ad4b5eddb$var$l]) {
                var s = t[$ef0a7b6ad4b5eddb$var$l]();
                i = s.next.bind(s);
            } else if ("body" in t && t.body) {
                var u = t.body.getReader();
                cancel = u.cancel.bind(u);
                i = u.read.bind(u);
            } else throw new TypeError("Streaming requests unsupported");
            var c = "";
            var v = !0;
            var m = null;
            var g = null;
            return i().then(function next(n) {
                if (!n.done) {
                    var o = function toString(e) {
                        return "Buffer" === e.constructor.name ? e.toString() : $ef0a7b6ad4b5eddb$var$p.decode(e);
                    }(n.value);
                    var s = o.indexOf(a);
                    if (s > -1) s += c.length;
                    else s = c.indexOf(a);
                    c += o;
                    while(s > -1){
                        var u = c.slice(0, s);
                        var l = c.slice(s + a.length);
                        if (v) v = !1;
                        else {
                            var d = u.indexOf("\r\n\r\n") + 4;
                            var y = u.slice(0, d);
                            var x = u.slice(d, u.lastIndexOf("\r\n"));
                            var b = void 0;
                            if ($ef0a7b6ad4b5eddb$var$h.test(y)) try {
                                b = JSON.parse(x);
                                m = g = g ? $ef0a7b6ad4b5eddb$export$23f2a1d2818174ef(g, b, t) : $ef0a7b6ad4b5eddb$export$953cecd6e717a553(r, b, t);
                            } catch (e) {}
                            if ("--" === l.slice(0, 2) || b && !b.hasNext) {
                                if (!g) return e($ef0a7b6ad4b5eddb$export$953cecd6e717a553(r, {}, t));
                                break;
                            }
                        }
                        s = (c = l).indexOf(a);
                    }
                } else f = !0;
                if (m) {
                    e(m);
                    m = null;
                }
                if (!n.done && (!g || g.hasNext)) return i().then(next);
            }).finally(cancel);
        }
        var c = !1;
        var v = !1;
        var m;
        Promise.resolve().then(function() {
            if (c) return;
            return (o || fetch)(r, t);
        }).then(function(r) {
            if (!r) return;
            v = (m = r).status < 200 || m.status >= n;
            return executeIncrementalFetch(i, e, m);
        }).then(s).catch(function(r) {
            if (f) throw r;
            var t = $ef0a7b6ad4b5eddb$export$407448d2b89b1813(e, v ? m.statusText ? new Error(m.statusText) : r : r, m);
            i(t);
            s();
        });
        return function() {
            c = !0;
            if (u) u.abort();
        };
    });
}



function $3bf714f6c012ccf2$var$collectTypes(e, n) {
    if (Array.isArray(e)) for(var r = 0; r < e.length; r++)$3bf714f6c012ccf2$var$collectTypes(e[r], n);
    else if ("object" == typeof e && null !== e) {
        for(var t in e)if ("__typename" === t && "string" == typeof e[t]) n[e[t]] = 0;
        else $3bf714f6c012ccf2$var$collectTypes(e[t], n);
    }
    return n;
}
function $3bf714f6c012ccf2$var$collectTypesFromResponse(e) {
    return Object.keys($3bf714f6c012ccf2$var$collectTypes(e, {}));
}
var $3bf714f6c012ccf2$var$formatNode = function(e) {
    if (e.selectionSet && !e.selectionSet.selections.some(function(e) {
        return e.kind === (0, $91330b884e9db43f$export$a84bdc57c5122798).FIELD && "__typename" === e.name.value && !e.alias;
    })) return (0, $ef0a7b6ad4b5eddb$export$71511d61b312f219)({}, e, {
        selectionSet: (0, $ef0a7b6ad4b5eddb$export$71511d61b312f219)({}, e.selectionSet, {
            selections: e.selectionSet.selections.concat([
                {
                    kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).FIELD,
                    name: {
                        kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).NAME,
                        value: "__typename"
                    }
                }
            ])
        })
    });
};
var $3bf714f6c012ccf2$var$F = new Map;
function $3bf714f6c012ccf2$export$4d94eb8deda64786(n) {
    var r = (0, $ef0a7b6ad4b5eddb$export$342063e11d6c3cad)(n);
    var a = $3bf714f6c012ccf2$var$F.get(r.__key);
    if (!a) {
        a = (0, $3a3231b31fef9807$export$bf638b60ea8b89b7)(r, {
            Field: $3bf714f6c012ccf2$var$formatNode,
            InlineFragment: $3bf714f6c012ccf2$var$formatNode
        });
        Object.defineProperty(a, "__key", {
            value: r.__key,
            enumerable: !1
        });
        $3bf714f6c012ccf2$var$F.set(r.__key, a);
    }
    return a;
}
function $3bf714f6c012ccf2$export$7b3d2f357293ffe3(e) {
    if (!e || "object" != typeof e) return e;
    return Object.keys(e).reduce(function(n, r) {
        var t = e[r];
        if ("__typename" === r) Object.defineProperty(n, "__typename", {
            enumerable: !1,
            value: t
        });
        else if (Array.isArray(t)) n[r] = t.map($3bf714f6c012ccf2$export$7b3d2f357293ffe3);
        else if (t && "object" == typeof t && "__typename" in t) n[r] = $3bf714f6c012ccf2$export$7b3d2f357293ffe3(t);
        else n[r] = t;
        return n;
    }, Array.isArray(e) ? [] : {});
}
function $3bf714f6c012ccf2$var$withPromise(e) {
    e.toPromise = function() {
        return new Promise(function(n) {
            var r = (0, $3e6f5df673a67418$export$ec068583843480e7)(function(e) {
                if (!e.stale && !e.hasNext) Promise.resolve().then(function() {
                    r.unsubscribe();
                    n(e);
                });
            })(e);
        });
    };
    return e;
}
function $3bf714f6c012ccf2$export$dac456ae68957b8f(e, n, r) {
    if (!r) r = n.context;
    return {
        key: n.key,
        query: n.query,
        variables: n.variables,
        kind: e,
        context: r
    };
}
function $3bf714f6c012ccf2$var$addMetadata(e, n) {
    return $3bf714f6c012ccf2$export$dac456ae68957b8f(e.kind, e, (0, $ef0a7b6ad4b5eddb$export$71511d61b312f219)({}, e.context, {
        meta: (0, $ef0a7b6ad4b5eddb$export$71511d61b312f219)({}, e.context.meta, n)
    }));
}
function $3bf714f6c012ccf2$var$noop() {}
function $3bf714f6c012ccf2$var$applyDefinitions(e, r, t) {
    for(var a = 0; a < t.length; a++)if (t[a].kind === (0, $91330b884e9db43f$export$a84bdc57c5122798).FRAGMENT_DEFINITION) {
        var o = t[a].name.value;
        var i = (0, $ef0a7b6ad4b5eddb$export$2408f22a0fab9ae5)(t[a]);
        if (!e.has(o)) {
            e.set(o, i);
            r.push(t[a]);
        }
    } else r.push(t[a]);
}
function $3bf714f6c012ccf2$export$72e4926bf8358653() {
    var e = arguments;
    var r = new Map;
    var a = [];
    var o = [];
    var i = Array.isArray(arguments[0]) ? arguments[0][0] : arguments[0] || "";
    for(var u = 1; u < arguments.length; u++){
        var c = e[u];
        if (c && c.definitions) o.push.apply(o, c.definitions);
        else i += c;
        i += e[0][u];
    }
    $3bf714f6c012ccf2$var$applyDefinitions(r, a, (0, $ef0a7b6ad4b5eddb$export$342063e11d6c3cad)(i).definitions);
    $3bf714f6c012ccf2$var$applyDefinitions(r, a, o);
    return (0, $ef0a7b6ad4b5eddb$export$342063e11d6c3cad)({
        kind: (0, $91330b884e9db43f$export$a84bdc57c5122798).DOCUMENT,
        definitions: a
    });
}
function $3bf714f6c012ccf2$var$shouldSkip(e) {
    var n = e.kind;
    return "mutation" !== n && "query" !== n;
}
function $3bf714f6c012ccf2$export$de01951d82452cab(e) {
    var n = e.forward;
    var r = e.client;
    var t = e.dispatchDebug;
    var a = new Map;
    var i = Object.create(null);
    function mapTypeNames(e) {
        var n = $3bf714f6c012ccf2$export$dac456ae68957b8f(e.kind, e);
        n.query = $3bf714f6c012ccf2$export$4d94eb8deda64786(e.query);
        return n;
    }
    function isOperationCached(e) {
        var n = e.context.requestPolicy;
        return "query" === e.kind && "network-only" !== n && ("cache-only" === n || a.has(e.key));
    }
    return function(e) {
        var u = (0, $3e6f5df673a67418$export$ed80d9de1d9df928)(e);
        var c = (0, $3e6f5df673a67418$export$871de8747c9eaa88)(function(e) {
            var n = a.get(e.key);
            var i = (0, $ef0a7b6ad4b5eddb$export$71511d61b312f219)({}, n, {
                operation: $3bf714f6c012ccf2$var$addMetadata(e, {
                    cacheOutcome: n ? "hit" : "miss"
                })
            });
            if ("cache-and-network" === e.context.requestPolicy) {
                i.stale = !0;
                $3bf714f6c012ccf2$var$reexecuteOperation(r, e);
            }
            return i;
        })((0, $3e6f5df673a67418$export$3dea766d36a8935f)(function(e) {
            return !$3bf714f6c012ccf2$var$shouldSkip(e) && isOperationCached(e);
        })(u));
        var s = (0, $3e6f5df673a67418$export$fff70a13d53402ec)(function(e) {
            var n = e.operation;
            if (!n) return;
            var o = $3bf714f6c012ccf2$var$collectTypesFromResponse(e.data).concat(n.context.additionalTypenames || []);
            if ("mutation" === e.operation.kind) {
                var u = new Set;
                for(var c = 0; c < o.length; c++){
                    var s = o[c];
                    var f = i[s] || (i[s] = new Set);
                    f.forEach(function(e) {
                        u.add(e);
                    });
                    f.clear();
                }
                u.forEach(function(e) {
                    if (a.has(e)) {
                        n = a.get(e).operation;
                        a.delete(e);
                        $3bf714f6c012ccf2$var$reexecuteOperation(r, n);
                    }
                });
            } else if ("query" === n.kind && e.data) {
                a.set(n.key, e);
                for(var p = 0; p < o.length; p++){
                    var l = o[p];
                    (i[l] || (i[l] = new Set)).add(n.key);
                }
            }
        })(n((0, $3e6f5df673a67418$export$3dea766d36a8935f)(function(e) {
            return "query" !== e.kind || "cache-only" !== e.context.requestPolicy;
        })((0, $3e6f5df673a67418$export$871de8747c9eaa88)(function(e) {
            return $3bf714f6c012ccf2$var$addMetadata(e, {
                cacheOutcome: "miss"
            });
        })((0, $3e6f5df673a67418$export$4950aa0f605343fb)([
            (0, $3e6f5df673a67418$export$871de8747c9eaa88)(mapTypeNames)((0, $3e6f5df673a67418$export$3dea766d36a8935f)(function(e) {
                return !$3bf714f6c012ccf2$var$shouldSkip(e) && !isOperationCached(e);
            })(u)),
            (0, $3e6f5df673a67418$export$3dea766d36a8935f)(function(e) {
                return $3bf714f6c012ccf2$var$shouldSkip(e);
            })(u)
        ])))));
        return (0, $3e6f5df673a67418$export$4950aa0f605343fb)([
            c,
            s
        ]);
    };
}
function $3bf714f6c012ccf2$var$reexecuteOperation(e, n) {
    return e.reexecuteOperation($3bf714f6c012ccf2$export$dac456ae68957b8f(n.kind, n, (0, $ef0a7b6ad4b5eddb$export$71511d61b312f219)({}, n.context, {
        requestPolicy: "network-only"
    })));
}
var $3bf714f6c012ccf2$var$Q = new Set;
function $3bf714f6c012ccf2$export$5487dac036b20ecc(e) {
    var n = !(!e || !e.staleWhileRevalidate);
    var r = !(!e || !e.includeExtensions);
    var t = {};
    var a = [];
    function invalidate(e) {
        a.push(e.operation.key);
        if (1 === a.length) Promise.resolve().then(function() {
            var e;
            while(e = a.shift())t[e] = null;
        });
    }
    var ssr = function(a) {
        var o = a.client;
        var i = a.forward;
        return function(a) {
            var u = e && "boolean" == typeof e.isClient ? !!e.isClient : !o.suspense;
            var s = (0, $3e6f5df673a67418$export$ed80d9de1d9df928)(a);
            var f = i((0, $3e6f5df673a67418$export$3dea766d36a8935f)(function(e) {
                return !t[e.key] || !!t[e.key].hasNext;
            })(s));
            var p = (0, $3e6f5df673a67418$export$871de8747c9eaa88)(function(e) {
                var a = function deserializeResult(e, n, r) {
                    return {
                        operation: e,
                        data: n.data ? JSON.parse(n.data) : void 0,
                        extensions: r && n.extensions ? JSON.parse(n.extensions) : void 0,
                        error: n.error ? new (0, $ef0a7b6ad4b5eddb$export$e7094788287c5e9b)({
                            networkError: n.error.networkError ? new Error(n.error.networkError) : void 0,
                            graphQLErrors: n.error.graphQLErrors
                        }) : void 0,
                        hasNext: n.hasNext
                    };
                }(e, t[e.key], r);
                if (n && !$3bf714f6c012ccf2$var$Q.has(e.key)) {
                    a.stale = !0;
                    $3bf714f6c012ccf2$var$Q.add(e.key);
                    $3bf714f6c012ccf2$var$reexecuteOperation(o, e);
                }
                return a;
            })((0, $3e6f5df673a67418$export$3dea766d36a8935f)(function(e) {
                return !!t[e.key] && "network-only" !== e.context.requestPolicy;
            })(s));
            if (!u) f = (0, $3e6f5df673a67418$export$fff70a13d53402ec)(function(e) {
                var n = e.operation;
                if ("mutation" !== n.kind) {
                    var a = function serializeResult(e, n) {
                        var r = e.hasNext;
                        var t = e.data;
                        var a = e.extensions;
                        var o = e.error;
                        var i = {};
                        if (void 0 !== t) i.data = JSON.stringify(t);
                        if (n && void 0 !== a) i.extensions = JSON.stringify(a);
                        if (r) i.hasNext = !0;
                        if (o) {
                            i.error = {
                                graphQLErrors: o.graphQLErrors.map(function(e) {
                                    if (!e.path && !e.extensions) return e.message;
                                    return {
                                        message: e.message,
                                        path: e.path,
                                        extensions: e.extensions
                                    };
                                })
                            };
                            if (o.networkError) i.error.networkError = "" + o.networkError;
                        }
                        return i;
                    }(e, r);
                    t[n.key] = a;
                }
            })(f);
            else p = (0, $3e6f5df673a67418$export$fff70a13d53402ec)(invalidate)(p);
            return (0, $3e6f5df673a67418$export$4950aa0f605343fb)([
                f,
                p
            ]);
        };
    };
    ssr.restoreData = function(e) {
        for(var n in e)if (null !== t[n]) t[n] = e[n];
    };
    ssr.extractData = function() {
        var e = {};
        for(var n in t)if (null != t[n]) e[n] = t[n];
        return e;
    };
    if (e && e.initialState) ssr.restoreData(e.initialState);
    return ssr;
}
function $3bf714f6c012ccf2$export$d2bda267fe4a032e(e) {
    var n = e.forwardSubscription;
    var t = e.enableAllOperations;
    var a = e.isSubscriptionOperation;
    return function(e) {
        var i = e.client;
        var u = e.forward;
        var c = a || function(e) {
            var n = e.kind;
            return "subscription" === n || !!t && ("query" === n || "mutation" === n);
        };
        return function(e) {
            var t = (0, $3e6f5df673a67418$export$ed80d9de1d9df928)(e);
            var a = (0, $3e6f5df673a67418$export$6b9f6c0d32c093f9)(function(e) {
                var a = e.key;
                var u = (0, $3e6f5df673a67418$export$3dea766d36a8935f)(function(e) {
                    return "teardown" === e.kind && e.key === a;
                })(t);
                return (0, $3e6f5df673a67418$export$ac8dfd3a7ad06e80)(u)(function createSubscriptionSource(e) {
                    var t = n({
                        key: e.key.toString(36),
                        query: (0, $e122e6bb51d23ef1$export$c2d084dc44961371)(e.query),
                        variables: e.variables,
                        context: (0, $ef0a7b6ad4b5eddb$export$71511d61b312f219)({}, e.context)
                    });
                    return (0, $3e6f5df673a67418$export$dd44f18ab656f3bb)(function(n) {
                        var r = n.next;
                        var a = n.complete;
                        var o = !1;
                        var u;
                        Promise.resolve().then(function() {
                            if (o) return;
                            u = t.subscribe({
                                next: function(n) {
                                    return r((0, $ef0a7b6ad4b5eddb$export$953cecd6e717a553)(e, n));
                                },
                                error: function(n) {
                                    return r((0, $ef0a7b6ad4b5eddb$export$407448d2b89b1813)(e, n));
                                },
                                complete: function() {
                                    if (!o) {
                                        o = !0;
                                        if ("subscription" === e.kind) i.reexecuteOperation($3bf714f6c012ccf2$export$dac456ae68957b8f("teardown", e, e.context));
                                        a();
                                    }
                                }
                            });
                        });
                        return function() {
                            o = !0;
                            if (u) u.unsubscribe();
                        };
                    });
                }(e));
            })((0, $3e6f5df673a67418$export$3dea766d36a8935f)(c)(t));
            var f = u((0, $3e6f5df673a67418$export$3dea766d36a8935f)(function(e) {
                return !c(e);
            })(t));
            return (0, $3e6f5df673a67418$export$4950aa0f605343fb)([
                a,
                f
            ]);
        };
    };
}
function $3bf714f6c012ccf2$export$f088b66ceb324131(e) {
    var n = e.forward;
    return function(e) {
        return n(e);
    };
}
function $3bf714f6c012ccf2$export$cabeac3724386ece(e) {
    var n = e.forward;
    var r = e.dispatchDebug;
    var t = new Set;
    function filterIncomingOperation(e) {
        var n = e.key;
        var a = e.kind;
        if ("teardown" === a) {
            t.delete(n);
            return !0;
        }
        if ("query" !== a && "subscription" !== a) return !0;
        var o = t.has(n);
        t.add(n);
        o;
        return !o;
    }
    function afterOperationResult(e) {
        if (!e.hasNext) t.delete(e.operation.key);
    }
    return function(e) {
        var r = (0, $3e6f5df673a67418$export$3dea766d36a8935f)(filterIncomingOperation)(e);
        return (0, $3e6f5df673a67418$export$fff70a13d53402ec)(afterOperationResult)(n(r));
    };
}
function $3bf714f6c012ccf2$export$7fed09527e654bc9(e) {
    var n = e.forward;
    var r = e.dispatchDebug;
    return function(e) {
        var t = (0, $3e6f5df673a67418$export$ed80d9de1d9df928)(e);
        var a = (0, $3e6f5df673a67418$export$6b9f6c0d32c093f9)(function(e) {
            var n = e.key;
            var a = (0, $3e6f5df673a67418$export$3dea766d36a8935f)(function(e) {
                return "teardown" === e.kind && e.key === n;
            })(t);
            var o = (0, $ef0a7b6ad4b5eddb$export$8b22cf2602fb60ce)(e);
            var i = (0, $ef0a7b6ad4b5eddb$export$db3b6bfb95261072)(e, o);
            var u = (0, $ef0a7b6ad4b5eddb$export$4368d992c4eafac0)(e, o);
            return (0, $3e6f5df673a67418$export$fff70a13d53402ec)(function(n) {
                var t = !n.data ? n.error : void 0;
            })((0, $3e6f5df673a67418$export$ac8dfd3a7ad06e80)(a)((0, $ef0a7b6ad4b5eddb$export$f1e1789686576879)(e, i, u)));
        })((0, $3e6f5df673a67418$export$3dea766d36a8935f)(function(e) {
            return "query" === e.kind || "mutation" === e.kind;
        })(t));
        var o = n((0, $3e6f5df673a67418$export$3dea766d36a8935f)(function(e) {
            return "query" !== e.kind && "mutation" !== e.kind;
        })(t));
        return (0, $3e6f5df673a67418$export$4950aa0f605343fb)([
            a,
            o
        ]);
    };
}
function $3bf714f6c012ccf2$var$fallbackExchange(e) {
    var n = e.dispatchDebug;
    return function(e) {
        return (0, $3e6f5df673a67418$export$3dea766d36a8935f)(function() {
            return !1;
        })((0, $3e6f5df673a67418$export$fff70a13d53402ec)(function(e) {
            e.kind;
            var r;
        })(e));
    };
}
var $3bf714f6c012ccf2$export$9d3d4c69d78982e3 = $3bf714f6c012ccf2$var$fallbackExchange({
    dispatchDebug: $3bf714f6c012ccf2$var$noop
});
function $3bf714f6c012ccf2$export$1e79974f5647c6ed(e) {
    return function(n) {
        var r = n.client;
        var t = n.dispatchDebug;
        return e.reduceRight(function(e, n) {
            return n({
                client: r,
                forward: e,
                dispatchDebug: function dispatchDebug$1(e) {}
            });
        }, n.forward);
    };
}
function $3bf714f6c012ccf2$export$454d06fa782923cb(e) {
    var n = e.onError;
    return function(e) {
        var r = e.forward;
        return function(e) {
            return (0, $3e6f5df673a67418$export$fff70a13d53402ec)(function(e) {
                var r = e.error;
                if (r) n(r, e.operation);
            })(r(e));
        };
    };
}
var $3bf714f6c012ccf2$export$cb23584d85a20048 = [
    $3bf714f6c012ccf2$export$cabeac3724386ece,
    $3bf714f6c012ccf2$export$de01951d82452cab,
    $3bf714f6c012ccf2$export$7fed09527e654bc9
];
var $3bf714f6c012ccf2$export$1f2bb630327ac4b6 = function Client(e) {
    var n = new Map;
    var r = new Map;
    var t = [];
    var a = (0, $3e6f5df673a67418$export$c4c2a35435b4a722)();
    var i = a.source;
    var u = a.next;
    var c = !1;
    function dispatchOperation(e) {
        if (e) u(e);
        if (!c) {
            c = !0;
            while(c && (e = t.shift()))u(e);
            c = !1;
        }
    }
    function makeResultSource(e) {
        var a = (0, $3e6f5df673a67418$export$3dea766d36a8935f)(function(n) {
            return n.operation.kind === e.kind && n.operation.key === e.key && (!n.operation.context._instance || n.operation.context._instance === e.context._instance);
        })(y);
        if (f.maskTypename) a = (0, $3e6f5df673a67418$export$871de8747c9eaa88)(function(e) {
            return (0, $ef0a7b6ad4b5eddb$export$71511d61b312f219)({}, e, {
                data: $3bf714f6c012ccf2$export$7b3d2f357293ffe3(e.data)
            });
        })(a);
        if ("mutation" === e.kind) return (0, $3e6f5df673a67418$export$b7df5d561049483a)(1)((0, $3e6f5df673a67418$export$aaa2d21dd8862419)(function() {
            return u(e);
        })(a));
        return (0, $3e6f5df673a67418$export$ed80d9de1d9df928)((0, $3e6f5df673a67418$export$db4d2a4aed77becf)(function() {
            n.delete(e.key);
            r.delete(e.key);
            for(var a = t.length - 1; a >= 0; a--)if (t[a].key === e.key) t.splice(a, 1);
            u($3bf714f6c012ccf2$export$dac456ae68957b8f("teardown", e, e.context));
        })((0, $3e6f5df673a67418$export$fff70a13d53402ec)(function(r) {
            n.set(e.key, r);
        })((0, $3e6f5df673a67418$export$9f6ea8e48bc26eab)(function(n) {
            if ("query" !== e.kind || n.stale) return (0, $3e6f5df673a67418$export$5f36b26c3833b3ba)(n);
            return (0, $3e6f5df673a67418$export$4950aa0f605343fb)([
                (0, $3e6f5df673a67418$export$5f36b26c3833b3ba)(n),
                (0, $3e6f5df673a67418$export$871de8747c9eaa88)(function() {
                    return (0, $ef0a7b6ad4b5eddb$export$71511d61b312f219)({}, n, {
                        stale: !0
                    });
                })((0, $3e6f5df673a67418$export$b7df5d561049483a)(1)((0, $3e6f5df673a67418$export$3dea766d36a8935f)(function(n) {
                    return "query" === n.kind && n.key === e.key && "cache-only" !== n.context.requestPolicy;
                })(i)))
            ]);
        })((0, $3e6f5df673a67418$export$ac8dfd3a7ad06e80)((0, $3e6f5df673a67418$export$3dea766d36a8935f)(function(n) {
            return "teardown" === n.kind && n.key === e.key;
        })(i))(a)))));
    }
    var s = this instanceof Client ? this : Object.create(Client.prototype);
    var f = (0, $ef0a7b6ad4b5eddb$export$71511d61b312f219)(s, {
        url: e.url,
        fetchOptions: e.fetchOptions,
        fetch: e.fetch,
        suspense: !!e.suspense,
        requestPolicy: e.requestPolicy || "cache-first",
        preferGetMethod: !!e.preferGetMethod,
        maskTypename: !!e.maskTypename,
        operations$: i,
        reexecuteOperation: function reexecuteOperation(e) {
            if ("mutation" === e.kind || r.has(e.key)) {
                t.push(e);
                Promise.resolve().then(dispatchOperation);
            }
        },
        createOperationContext: function createOperationContext(e) {
            if (!e) e = {};
            return (0, $ef0a7b6ad4b5eddb$export$71511d61b312f219)({}, {
                _instance: void 0,
                url: f.url,
                fetchOptions: f.fetchOptions,
                fetch: f.fetch,
                preferGetMethod: f.preferGetMethod
            }, e, {
                suspense: e.suspense || !1 !== e.suspense && f.suspense,
                requestPolicy: e.requestPolicy || f.requestPolicy
            });
        },
        createRequestOperation: function createRequestOperation(e, n, r) {
            var t = (0, $ef0a7b6ad4b5eddb$export$39b482c5e57630a8)(n.query);
            var a = f.createOperationContext(r);
            if ("mutation" === e) a._instance = [];
            return $3bf714f6c012ccf2$export$dac456ae68957b8f(e, n, a);
        },
        executeRequestOperation: function executeRequestOperation(e) {
            if ("mutation" === e.kind) return makeResultSource(e);
            return (0, $3e6f5df673a67418$export$dd44f18ab656f3bb)(function(t) {
                var a = r.get(e.key);
                if (!a) r.set(e.key, a = makeResultSource(e));
                var i = "cache-and-network" === e.context.requestPolicy || "network-only" === e.context.requestPolicy;
                return (0, $3e6f5df673a67418$export$ec068583843480e7)(t.next)((0, $3e6f5df673a67418$export$db4d2a4aed77becf)(function() {
                    c = !1;
                    t.complete();
                })((0, $3e6f5df673a67418$export$aaa2d21dd8862419)(function() {
                    var r = n.get(e.key);
                    if ("subscription" === e.kind) return dispatchOperation(e);
                    else if (i) dispatchOperation(e);
                    if (null != r && r === n.get(e.key)) t.next(i ? (0, $ef0a7b6ad4b5eddb$export$71511d61b312f219)({}, r, {
                        stale: !0
                    }) : r);
                    else if (!i) dispatchOperation(e);
                })(a))).unsubscribe;
            });
        },
        executeQuery: function executeQuery(e, n) {
            var r = f.createRequestOperation("query", e, n);
            return f.executeRequestOperation(r);
        },
        executeSubscription: function executeSubscription(e, n) {
            var r = f.createRequestOperation("subscription", e, n);
            return f.executeRequestOperation(r);
        },
        executeMutation: function executeMutation(e, n) {
            var r = f.createRequestOperation("mutation", e, n);
            return f.executeRequestOperation(r);
        },
        query: function query(e, n, r) {
            if (!r || "boolean" != typeof r.suspense) r = (0, $ef0a7b6ad4b5eddb$export$71511d61b312f219)({}, r, {
                suspense: !1
            });
            return $3bf714f6c012ccf2$var$withPromise(f.executeQuery((0, $ef0a7b6ad4b5eddb$export$2d1720544b23b823)(e, n), r));
        },
        readQuery: function readQuery(e, n, r) {
            var t = null;
            (0, $3e6f5df673a67418$export$ec068583843480e7)(function(e) {
                t = e;
            })(f.query(e, n, r)).unsubscribe();
            return t;
        },
        subscription: function subscription(e, n, r) {
            return f.executeSubscription((0, $ef0a7b6ad4b5eddb$export$2d1720544b23b823)(e, n), r);
        },
        mutation: function mutation(e, n, r) {
            return $3bf714f6c012ccf2$var$withPromise(f.executeMutation((0, $ef0a7b6ad4b5eddb$export$2d1720544b23b823)(e, n), r));
        }
    });
    var p = $3bf714f6c012ccf2$var$noop;
    var l, d, v;
    var h = $3bf714f6c012ccf2$export$1e79974f5647c6ed(void 0 !== e.exchanges ? e.exchanges : $3bf714f6c012ccf2$export$cb23584d85a20048);
    var y = (0, $3e6f5df673a67418$export$ed80d9de1d9df928)(h({
        client: f,
        dispatchDebug: p,
        forward: $3bf714f6c012ccf2$var$fallbackExchange({
            dispatchDebug: p
        })
    })(i));
    (0, $3e6f5df673a67418$export$89b472e03be495df)(y);
    return f;
};
var $3bf714f6c012ccf2$export$5d730b7aed1a3eb0 = $3bf714f6c012ccf2$export$1f2bb630327ac4b6;



var $exYeM = parcelRequire("exYeM");

var $4806a602ceddc868$var$p = (0, $3bf714f6c012ccf2$export$5d730b7aed1a3eb0)({
    url: "/graphql"
});
var $4806a602ceddc868$export$841858b892ce1f4c = (0, $exYeM.createContext)($4806a602ceddc868$var$p);
var $4806a602ceddc868$export$2881499e37b75b9a = $4806a602ceddc868$export$841858b892ce1f4c.Provider;
var $4806a602ceddc868$export$b3bffd4bb7da6b8f = $4806a602ceddc868$export$841858b892ce1f4c.Consumer;
$4806a602ceddc868$export$841858b892ce1f4c.displayName = "UrqlContext";
var $4806a602ceddc868$var$g = !1;
function $4806a602ceddc868$export$95f99d327bc8fbbd() {
    var e = (0, $exYeM.useContext)($4806a602ceddc868$export$841858b892ce1f4c);
    return e;
}
function $4806a602ceddc868$var$_extends() {
    $4806a602ceddc868$var$_extends = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)if (Object.prototype.hasOwnProperty.call(n, r)) e[r] = n[r];
        }
        return e;
    };
    return $4806a602ceddc868$var$_extends.apply(this, arguments);
}
var $4806a602ceddc868$var$b = {
    fetching: !1,
    stale: !1,
    error: void 0,
    data: void 0,
    extensions: void 0,
    operation: void 0
};
function $4806a602ceddc868$var$computeNextState(e, t) {
    var n = $4806a602ceddc868$var$_extends({}, e, t, {
        data: void 0 !== t.data || t.error ? t.data : e.data,
        fetching: !!t.fetching,
        stale: !!t.stale
    });
    return function isShallowDifferent(e, t) {
        if ("object" != typeof e || "object" != typeof t) return e !== t;
        for(var n in e){
            if (!(n in t)) return !0;
        }
        for(var r in t){
            if (e[r] !== t[r]) return !0;
        }
        return !1;
    }(e, n) ? n : e;
}
function $4806a602ceddc868$var$hasDepsChanged(e, t) {
    for(var n = 0, r = t.length; n < r; n++){
        if (e[n] !== t[n]) return !0;
    }
    return !1;
}
function $4806a602ceddc868$export$609860bf8b0084c(e) {
    var n = (0, $exYeM.useRef)(!0);
    var r = $4806a602ceddc868$export$95f99d327bc8fbbd();
    var c = (0, $exYeM.useState)($4806a602ceddc868$var$b);
    var f = c[0];
    var l = c[1];
    var v = (0, $exYeM.useCallback)(function(u, i) {
        l($4806a602ceddc868$var$_extends({}, $4806a602ceddc868$var$b, {
            fetching: !0
        }));
        return (0, $3e6f5df673a67418$export$4dbaaf6c79705e6c)(r.executeMutation((0, $ef0a7b6ad4b5eddb$export$2d1720544b23b823)(e, u), i || {})).then(function(e) {
            if (n.current) l({
                fetching: !1,
                stale: !!e.stale,
                data: e.data,
                error: e.error,
                extensions: e.extensions,
                operation: e.operation
            });
            return e;
        });
    }, [
        r,
        e,
        l
    ]);
    (0, $exYeM.useEffect)(function() {
        n.current = !0;
        return function() {
            n.current = !1;
        };
    }, []);
    return [
        f,
        v
    ];
}
function $4806a602ceddc868$var$useRequest(e, n) {
    var r = (0, $exYeM.useRef)(void 0);
    return (0, $exYeM.useMemo)(function() {
        var u = (0, $ef0a7b6ad4b5eddb$export$2d1720544b23b823)(e, n);
        if (void 0 !== r.current && r.current.key === u.key) return r.current;
        else {
            r.current = u;
            return u;
        }
    }, [
        e,
        n
    ]);
}
function $4806a602ceddc868$export$dd0a697e1782aedd(e) {
    var t = $4806a602ceddc868$export$95f99d327bc8fbbd();
    var n = function getCacheForClient(e) {
        if (!e._react) {
            var t = new Set;
            var n = new Map;
            if (e.operations$) (0, $3e6f5df673a67418$export$ec068583843480e7)(function(e) {
                if ("teardown" === e.kind && t.has(e.key)) {
                    t.delete(e.key);
                    n.delete(e.key);
                }
            })(e.operations$);
            e._react = {
                get: function get(e) {
                    return n.get(e);
                },
                set: function set(e, r) {
                    t.delete(e);
                    n.set(e, r);
                },
                dispose: function dispose(e) {
                    t.add(e);
                }
            };
        }
        return e._react;
    }(t);
    var r = function isSuspense(e, t) {
        return e.suspense && (!t || !1 !== t.suspense);
    }(t, e.context);
    var u = $4806a602ceddc868$var$useRequest(e.query, e.variables);
    var s = (0, $exYeM.useMemo)(function() {
        if (e.pause) return null;
        var i = t.executeQuery(u, $4806a602ceddc868$var$_extends({}, {
            requestPolicy: e.requestPolicy
        }, e.context));
        return r ? (0, $3e6f5df673a67418$export$fff70a13d53402ec)(function(e) {
            n.set(u.key, e);
        })(i) : i;
    }, [
        n,
        t,
        u,
        r,
        e.pause,
        e.requestPolicy,
        e.context
    ]);
    var p = (0, $exYeM.useCallback)(function(e, t) {
        if (!e) return {
            fetching: !1
        };
        var r = n.get(u.key);
        if (!r) {
            var i;
            var a = (0, $3e6f5df673a67418$export$ec068583843480e7)(function(e) {
                r = e;
                if (i) i(r);
            })((0, $3e6f5df673a67418$export$9384c7afe4015e42)(function() {
                return t && !i || !r;
            })(e));
            if (null == r && t) {
                var o = new Promise(function(e) {
                    i = e;
                });
                n.set(u.key, o);
                throw o;
            } else a.unsubscribe();
        } else if (t && null != r && "then" in r) throw r;
        return r || {
            fetching: !0
        };
    }, [
        n,
        u
    ]);
    var x = [
        t,
        u,
        e.requestPolicy,
        e.context,
        e.pause
    ];
    var h = (0, $exYeM.useState)(function() {
        return [
            s,
            $4806a602ceddc868$var$computeNextState($4806a602ceddc868$var$b, p(s, r)),
            x
        ];
    });
    var y = h[0];
    var g = h[1];
    var q = y[1];
    if (s !== y[0] && $4806a602ceddc868$var$hasDepsChanged(y[2], x)) g([
        s,
        q = $4806a602ceddc868$var$computeNextState(y[1], p(s, r)),
        x
    ]);
    (0, $exYeM.useEffect)(function() {
        var e = y[0];
        var t = y[2][1];
        var r = !1;
        function updateResult(e) {
            r = !0;
            g(function(t) {
                var n = $4806a602ceddc868$var$computeNextState(t[1], e);
                return t[1] !== n ? [
                    t[0],
                    n,
                    t[2]
                ] : t;
            });
        }
        if (e) {
            var u = (0, $3e6f5df673a67418$export$ec068583843480e7)(updateResult)((0, $3e6f5df673a67418$export$db4d2a4aed77becf)(function() {
                updateResult({
                    fetching: !1
                });
            })(e));
            if (!r) updateResult({
                fetching: !0
            });
            return function() {
                n.dispose(t.key);
                u.unsubscribe();
            };
        } else updateResult({
            fetching: !1
        });
    }, [
        n,
        y[0],
        y[2][1]
    ]);
    var m = (0, $exYeM.useCallback)(function(i) {
        var a = $4806a602ceddc868$var$_extends({}, {
            requestPolicy: e.requestPolicy
        }, e.context, i);
        g(function(e) {
            return [
                r ? (0, $3e6f5df673a67418$export$fff70a13d53402ec)(function(e) {
                    n.set(u.key, e);
                })(t.executeQuery(u, a)) : t.executeQuery(u, a),
                e[1],
                x
            ];
        });
    }, [
        t,
        n,
        u,
        r,
        p,
        e.requestPolicy,
        e.context
    ]);
    return [
        q,
        m
    ];
}
function $4806a602ceddc868$export$368b4214baeb914c(e, t) {
    var n = $4806a602ceddc868$export$95f99d327bc8fbbd();
    var r = $4806a602ceddc868$var$useRequest(e.query, e.variables);
    var s = (0, $exYeM.useRef)(t);
    s.current = t;
    var l = (0, $exYeM.useMemo)(function() {
        return !e.pause ? n.executeSubscription(r, e.context) : null;
    }, [
        n,
        r,
        e.pause,
        e.context
    ]);
    var v = [
        n,
        r,
        e.context,
        e.pause
    ];
    var p = (0, $exYeM.useState)(function() {
        return [
            l,
            $4806a602ceddc868$var$_extends({}, $4806a602ceddc868$var$b, {
                fetching: !!l
            }),
            v
        ];
    });
    var x = p[0];
    var h = p[1];
    var y = x[1];
    if (l !== x[0] && $4806a602ceddc868$var$hasDepsChanged(x[2], v)) h([
        l,
        y = $4806a602ceddc868$var$computeNextState(x[1], {
            fetching: !!l
        }),
        v
    ]);
    (0, $exYeM.useEffect)(function() {
        function updateResult(e) {
            h(function(t) {
                var n = $4806a602ceddc868$var$computeNextState(t[1], e);
                if (t[1] === n) return t;
                if (s.current && t[1].data !== n.data) n.data = s.current(t[1].data, n.data);
                return [
                    t[0],
                    n,
                    t[2]
                ];
            });
        }
        if (x[0]) return (0, $3e6f5df673a67418$export$ec068583843480e7)(updateResult)((0, $3e6f5df673a67418$export$db4d2a4aed77becf)(function() {
            updateResult({
                fetching: !1
            });
        })(x[0])).unsubscribe;
        else updateResult({
            fetching: !1
        });
    }, [
        x[0]
    ]);
    var g = (0, $exYeM.useCallback)(function(t) {
        var u = n.executeSubscription(r, $4806a602ceddc868$var$_extends({}, e.context, t));
        h(function(e) {
            return [
                u,
                e[1],
                v
            ];
        });
    }, [
        n,
        e.context,
        r
    ]);
    return [
        y,
        g
    ];
}
function $4806a602ceddc868$export$17b8b19c814bcf56(e) {
    var t = $4806a602ceddc868$export$609860bf8b0084c(e.query);
    return e.children($4806a602ceddc868$var$_extends({}, t[0], {
        executeMutation: t[1]
    }));
}
function $4806a602ceddc868$export$62297b13309008b2(e) {
    var t = $4806a602ceddc868$export$dd0a697e1782aedd(e);
    return e.children($4806a602ceddc868$var$_extends({}, t[0], {
        executeQuery: t[1]
    }));
}
function $4806a602ceddc868$export$f55210826850c514(e) {
    var t = $4806a602ceddc868$export$368b4214baeb914c(e, e.handler);
    return e.children($4806a602ceddc868$var$_extends({}, t[0], {
        executeSubscription: t[1]
    }));
}




var $exYeM = parcelRequire("exYeM");
var $65f4f8d7e6ac0946$export$b06b2c3e1088464c;
var $65f4f8d7e6ac0946$export$f4fced1bb3601104;
var $65f4f8d7e6ac0946$export$e1676888100bc422;
var $65f4f8d7e6ac0946$export$9b67d00cfd7e4e36;
var $65f4f8d7e6ac0946$export$46ec664fe6b3fd13;
var $65f4f8d7e6ac0946$export$f9f47db273b1c86b;
var $65f4f8d7e6ac0946$export$bff8506071621221;
var $65f4f8d7e6ac0946$export$fe9093199d63c3a8;
var $65f4f8d7e6ac0946$export$db3c28d99448dcff;
var $65f4f8d7e6ac0946$export$109a06d8b89cba0;
var $65f4f8d7e6ac0946$export$6ab52428572992d9;
var $65f4f8d7e6ac0946$export$e3d866421f0edfb0;
var $65f4f8d7e6ac0946$export$2bacab2130704b28;
var $65f4f8d7e6ac0946$export$8439e0443b88eae;
var $65f4f8d7e6ac0946$export$7b95bf28071744ad;
var $65f4f8d7e6ac0946$export$f1de0d6ae757bad;
var $65f4f8d7e6ac0946$export$92d56ee656c0230d;
var $65f4f8d7e6ac0946$export$871bd626df29da4a;
var $65f4f8d7e6ac0946$export$a77fb8b4c930973e;
var $65f4f8d7e6ac0946$export$e8e78c978b129247;
var $65f4f8d7e6ac0946$export$8b6cd955264cbc13;
var $65f4f8d7e6ac0946$export$f2e2c2dcd279aeeb;
var $65f4f8d7e6ac0946$export$8687ffcdea58e000;
$65f4f8d7e6ac0946$export$b06b2c3e1088464c = `x3TWQG_aboutMenu`;
$65f4f8d7e6ac0946$export$f4fced1bb3601104 = `x3TWQG_aboutMenuItem`;
$65f4f8d7e6ac0946$export$e1676888100bc422 = `x3TWQG_aboutMenuItemLink`;
$65f4f8d7e6ac0946$export$9b67d00cfd7e4e36 = `x3TWQG_cartActiveDot`;
$65f4f8d7e6ac0946$export$46ec664fe6b3fd13 = `x3TWQG_cartIcon`;
$65f4f8d7e6ac0946$export$f9f47db273b1c86b = `x3TWQG_hlIcon`;
$65f4f8d7e6ac0946$export$bff8506071621221 = `x3TWQG_leftArea`;
$65f4f8d7e6ac0946$export$fe9093199d63c3a8 = `x3TWQG_leftAreaDesktop`;
$65f4f8d7e6ac0946$export$db3c28d99448dcff = `x3TWQG_logo`;
$65f4f8d7e6ac0946$export$109a06d8b89cba0 = `x3TWQG_logoArea`;
$65f4f8d7e6ac0946$export$6ab52428572992d9 = `x3TWQG_maskRoot`;
$65f4f8d7e6ac0946$export$e3d866421f0edfb0 = `x3TWQG_menuActive`;
$65f4f8d7e6ac0946$export$2bacab2130704b28 = `x3TWQG_menuButton`;
$65f4f8d7e6ac0946$export$8439e0443b88eae = `x3TWQG_menuIcon`;
$65f4f8d7e6ac0946$export$7b95bf28071744ad = `x3TWQG_menuScrolled`;
$65f4f8d7e6ac0946$export$f1de0d6ae757bad = `x3TWQG_navItem`;
$65f4f8d7e6ac0946$export$92d56ee656c0230d = `x3TWQG_navItemDesktop`;
$65f4f8d7e6ac0946$export$871bd626df29da4a = `x3TWQG_rightArea`;
$65f4f8d7e6ac0946$export$a77fb8b4c930973e = `x3TWQG_rightAreaDesktop`;
$65f4f8d7e6ac0946$export$e8e78c978b129247 = `x3TWQG_root`;
$65f4f8d7e6ac0946$export$8b6cd955264cbc13 = `x3TWQG_rootInverted`;
$65f4f8d7e6ac0946$export$f2e2c2dcd279aeeb = `x3TWQG_rootPadding`;
$65f4f8d7e6ac0946$export$8687ffcdea58e000 = `x3TWQG_searchIcon`;



parcelRequire("exYeM");
var $472ca6341614a815$exports = {};

$parcel$export($472ca6341614a815$exports, "root", function () { return $472ca6341614a815$export$e8e78c978b129247; }, function (v) { return $472ca6341614a815$export$e8e78c978b129247 = v; });
var $472ca6341614a815$export$e8e78c978b129247;
$472ca6341614a815$export$e8e78c978b129247 = `XxjO4a_root`;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $3433e5a3eb89c040$var$extendStatics = function(d, b) {
    $3433e5a3eb89c040$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3433e5a3eb89c040$var$extendStatics(d, b);
};
function $3433e5a3eb89c040$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3433e5a3eb89c040$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3433e5a3eb89c040$export$18ce0697a983be9b = function() {
    $3433e5a3eb89c040$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3433e5a3eb89c040$export$18ce0697a983be9b.apply(this, arguments);
};
function $3433e5a3eb89c040$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3433e5a3eb89c040$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3433e5a3eb89c040$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3433e5a3eb89c040$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3433e5a3eb89c040$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3433e5a3eb89c040$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $3433e5a3eb89c040$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3433e5a3eb89c040$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3433e5a3eb89c040$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3433e5a3eb89c040$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3433e5a3eb89c040$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3433e5a3eb89c040$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3433e5a3eb89c040$export$45d3717a4c69092e(o, m, p);
}
function $3433e5a3eb89c040$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3433e5a3eb89c040$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3433e5a3eb89c040$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3433e5a3eb89c040$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3433e5a3eb89c040$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3433e5a3eb89c040$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3433e5a3eb89c040$export$10c90e4f7922046c(v) {
    return this instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? (this.v = v, this) : new $3433e5a3eb89c040$export$10c90e4f7922046c(v);
}
function $3433e5a3eb89c040$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3433e5a3eb89c040$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3433e5a3eb89c040$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3433e5a3eb89c040$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3433e5a3eb89c040$export$19a8beecd37a4c45 === "function" ? $3433e5a3eb89c040$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3433e5a3eb89c040$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3433e5a3eb89c040$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3433e5a3eb89c040$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3433e5a3eb89c040$export$45d3717a4c69092e(result, mod, k);
    }
    $3433e5a3eb89c040$var$__setModuleDefault(result, mod);
    return result;
}
function $3433e5a3eb89c040$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3433e5a3eb89c040$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3433e5a3eb89c040$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3433e5a3eb89c040$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $3433e5a3eb89c040$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $3433e5a3eb89c040$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $3433e5a3eb89c040$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $3433e5a3eb89c040$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $3433e5a3eb89c040$export$2e2bcd8739ae039 = {
    __extends: $3433e5a3eb89c040$export$a8ba968b8961cb8a,
    __assign: $3433e5a3eb89c040$export$18ce0697a983be9b,
    __rest: $3433e5a3eb89c040$export$3c9a16f847548506,
    __decorate: $3433e5a3eb89c040$export$29e00dfd3077644b,
    __param: $3433e5a3eb89c040$export$d5ad3fd78186038f,
    __metadata: $3433e5a3eb89c040$export$f1db080c865becb9,
    __awaiter: $3433e5a3eb89c040$export$1050f835b63b671e,
    __generator: $3433e5a3eb89c040$export$67ebef60e6f28a6,
    __createBinding: $3433e5a3eb89c040$export$45d3717a4c69092e,
    __exportStar: $3433e5a3eb89c040$export$f33643c0debef087,
    __values: $3433e5a3eb89c040$export$19a8beecd37a4c45,
    __read: $3433e5a3eb89c040$export$8d051b38c9118094,
    __spread: $3433e5a3eb89c040$export$afc72e2116322959,
    __spreadArrays: $3433e5a3eb89c040$export$6388937ca91ccae8,
    __spreadArray: $3433e5a3eb89c040$export$1216008129fb82ed,
    __await: $3433e5a3eb89c040$export$10c90e4f7922046c,
    __asyncGenerator: $3433e5a3eb89c040$export$e427f37a30a4de9b,
    __asyncDelegator: $3433e5a3eb89c040$export$bbd80228419bb833,
    __asyncValues: $3433e5a3eb89c040$export$e3b29a3d6162315f,
    __makeTemplateObject: $3433e5a3eb89c040$export$4fb47efe1390b86f,
    __importStar: $3433e5a3eb89c040$export$c21735bcef00d192,
    __importDefault: $3433e5a3eb89c040$export$da59b14a69baef04,
    __classPrivateFieldGet: $3433e5a3eb89c040$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3433e5a3eb89c040$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3433e5a3eb89c040$export$81fdc39f203e4e04,
    __addDisposableResource: $3433e5a3eb89c040$export$88ac25d8e944e405,
    __disposeResources: $3433e5a3eb89c040$export$8f076105dc360e92
};




var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
/**
 * Browser-safe usage of process
 */ var $4acf49f6c3e67aec$exports = {};
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = $4acf49f6c3e67aec$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};


var $6402a3fe96f57175$var$defaultEnvironment = "production";
var $6402a3fe96f57175$export$a7b6bc01c63cdfc3 = typeof $4acf49f6c3e67aec$exports === "undefined" || $4acf49f6c3e67aec$exports.env === undefined ? $6402a3fe96f57175$var$defaultEnvironment : "production";


var $f7fe4e10b799a8b2$var$createDefinition = function(propNames) {
    return {
        isEnabled: function(props) {
            return propNames.some(function(name) {
                return !!props[name];
            });
        }
    };
};
var $f7fe4e10b799a8b2$export$65570e08d843624d = {
    measureLayout: $f7fe4e10b799a8b2$var$createDefinition([
        "layout",
        "layoutId",
        "drag"
    ]),
    animation: $f7fe4e10b799a8b2$var$createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag",
        "whileInView"
    ]),
    exit: $f7fe4e10b799a8b2$var$createDefinition([
        "exit"
    ]),
    drag: $f7fe4e10b799a8b2$var$createDefinition([
        "drag",
        "dragControls"
    ]),
    focus: $f7fe4e10b799a8b2$var$createDefinition([
        "whileFocus"
    ]),
    hover: $f7fe4e10b799a8b2$var$createDefinition([
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ]),
    tap: $f7fe4e10b799a8b2$var$createDefinition([
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ]),
    pan: $f7fe4e10b799a8b2$var$createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ]),
    inView: $f7fe4e10b799a8b2$var$createDefinition([
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ])
};
function $f7fe4e10b799a8b2$export$449561ec5703cdc8(features) {
    for(var key in features){
        if (features[key] === null) continue;
        if (key === "projectionNodeConstructor") $f7fe4e10b799a8b2$export$65570e08d843624d.projectionNodeConstructor = features[key];
        else $f7fe4e10b799a8b2$export$65570e08d843624d[key].Component = features[key];
    }
}


var $8494256d1df1e442$export$491112666e282270 = function() {};
var $8494256d1df1e442$export$f5708dca728d7177 = function() {};



var $exYeM = parcelRequire("exYeM");
var $1cdfc9563e072a56$export$40f10139ecf1f171 = (0, $exYeM.createContext)({
    strict: false
});


var $4444ddb7c5a95e8d$var$featureNames = Object.keys((0, $f7fe4e10b799a8b2$export$65570e08d843624d));
var $4444ddb7c5a95e8d$var$numFeatures = $4444ddb7c5a95e8d$var$featureNames.length;
/**
 * Load features via renderless components based on the provided MotionProps.
 */ function $4444ddb7c5a95e8d$export$4a39035bacc4ed76(props, visualElement, preloadedFeatures) {
    var features = [];
    var lazyContext = (0, $exYeM.useContext)((0, $1cdfc9563e072a56$export$40f10139ecf1f171));
    if (!visualElement) return null;
    /**
     * If we're in development mode, check to make sure we're not rendering a motion component
     * as a child of LazyMotion, as this will break the file-size benefits of using it.
     */ if ((0, $6402a3fe96f57175$export$a7b6bc01c63cdfc3) !== "production" && preloadedFeatures && lazyContext.strict) (0, $8494256d1df1e442$export$f5708dca728d7177)(false, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
    for(var i = 0; i < $4444ddb7c5a95e8d$var$numFeatures; i++){
        var name_1 = $4444ddb7c5a95e8d$var$featureNames[i];
        var _a = (0, $f7fe4e10b799a8b2$export$65570e08d843624d)[name_1], isEnabled = _a.isEnabled, Component = _a.Component;
        /**
         * It might be possible in the future to use this moment to
         * dynamically request functionality. In initial tests this
         * was producing a lot of duplication amongst bundles.
         */ if (isEnabled(props) && Component) features.push($exYeM.createElement(Component, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({
            key: name_1
        }, props, {
            visualElement: visualElement
        })));
    }
    return features;
}



var $exYeM = parcelRequire("exYeM");
/**
 * @public
 */ var $2d642de93cca1124$export$22a697fb29aac98d = (0, $exYeM.createContext)({
    transformPagePoint: function(p) {
        return p;
    },
    isStatic: false,
    reducedMotion: "never"
});



var $exYeM = parcelRequire("exYeM");
var $9a6e4e852eb4f373$export$2285bbca2c666415 = (0, $exYeM.createContext)({});
function $9a6e4e852eb4f373$export$cd995842eb2ab956() {
    return (0, $exYeM.useContext)($9a6e4e852eb4f373$export$2285bbca2c666415).visualElement;
}



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
/**
 * @public
 */ var $32835478aabc17b5$export$f224e4635b6f8ce2 = (0, $exYeM.createContext)(null);




var $exYeM = parcelRequire("exYeM");
var $c763d68aeba74b31$export$4e09c449d6c407f7 = typeof document !== "undefined";


var $0e2d049f2abcd2c9$export$700979bc83e7db82 = (0, $c763d68aeba74b31$export$4e09c449d6c407f7) ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);





var $exYeM = parcelRequire("exYeM");


// Does this device prefer reduced motion? Returns `null` server-side.
var $5147aa1bf7276b96$var$prefersReducedMotion = {
    current: null
};
var $5147aa1bf7276b96$var$hasDetected = false;
function $5147aa1bf7276b96$var$initPrefersReducedMotion() {
    $5147aa1bf7276b96$var$hasDetected = true;
    if (!(0, $c763d68aeba74b31$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        var motionMediaQuery_1 = window.matchMedia("(prefers-reduced-motion)");
        var setReducedMotionPreferences = function() {
            return $5147aa1bf7276b96$var$prefersReducedMotion.current = motionMediaQuery_1.matches;
        };
        motionMediaQuery_1.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else $5147aa1bf7276b96$var$prefersReducedMotion.current = false;
}
/**
 * A hook that returns `true` if we should be using reduced motion based on the current device's Reduced Motion setting.
 *
 * This can be used to implement changes to your UI based on Reduced Motion. For instance, replacing motion-sickness inducing
 * `x`/`y` animations with `opacity`, disabling the autoplay of background videos, or turning off parallax motion.
 *
 * It will actively respond to changes and re-render your components with the latest setting.
 *
 * ```jsx
 * export function Sidebar({ isOpen }) {
 *   const shouldReduceMotion = useReducedMotion()
 *   const closedX = shouldReduceMotion ? 0 : "-100%"
 *
 *   return (
 *     <motion.div animate={{
 *       opacity: isOpen ? 1 : 0,
 *       x: isOpen ? 0 : closedX
 *     }} />
 *   )
 * }
 * ```
 *
 * @return boolean
 *
 * @public
 */ function $5147aa1bf7276b96$export$6a42007cf1e7b6f8() {
    /**
     * Lazy initialisation of prefersReducedMotion
     */ !$5147aa1bf7276b96$var$hasDetected && $5147aa1bf7276b96$var$initPrefersReducedMotion();
    var _a = (0, $3433e5a3eb89c040$export$8d051b38c9118094)((0, $exYeM.useState)($5147aa1bf7276b96$var$prefersReducedMotion.current), 1), shouldReduceMotion = _a[0];
    /**
     * TODO See if people miss automatically updating shouldReduceMotion setting
     */ return shouldReduceMotion;
}
function $5147aa1bf7276b96$export$ec21f7709af6bc1e() {
    var reducedMotionPreference = $5147aa1bf7276b96$export$6a42007cf1e7b6f8();
    var reducedMotion = (0, $exYeM.useContext)((0, $2d642de93cca1124$export$22a697fb29aac98d)).reducedMotion;
    if (reducedMotion === "never") return false;
    else if (reducedMotion === "always") return true;
    else return reducedMotionPreference;
}


function $d1d2872af74835eb$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    var lazyContext = (0, $exYeM.useContext)((0, $1cdfc9563e072a56$export$40f10139ecf1f171));
    var parent = (0, $9a6e4e852eb4f373$export$cd995842eb2ab956)();
    var presenceContext = (0, $exYeM.useContext)((0, $32835478aabc17b5$export$f224e4635b6f8ce2));
    var shouldReduceMotion = (0, $5147aa1bf7276b96$export$ec21f7709af6bc1e)();
    var visualElementRef = (0, $exYeM.useRef)(undefined);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ if (!createVisualElement) createVisualElement = lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
        blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false,
        shouldReduceMotion: shouldReduceMotion
    });
    var visualElement = visualElementRef.current;
    (0, $0e2d049f2abcd2c9$export$700979bc83e7db82)(function() {
        visualElement === null || visualElement === void 0 || visualElement.syncRender();
    });
    (0, $exYeM.useEffect)(function() {
        var _a;
        (_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.animationState) === null || _a === void 0 || _a.animateChanges();
    });
    (0, $0e2d049f2abcd2c9$export$700979bc83e7db82)(function() {
        return function() {
            return visualElement === null || visualElement === void 0 ? void 0 : visualElement.notifyUnmount();
        };
    }, []);
    return visualElement;
}



var $exYeM = parcelRequire("exYeM");
function $7be42aa7b9b2349b$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $3e0b35cdea07cd56$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $exYeM.useCallback)(function(instance) {
        var _a;
        instance && ((_a = visualState.mount) === null || _a === void 0 || _a.call(visualState, instance));
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $exYeM = parcelRequire("exYeM");

/**
 * Decides if the supplied variable is an array of variant labels
 */ function $70145b2788b65a38$export$562271cd22f751d(v) {
    return Array.isArray(v);
}
/**
 * Decides if the supplied variable is variant label
 */ function $70145b2788b65a38$export$720b90e312cea233(v) {
    return typeof v === "string" || $70145b2788b65a38$export$562271cd22f751d(v);
}
/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $70145b2788b65a38$var$getCurrent(visualElement) {
    var current = {};
    visualElement.forEachValue(function(value, key) {
        return current[key] = value.get();
    });
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $70145b2788b65a38$var$getVelocity(visualElement) {
    var velocity = {};
    visualElement.forEachValue(function(value, key) {
        return velocity[key] = value.getVelocity();
    });
    return velocity;
}
function $70145b2788b65a38$export$d68f140c4d9b48bc(props, definition, custom, currentValues, currentVelocity) {
    var _a;
    if (currentValues === void 0) currentValues = {};
    if (currentVelocity === void 0) currentVelocity = {};
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}
function $70145b2788b65a38$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return $70145b2788b65a38$export$d68f140c4d9b48bc(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, $70145b2788b65a38$var$getCurrent(visualElement), $70145b2788b65a38$var$getVelocity(visualElement));
}
function $70145b2788b65a38$export$cf3a7bd331c35bf0(props) {
    var _a;
    return typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" || $70145b2788b65a38$export$720b90e312cea233(props.initial) || $70145b2788b65a38$export$720b90e312cea233(props.animate) || $70145b2788b65a38$export$720b90e312cea233(props.whileHover) || $70145b2788b65a38$export$720b90e312cea233(props.whileDrag) || $70145b2788b65a38$export$720b90e312cea233(props.whileTap) || $70145b2788b65a38$export$720b90e312cea233(props.whileFocus) || $70145b2788b65a38$export$720b90e312cea233(props.exit);
}
function $70145b2788b65a38$export$c0eba02279c18fea(props) {
    return Boolean($70145b2788b65a38$export$cf3a7bd331c35bf0(props) || props.variants);
}


function $d9dc1d37927f1414$export$12fc32fc096a04a3(props, context) {
    if ((0, $70145b2788b65a38$export$cf3a7bd331c35bf0)(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || (0, $70145b2788b65a38$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $70145b2788b65a38$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $1fba5faa46b4b8c9$export$c5638d843b37a176(props) {
    var _a = (0, $d9dc1d37927f1414$export$12fc32fc096a04a3)(props, (0, $exYeM.useContext)((0, $9a6e4e852eb4f373$export$2285bbca2c666415))), initial = _a.initial, animate = _a.animate;
    return (0, $exYeM.useMemo)(function() {
        return {
            initial: initial,
            animate: animate
        };
    }, [
        $1fba5faa46b4b8c9$var$variantLabelsAsDependency(initial),
        $1fba5faa46b4b8c9$var$variantLabelsAsDependency(animate)
    ]);
}
function $1fba5faa46b4b8c9$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}





var $exYeM = parcelRequire("exYeM");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $73d7e626f45c1838$export$fe4300aa8eebea86(init) {
    var ref = (0, $exYeM.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ var $d92fcbc1a711d121$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};


var $238825e7891c5532$var$id = 1;
function $238825e7891c5532$export$5ed57b87c18af11a() {
    return (0, $73d7e626f45c1838$export$fe4300aa8eebea86)(function() {
        if ((0, $d92fcbc1a711d121$export$97db156a3ed1593b).hasEverUpdated) return $238825e7891c5532$var$id++;
    });
}



var $exYeM = parcelRequire("exYeM");
var $0d8fa753a19a110b$export$a3579ca508007a95 = (0, $exYeM.createContext)({});




var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
/**
 * Internal, exported only for usage in Framer
 */ var $df9c3e45a16d5ebc$export$da5f7b802957459a = (0, $exYeM.createContext)({});


function $105a8c3f4d953db5$export$80ade90e64f5118b(projectionId, _a, visualElement, ProjectionNodeConstructor) {
    var _b;
    var layoutId = _a.layoutId, layout = _a.layout, drag = _a.drag, dragConstraints = _a.dragConstraints, layoutScroll = _a.layoutScroll;
    var initialPromotionConfig = (0, $exYeM.useContext)((0, $df9c3e45a16d5ebc$export$da5f7b802957459a));
    if (!ProjectionNodeConstructor || !visualElement || (visualElement === null || visualElement === void 0 ? void 0 : visualElement.projection)) return;
    visualElement.projection = new ProjectionNodeConstructor(projectionId, visualElement.getLatestValues(), (_b = visualElement.parent) === null || _b === void 0 ? void 0 : _b.projection);
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        scheduleRender: function() {
            return visualElement.scheduleRender();
        },
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll
    });
}




var $exYeM = parcelRequire("exYeM");
var $3b2182ee7c299f8c$export$a9ca437df31f9491 = /** @class */ function(_super) {
    (0, $3433e5a3eb89c040$export$a8ba968b8961cb8a)(VisualElementHandler, _super);
    function VisualElementHandler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Update visual element props as soon as we know this update is going to be commited.
     */ VisualElementHandler.prototype.getSnapshotBeforeUpdate = function() {
        this.updateProps();
        return null;
    };
    VisualElementHandler.prototype.componentDidUpdate = function() {};
    VisualElementHandler.prototype.updateProps = function() {
        var _a = this.props, visualElement = _a.visualElement, props = _a.props;
        if (visualElement) visualElement.setProps(props);
    };
    VisualElementHandler.prototype.render = function() {
        return this.props.children;
    };
    return VisualElementHandler;
}((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Component);


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $002ee5308395fa07$export$46b7e4b9dc6110c3(_a) {
    var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, projectionNodeConstructor = _a.projectionNodeConstructor, useRender = _a.useRender, useVisualState = _a.useVisualState, Component = _a.Component;
    preloadedFeatures && (0, $f7fe4e10b799a8b2$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        var layoutId = $002ee5308395fa07$var$useLayoutId(props);
        props = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, props), {
            layoutId: layoutId
        });
        /**
         * If we're rendering in a static environment, we only visually update the component
         * as a result of a React-rerender rather than interactions or animations. This
         * means we don't need to load additional memory structures like VisualElement,
         * or any gesture/animation features.
         */ var config = (0, $exYeM.useContext)((0, $2d642de93cca1124$export$22a697fb29aac98d));
        var features = null;
        var context = (0, $1fba5faa46b4b8c9$export$c5638d843b37a176)(props);
        /**
         * Create a unique projection ID for this component. If a new component is added
         * during a layout animation we'll use this to query the DOM and hydrate its ref early, allowing
         * us to measure it as soon as any layout effect flushes pending layout animations.
         *
         * Performance note: It'd be better not to have to search the DOM for these elements.
         * For newly-entering components it could be enough to only correct treeScale, in which
         * case we could mount in a scale-correction mode. This wouldn't be enough for
         * shared element transitions however. Perhaps for those we could revert to a root node
         * that gets forceRendered and layout animations are triggered on its layout effect.
         */ var projectionId = config.isStatic ? undefined : (0, $238825e7891c5532$export$5ed57b87c18af11a)();
        /**
         *
         */ var visualState = useVisualState(props, config.isStatic);
        if (!config.isStatic && (0, $c763d68aeba74b31$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $d1d2872af74835eb$export$dc0335d73ab0b115)(Component, visualState, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, config), props), createVisualElement);
            (0, $105a8c3f4d953db5$export$80ade90e64f5118b)(projectionId, props, context.visualElement, projectionNodeConstructor || (0, $f7fe4e10b799a8b2$export$65570e08d843624d).projectionNodeConstructor);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ features = (0, $4444ddb7c5a95e8d$export$4a39035bacc4ed76)(props, context.visualElement, preloadedFeatures);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $exYeM.createElement((0, $3b2182ee7c299f8c$export$a9ca437df31f9491), {
            visualElement: context.visualElement,
            props: (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, config), props)
        }, features, $exYeM.createElement((0, $9a6e4e852eb4f373$export$2285bbca2c666415).Provider, {
            value: context
        }, useRender(Component, props, projectionId, (0, $3e0b35cdea07cd56$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, config.isStatic, context.visualElement)));
    }
    return (0, $exYeM.forwardRef)(MotionComponent);
}
function $002ee5308395fa07$var$useLayoutId(_a) {
    var _b;
    var layoutId = _a.layoutId;
    var layoutGroupId = (_b = (0, $exYeM.useContext)((0, $0d8fa753a19a110b$export$a3579ca508007a95))) === null || _b === void 0 ? void 0 : _b.id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $6b2ebacab9b54f79$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig) {
        if (customMotionComponentConfig === void 0) customMotionComponentConfig = {};
        return (0, $002ee5308395fa07$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ var componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: function(_target, key) {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}



/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ var $3382724af6d1489a$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "tspan",
    "use",
    "view"
];


function $9c5a7490b01b42fd$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $3382724af6d1489a$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}




var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
var $93099dc5c3aa7524$export$91ddd985b97788d1 = {};
function $93099dc5c3aa7524$export$de9e7791c71225fd(correctors) {
    Object.assign($93099dc5c3aa7524$export$91ddd985b97788d1, correctors);
}


/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ var $da211e07316d6e39$export$67cd428da31419e1 = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ var $da211e07316d6e39$var$order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
/**
 * Generate a list of every possible transform key.
 */ var $da211e07316d6e39$export$7b42a0094fb00b6e = [
    "transformPerspective",
    "x",
    "y",
    "z"
];
$da211e07316d6e39$var$order.forEach(function(operationKey) {
    return $da211e07316d6e39$export$67cd428da31419e1.forEach(function(axesKey) {
        return $da211e07316d6e39$export$7b42a0094fb00b6e.push(operationKey + axesKey);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ function $da211e07316d6e39$export$61f68472e7973485(a, b) {
    return $da211e07316d6e39$export$7b42a0094fb00b6e.indexOf(a) - $da211e07316d6e39$export$7b42a0094fb00b6e.indexOf(b);
}
/**
 * A quick lookup for transform props.
 */ var $da211e07316d6e39$var$transformPropSet = new Set($da211e07316d6e39$export$7b42a0094fb00b6e);
function $da211e07316d6e39$export$15240a8a4379d8de(key) {
    return $da211e07316d6e39$var$transformPropSet.has(key);
}
/**
 * A quick lookup for transform origin props
 */ var $da211e07316d6e39$var$transformOriginProps = new Set([
    "originX",
    "originY",
    "originZ"
]);
function $da211e07316d6e39$export$91fe49ee9d172523(key) {
    return $da211e07316d6e39$var$transformOriginProps.has(key);
}


function $57cc9ca03e37ffaf$export$6d27ce8e3de1c3cf(key, _a) {
    var layout = _a.layout, layoutId = _a.layoutId;
    return (0, $da211e07316d6e39$export$15240a8a4379d8de)(key) || (0, $da211e07316d6e39$export$91fe49ee9d172523)(key) || (layout || layoutId !== undefined) && (!!(0, $93099dc5c3aa7524$export$91ddd985b97788d1)[key] || key === "opacity");
}


var $65e8d3d378a9947e$export$605d60a2578142d3 = function(value) {
    return Boolean(value !== null && typeof value === "object" && value.getVelocity);
};



var $9384da345cfe955b$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $9384da345cfe955b$export$bdc96e0d5c8f914(_a, _b, transformIsDefault, transformTemplate) {
    var transform = _a.transform, transformKeys = _a.transformKeys;
    var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
    // The transform string we're going to build into.
    var transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort((0, $da211e07316d6e39$export$61f68472e7973485));
    // Track whether the defined transform has a defined z so we don't add a
    // second to enable hardware acceleration
    var transformHasZ = false;
    // Loop over each transform and build them into transformString
    var numTransformKeys = transformKeys.length;
    for(var i = 0; i < numTransformKeys; i++){
        var key = transformKeys[i];
        transformString += "".concat($9384da345cfe955b$var$translateAlias[key] || key, "(").concat(transform[key], ") ");
        if (key === "z") transformHasZ = true;
    }
    if (!transformHasZ && enableHardwareAcceleration) transformString += "translateZ(0)";
    else transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}
/**
 * Build a transformOrigin style. Uses the same defaults as the browser for
 * undefined origins.
 */ function $9384da345cfe955b$export$22d2fbf39767d07a(_a) {
    var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
    return "".concat(originX, " ").concat(originY, " ").concat(originZ);
}


/**
 * Returns true if the provided key is a CSS variable
 */ function $7788fac55eb8bc79$export$451bc42768436155(key) {
    return key.startsWith("--");
}



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var $6a51529d989adf9c$export$453ef540a9a1bd6b = function(value, type) {
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $01f71f54e5605f2f$export$7d15b64cf5a3a4c4 = (min, max)=>(v)=>Math.max(Math.min(v, max), min);
const $01f71f54e5605f2f$export$83d2e9e3e4ee39ed = (v)=>v % 1 ? Number(v.toFixed(5)) : v;
const $01f71f54e5605f2f$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $01f71f54e5605f2f$export$740b69c5fad25dba = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
const $01f71f54e5605f2f$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function $01f71f54e5605f2f$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $5e966ba53bca97ed$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $5e966ba53bca97ed$export$58f0f39f63f3cf42 = Object.assign(Object.assign({}, $5e966ba53bca97ed$export$98e628dec113755e), {
    transform: (0, $01f71f54e5605f2f$export$7d15b64cf5a3a4c4)(0, 1)
});
const $5e966ba53bca97ed$export$dcdf75081b88279d = Object.assign(Object.assign({}, $5e966ba53bca97ed$export$98e628dec113755e), {
    default: 1
});


const $0d8007420b761bba$var$createUnitType = (unit)=>({
        test: (v)=>(0, $01f71f54e5605f2f$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $0d8007420b761bba$export$41fc368e1a942b97 = $0d8007420b761bba$var$createUnitType("deg");
const $0d8007420b761bba$export$626336c2cd4b14de = $0d8007420b761bba$var$createUnitType("%");
const $0d8007420b761bba$export$91c0eda1d06bf008 = $0d8007420b761bba$var$createUnitType("px");
const $0d8007420b761bba$export$f91e8c45a95a32f2 = $0d8007420b761bba$var$createUnitType("vh");
const $0d8007420b761bba$export$aed3d7b7d206c196 = $0d8007420b761bba$var$createUnitType("vw");
const $0d8007420b761bba$export$44e2e1705876d7ed = Object.assign(Object.assign({}, $0d8007420b761bba$export$626336c2cd4b14de), {
    parse: (v)=>$0d8007420b761bba$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$0d8007420b761bba$export$626336c2cd4b14de.transform(v * 100)
});




var $d16ea4f0603eeb66$export$7d260a2a5f8bc19e = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, (0, $5e966ba53bca97ed$export$98e628dec113755e)), {
    transform: Math.round
});


var $0d74cfa63198be03$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    borderTopWidth: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    borderRightWidth: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    borderRadius: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    radius: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    maxWidth: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    height: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    maxHeight: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    size: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    top: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    right: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    bottom: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    left: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    paddingTop: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    paddingRight: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    paddingBottom: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    paddingLeft: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    margin: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    marginTop: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    marginRight: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    marginBottom: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    marginLeft: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $0d8007420b761bba$export$41fc368e1a942b97),
    rotateX: (0, $0d8007420b761bba$export$41fc368e1a942b97),
    rotateY: (0, $0d8007420b761bba$export$41fc368e1a942b97),
    rotateZ: (0, $0d8007420b761bba$export$41fc368e1a942b97),
    scale: (0, $5e966ba53bca97ed$export$dcdf75081b88279d),
    scaleX: (0, $5e966ba53bca97ed$export$dcdf75081b88279d),
    scaleY: (0, $5e966ba53bca97ed$export$dcdf75081b88279d),
    scaleZ: (0, $5e966ba53bca97ed$export$dcdf75081b88279d),
    skew: (0, $0d8007420b761bba$export$41fc368e1a942b97),
    skewX: (0, $0d8007420b761bba$export$41fc368e1a942b97),
    skewY: (0, $0d8007420b761bba$export$41fc368e1a942b97),
    distance: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    translateX: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    translateY: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    translateZ: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    x: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    y: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    z: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    perspective: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    transformPerspective: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    opacity: (0, $5e966ba53bca97ed$export$58f0f39f63f3cf42),
    originX: (0, $0d8007420b761bba$export$44e2e1705876d7ed),
    originY: (0, $0d8007420b761bba$export$44e2e1705876d7ed),
    originZ: (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $d16ea4f0603eeb66$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $5e966ba53bca97ed$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $5e966ba53bca97ed$export$58f0f39f63f3cf42),
    numOctaves: (0, $d16ea4f0603eeb66$export$7d260a2a5f8bc19e)
};


function $d5a7ccaf3657bbce$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    var _a;
    var style = state.style, vars = state.vars, transform = state.transform, transformKeys = state.transformKeys, transformOrigin = state.transformOrigin;
    // Empty the transformKeys array. As we're throwing out refs to its items
    // this might not be as cheap as suspected. Maybe using the array as a buffer
    // with a manual incrementation would be better.
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    var transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(var key in latestValues){
        var value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $7788fac55eb8bc79$export$451bc42768436155)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        var valueType = (0, $0d74cfa63198be03$export$eec14432cd1cb67b)[key];
        var valueAsType = (0, $6a51529d989adf9c$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $da211e07316d6e39$export$15240a8a4379d8de)(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0)) transformIsNone = false;
        } else if ((0, $da211e07316d6e39$export$91fe49ee9d172523)(key)) {
            transformOrigin[key] = valueAsType;
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
        } else style[key] = valueAsType;
    }
    if (hasTransform) style.transform = (0, $9384da345cfe955b$export$bdc96e0d5c8f914)(state, options, transformIsNone, transformTemplate);
    else if (transformTemplate) style.transform = transformTemplate({}, "");
    else if (!latestValues.transform && style.transform) style.transform = "none";
    if (hasTransformOrigin) style.transformOrigin = (0, $9384da345cfe955b$export$22d2fbf39767d07a)(transformOrigin);
}


var $43cb856997daead8$export$8940b483cf52eeda = function() {
    return {
        style: {},
        transform: {},
        transformKeys: [],
        transformOrigin: {},
        vars: {}
    };
};


function $582c92f88e1a1e68$export$40dafdb8630c956b(target, source, props) {
    for(var key in source)if (!(0, $65e8d3d378a9947e$export$605d60a2578142d3)(source[key]) && !(0, $57cc9ca03e37ffaf$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $582c92f88e1a1e68$var$useInitialMotionValues(_a, visualState, isStatic) {
    var transformTemplate = _a.transformTemplate;
    return (0, $exYeM.useMemo)(function() {
        var state = (0, $43cb856997daead8$export$8940b483cf52eeda)();
        (0, $d5a7ccaf3657bbce$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        var vars = state.vars, style = state.style;
        return (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, vars), style);
    }, [
        visualState
    ]);
}
function $582c92f88e1a1e68$export$72c85e333541e7f(props, visualState, isStatic) {
    var styleProp = props.style || {};
    var style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $582c92f88e1a1e68$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $582c92f88e1a1e68$var$useInitialMotionValues(props, visualState, isStatic));
    if (props.transformValues) style = props.transformValues(style);
    return style;
}
function $582c92f88e1a1e68$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    var htmlProps = {};
    var style = $582c92f88e1a1e68$export$72c85e333541e7f(props, visualState, isStatic);
    if (Boolean(props.drag) && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : "pan-".concat(props.drag === "x" ? "y" : "x");
    }
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ var $1f4002463fc06750$var$validMotionProps = new Set([
    "initial",
    "animate",
    "exit",
    "style",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "layoutDependency",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "dragSnapToOrigin",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "whileDrag",
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "onHoverStart",
    "onHoverEnd",
    "whileFocus",
    "whileTap",
    "whileHover",
    "whileInView",
    "onViewportEnter",
    "onViewportLeave",
    "viewport",
    "layoutScroll"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $1f4002463fc06750$export$2f9c46555243bf04(key) {
    return $1f4002463fc06750$var$validMotionProps.has(key);
}


var $a52b0ca54619c60e$var$shouldForward = function(key) {
    return !(0, $1f4002463fc06750$export$2f9c46555243bf04)(key);
};
function $a52b0ca54619c60e$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $a52b0ca54619c60e$var$shouldForward = function(key) {
        return key.startsWith("on") ? !(0, $1f4002463fc06750$export$2f9c46555243bf04)(key) : isValidProp(key);
    };
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $a52b0ca54619c60e$export$59d6962c470509a5((parcelRequire("5Ab7O")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $a52b0ca54619c60e$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for(var key in props)if ($a52b0ca54619c60e$var$shouldForward(key) || forwardMotionProps === true && (0, $1f4002463fc06750$export$2f9c46555243bf04)(key) || !isDom && !(0, $1f4002463fc06750$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
    props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    return filteredProps;
}





var $exYeM = parcelRequire("exYeM");




function $de9ca7d9f74b1dc4$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $0d8007420b761bba$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $de9ca7d9f74b1dc4$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    var pxOriginX = $de9ca7d9f74b1dc4$var$calcOrigin(originX, dimensions.x, dimensions.width);
    var pxOriginY = $de9ca7d9f74b1dc4$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return "".concat(pxOriginX, " ").concat(pxOriginY);
}



var $ecef2446ddaf0120$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
var $ecef2446ddaf0120$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $ecef2446ddaf0120$export$311b43f666da1d82(attrs, length, spacing, offset, useDashCase) {
    if (spacing === void 0) spacing = 1;
    if (offset === void 0) offset = 0;
    if (useDashCase === void 0) useDashCase = true;
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? $ecef2446ddaf0120$var$dashKeys : $ecef2446ddaf0120$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $0d8007420b761bba$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    var pathLength = (0, $0d8007420b761bba$export$91c0eda1d06bf008).transform(length);
    var pathSpacing = (0, $0d8007420b761bba$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = "".concat(pathLength, " ").concat(pathSpacing);
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $22afbc6679b4fb16$export$5475d24f125d7053(state, _a, options, transformTemplate) {
    var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, // This is object creation, which we try to avoid per-frame.
    latest = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(_a, [
        "attrX",
        "attrY",
        "originX",
        "originY",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $d5a7ccaf3657bbce$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style, dimensions = state.dimensions;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $de9ca7d9f74b1dc4$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $ecef2446ddaf0120$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}




var $93153305d91bad5b$export$41be8b43e1c4d4f9 = function() {
    return (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, (0, $43cb856997daead8$export$8940b483cf52eeda)()), {
        attrs: {}
    });
};


function $678da409a301bad8$export$84309c4f53cb1bd5(props, visualState) {
    var visualProps = (0, $exYeM.useMemo)(function() {
        var state = (0, $93153305d91bad5b$export$41be8b43e1c4d4f9)();
        (0, $22afbc6679b4fb16$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, props.transformTemplate);
        return (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, state.attrs), {
            style: (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        var rawStyles = {};
        (0, $582c92f88e1a1e68$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, rawStyles), visualProps.style);
    }
    return visualProps;
}


function $9f5d406889886ff1$export$5d29104eefd89cc8(forwardMotionProps) {
    if (forwardMotionProps === void 0) forwardMotionProps = false;
    var useRender = function(Component, props, projectionId, ref, _a, isStatic) {
        var latestValues = _a.latestValues;
        var useVisualProps = (0, $9c5a7490b01b42fd$export$88f3fc2fd3766989)(Component) ? (0, $678da409a301bad8$export$84309c4f53cb1bd5) : (0, $582c92f88e1a1e68$export$57be0a314572d87d);
        var visualProps = useVisualProps(props, latestValues, isStatic);
        var filteredProps = (0, $a52b0ca54619c60e$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        var elementProps = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, filteredProps), visualProps), {
            ref: ref
        });
        if (projectionId) elementProps["data-projection-id"] = projectionId;
        return (0, $exYeM.createElement)(Component, elementProps);
    };
    return useRender;
}


var $ccc055b4a72c1347$var$CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var $ccc055b4a72c1347$var$REPLACE_TEMPLATE = "$1-$2";
/**
 * Convert camelCase to dash-case properties.
 */ var $ccc055b4a72c1347$export$9fd24a634729c672 = function(str) {
    return str.replace($ccc055b4a72c1347$var$CAMEL_CASE_PATTERN, $ccc055b4a72c1347$var$REPLACE_TEMPLATE).toLowerCase();
};


function $4d3a9c3652fbcbe3$export$1a32bf6229c258c0(element, _a, styleProp, projection) {
    var style = _a.style, vars = _a.vars;
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(var key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ var $53f5831d8ff6fe26$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength"
]);


function $6ecc69af052e005d$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $4d3a9c3652fbcbe3$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(var key in renderState.attrs)element.setAttribute(!(0, $53f5831d8ff6fe26$export$28931db5d57958e5).has(key) ? (0, $ccc055b4a72c1347$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $e87aa36d3552d0b1$export$16da615486abaa45(props) {
    var style = props.style;
    var newValues = {};
    for(var key in style)if ((0, $65e8d3d378a9947e$export$605d60a2578142d3)(style[key]) || (0, $57cc9ca03e37ffaf$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}


function $4c74588f3910fe04$export$16da615486abaa45(props) {
    var newValues = (0, $e87aa36d3552d0b1$export$16da615486abaa45)(props);
    for(var key in props)if ((0, $65e8d3d378a9947e$export$605d60a2578142d3)(props[key])) {
        var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}




var $exYeM = parcelRequire("exYeM");
function $0c915d7372d9814d$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}





var $6f683bc80c6d969e$export$9153ad4c4999f4a0 = function(v) {
    return Array.isArray(v);
};


var $0d15acf980467e42$export$2f308ad9864b3ac9 = function(v) {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var $0d15acf980467e42$export$5485128c47bd48bb = function(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $6f683bc80c6d969e$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $a6687c7d507e2d36$export$fcc2206ecb6d74b(value) {
    var unwrappedValue = (0, $65e8d3d378a9947e$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $0d15acf980467e42$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}



function $30ccd5a4894de23b$var$makeState(_a, props, context, presenceContext) {
    var scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
    var state = {
        latestValues: $30ccd5a4894de23b$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = function(instance) {
        return onMount(props, instance, state);
    };
    return state;
}
var $30ccd5a4894de23b$export$e91e107bc6d03a8e = function(config) {
    return function(props, isStatic) {
        var context = (0, $exYeM.useContext)((0, $9a6e4e852eb4f373$export$2285bbca2c666415));
        var presenceContext = (0, $exYeM.useContext)((0, $32835478aabc17b5$export$f224e4635b6f8ce2));
        return isStatic ? $30ccd5a4894de23b$var$makeState(config, props, context, presenceContext) : (0, $73d7e626f45c1838$export$fe4300aa8eebea86)(function() {
            return $30ccd5a4894de23b$var$makeState(config, props, context, presenceContext);
        });
    };
};
function $30ccd5a4894de23b$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    var values = {};
    var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
    var motionValues = scrapeMotionValues(props);
    for(var key in motionValues)values[key] = (0, $a6687c7d507e2d36$export$fcc2206ecb6d74b)(motionValues[key]);
    var initial = props.initial, animate = props.animate;
    var isControllingVariants = (0, $70145b2788b65a38$export$cf3a7bd331c35bf0)(props);
    var isVariantNode = (0, $70145b2788b65a38$export$c0eba02279c18fea)(props);
    if (context && isVariantNode && !isControllingVariants && props.inherit !== false) {
        initial !== null && initial !== void 0 ? initial : initial = context.initial;
        animate !== null && animate !== void 0 ? animate : animate = context.animate;
    }
    var initialAnimationIsBlocked = blockInitialAnimation || initial === false;
    var variantToSet = initialAnimationIsBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $0c915d7372d9814d$export$aa71198ceeaf53ce)(variantToSet)) {
        var list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach(function(definition) {
            var resolved = (0, $70145b2788b65a38$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            var transitionEnd = resolved.transitionEnd;
            resolved.transition;
            var target = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(resolved, [
                "transitionEnd",
                "transition"
            ]);
            for(var key in target){
                var valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ var index = initialAnimationIsBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(var key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}




var $a38e3c634edf90c1$export$44dabd3fae512e85 = {
    useVisualState: (0, $30ccd5a4894de23b$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $4c74588f3910fe04$export$16da615486abaa45),
        createRenderState: (0, $93153305d91bad5b$export$41be8b43e1c4d4f9),
        onMount: function(props, instance, _a) {
            var renderState = _a.renderState, latestValues = _a.latestValues;
            try {
                renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
            } catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }
            (0, $22afbc6679b4fb16$export$5475d24f125d7053)(renderState, latestValues, {
                enableHardwareAcceleration: false
            }, props.transformTemplate);
            (0, $6ecc69af052e005d$export$c5f8399d19a7394b)(instance, renderState);
        }
    })
};





var $7e738ddebc5e1ace$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $30ccd5a4894de23b$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $e87aa36d3552d0b1$export$16da615486abaa45),
        createRenderState: (0, $43cb856997daead8$export$8940b483cf52eeda)
    })
};


function $e939d64425c6240c$export$732916c0e88175fb(Component, _a, preloadedFeatures, createVisualElement, projectionNodeConstructor) {
    var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
    var baseConfig = (0, $9c5a7490b01b42fd$export$88f3fc2fd3766989)(Component) ? (0, $a38e3c634edf90c1$export$44dabd3fae512e85) : (0, $7e738ddebc5e1ace$export$e13ea21d87ea57c8);
    return (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, baseConfig), {
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $9f5d406889886ff1$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        projectionNodeConstructor: projectionNodeConstructor,
        Component: Component
    });
}


var $8f246e49b2cb6bd7$export$2deb71ebd3734d23;
(function(AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["InView"] = "whileInView";
    AnimationType["Exit"] = "exit";
})($8f246e49b2cb6bd7$export$2deb71ebd3734d23 || ($8f246e49b2cb6bd7$export$2deb71ebd3734d23 = {}));



var $exYeM = parcelRequire("exYeM");
function $2bb083316bee0fb8$export$b1d829ddf82884aa(target, eventName, handler, options) {
    if (options === void 0) options = {
        passive: true
    };
    target.addEventListener(eventName, handler, options);
    return function() {
        return target.removeEventListener(eventName, handler);
    };
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */ function $2bb083316bee0fb8$export$c1052189363cb2e0(ref, eventName, handler, options) {
    (0, $exYeM.useEffect)(function() {
        var element = ref.current;
        if (handler && element) return $2bb083316bee0fb8$export$b1d829ddf82884aa(element, eventName, handler, options);
    }, [
        ref,
        eventName,
        handler,
        options
    ]);
}


/**
 *
 * @param props
 * @param ref
 * @internal
 */ function $66963314b48a6651$export$cac52d7cca250a66(_a) {
    var whileFocus = _a.whileFocus, visualElement = _a.visualElement;
    var onFocus = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Focus, true);
    };
    var onBlur = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Focus, false);
    };
    (0, $2bb083316bee0fb8$export$c1052189363cb2e0)(visualElement, "focus", whileFocus ? onFocus : undefined);
    (0, $2bb083316bee0fb8$export$c1052189363cb2e0)(visualElement, "blur", whileFocus ? onBlur : undefined);
}


function $486d9e6769e4fdda$export$764db16956f554f8(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof MouseEvent;
}
function $486d9e6769e4fdda$export$c4dfce035d43d1e0(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}





/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function $19290b72856733e8$var$filterPrimaryPointer(eventHandler) {
    return function(event) {
        var isMouseEvent = event instanceof MouseEvent;
        var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
var $19290b72856733e8$var$defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function $19290b72856733e8$var$pointFromTouch(e, pointType) {
    if (pointType === void 0) pointType = "page";
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || $19290b72856733e8$var$defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $19290b72856733e8$var$pointFromMouse(point, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $19290b72856733e8$export$12f84bb882d06e1a(event, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        point: (0, $486d9e6769e4fdda$export$c4dfce035d43d1e0)(event) ? $19290b72856733e8$var$pointFromTouch(event, pointType) : $19290b72856733e8$var$pointFromMouse(event, pointType)
    };
}
var $19290b72856733e8$export$f4437ba81469b709 = function(handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) shouldFilterPrimaryPointer = false;
    var listener = function(event) {
        return handler(event, $19290b72856733e8$export$12f84bb882d06e1a(event));
    };
    return shouldFilterPrimaryPointer ? $19290b72856733e8$var$filterPrimaryPointer(listener) : listener;
};



// We check for event support via functions in case they've been mocked by a testing suite.
var $3a5ac46980083dfa$export$ed662207763ba653 = function() {
    return (0, $c763d68aeba74b31$export$4e09c449d6c407f7) && window.onpointerdown === null;
};
var $3a5ac46980083dfa$export$58e9cbc5718eb8c2 = function() {
    return (0, $c763d68aeba74b31$export$4e09c449d6c407f7) && window.ontouchstart === null;
};
var $3a5ac46980083dfa$export$1a3879af679d3ede = function() {
    return (0, $c763d68aeba74b31$export$4e09c449d6c407f7) && window.onmousedown === null;
};


var $0bac0becffd44d3d$var$mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
var $0bac0becffd44d3d$var$touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function $0bac0becffd44d3d$var$getPointerEventName(name) {
    if ((0, $3a5ac46980083dfa$export$ed662207763ba653)()) return name;
    else if ((0, $3a5ac46980083dfa$export$58e9cbc5718eb8c2)()) return $0bac0becffd44d3d$var$touchEventNames[name];
    else if ((0, $3a5ac46980083dfa$export$1a3879af679d3ede)()) return $0bac0becffd44d3d$var$mouseEventNames[name];
    return name;
}
function $0bac0becffd44d3d$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $2bb083316bee0fb8$export$b1d829ddf82884aa)(target, $0bac0becffd44d3d$var$getPointerEventName(eventName), (0, $19290b72856733e8$export$f4437ba81469b709)(handler, eventName === "pointerdown"), options);
}
function $0bac0becffd44d3d$export$734d04395f5243cd(ref, eventName, handler, options) {
    return (0, $2bb083316bee0fb8$export$c1052189363cb2e0)(ref, $0bac0becffd44d3d$var$getPointerEventName(eventName), handler && (0, $19290b72856733e8$export$f4437ba81469b709)(handler, eventName === "pointerdown"), options);
}


function $96522e0a3b96b9e4$export$518c5fc2dcb7974b(name) {
    var lock = null;
    return function() {
        var openLock = function() {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
var $96522e0a3b96b9e4$var$globalHorizontalLock = $96522e0a3b96b9e4$export$518c5fc2dcb7974b("dragHorizontal");
var $96522e0a3b96b9e4$var$globalVerticalLock = $96522e0a3b96b9e4$export$518c5fc2dcb7974b("dragVertical");
function $96522e0a3b96b9e4$export$2b7959ed03c1a3fe(drag) {
    var lock = false;
    if (drag === "y") lock = $96522e0a3b96b9e4$var$globalVerticalLock();
    else if (drag === "x") lock = $96522e0a3b96b9e4$var$globalHorizontalLock();
    else {
        var openHorizontal_1 = $96522e0a3b96b9e4$var$globalHorizontalLock();
        var openVertical_1 = $96522e0a3b96b9e4$var$globalVerticalLock();
        if (openHorizontal_1 && openVertical_1) lock = function() {
            openHorizontal_1();
            openVertical_1();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal_1) openHorizontal_1();
            if (openVertical_1) openVertical_1();
        }
    }
    return lock;
}
function $96522e0a3b96b9e4$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    var openGestureLock = $96522e0a3b96b9e4$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


function $80258796415e9256$var$createHoverEvent(visualElement, isActive, callback) {
    return function(event, info) {
        var _a;
        if (!(0, $486d9e6769e4fdda$export$764db16956f554f8)(event) || (0, $96522e0a3b96b9e4$export$1b3dd616664938e4)()) return;
        /**
         * Ensure we trigger animations before firing event callback
         */ (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Hover, isActive);
        callback === null || callback === void 0 || callback(event, info);
    };
}
function $80258796415e9256$export$dea06860711b7ebc(_a) {
    var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement = _a.visualElement;
    (0, $0bac0becffd44d3d$export$734d04395f5243cd)(visualElement, "pointerenter", onHoverStart || whileHover ? $80258796415e9256$var$createHoverEvent(visualElement, true, onHoverStart) : undefined, {
        passive: !onHoverStart
    });
    (0, $0bac0becffd44d3d$export$734d04395f5243cd)(visualElement, "pointerleave", onHoverEnd || whileHover ? $80258796415e9256$var$createHoverEvent(visualElement, false, onHoverEnd) : undefined, {
        passive: !onHoverEnd
    });
}



var $exYeM = parcelRequire("exYeM");
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ var $67a7f133a245336d$export$e841ada32ff745b = function(parent, child) {
    if (!child) return false;
    else if (parent === child) return true;
    else return $67a7f133a245336d$export$e841ada32ff745b(parent, child.parentElement);
};




var $exYeM = parcelRequire("exYeM");
function $5575fd4776144082$export$f3a192d0cbd30b96(callback) {
    return (0, $exYeM.useEffect)(function() {
        return function() {
            return callback();
        };
    }, []);
}


const $29c678fcd20f76f7$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $29c678fcd20f76f7$export$a4627e546088548d = (...transformers)=>transformers.reduce($29c678fcd20f76f7$var$combineFunctions);




/**
 * @param handlers -
 * @internal
 */ function $cd433281a7423b2d$export$16dee6ef8c34532(_a) {
    var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement = _a.visualElement;
    var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    var isPressing = (0, $exYeM.useRef)(false);
    var cancelPointerEndListeners = (0, $exYeM.useRef)(null);
    /**
     * Only set listener to passive if there are no external listeners.
     */ var eventOptions = {
        passive: !(onTapStart || onTap || onTapCancel || onPointerDown)
    };
    function removePointerEndListener() {
        var _a;
        (_a = cancelPointerEndListeners.current) === null || _a === void 0 || _a.call(cancelPointerEndListeners);
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        var _a;
        removePointerEndListener();
        isPressing.current = false;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Tap, false);
        return !(0, $96522e0a3b96b9e4$export$1b3dd616664938e4)();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd()) return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */ !(0, $67a7f133a245336d$export$e841ada32ff745b)(visualElement.getInstance(), event.target) ? onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info) : onTap === null || onTap === void 0 || onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd()) return;
        onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        var _a;
        removePointerEndListener();
        if (isPressing.current) return;
        isPressing.current = true;
        cancelPointerEndListeners.current = (0, $29c678fcd20f76f7$export$a4627e546088548d)((0, $0bac0becffd44d3d$export$fcff2e64e6676b81)(window, "pointerup", onPointerUp, eventOptions), (0, $0bac0becffd44d3d$export$fcff2e64e6676b81)(window, "pointercancel", onPointerCancel, eventOptions));
        /**
         * Ensure we trigger animations before firing event callback
         */ (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Tap, true);
        onTapStart === null || onTapStart === void 0 || onTapStart(event, info);
    }
    (0, $0bac0becffd44d3d$export$734d04395f5243cd)(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined, eventOptions);
    (0, $5575fd4776144082$export$f3a192d0cbd30b96)(removePointerEndListener);
}




var $exYeM = parcelRequire("exYeM");

var $0f1c614a58ec263c$var$warned = new Set();
function $0f1c614a58ec263c$export$5b28268982f175ba(condition, message, element) {
    if (condition || $0f1c614a58ec263c$var$warned.has(message)) return;
    console.warn(message);
    if (element) console.warn(element);
    $0f1c614a58ec263c$var$warned.add(message);
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ var $6e6be83e8d5cf4f5$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ var $6e6be83e8d5cf4f5$var$observers = new WeakMap();
var $6e6be83e8d5cf4f5$var$fireObserverCallback = function(entry) {
    var _a;
    (_a = $6e6be83e8d5cf4f5$var$observerCallbacks.get(entry.target)) === null || _a === void 0 || _a(entry);
};
var $6e6be83e8d5cf4f5$var$fireAllObserverCallbacks = function(entries) {
    entries.forEach($6e6be83e8d5cf4f5$var$fireObserverCallback);
};
function $6e6be83e8d5cf4f5$var$initIntersectionObserver(_a) {
    var root = _a.root, options = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(_a, [
        "root"
    ]);
    var lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$6e6be83e8d5cf4f5$var$observers.has(lookupRoot)) $6e6be83e8d5cf4f5$var$observers.set(lookupRoot, {});
    var rootObservers = $6e6be83e8d5cf4f5$var$observers.get(lookupRoot);
    var key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($6e6be83e8d5cf4f5$var$fireAllObserverCallbacks, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({
        root: root
    }, options));
    return rootObservers[key];
}
function $6e6be83e8d5cf4f5$export$b2bcd62fb7925aa5(element, options, callback) {
    var rootInteresectionObserver = $6e6be83e8d5cf4f5$var$initIntersectionObserver(options);
    $6e6be83e8d5cf4f5$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return function() {
        $6e6be83e8d5cf4f5$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


function $05b4e8f13b0ee49a$export$297ec8eb77d6211d(_a) {
    var visualElement = _a.visualElement, whileInView = _a.whileInView, onViewportEnter = _a.onViewportEnter, onViewportLeave = _a.onViewportLeave, _b = _a.viewport, viewport = _b === void 0 ? {} : _b;
    var state = (0, $exYeM.useRef)({
        hasEnteredView: false,
        isInView: false
    });
    var shouldObserve = Boolean(whileInView || onViewportEnter || onViewportLeave);
    if (viewport.once && state.current.hasEnteredView) shouldObserve = false;
    var useObserver = typeof IntersectionObserver === "undefined" ? $05b4e8f13b0ee49a$var$useMissingIntersectionObserver : $05b4e8f13b0ee49a$var$useIntersectionObserver;
    useObserver(shouldObserve, state.current, visualElement, viewport);
}
var $05b4e8f13b0ee49a$var$thresholdNames = {
    some: 0,
    all: 1
};
function $05b4e8f13b0ee49a$var$useIntersectionObserver(shouldObserve, state, visualElement, _a) {
    var root = _a.root, rootMargin = _a.margin, _b = _a.amount, amount = _b === void 0 ? "some" : _b, once = _a.once;
    (0, $exYeM.useEffect)(function() {
        if (!shouldObserve) return;
        var options = {
            root: root === null || root === void 0 ? void 0 : root.current,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $05b4e8f13b0ee49a$var$thresholdNames[amount]
        };
        var intersectionCallback = function(entry) {
            var _a;
            var isIntersecting = entry.isIntersecting;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (state.isInView === isIntersecting) return;
            state.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && state.hasEnteredView) return;
            else if (isIntersecting) state.hasEnteredView = true;
            (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).InView, isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ var props = visualElement.getProps();
            var callback = isIntersecting ? props.onViewportEnter : props.onViewportLeave;
            callback === null || callback === void 0 || callback(entry);
        };
        return (0, $6e6be83e8d5cf4f5$export$b2bcd62fb7925aa5)(visualElement.getInstance(), options, intersectionCallback);
    }, [
        shouldObserve,
        root,
        rootMargin,
        amount
    ]);
}
/**
 * If IntersectionObserver is missing, we activate inView and fire onViewportEnter
 * on mount. This way, the page will be in the state the author expects users
 * to see it in for everyone.
 */ function $05b4e8f13b0ee49a$var$useMissingIntersectionObserver(shouldObserve, state, visualElement, _a) {
    var _b = _a.fallback, fallback = _b === void 0 ? true : _b;
    (0, $exYeM.useEffect)(function() {
        if (!shouldObserve || !fallback) return;
        if ((0, $6402a3fe96f57175$export$a7b6bc01c63cdfc3) !== "production") (0, $0f1c614a58ec263c$export$5b28268982f175ba)(false, "IntersectionObserver not available on this device. whileInView animations will trigger on mount.");
        /**
         * Fire this in an rAF because, at this point, the animation state
         * won't have flushed for the first time and there's certain logic in
         * there that behaves differently on the initial animation.
         *
         * This hook should be quite rarely called so setting this in an rAF
         * is preferred to changing the behaviour of the animation state.
         */ requestAnimationFrame(function() {
            var _a;
            state.hasEnteredView = true;
            var onViewportEnter = visualElement.getProps().onViewportEnter;
            onViewportEnter === null || onViewportEnter === void 0 || onViewportEnter(null);
            (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).InView, true);
        });
    }, [
        shouldObserve
    ]);
}


var $758545c245c88998$export$46d1d6d046f826e4 = function(hook) {
    return function(props) {
        hook(props);
        return null;
    };
};


var $60b1baafc37a77f3$export$e5b72898e5a201f1 = {
    inView: (0, $758545c245c88998$export$46d1d6d046f826e4)((0, $05b4e8f13b0ee49a$export$297ec8eb77d6211d)),
    tap: (0, $758545c245c88998$export$46d1d6d046f826e4)((0, $cd433281a7423b2d$export$16dee6ef8c34532)),
    focus: (0, $758545c245c88998$export$46d1d6d046f826e4)((0, $66963314b48a6651$export$cac52d7cca250a66)),
    hover: (0, $758545c245c88998$export$46d1d6d046f826e4)((0, $80258796415e9256$export$dea06860711b7ebc))
};




var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");


var $8740f6e701a5b2bf$var$counter = 0;
var $8740f6e701a5b2bf$var$incrementId = function() {
    return $8740f6e701a5b2bf$var$counter++;
};
var $8740f6e701a5b2bf$export$f680877a34711e37 = function() {
    return (0, $73d7e626f45c1838$export$fe4300aa8eebea86)($8740f6e701a5b2bf$var$incrementId);
};


/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $eecb2e495db1f2fd$export$2a8c16d82a0a0e26() {
    var context = (0, $exYeM.useContext)((0, $32835478aabc17b5$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useId when released in React
    var id = (0, $8740f6e701a5b2bf$export$f680877a34711e37)();
    (0, $exYeM.useEffect)(function() {
        return register(id);
    }, []);
    var safeToRemove = function() {
        return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id);
    };
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $eecb2e495db1f2fd$export$8249053f690ea39a() {
    return $eecb2e495db1f2fd$export$ee27c052bca048fb((0, $exYeM.useContext)((0, $32835478aabc17b5$export$f224e4635b6f8ce2)));
}
function $eecb2e495db1f2fd$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}






function $423df1fac2a0b98a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    var prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(var i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}







const $4b2c08a9f3cbcf29$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $97af01bbb62c2a82$var$safeMin = 0.001;
const $97af01bbb62c2a82$export$a3cdb76e84ee608e = 0.01;
const $97af01bbb62c2a82$export$1824b851fad8862b = 10.0;
const $97af01bbb62c2a82$export$ff08f2d53484465 = 0.05;
const $97af01bbb62c2a82$export$201ca48e54038115 = 1;
function $97af01bbb62c2a82$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $8494256d1df1e442$export$491112666e282270)(duration <= $97af01bbb62c2a82$export$1824b851fad8862b * 1000, "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    dampingRatio = (0, $4b2c08a9f3cbcf29$export$7d15b64cf5a3a4c4)($97af01bbb62c2a82$export$ff08f2d53484465, $97af01bbb62c2a82$export$201ca48e54038115, dampingRatio);
    duration = (0, $4b2c08a9f3cbcf29$export$7d15b64cf5a3a4c4)($97af01bbb62c2a82$export$a3cdb76e84ee608e, $97af01bbb62c2a82$export$1824b851fad8862b, duration / 1000);
    if (dampingRatio < 1) {
        envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $97af01bbb62c2a82$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $97af01bbb62c2a82$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $97af01bbb62c2a82$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $97af01bbb62c2a82$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$97af01bbb62c2a82$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $97af01bbb62c2a82$var$approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $97af01bbb62c2a82$var$rootIterations = 12;
function $97af01bbb62c2a82$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $97af01bbb62c2a82$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $97af01bbb62c2a82$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $a5491f59f9023a0d$var$durationKeys = [
    "duration",
    "bounce"
];
const $a5491f59f9023a0d$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $a5491f59f9023a0d$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $a5491f59f9023a0d$var$getSpringOptions(options) {
    let springOptions = Object.assign({
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false
    }, options);
    if (!$a5491f59f9023a0d$var$isSpringType(options, $a5491f59f9023a0d$var$physicsKeys) && $a5491f59f9023a0d$var$isSpringType(options, $a5491f59f9023a0d$var$durationKeys)) {
        const derived = (0, $97af01bbb62c2a82$export$b15f158dc6d6f458)(options);
        springOptions = Object.assign(Object.assign(Object.assign({}, springOptions), derived), {
            velocity: 0.0,
            mass: 1.0
        });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $a5491f59f9023a0d$export$b36281d89752ae66(_a) {
    var { from: from = 0.0, to: to = 1.0, restSpeed: restSpeed = 2, restDelta: restDelta } = _a, options = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(_a, [
        "from",
        "to",
        "restSpeed",
        "restDelta"
    ]);
    const state = {
        done: false,
        value: from
    };
    let { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $a5491f59f9023a0d$var$getSpringOptions(options);
    let resolveSpring = $a5491f59f9023a0d$var$zero;
    let resolveVelocity = $a5491f59f9023a0d$var$zero;
    function createSpring() {
        const initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        const initialDelta = to - from;
        const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        if (restDelta === undefined) restDelta = Math.min(Math.abs(to - from) / 100, 0.4);
        if (dampingRatio < 1) {
            const angularFreq = (0, $97af01bbb62c2a82$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
            };
            resolveVelocity = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return dampingRatio * undampedAngularFreq * envelope * (Math.sin(angularFreq * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq + initialDelta * Math.cos(angularFreq * t)) - envelope * (Math.cos(angularFreq * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) - angularFreq * initialDelta * Math.sin(angularFreq * t));
            };
        } else if (dampingRatio === 1) resolveSpring = (t)=>to - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        else {
            const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                const freqForT = Math.min(dampedAngularFreq * t, 300);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
            };
        }
    }
    createSpring();
    return {
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                const currentVelocity = resolveVelocity(t) * 1000;
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? to : current;
            return state;
        },
        flipTarget: ()=>{
            velocity = -velocity;
            [from, to] = [
                to,
                from
            ];
            createSpring();
        }
    };
}
$a5491f59f9023a0d$export$b36281d89752ae66.needsInterpolation = (a, b)=>typeof a === "string" || typeof b === "string";
const $a5491f59f9023a0d$var$zero = (_t)=>0;


const $495f4f72f02e3374$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


const $3318cde9c86c9824$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;






const $9640c9fa7d8eea89$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $01f71f54e5605f2f$export$844ec244b1367d54)(v) && (0, $01f71f54e5605f2f$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $9640c9fa7d8eea89$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $01f71f54e5605f2f$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $01f71f54e5605f2f$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $aeb4fcb31ae15f3f$var$clampRgbUnit = (0, $01f71f54e5605f2f$export$7d15b64cf5a3a4c4)(0, 255);
const $aeb4fcb31ae15f3f$export$7a99c86b5b1f4c9e = Object.assign(Object.assign({}, (0, $5e966ba53bca97ed$export$98e628dec113755e)), {
    transform: (v)=>Math.round($aeb4fcb31ae15f3f$var$clampRgbUnit(v))
});
const $aeb4fcb31ae15f3f$export$4e46ac54fc82cf3b = {
    test: (0, $9640c9fa7d8eea89$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $9640c9fa7d8eea89$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $aeb4fcb31ae15f3f$export$7a99c86b5b1f4c9e.transform(red) + ", " + $aeb4fcb31ae15f3f$export$7a99c86b5b1f4c9e.transform(green) + ", " + $aeb4fcb31ae15f3f$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $01f71f54e5605f2f$export$83d2e9e3e4ee39ed)((0, $5e966ba53bca97ed$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $9f583f7bba2bd472$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    if (v.length > 5) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
        a = v.substr(7, 2);
    } else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        a = v.substr(4, 1);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $9f583f7bba2bd472$export$834dfc94dde4b3d8 = {
    test: (0, $9640c9fa7d8eea89$export$2c8400d58aca05e)("#"),
    parse: $9f583f7bba2bd472$var$parseHex,
    transform: (0, $aeb4fcb31ae15f3f$export$4e46ac54fc82cf3b).transform
};





const $cf65d5b1ba501bd9$export$810b04175080204c = {
    test: (0, $9640c9fa7d8eea89$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $9640c9fa7d8eea89$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $0d8007420b761bba$export$626336c2cd4b14de).transform((0, $01f71f54e5605f2f$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $0d8007420b761bba$export$626336c2cd4b14de).transform((0, $01f71f54e5605f2f$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $01f71f54e5605f2f$export$83d2e9e3e4ee39ed)((0, $5e966ba53bca97ed$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



function $59f3cfd720ed6ea8$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $59f3cfd720ed6ea8$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $59f3cfd720ed6ea8$var$hueToRgb(p, q, hue + 1 / 3);
        green = $59f3cfd720ed6ea8$var$hueToRgb(p, q, hue);
        blue = $59f3cfd720ed6ea8$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}


const $80a0bd0ef090e3b1$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
const $80a0bd0ef090e3b1$var$colorTypes = [
    (0, $9f583f7bba2bd472$export$834dfc94dde4b3d8),
    (0, $aeb4fcb31ae15f3f$export$4e46ac54fc82cf3b),
    (0, $cf65d5b1ba501bd9$export$810b04175080204c)
];
const $80a0bd0ef090e3b1$var$getColorType = (v)=>$80a0bd0ef090e3b1$var$colorTypes.find((type)=>type.test(v));
const $80a0bd0ef090e3b1$var$notAnimatable = (color)=>`'${color}' is not an animatable color. Use the equivalent color code instead.`;
const $80a0bd0ef090e3b1$export$51e568cf5c039bac = (from, to)=>{
    let fromColorType = $80a0bd0ef090e3b1$var$getColorType(from);
    let toColorType = $80a0bd0ef090e3b1$var$getColorType(to);
    (0, $8494256d1df1e442$export$f5708dca728d7177)(!!fromColorType, $80a0bd0ef090e3b1$var$notAnimatable(from));
    (0, $8494256d1df1e442$export$f5708dca728d7177)(!!toColorType, $80a0bd0ef090e3b1$var$notAnimatable(to));
    let fromColor = fromColorType.parse(from);
    let toColor = toColorType.parse(to);
    if (fromColorType === (0, $cf65d5b1ba501bd9$export$810b04175080204c)) {
        fromColor = (0, $59f3cfd720ed6ea8$export$6ae64dbcd6bfc33e)(fromColor);
        fromColorType = (0, $aeb4fcb31ae15f3f$export$4e46ac54fc82cf3b);
    }
    if (toColorType === (0, $cf65d5b1ba501bd9$export$810b04175080204c)) {
        toColor = (0, $59f3cfd720ed6ea8$export$6ae64dbcd6bfc33e)(toColor);
        toColorType = (0, $aeb4fcb31ae15f3f$export$4e46ac54fc82cf3b);
    }
    const blended = Object.assign({}, fromColor);
    return (v)=>{
        for(const key in blended)if (key !== "alpha") blended[key] = $80a0bd0ef090e3b1$export$d4ecea248cce73c(fromColor[key], toColor[key], v);
        blended.alpha = (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
};






const $262cc884a4762e38$export$35e9368ef982300f = {
    test: (v)=>(0, $aeb4fcb31ae15f3f$export$4e46ac54fc82cf3b).test(v) || (0, $9f583f7bba2bd472$export$834dfc94dde4b3d8).test(v) || (0, $cf65d5b1ba501bd9$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $aeb4fcb31ae15f3f$export$4e46ac54fc82cf3b).test(v)) return (0, $aeb4fcb31ae15f3f$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $cf65d5b1ba501bd9$export$810b04175080204c).test(v)) return (0, $cf65d5b1ba501bd9$export$810b04175080204c).parse(v);
        else return (0, $9f583f7bba2bd472$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $01f71f54e5605f2f$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $aeb4fcb31ae15f3f$export$4e46ac54fc82cf3b).transform(v) : (0, $cf65d5b1ba501bd9$export$810b04175080204c).transform(v);
    }
};




const $dd5b1de03e779230$var$colorToken = "${c}";
const $dd5b1de03e779230$var$numberToken = "${n}";
function $dd5b1de03e779230$var$test(v) {
    var _a, _b, _c, _d;
    return isNaN(v) && (0, $01f71f54e5605f2f$export$844ec244b1367d54)(v) && ((_b = (_a = v.match((0, $01f71f54e5605f2f$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match((0, $01f71f54e5605f2f$export$740b69c5fad25dba))) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
}
function $dd5b1de03e779230$var$analyse(v) {
    if (typeof v === "number") v = `${v}`;
    const values = [];
    let numColors = 0;
    const colors = v.match((0, $01f71f54e5605f2f$export$740b69c5fad25dba));
    if (colors) {
        numColors = colors.length;
        v = v.replace((0, $01f71f54e5605f2f$export$740b69c5fad25dba), $dd5b1de03e779230$var$colorToken);
        values.push(...colors.map((0, $262cc884a4762e38$export$35e9368ef982300f).parse));
    }
    const numbers = v.match((0, $01f71f54e5605f2f$export$2444ca58c08448e4));
    if (numbers) {
        v = v.replace((0, $01f71f54e5605f2f$export$2444ca58c08448e4), $dd5b1de03e779230$var$numberToken);
        values.push(...numbers.map((0, $5e966ba53bca97ed$export$98e628dec113755e).parse));
    }
    return {
        values: values,
        numColors: numColors,
        tokenised: v
    };
}
function $dd5b1de03e779230$var$parse(v) {
    return $dd5b1de03e779230$var$analyse(v).values;
}
function $dd5b1de03e779230$var$createTransformer(v) {
    const { values: values, numColors: numColors, tokenised: tokenised } = $dd5b1de03e779230$var$analyse(v);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++)output = output.replace(i < numColors ? $dd5b1de03e779230$var$colorToken : $dd5b1de03e779230$var$numberToken, i < numColors ? (0, $262cc884a4762e38$export$35e9368ef982300f).transform(v[i]) : (0, $01f71f54e5605f2f$export$83d2e9e3e4ee39ed)(v[i]));
        return output;
    };
}
const $dd5b1de03e779230$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $dd5b1de03e779230$var$getAnimatableNone(v) {
    const parsed = $dd5b1de03e779230$var$parse(v);
    const transformer = $dd5b1de03e779230$var$createTransformer(v);
    return transformer(parsed.map($dd5b1de03e779230$var$convertNumbersToZero));
}
const $dd5b1de03e779230$export$83a0e34f1302825b = {
    test: $dd5b1de03e779230$var$test,
    parse: $dd5b1de03e779230$var$parse,
    createTransformer: $dd5b1de03e779230$var$createTransformer,
    getAnimatableNone: $dd5b1de03e779230$var$getAnimatableNone
};




const $a595db145234e7da$export$c0c148ccc4f34a76 = {
    x: 0,
    y: 0,
    z: 0
};
const $a595db145234e7da$export$4e960b977ccfec97 = (v)=>typeof v === "number";




function $45bf3fac14e4a167$var$getMixer(origin, target) {
    if ((0, $a595db145234e7da$export$4e960b977ccfec97)(origin)) return (v)=>(0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $262cc884a4762e38$export$35e9368ef982300f).test(origin)) return (0, $80a0bd0ef090e3b1$export$51e568cf5c039bac)(origin, target);
    else return $45bf3fac14e4a167$export$65516310a87d8205(origin, target);
}
const $45bf3fac14e4a167$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$45bf3fac14e4a167$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $45bf3fac14e4a167$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = Object.assign(Object.assign({}, origin), target);
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $45bf3fac14e4a167$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
function $45bf3fac14e4a167$var$analyse(value) {
    const parsed = (0, $dd5b1de03e779230$export$83a0e34f1302825b).parse(value);
    const numValues = parsed.length;
    let numNumbers = 0;
    let numRGB = 0;
    let numHSL = 0;
    for(let i = 0; i < numValues; i++){
        if (numNumbers || typeof parsed[i] === "number") numNumbers++;
        else if (parsed[i].hue !== undefined) numHSL++;
        else numRGB++;
    }
    return {
        parsed: parsed,
        numNumbers: numNumbers,
        numRGB: numRGB,
        numHSL: numHSL
    };
}
const $45bf3fac14e4a167$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $dd5b1de03e779230$export$83a0e34f1302825b).createTransformer(target);
    const originStats = $45bf3fac14e4a167$var$analyse(origin);
    const targetStats = $45bf3fac14e4a167$var$analyse(target);
    const canInterpolate = originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $29c678fcd20f76f7$export$a4627e546088548d)($45bf3fac14e4a167$export$3bbefa2f402845c4(originStats.parsed, targetStats.parsed), template);
    else {
        (0, $8494256d1df1e442$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (p)=>`${p > 0 ? target : origin}`;
    }
};






const $2864dcb351a435f4$var$mixNumber = (from, to)=>(p)=>(0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(from, to, p);
function $2864dcb351a435f4$var$detectMixerFactory(v) {
    if (typeof v === "number") return $2864dcb351a435f4$var$mixNumber;
    else if (typeof v === "string") {
        if ((0, $262cc884a4762e38$export$35e9368ef982300f).test(v)) return 0, $80a0bd0ef090e3b1$export$51e568cf5c039bac;
        else return 0, $45bf3fac14e4a167$export$65516310a87d8205;
    } else if (Array.isArray(v)) return 0, $45bf3fac14e4a167$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $45bf3fac14e4a167$export$ebc23b6840c51ba1;
}
function $2864dcb351a435f4$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $2864dcb351a435f4$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = (0, $29c678fcd20f76f7$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function $2864dcb351a435f4$var$fastInterpolate([from, to], [mixer]) {
    return (v)=>mixer((0, $495f4f72f02e3374$export$504d7abb21fa8c9)(from, to, v));
}
function $2864dcb351a435f4$var$slowInterpolate(input, mixers) {
    const inputLength = input.length;
    const lastInputIndex = inputLength - 1;
    return (v)=>{
        let mixerIndex = 0;
        let foundMixerIndex = false;
        if (v <= input[0]) foundMixerIndex = true;
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            let i = 1;
            for(; i < inputLength; i++){
                if (input[i] > v || i === lastInputIndex) break;
            }
            mixerIndex = i - 1;
        }
        const progressInRange = (0, $495f4f72f02e3374$export$504d7abb21fa8c9)(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function $2864dcb351a435f4$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $8494256d1df1e442$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    (0, $8494256d1df1e442$export$f5708dca728d7177)(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.");
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    const mixers = $2864dcb351a435f4$var$createMixers(output, ease, mixer);
    const interpolator = inputLength === 2 ? $2864dcb351a435f4$var$fastInterpolate(input, mixers) : $2864dcb351a435f4$var$slowInterpolate(input, mixers);
    return isClamp ? (v)=>interpolator((0, $4b2c08a9f3cbcf29$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}


const $e8091545037bd561$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);
const $e8091545037bd561$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
const $e8091545037bd561$export$c90c8c5a3c7a5e80 = (power)=>(p)=>Math.pow(p, power);
const $e8091545037bd561$export$2a739ba6da1d1495 = (power)=>(p)=>p * p * ((power + 1) * p - power);
const $e8091545037bd561$export$222fa0be41d8b537 = (power)=>{
    const backEasing = $e8091545037bd561$export$2a739ba6da1d1495(power);
    return (p)=>(p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
};


const $103ab17de5093dac$var$DEFAULT_OVERSHOOT_STRENGTH = 1.525;
const $103ab17de5093dac$var$BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
const $103ab17de5093dac$var$BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
const $103ab17de5093dac$var$BOUNCE_THIRD_THRESHOLD = 0.9;
const $103ab17de5093dac$export$45db2fc2f15997e7 = (p)=>p;
const $103ab17de5093dac$export$929e5a82286172a6 = (0, $e8091545037bd561$export$c90c8c5a3c7a5e80)(2);
const $103ab17de5093dac$export$57636bb43b1ccbb0 = (0, $e8091545037bd561$export$2c07eeff45156d4d)($103ab17de5093dac$export$929e5a82286172a6);
const $103ab17de5093dac$export$c07234257a03d5e9 = (0, $e8091545037bd561$export$f946554fb8aeaf0d)($103ab17de5093dac$export$929e5a82286172a6);
const $103ab17de5093dac$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $103ab17de5093dac$export$c8d67a19199d1a50 = (0, $e8091545037bd561$export$2c07eeff45156d4d)($103ab17de5093dac$export$e444123e42d03385);
const $103ab17de5093dac$export$30d3455eee55bed5 = (0, $e8091545037bd561$export$f946554fb8aeaf0d)($103ab17de5093dac$export$c8d67a19199d1a50);
const $103ab17de5093dac$export$b01116c84cdfe1a2 = (0, $e8091545037bd561$export$2a739ba6da1d1495)($103ab17de5093dac$var$DEFAULT_OVERSHOOT_STRENGTH);
const $103ab17de5093dac$export$77edfce482316a60 = (0, $e8091545037bd561$export$2c07eeff45156d4d)($103ab17de5093dac$export$b01116c84cdfe1a2);
const $103ab17de5093dac$export$ddc5fd596f6c71b2 = (0, $e8091545037bd561$export$f946554fb8aeaf0d)($103ab17de5093dac$export$b01116c84cdfe1a2);
const $103ab17de5093dac$export$6b0af63b873d419e = (0, $e8091545037bd561$export$222fa0be41d8b537)($103ab17de5093dac$var$DEFAULT_OVERSHOOT_STRENGTH);
const $103ab17de5093dac$var$ca = 4356.0 / 361.0;
const $103ab17de5093dac$var$cb = 35442.0 / 1805.0;
const $103ab17de5093dac$var$cc = 16061.0 / 1805.0;
const $103ab17de5093dac$export$cccc9e04465dce11 = (p)=>{
    if (p === 1 || p === 0) return p;
    const p2 = p * p;
    return p < $103ab17de5093dac$var$BOUNCE_FIRST_THRESHOLD ? 7.5625 * p2 : p < $103ab17de5093dac$var$BOUNCE_SECOND_THRESHOLD ? 9.075 * p2 - 9.9 * p + 3.4 : p < $103ab17de5093dac$var$BOUNCE_THIRD_THRESHOLD ? $103ab17de5093dac$var$ca * p2 - $103ab17de5093dac$var$cb * p + $103ab17de5093dac$var$cc : 10.8 * p * p - 20.52 * p + 10.72;
};
const $103ab17de5093dac$export$fccebd7948554554 = (0, $e8091545037bd561$export$2c07eeff45156d4d)($103ab17de5093dac$export$cccc9e04465dce11);
const $103ab17de5093dac$export$41ad9e9849a703ce = (p)=>p < 0.5 ? 0.5 * (1.0 - $103ab17de5093dac$export$cccc9e04465dce11(1.0 - p * 2.0)) : 0.5 * $103ab17de5093dac$export$cccc9e04465dce11(p * 2.0 - 1.0) + 0.5;


function $2a673aae56c5fc7a$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $103ab17de5093dac$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $2a673aae56c5fc7a$export$24dbcec0b26e6d9d(values) {
    const numValues = values.length;
    return values.map((_value, i)=>i !== 0 ? i / (numValues - 1) : 0);
}
function $2a673aae56c5fc7a$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}
function $2a673aae56c5fc7a$export$d25ddfdf17c3ad3e({ from: from = 0, to: to = 1, ease: ease, offset: offset, duration: duration = 300 }) {
    const state = {
        done: false,
        value: from
    };
    const values = Array.isArray(to) ? to : [
        from,
        to
    ];
    const times = $2a673aae56c5fc7a$export$2a91b4e3a4539316(offset && offset.length === values.length ? offset : $2a673aae56c5fc7a$export$24dbcec0b26e6d9d(values), duration);
    function createInterpolator() {
        return (0, $2864dcb351a435f4$export$89e29e4ab65e70a9)(times, values, {
            ease: Array.isArray(ease) ? ease : $2a673aae56c5fc7a$export$6b60b58e4ea7d715(values, ease)
        });
    }
    let interpolator = createInterpolator();
    return {
        next: (t)=>{
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: ()=>{
            values.reverse();
            interpolator = createInterpolator();
        }
    };
}


function $2def364b8b1b4411$export$e9341ba102272ab9({ velocity: velocity = 0, from: from = 0, power: power = 0.8, timeConstant: timeConstant = 350, restDelta: restDelta = 0.5, modifyTarget: modifyTarget }) {
    const state = {
        done: false,
        value: from
    };
    let amplitude = power * velocity;
    const ideal = from + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    if (target !== ideal) amplitude = target - from;
    return {
        next: (t)=>{
            const delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: ()=>{}
    };
}


const $9cb5ee911b7ff539$var$types = {
    keyframes: $2a673aae56c5fc7a$export$d25ddfdf17c3ad3e,
    spring: $a5491f59f9023a0d$export$b36281d89752ae66,
    decay: $2def364b8b1b4411$export$e9341ba102272ab9
};
function $9cb5ee911b7ff539$export$74df49bbebf8cb2c(config) {
    if (Array.isArray(config.to)) return 0, $2a673aae56c5fc7a$export$d25ddfdf17c3ad3e;
    else if ($9cb5ee911b7ff539$var$types[config.type]) return $9cb5ee911b7ff539$var$types[config.type];
    const keys = new Set(Object.keys(config));
    if (keys.has("ease") || keys.has("duration") && !keys.has("dampingRatio")) return 0, $2a673aae56c5fc7a$export$d25ddfdf17c3ad3e;
    else if (keys.has("dampingRatio") || keys.has("stiffness") || keys.has("mass") || keys.has("damping") || keys.has("restSpeed") || keys.has("restDelta")) return 0, $a5491f59f9023a0d$export$b36281d89752ae66;
    return 0, $2a673aae56c5fc7a$export$d25ddfdf17c3ad3e;
}


const $819b035a2e1a6df6$export$f8caf8121275292d = 1 / 60 * 1000;
const $819b035a2e1a6df6$var$getCurrentTime = typeof performance !== "undefined" ? ()=>performance.now() : ()=>Date.now();
const $819b035a2e1a6df6$export$4fdea63ab5513fd5 = typeof window !== "undefined" ? (callback)=>window.requestAnimationFrame(callback) : (callback)=>setTimeout(()=>callback($819b035a2e1a6df6$var$getCurrentTime()), $819b035a2e1a6df6$export$f8caf8121275292d);


function $7c714a55df5605d9$export$b995e5e85f5c8289(runNextFrame) {
    let toRun = [];
    let toRunNextFrame = [];
    let numToRun = 0;
    let isProcessing = false;
    let flushNextFrame = false;
    const toKeepAlive = new WeakSet();
    const step = {
        schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        cancel: (callback)=>{
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: (frameData)=>{
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [
                toRunNextFrame,
                toRun
            ];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $2e071b817ebd59af$var$maxElapsed = 40;
let $2e071b817ebd59af$var$useDefaultElapsed = true;
let $2e071b817ebd59af$var$runNextFrame = false;
let $2e071b817ebd59af$var$isProcessing = false;
const $2e071b817ebd59af$var$frame = {
    delta: 0,
    timestamp: 0
};
const $2e071b817ebd59af$var$stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $2e071b817ebd59af$var$steps = $2e071b817ebd59af$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = (0, $7c714a55df5605d9$export$b995e5e85f5c8289)(()=>$2e071b817ebd59af$var$runNextFrame = true);
    return acc;
}, {});
const $2e071b817ebd59af$var$sync = $2e071b817ebd59af$var$stepsOrder.reduce((acc, key)=>{
    const step = $2e071b817ebd59af$var$steps[key];
    acc[key] = (process, keepAlive = false, immediate = false)=>{
        if (!$2e071b817ebd59af$var$runNextFrame) $2e071b817ebd59af$var$startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const $2e071b817ebd59af$export$d93e9c1fe0553512 = $2e071b817ebd59af$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = $2e071b817ebd59af$var$steps[key].cancel;
    return acc;
}, {});
const $2e071b817ebd59af$export$cd75ccfd720a3cd4 = $2e071b817ebd59af$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = ()=>$2e071b817ebd59af$var$steps[key].process($2e071b817ebd59af$var$frame);
    return acc;
}, {});
const $2e071b817ebd59af$var$processStep = (stepId)=>$2e071b817ebd59af$var$steps[stepId].process($2e071b817ebd59af$var$frame);
const $2e071b817ebd59af$var$processFrame = (timestamp)=>{
    $2e071b817ebd59af$var$runNextFrame = false;
    $2e071b817ebd59af$var$frame.delta = $2e071b817ebd59af$var$useDefaultElapsed ? (0, $819b035a2e1a6df6$export$f8caf8121275292d) : Math.max(Math.min(timestamp - $2e071b817ebd59af$var$frame.timestamp, $2e071b817ebd59af$var$maxElapsed), 1);
    $2e071b817ebd59af$var$frame.timestamp = timestamp;
    $2e071b817ebd59af$var$isProcessing = true;
    $2e071b817ebd59af$var$stepsOrder.forEach($2e071b817ebd59af$var$processStep);
    $2e071b817ebd59af$var$isProcessing = false;
    if ($2e071b817ebd59af$var$runNextFrame) {
        $2e071b817ebd59af$var$useDefaultElapsed = false;
        (0, $819b035a2e1a6df6$export$4fdea63ab5513fd5)($2e071b817ebd59af$var$processFrame);
    }
};
const $2e071b817ebd59af$var$startLoop = ()=>{
    $2e071b817ebd59af$var$runNextFrame = true;
    $2e071b817ebd59af$var$useDefaultElapsed = true;
    if (!$2e071b817ebd59af$var$isProcessing) (0, $819b035a2e1a6df6$export$4fdea63ab5513fd5)($2e071b817ebd59af$var$processFrame);
};
const $2e071b817ebd59af$export$7244445918e670ed = ()=>$2e071b817ebd59af$var$frame;
var $2e071b817ebd59af$export$2e2bcd8739ae039 = $2e071b817ebd59af$var$sync;



function $e86e351befa9de05$export$7d0784e050d8e25f(elapsed, duration, delay = 0) {
    return elapsed - duration - delay;
}
function $e86e351befa9de05$export$ab9042754680126b(elapsed, duration, delay = 0, isForwardPlayback = true) {
    return isForwardPlayback ? $e86e351befa9de05$export$7d0784e050d8e25f(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function $e86e351befa9de05$export$c9c9437f9b8733b5(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}


const $8b5db46a1e8dd46b$var$framesync = (update)=>{
    const passTimestamp = ({ delta: delta })=>update(delta);
    return {
        start: ()=>(0, $2e071b817ebd59af$export$2e2bcd8739ae039).update(passTimestamp, true),
        stop: ()=>(0, $2e071b817ebd59af$export$d93e9c1fe0553512).update(passTimestamp)
    };
};
function $8b5db46a1e8dd46b$export$e3607ec2d7a891c4(_a) {
    var _b, _c;
    var { from: from, autoplay: autoplay = true, driver: driver = $8b5db46a1e8dd46b$var$framesync, elapsed: elapsed = 0, repeat: repeatMax = 0, repeatType: repeatType = "loop", repeatDelay: repeatDelay = 0, onPlay: onPlay, onStop: onStop, onComplete: onComplete, onRepeat: onRepeat, onUpdate: onUpdate } = _a, options = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(_a, [
        "from",
        "autoplay",
        "driver",
        "elapsed",
        "repeat",
        "repeatType",
        "repeatDelay",
        "onPlay",
        "onStop",
        "onComplete",
        "onRepeat",
        "onUpdate"
    ]);
    let { to: to } = options;
    let driverControls;
    let repeatCount = 0;
    let computedDuration = options.duration;
    let latest;
    let isComplete = false;
    let isForwardPlayback = true;
    let interpolateFromNumber;
    const animator = (0, $9cb5ee911b7ff539$export$74df49bbebf8cb2c)(options);
    if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
        interpolateFromNumber = (0, $2864dcb351a435f4$export$89e29e4ab65e70a9)([
            0,
            100
        ], [
            from,
            to
        ], {
            clamp: false
        });
        from = 0;
        to = 100;
    }
    const animation = animator(Object.assign(Object.assign({}, options), {
        from: from,
        to: to
    }));
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = (0, $e86e351befa9de05$export$ab9042754680126b)(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        } else {
            elapsed = (0, $e86e351befa9de05$export$7d0784e050d8e25f)(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror") animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback) delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            const state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber) latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate === null || onUpdate === void 0 || onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0) computedDuration !== null && computedDuration !== void 0 ? computedDuration : computedDuration = elapsed;
            if (repeatCount < repeatMax) (0, $e86e351befa9de05$export$c9c9437f9b8733b5)(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            else complete();
        }
    }
    function play() {
        onPlay === null || onPlay === void 0 || onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: ()=>{
            onStop === null || onStop === void 0 || onStop();
            driverControls.stop();
        }
    };
}


function $9be0a78390785f5d$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}



function $1cc109d8d2c5fa11$export$ee3ff3a17106998({ from: from = 0, velocity: velocity = 0, min: min, max: max, power: power = 0.8, timeConstant: timeConstant = 750, bounceStiffness: bounceStiffness = 500, bounceDamping: bounceDamping = 10, restDelta: restDelta = 1, modifyTarget: modifyTarget, driver: driver, onUpdate: onUpdate, onComplete: onComplete, onStop: onStop }) {
    let currentAnimation;
    function isOutOfBounds(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    }
    function boundaryNearest(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 || currentAnimation.stop();
        currentAnimation = (0, $8b5db46a1e8dd46b$export$e3607ec2d7a891c4)(Object.assign(Object.assign({}, options), {
            driver: driver,
            onUpdate: (v)=>{
                var _a;
                onUpdate === null || onUpdate === void 0 || onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, v);
            },
            onComplete: onComplete,
            onStop: onStop
        }));
    }
    function startSpring(options) {
        startAnimation(Object.assign({
            type: "spring",
            stiffness: bounceStiffness,
            damping: bounceDamping,
            restDelta: restDelta
        }, options));
    }
    if (isOutOfBounds(from)) startSpring({
        from: from,
        velocity: velocity,
        to: boundaryNearest(from)
    });
    else {
        let target = power * velocity + from;
        if (typeof modifyTarget !== "undefined") target = modifyTarget(target);
        const boundary = boundaryNearest(target);
        const heading = boundary === min ? -1 : 1;
        let prev;
        let current;
        const checkBoundary = (v)=>{
            prev = current;
            current = v;
            velocity = (0, $9be0a78390785f5d$export$eab0632f7ad4f9d7)(v - prev, (0, $2e071b817ebd59af$export$7244445918e670ed)().delta);
            if (heading === 1 && v > boundary || heading === -1 && v < boundary) startSpring({
                from: v,
                to: boundary,
                velocity: velocity
            });
        };
        startAnimation({
            type: "decay",
            from: from,
            velocity: velocity,
            timeConstant: timeConstant,
            power: power,
            restDelta: restDelta,
            modifyTarget: modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined
        });
    }
    return {
        stop: ()=>currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop()
    };
}


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ var $bfda710cf857a073$export$fc3e7e8557f8c8c7 = function(seconds) {
    return seconds * 1000;
};





const $a529804619ba9de7$var$a = (a1, a2)=>1.0 - 3.0 * a2 + 3.0 * a1;
const $a529804619ba9de7$var$b = (a1, a2)=>3.0 * a2 - 6.0 * a1;
const $a529804619ba9de7$var$c = (a1)=>3.0 * a1;
const $a529804619ba9de7$var$calcBezier = (t, a1, a2)=>(($a529804619ba9de7$var$a(a1, a2) * t + $a529804619ba9de7$var$b(a1, a2)) * t + $a529804619ba9de7$var$c(a1)) * t;
const $a529804619ba9de7$var$getSlope = (t, a1, a2)=>3.0 * $a529804619ba9de7$var$a(a1, a2) * t * t + 2.0 * $a529804619ba9de7$var$b(a1, a2) * t + $a529804619ba9de7$var$c(a1);
const $a529804619ba9de7$var$subdivisionPrecision = 0.0000001;
const $a529804619ba9de7$var$subdivisionMaxIterations = 10;
function $a529804619ba9de7$var$binarySubdivide(aX, aA, aB, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = $a529804619ba9de7$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $a529804619ba9de7$var$subdivisionPrecision && ++i < $a529804619ba9de7$var$subdivisionMaxIterations);
    return currentT;
}
const $a529804619ba9de7$var$newtonIterations = 8;
const $a529804619ba9de7$var$newtonMinSlope = 0.001;
function $a529804619ba9de7$var$newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(let i = 0; i < $a529804619ba9de7$var$newtonIterations; ++i){
        const currentSlope = $a529804619ba9de7$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        const currentX = $a529804619ba9de7$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
const $a529804619ba9de7$var$kSplineTableSize = 11;
const $a529804619ba9de7$var$kSampleStepSize = 1.0 / ($a529804619ba9de7$var$kSplineTableSize - 1.0);
function $a529804619ba9de7$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    if (mX1 === mY1 && mX2 === mY2) return 0, $103ab17de5093dac$export$45db2fc2f15997e7;
    const sampleValues = new Float32Array($a529804619ba9de7$var$kSplineTableSize);
    for(let i = 0; i < $a529804619ba9de7$var$kSplineTableSize; ++i)sampleValues[i] = $a529804619ba9de7$var$calcBezier(i * $a529804619ba9de7$var$kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        let intervalStart = 0.0;
        let currentSample = 1;
        const lastSample = $a529804619ba9de7$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $a529804619ba9de7$var$kSampleStepSize;
        --currentSample;
        const dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        const guessForT = intervalStart + dist * $a529804619ba9de7$var$kSampleStepSize;
        const initialSlope = $a529804619ba9de7$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $a529804619ba9de7$var$newtonMinSlope) return $a529804619ba9de7$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        else if (initialSlope === 0.0) return guessForT;
        else return $a529804619ba9de7$var$binarySubdivide(aX, intervalStart, intervalStart + $a529804619ba9de7$var$kSampleStepSize, mX1, mX2);
    }
    return (t)=>t === 0 || t === 1 ? t : $a529804619ba9de7$var$calcBezier(getTForX(t), mY1, mY2);
}


var $2927493cdf40a8cb$var$easingLookup = {
    linear: (0, $103ab17de5093dac$export$45db2fc2f15997e7),
    easeIn: (0, $103ab17de5093dac$export$929e5a82286172a6),
    easeInOut: (0, $103ab17de5093dac$export$c07234257a03d5e9),
    easeOut: (0, $103ab17de5093dac$export$57636bb43b1ccbb0),
    circIn: (0, $103ab17de5093dac$export$e444123e42d03385),
    circInOut: (0, $103ab17de5093dac$export$30d3455eee55bed5),
    circOut: (0, $103ab17de5093dac$export$c8d67a19199d1a50),
    backIn: (0, $103ab17de5093dac$export$b01116c84cdfe1a2),
    backInOut: (0, $103ab17de5093dac$export$ddc5fd596f6c71b2),
    backOut: (0, $103ab17de5093dac$export$77edfce482316a60),
    anticipate: (0, $103ab17de5093dac$export$6b0af63b873d419e),
    bounceIn: (0, $103ab17de5093dac$export$fccebd7948554554),
    bounceInOut: (0, $103ab17de5093dac$export$41ad9e9849a703ce),
    bounceOut: (0, $103ab17de5093dac$export$cccc9e04465dce11)
};
var $2927493cdf40a8cb$export$ef97fe084f156ca4 = function(definition) {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $8494256d1df1e442$export$f5708dca728d7177)(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
        var _a = (0, $3433e5a3eb89c040$export$8d051b38c9118094)(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
        return (0, $a529804619ba9de7$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $8494256d1df1e442$export$f5708dca728d7177)($2927493cdf40a8cb$var$easingLookup[definition] !== undefined, "Invalid easing type '".concat(definition, "'"));
        return $2927493cdf40a8cb$var$easingLookup[definition];
    }
    return definition;
};
var $2927493cdf40a8cb$export$216948827bbdc797 = function(ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ var $ad3409c8def06c51$export$65676b58b122bc38 = function(key, value) {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    (0, $dd5b1de03e779230$export$83a0e34f1302825b).test(value) && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};




var $d51b9411f6ccbbd1$export$2577c2184b2254d3 = function() {
    return {
        type: "spring",
        stiffness: 500,
        damping: 25,
        restSpeed: 10
    };
};
var $d51b9411f6ccbbd1$export$a743142a31c132c = function(to) {
    return {
        type: "spring",
        stiffness: 550,
        damping: to === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    };
};
var $d51b9411f6ccbbd1$export$c2d663fbb86d66d6 = function() {
    return {
        type: "keyframes",
        ease: "linear",
        duration: 0.3
    };
};
var $d51b9411f6ccbbd1$var$keyframes = function(values) {
    return {
        type: "keyframes",
        duration: 0.8,
        values: values
    };
};
var $d51b9411f6ccbbd1$var$defaultTransitions = {
    x: $d51b9411f6ccbbd1$export$2577c2184b2254d3,
    y: $d51b9411f6ccbbd1$export$2577c2184b2254d3,
    z: $d51b9411f6ccbbd1$export$2577c2184b2254d3,
    rotate: $d51b9411f6ccbbd1$export$2577c2184b2254d3,
    rotateX: $d51b9411f6ccbbd1$export$2577c2184b2254d3,
    rotateY: $d51b9411f6ccbbd1$export$2577c2184b2254d3,
    rotateZ: $d51b9411f6ccbbd1$export$2577c2184b2254d3,
    scaleX: $d51b9411f6ccbbd1$export$a743142a31c132c,
    scaleY: $d51b9411f6ccbbd1$export$a743142a31c132c,
    scale: $d51b9411f6ccbbd1$export$a743142a31c132c,
    opacity: $d51b9411f6ccbbd1$export$c2d663fbb86d66d6,
    backgroundColor: $d51b9411f6ccbbd1$export$c2d663fbb86d66d6,
    color: $d51b9411f6ccbbd1$export$c2d663fbb86d66d6,
    default: $d51b9411f6ccbbd1$export$a743142a31c132c
};
var $d51b9411f6ccbbd1$export$262124b154b9f1c0 = function(valueKey, to) {
    var transitionFactory;
    if ((0, $6f683bc80c6d969e$export$9153ad4c4999f4a0)(to)) transitionFactory = $d51b9411f6ccbbd1$var$keyframes;
    else transitionFactory = $d51b9411f6ccbbd1$var$defaultTransitions[valueKey] || $d51b9411f6ccbbd1$var$defaultTransitions.default;
    return (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({
        to: to
    }, transitionFactory(to));
};





const $9e8547e2cda908d3$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $9e8547e2cda908d3$var$applyDefaultFilter(v) {
    let [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $01f71f54e5605f2f$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $9e8547e2cda908d3$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $9e8547e2cda908d3$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $9e8547e2cda908d3$export$3dea766d36a8935f = Object.assign(Object.assign({}, (0, $dd5b1de03e779230$export$83a0e34f1302825b)), {
    getAnimatableNone: (v)=>{
        const functions = v.match($9e8547e2cda908d3$var$functionRegex);
        return functions ? functions.map($9e8547e2cda908d3$var$applyDefaultFilter).join(" ") : v;
    }
});





/**
 * A map of default value types for common values
 */ var $10ea5fd01401393b$export$98cd7c72c5a731fb = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, (0, $0d74cfa63198be03$export$eec14432cd1cb67b)), {
    // Color props
    color: (0, $262cc884a4762e38$export$35e9368ef982300f),
    backgroundColor: (0, $262cc884a4762e38$export$35e9368ef982300f),
    outlineColor: (0, $262cc884a4762e38$export$35e9368ef982300f),
    fill: (0, $262cc884a4762e38$export$35e9368ef982300f),
    stroke: (0, $262cc884a4762e38$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $262cc884a4762e38$export$35e9368ef982300f),
    borderTopColor: (0, $262cc884a4762e38$export$35e9368ef982300f),
    borderRightColor: (0, $262cc884a4762e38$export$35e9368ef982300f),
    borderBottomColor: (0, $262cc884a4762e38$export$35e9368ef982300f),
    borderLeftColor: (0, $262cc884a4762e38$export$35e9368ef982300f),
    filter: (0, $9e8547e2cda908d3$export$3dea766d36a8935f),
    WebkitFilter: (0, $9e8547e2cda908d3$export$3dea766d36a8935f)
});
/**
 * Gets the default ValueType for the provided value key
 */ var $10ea5fd01401393b$export$67d1babe0338d23b = function(key) {
    return $10ea5fd01401393b$export$98cd7c72c5a731fb[key];
};


function $f39674aa42131bf6$export$cea0cedcb94873b5(key, value) {
    var _a;
    var defaultValueType = (0, $10ea5fd01401393b$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $9e8547e2cda908d3$export$3dea766d36a8935f)) defaultValueType = (0, $dd5b1de03e779230$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}


var $f006002175d4313e$export$888a3d84909f9e3d = {
    current: false
};



/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $1d127c5bbdfabc9c$export$ca8e47dc8ed5a9d7(_a) {
    _a.when;
    _a.delay;
    _a.delayChildren;
    _a.staggerChildren;
    _a.staggerDirection;
    _a.repeat;
    _a.repeatType;
    _a.repeatDelay;
    _a.from;
    var transition = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(_a, [
        "when",
        "delay",
        "delayChildren",
        "staggerChildren",
        "staggerDirection",
        "repeat",
        "repeatType",
        "repeatDelay",
        "from"
    ]);
    return !!Object.keys(transition).length;
}
var $1d127c5bbdfabc9c$var$legacyRepeatWarning = false;
/**
 * Convert Framer Motion's Transition type into Popmotion-compatible options.
 */ function $1d127c5bbdfabc9c$export$998eb6d72a6574db(_a) {
    var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(_a, [
        "ease",
        "times",
        "yoyo",
        "flip",
        "loop"
    ]);
    var options = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, transition);
    if (times) options["offset"] = times;
    /**
     * Convert any existing durations from seconds to milliseconds
     */ if (transition.duration) options["duration"] = (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(transition.duration);
    if (transition.repeatDelay) options.repeatDelay = (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(transition.repeatDelay);
    /**
     * Map easing names to Popmotion's easing functions
     */ if (ease) options["ease"] = (0, $2927493cdf40a8cb$export$216948827bbdc797)(ease) ? ease.map((0, $2927493cdf40a8cb$export$ef97fe084f156ca4)) : (0, $2927493cdf40a8cb$export$ef97fe084f156ca4)(ease);
    /**
     * Support legacy transition API
     */ if (transition.type === "tween") options.type = "keyframes";
    /**
     * TODO: These options are officially removed from the API.
     */ if (yoyo || loop || flip) {
        (0, $8494256d1df1e442$export$491112666e282270)(!$1d127c5bbdfabc9c$var$legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
        $1d127c5bbdfabc9c$var$legacyRepeatWarning = true;
        if (yoyo) options.repeatType = "reverse";
        else if (loop) options.repeatType = "loop";
        else if (flip) options.repeatType = "mirror";
        options.repeat = loop || yoyo || flip || transition.repeat;
    }
    /**
     * TODO: Popmotion 9 has the ability to automatically detect whether to use
     * a keyframes or spring animation, but does so by detecting velocity and other spring options.
     * It'd be good to introduce a similar thing here.
     */ if (transition.type !== "spring") options.type = "keyframes";
    return options;
}
/**
 * Get the delay for a value by checking Transition with decreasing specificity.
 */ function $1d127c5bbdfabc9c$export$b55a0e77aebddb70(transition, key) {
    var _a, _b;
    var valueTransition = $1d127c5bbdfabc9c$export$7c1391340308742e(transition, key) || {};
    return (_b = (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : transition.delay) !== null && _b !== void 0 ? _b : 0;
}
function $1d127c5bbdfabc9c$export$3d2f5b3e7004e0cf(options) {
    if (Array.isArray(options.to) && options.to[0] === null) {
        options.to = (0, $3433e5a3eb89c040$export$1216008129fb82ed)([], (0, $3433e5a3eb89c040$export$8d051b38c9118094)(options.to), false);
        options.to[0] = options.from;
    }
    return options;
}
function $1d127c5bbdfabc9c$export$9019a69adbea191(transition, options, key) {
    var _a;
    if (Array.isArray(options.to)) (_a = transition.duration) !== null && _a !== void 0 ? _a : transition.duration = 0.8;
    $1d127c5bbdfabc9c$export$3d2f5b3e7004e0cf(options);
    /**
     * Get a default transition if none is determined to be defined.
     */ if (!$1d127c5bbdfabc9c$export$ca8e47dc8ed5a9d7(transition)) transition = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, transition), (0, $d51b9411f6ccbbd1$export$262124b154b9f1c0)(key, options.to));
    return (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, options), $1d127c5bbdfabc9c$export$998eb6d72a6574db(transition));
}
/**
 *
 */ function $1d127c5bbdfabc9c$var$getAnimation(key, value, target, transition, onComplete) {
    var _a;
    var valueTransition = $1d127c5bbdfabc9c$export$7c1391340308742e(transition, key);
    var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
    var isTargetAnimatable = (0, $ad3409c8def06c51$export$65676b58b122bc38)(key, target);
    if (origin === "none" && isTargetAnimatable && typeof target === "string") /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */ origin = (0, $f39674aa42131bf6$export$cea0cedcb94873b5)(key, target);
    else if ($1d127c5bbdfabc9c$export$c46ec7d82fb1f602(origin) && typeof target === "string") origin = $1d127c5bbdfabc9c$export$36cd6032f9de8a48(target);
    else if (!Array.isArray(target) && $1d127c5bbdfabc9c$export$c46ec7d82fb1f602(target) && typeof origin === "string") target = $1d127c5bbdfabc9c$export$36cd6032f9de8a48(origin);
    var isOriginAnimatable = (0, $ad3409c8def06c51$export$65676b58b122bc38)(key, origin);
    (0, $8494256d1df1e442$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, "You are trying to animate ".concat(key, ' from "').concat(origin, '" to "').concat(target, '". ').concat(origin, " is not an animatable value - to enable this animation set ").concat(origin, " to a value animatable to ").concat(target, " via the `style` property."));
    function start() {
        var options = {
            from: origin,
            to: target,
            velocity: value.getVelocity(),
            onComplete: onComplete,
            onUpdate: function(v) {
                return value.set(v);
            }
        };
        return valueTransition.type === "inertia" || valueTransition.type === "decay" ? (0, $1cc109d8d2c5fa11$export$ee3ff3a17106998)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, options), valueTransition)) : (0, $8b5db46a1e8dd46b$export$e3607ec2d7a891c4)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, $1d127c5bbdfabc9c$export$9019a69adbea191(valueTransition, options, key)), {
            onUpdate: function(v) {
                var _a;
                options.onUpdate(v);
                (_a = valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, v);
            },
            onComplete: function() {
                var _a;
                options.onComplete();
                (_a = valueTransition.onComplete) === null || _a === void 0 || _a.call(valueTransition);
            }
        }));
    }
    function set() {
        var _a, _b;
        var finalTarget = (0, $0d15acf980467e42$export$5485128c47bd48bb)(target);
        value.set(finalTarget);
        onComplete();
        (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, finalTarget);
        (_b = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _b === void 0 || _b.call(valueTransition);
        return {
            stop: function() {}
        };
    }
    return !isOriginAnimatable || !isTargetAnimatable || valueTransition.type === false ? set : start;
}
function $1d127c5bbdfabc9c$export$c46ec7d82fb1f602(value) {
    return value === 0 || typeof value === "string" && parseFloat(value) === 0 && value.indexOf(" ") === -1;
}
function $1d127c5bbdfabc9c$export$36cd6032f9de8a48(potentialUnitType) {
    return typeof potentialUnitType === "number" ? 0 : (0, $f39674aa42131bf6$export$cea0cedcb94873b5)("", potentialUnitType);
}
function $1d127c5bbdfabc9c$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}
/**
 * Start animation on a MotionValue. This function is an interface between
 * Framer Motion and Popmotion
 */ function $1d127c5bbdfabc9c$export$592dbd515a49cf1b(key, value, target, transition) {
    if (transition === void 0) transition = {};
    if ((0, $f006002175d4313e$export$888a3d84909f9e3d).current) transition = {
        type: false
    };
    return value.start(function(onComplete) {
        var delayTimer;
        var controls;
        var animation = $1d127c5bbdfabc9c$var$getAnimation(key, value, target, transition, onComplete);
        var delay = $1d127c5bbdfabc9c$export$b55a0e77aebddb70(transition, key);
        var start = function() {
            return controls = animation();
        };
        if (delay) delayTimer = window.setTimeout(start, (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(delay));
        else start();
        return function() {
            clearTimeout(delayTimer);
            controls === null || controls === void 0 || controls.stop();
        };
    });
}




/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var $fe062db003bcffb8$export$65583ed5a868f2d9 = function(v) {
    return /^\-?\d*\.?\d+$/.test(v);
};


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ var $dc25af1e857ab50f$export$ade84c85e44a6cb1 = function(v) {
    return /^0[^.\s]+$/.test(v);
};






function $d2a9bfd104bd5453$export$20e507e47fae79fd(arr, item) {
    arr.indexOf(item) === -1 && arr.push(item);
}
function $d2a9bfd104bd5453$export$fe2d9b4e03920b4c(arr, item) {
    var index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}
// Adapted from array-move
function $d2a9bfd104bd5453$export$ec937e64de6c1257(_a, fromIndex, toIndex) {
    var _b = (0, $3433e5a3eb89c040$export$8d051b38c9118094)(_a), arr = _b.slice(0);
    var startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        var endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        var _c = (0, $3433e5a3eb89c040$export$8d051b38c9118094)(arr.splice(fromIndex, 1), 1), item = _c[0];
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


var $97358bb0f01597b3$export$e7dff9482a5fd23c = /** @class */ function() {
    function SubscriptionManager() {
        this.subscriptions = [];
    }
    SubscriptionManager.prototype.add = function(handler) {
        var _this = this;
        (0, $d2a9bfd104bd5453$export$20e507e47fae79fd)(this.subscriptions, handler);
        return function() {
            return (0, $d2a9bfd104bd5453$export$fe2d9b4e03920b4c)(_this.subscriptions, handler);
        };
    };
    SubscriptionManager.prototype.notify = function(a, b, c) {
        var numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(var i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ var handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    };
    SubscriptionManager.prototype.getSize = function() {
        return this.subscriptions.length;
    };
    SubscriptionManager.prototype.clear = function() {
        this.subscriptions.length = 0;
    };
    return SubscriptionManager;
}();


var $4b2846f88af5423d$var$isFloat = function(value) {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ var $4b2846f88af5423d$export$8cea36d14ee64562 = /** @class */ function() {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ function MotionValue(init) {
        var _this = this;
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "6.5.1";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Functions to notify when the `MotionValue` updates.
         *
         * @internal
         */ this.updateSubscribers = new (0, $97358bb0f01597b3$export$e7dff9482a5fd23c)();
        /**
         * Functions to notify when the velocity updates.
         *
         * @internal
         */ this.velocityUpdateSubscribers = new (0, $97358bb0f01597b3$export$e7dff9482a5fd23c)();
        /**
         * Functions to notify when the `MotionValue` updates and `render` is set to `true`.
         *
         * @internal
         */ this.renderSubscribers = new (0, $97358bb0f01597b3$export$e7dff9482a5fd23c)();
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        this.updateAndNotify = function(v, render) {
            if (render === void 0) render = true;
            _this.prev = _this.current;
            _this.current = v;
            // Update timestamp
            var _a = (0, $2e071b817ebd59af$export$7244445918e670ed)(), delta = _a.delta, timestamp = _a.timestamp;
            if (_this.lastUpdated !== timestamp) {
                _this.timeDelta = delta;
                _this.lastUpdated = timestamp;
                (0, $2e071b817ebd59af$export$2e2bcd8739ae039).postRender(_this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (_this.prev !== _this.current) _this.updateSubscribers.notify(_this.current);
            // Update velocity subscribers
            if (_this.velocityUpdateSubscribers.getSize()) _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            // Update render subscribers
            if (render) _this.renderSubscribers.notify(_this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = function() {
            return (0, $2e071b817ebd59af$export$2e2bcd8739ae039).postRender(_this.velocityCheck);
        };
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = function(_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $4b2846f88af5423d$var$isFloat(this.current);
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @privateRemarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @public
     */ MotionValue.prototype.onChange = function(subscription) {
        return this.updateSubscribers.add(subscription);
    };
    MotionValue.prototype.clearListeners = function() {
        this.updateSubscribers.clear();
    };
    /**
     * Adds a function that will be notified when the `MotionValue` requests a render.
     *
     * @param subscriber - A function that's provided the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @internal
     */ MotionValue.prototype.onRenderRequest = function(subscription) {
        // Render immediately
        subscription(this.get());
        return this.renderSubscribers.add(subscription);
    };
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ MotionValue.prototype.attach = function(passiveEffect) {
        this.passiveEffect = passiveEffect;
    };
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ MotionValue.prototype.set = function(v, render) {
        if (render === void 0) render = true;
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    };
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ MotionValue.prototype.get = function() {
        return this.current;
    };
    /**
     * @public
     */ MotionValue.prototype.getPrevious = function() {
        return this.prev;
    };
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ MotionValue.prototype.getVelocity = function() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $9be0a78390785f5d$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    };
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ MotionValue.prototype.start = function(animation) {
        var _this = this;
        this.stop();
        return new Promise(function(resolve) {
            _this.hasAnimated = true;
            _this.stopAnimation = animation(resolve);
        }).then(function() {
            return _this.clearAnimation();
        });
    };
    /**
     * Stop the currently active animation.
     *
     * @public
     */ MotionValue.prototype.stop = function() {
        if (this.stopAnimation) this.stopAnimation();
        this.clearAnimation();
    };
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ MotionValue.prototype.isAnimating = function() {
        return !!this.stopAnimation;
    };
    MotionValue.prototype.clearAnimation = function() {
        this.stopAnimation = null;
    };
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ MotionValue.prototype.destroy = function() {
        this.updateSubscribers.clear();
        this.renderSubscribers.clear();
        this.stop();
    };
    return MotionValue;
}();
function $4b2846f88af5423d$export$ce8bdc721e76545f(init) {
    return new $4b2846f88af5423d$export$8cea36d14ee64562(init);
}






/**
 * Tests a provided value against a ValueType
 */ var $0a85921ea474cb14$export$6eae4d0a6a7ca7cd = function(v) {
    return function(type) {
        return type.test(v);
    };
};


/**
 * ValueType for "auto"
 */ var $e8457b7d67ceabe9$export$dfb5619354ba860 = {
    test: function(v) {
        return v === "auto";
    },
    parse: function(v) {
        return v;
    }
};


/**
 * A list of value types commonly used for dimensions
 */ var $b2fd586ec5020ed9$export$d176691c1998a1f5 = [
    (0, $5e966ba53bca97ed$export$98e628dec113755e),
    (0, $0d8007420b761bba$export$91c0eda1d06bf008),
    (0, $0d8007420b761bba$export$626336c2cd4b14de),
    (0, $0d8007420b761bba$export$41fc368e1a942b97),
    (0, $0d8007420b761bba$export$aed3d7b7d206c196),
    (0, $0d8007420b761bba$export$f91e8c45a95a32f2),
    (0, $e8457b7d67ceabe9$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ var $b2fd586ec5020ed9$export$eefdd52e3ccae428 = function(v) {
    return $b2fd586ec5020ed9$export$d176691c1998a1f5.find((0, $0a85921ea474cb14$export$6eae4d0a6a7ca7cd)(v));
};



/**
 * A list of all ValueTypes
 */ var $b271d9f56e72d485$var$valueTypes = (0, $3433e5a3eb89c040$export$1216008129fb82ed)((0, $3433e5a3eb89c040$export$1216008129fb82ed)([], (0, $3433e5a3eb89c040$export$8d051b38c9118094)((0, $b2fd586ec5020ed9$export$d176691c1998a1f5)), false), [
    (0, $262cc884a4762e38$export$35e9368ef982300f),
    (0, $dd5b1de03e779230$export$83a0e34f1302825b)
], false);
/**
 * Tests a value against the list of ValueTypes
 */ var $b271d9f56e72d485$export$950e7e59ea1ffed7 = function(v) {
    return $b271d9f56e72d485$var$valueTypes.find((0, $0a85921ea474cb14$export$6eae4d0a6a7ca7cd)(v));
};



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $e4befcaa41a4f540$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $4b2846f88af5423d$export$ce8bdc721e76545f)(value));
}
function $e4befcaa41a4f540$export$1f61c53461aff4a5(visualElement, definition) {
    var resolved = (0, $70145b2788b65a38$export$7b1b1c981f4f0558)(visualElement, definition);
    var _a = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b;
    _a.transition;
    var target = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(_a, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, target), transitionEnd);
    for(var key in target){
        var value = (0, $0d15acf980467e42$export$5485128c47bd48bb)(target[key]);
        $e4befcaa41a4f540$var$setMotionValue(visualElement, key, value);
    }
}
function $e4befcaa41a4f540$var$setVariants(visualElement, variantLabels) {
    var reversedLabels = (0, $3433e5a3eb89c040$export$1216008129fb82ed)([], (0, $3433e5a3eb89c040$export$8d051b38c9118094)(variantLabels), false).reverse();
    reversedLabels.forEach(function(key) {
        var _a;
        var variant = visualElement.getVariant(key);
        variant && $e4befcaa41a4f540$export$1f61c53461aff4a5(visualElement, variant);
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            $e4befcaa41a4f540$var$setVariants(child, variantLabels);
        });
    });
}
function $e4befcaa41a4f540$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $e4befcaa41a4f540$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $e4befcaa41a4f540$var$setVariants(visualElement, [
        definition
    ]);
    else $e4befcaa41a4f540$export$1f61c53461aff4a5(visualElement, definition);
}
function $e4befcaa41a4f540$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b, _c;
    var _d;
    var newValueKeys = Object.keys(target).filter(function(key) {
        return !visualElement.hasValue(key);
    });
    var numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(var i = 0; i < numNewValues; i++){
        var key = newValueKeys[i];
        var targetValue = target[key];
        var value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $fe062db003bcffb8$export$65583ed5a868f2d9)(value) || (0, $dc25af1e857ab50f$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $b271d9f56e72d485$export$950e7e59ea1ffed7)(value) && (0, $dd5b1de03e779230$export$83a0e34f1302825b).test(targetValue)) value = (0, $f39674aa42131bf6$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $4b2846f88af5423d$export$ce8bdc721e76545f)(value));
        (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : _d[key] = value;
        visualElement.setBaseTarget(key, value);
    }
}
function $e4befcaa41a4f540$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    var valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $e4befcaa41a4f540$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    var _a, _b;
    var origin = {};
    for(var key in target)origin[key] = (_a = $e4befcaa41a4f540$export$c3befe8e18686628(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
    return origin;
}




function $c49729af7b56acce$export$ff62cf473653f109(visualElement, definition, options) {
    if (options === void 0) options = {};
    visualElement.notifyAnimationStart(definition);
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function(variant) {
            return $c49729af7b56acce$var$animateVariant(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = $c49729af7b56acce$var$animateVariant(visualElement, definition, options);
    else {
        var resolvedDefinition = typeof definition === "function" ? (0, $70145b2788b65a38$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = $c49729af7b56acce$var$animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(function() {
        return visualElement.notifyAnimationComplete(definition);
    });
}
function $c49729af7b56acce$var$animateVariant(visualElement, variant, options) {
    var _a;
    if (options === void 0) options = {};
    var resolved = (0, $70145b2788b65a38$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement.getDefaultTransition() || {} : _b;
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getAnimation = resolved ? function() {
        return $c49729af7b56acce$var$animateTarget(visualElement, resolved, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size) ? function(forwardDelay) {
        if (forwardDelay === void 0) forwardDelay = 0;
        var _a = transition.delayChildren, delayChildren = _a === void 0 ? 0 : _a, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
        return $c49729af7b56acce$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ var when = transition.when;
    if (when) {
        var _c = (0, $3433e5a3eb89c040$export$8d051b38c9118094)(when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ], 2), first = _c[0], last = _c[1];
        return first().then(last);
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
/**
 * @internal
 */ function $c49729af7b56acce$var$animateTarget(visualElement, definition, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
    var _e = visualElement.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(_e, [
        "transition",
        "transitionEnd"
    ]);
    if (transitionOverride) transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && ((_b = visualElement.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
    for(var key in target){
        var value = visualElement.getValue(key);
        var valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $c49729af7b56acce$var$shouldBlockAnimation(animationTypeState, key)) continue;
        var valueTransition = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({
            delay: delay
        }, transition);
        /**
         * Make animation instant if this is a transform prop and we should reduce motion.
         */ if (visualElement.shouldReduceMotion && (0, $da211e07316d6e39$export$15240a8a4379d8de)(key)) valueTransition = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, valueTransition), {
            type: false,
            delay: 0
        });
        var animation = (0, $1d127c5bbdfabc9c$export$592dbd515a49cf1b)(key, value, valueTarget, valueTransition);
        animations.push(animation);
    }
    return Promise.all(animations).then(function() {
        transitionEnd && (0, $e4befcaa41a4f540$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
}
function $c49729af7b56acce$var$animateChildren(visualElement, variant, delayChildren, staggerChildren, staggerDirection, options) {
    if (delayChildren === void 0) delayChildren = 0;
    if (staggerChildren === void 0) staggerChildren = 0;
    if (staggerDirection === void 0) staggerDirection = 1;
    var animations = [];
    var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    var generateStaggerDuration = staggerDirection === 1 ? function(i) {
        if (i === void 0) i = 0;
        return i * staggerChildren;
    } : function(i) {
        if (i === void 0) i = 0;
        return maxStaggerDuration - i * staggerChildren;
    };
    Array.from(visualElement.variantChildren).sort($c49729af7b56acce$export$523a0bedf33ad781).forEach(function(child, i) {
        animations.push($c49729af7b56acce$var$animateVariant(child, variant, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, options), {
            delay: delayChildren + generateStaggerDuration(i)
        })).then(function() {
            return child.notifyAnimationComplete(variant);
        }));
    });
    return Promise.all(animations);
}
function $c49729af7b56acce$export$3cc6f911ef1fd837(visualElement) {
    visualElement.forEachValue(function(value) {
        return value.stop();
    });
}
function $c49729af7b56acce$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $c49729af7b56acce$var$shouldBlockAnimation(_a, key) {
    var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}




var $b147b3fbcf8b2fc8$export$16e45afcc206d3a8 = [
    (0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Animate,
    (0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).InView,
    (0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Focus,
    (0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Hover,
    (0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Tap,
    (0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Drag,
    (0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Exit
];
var $b147b3fbcf8b2fc8$var$reversePriorityOrder = (0, $3433e5a3eb89c040$export$1216008129fb82ed)([], (0, $3433e5a3eb89c040$export$8d051b38c9118094)($b147b3fbcf8b2fc8$export$16e45afcc206d3a8), false).reverse();
var $b147b3fbcf8b2fc8$var$numAnimationTypes = $b147b3fbcf8b2fc8$export$16e45afcc206d3a8.length;
function $b147b3fbcf8b2fc8$var$animateList(visualElement) {
    return function(animations) {
        return Promise.all(animations.map(function(_a) {
            var animation = _a.animation, options = _a.options;
            return (0, $c49729af7b56acce$export$ff62cf473653f109)(visualElement, animation, options);
        }));
    };
}
function $b147b3fbcf8b2fc8$export$bb53502b7a672aa8(visualElement) {
    var animate = $b147b3fbcf8b2fc8$var$animateList(visualElement);
    var state = $b147b3fbcf8b2fc8$var$createState();
    var allAnimatedKeys = {};
    var isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ var buildResolvedTypeValues = function(acc, definition) {
        var resolved = (0, $70145b2788b65a38$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            resolved.transition;
            var transitionEnd = resolved.transitionEnd, target = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(resolved, [
                "transition",
                "transitionEnd"
            ]);
            acc = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, acc), target), transitionEnd);
        }
        return acc;
    };
    function isAnimated(key) {
        return allAnimatedKeys[key] !== undefined;
    }
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        var _a;
        var props = visualElement.getProps();
        var context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ var animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ var removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ var encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ var removedVariantIndex = Infinity;
        var _loop_1 = function(i) {
            var type = $b147b3fbcf8b2fc8$var$reversePriorityOrder[i];
            var typeState = state[type];
            var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
            var propIsVariant = (0, $70145b2788b65a38$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $0c915d7372d9814d$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") return "continue";
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ var variantDidChange = $b147b3fbcf8b2fc8$export$68651800594fd43c(typeState.prevProp, prop);
            var shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ var definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
            var allKeys = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, prevResolvedValues), resolvedValues);
            var markToAnimate = function(key) {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(var key in allKeys){
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $6f683bc80c6d969e$export$9153ad4c4999f4a0)(next) && (0, $6f683bc80c6d969e$export$9153ad4c4999f4a0)(prev)) {
                        if (!(0, $423df1fac2a0b98a$export$90e866afbd6b9f1a)(next, prev) || variantDidChange) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, encounteredKeys), resolvedValues);
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push.apply(animations, (0, $3433e5a3eb89c040$export$1216008129fb82ed)([], (0, $3433e5a3eb89c040$export$8d051b38c9118094)(definitionList.map(function(animation) {
                return {
                    animation: animation,
                    options: (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({
                        type: type
                    }, options)
                };
            })), false));
        };
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(var i = 0; i < $b147b3fbcf8b2fc8$var$numAnimationTypes; i++)_loop_1(i);
        allAnimatedKeys = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, encounteredKeys);
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            var fallbackAnimation_1 = {};
            removedKeys.forEach(function(key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation_1[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation_1
            });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        var animations = animateChanges(options, type);
        for(var key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        isAnimated: isAnimated,
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function() {
            return state;
        }
    };
}
function $b147b3fbcf8b2fc8$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if ((0, $70145b2788b65a38$export$562271cd22f751d)(next)) return !(0, $423df1fac2a0b98a$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $b147b3fbcf8b2fc8$var$createTypeState(isActive) {
    if (isActive === void 0) isActive = false;
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $b147b3fbcf8b2fc8$var$createState() {
    var _a;
    return _a = {}, _a[(0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Animate] = $b147b3fbcf8b2fc8$var$createTypeState(true), _a[(0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).InView] = $b147b3fbcf8b2fc8$var$createTypeState(), _a[(0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Hover] = $b147b3fbcf8b2fc8$var$createTypeState(), _a[(0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Tap] = $b147b3fbcf8b2fc8$var$createTypeState(), _a[(0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Drag] = $b147b3fbcf8b2fc8$var$createTypeState(), _a[(0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Focus] = $b147b3fbcf8b2fc8$var$createTypeState(), _a[(0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Exit] = $b147b3fbcf8b2fc8$var$createTypeState(), _a;
}




var $7170ce59c2debd45$export$7f9953c70dacfd7f = {
    animation: (0, $758545c245c88998$export$46d1d6d046f826e4)(function(_a) {
        var visualElement = _a.visualElement, animate = _a.animate;
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */ visualElement.animationState || (visualElement.animationState = (0, $b147b3fbcf8b2fc8$export$bb53502b7a672aa8)(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */ if ((0, $0c915d7372d9814d$export$aa71198ceeaf53ce)(animate)) (0, $exYeM.useEffect)(function() {
            return animate.subscribe(visualElement);
        }, [
            animate
        ]);
    }),
    exit: (0, $758545c245c88998$export$46d1d6d046f826e4)(function(props) {
        var custom = props.custom, visualElement = props.visualElement;
        var _a = (0, $3433e5a3eb89c040$export$8d051b38c9118094)((0, $eecb2e495db1f2fd$export$2a8c16d82a0a0e26)(), 2), isPresent = _a[0], safeToRemove = _a[1];
        var presenceContext = (0, $exYeM.useContext)((0, $32835478aabc17b5$export$f224e4635b6f8ce2));
        (0, $exYeM.useEffect)(function() {
            var _a, _b;
            visualElement.isPresent = isPresent;
            var animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive((0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Exit, !isPresent, {
                custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom
            });
            !isPresent && (animation === null || animation === void 0 || animation.then(safeToRemove));
        }, [
            isPresent
        ]);
    })
};



var $exYeM = parcelRequire("exYeM");








const $038c57f3fff6a261$export$aff838a5553f2a92 = (point)=>point.hasOwnProperty("x") && point.hasOwnProperty("y");



const $3f8ea26519e6653e$export$319d74662aaa2966 = (point)=>(0, $038c57f3fff6a261$export$aff838a5553f2a92)(point) && point.hasOwnProperty("z");



const $f0517dd85cb4097b$var$distance1D = (a, b)=>Math.abs(a - b);
function $f0517dd85cb4097b$export$9f17032d917177de(a, b) {
    if ((0, $a595db145234e7da$export$4e960b977ccfec97)(a) && (0, $a595db145234e7da$export$4e960b977ccfec97)(b)) return $f0517dd85cb4097b$var$distance1D(a, b);
    else if ((0, $038c57f3fff6a261$export$aff838a5553f2a92)(a) && (0, $038c57f3fff6a261$export$aff838a5553f2a92)(b)) {
        const xDelta = $f0517dd85cb4097b$var$distance1D(a.x, b.x);
        const yDelta = $f0517dd85cb4097b$var$distance1D(a.y, b.y);
        const zDelta = (0, $3f8ea26519e6653e$export$319d74662aaa2966)(a) && (0, $3f8ea26519e6653e$export$319d74662aaa2966)(b) ? $f0517dd85cb4097b$var$distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
}


/**
 * @internal
 */ var $2ef01b44f183dc73$export$d9c66232c9c4689c = /** @class */ function() {
    function PanSession(event, handlers, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = function() {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            var info = $2ef01b44f183dc73$var$getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            var isDistancePastThreshold = (0, $f0517dd85cb4097b$export$9f17032d917177de)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var point = info.point;
            var timestamp = (0, $2e071b817ebd59af$export$7244445918e670ed)().timestamp;
            _this.history.push((0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, point), {
                timestamp: timestamp
            }));
            var _a = _this.handlers, onStart = _a.onStart, onMove = _a.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function(event, info) {
            _this.lastMoveEvent = event;
            _this.lastMoveEventInfo = $2ef01b44f183dc73$var$transformPoint(info, _this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if ((0, $486d9e6769e4fdda$export$764db16956f554f8)(event) && event.buttons === 0) {
                _this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            (0, $2e071b817ebd59af$export$2e2bcd8739ae039).update(_this.updatePoint, true);
        };
        this.handlePointerUp = function(event, info) {
            _this.end();
            var _a = _this.handlers, onEnd = _a.onEnd, onSessionEnd = _a.onSessionEnd;
            var panInfo = $2ef01b44f183dc73$var$getPanInfo($2ef01b44f183dc73$var$transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if ((0, $486d9e6769e4fdda$export$c4dfce035d43d1e0)(event) && event.touches.length > 1) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        var info = (0, $19290b72856733e8$export$12f84bb882d06e1a)(event);
        var initialInfo = $2ef01b44f183dc73$var$transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = (0, $2e071b817ebd59af$export$7244445918e670ed)().timestamp;
        this.history = [
            (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, point), {
                timestamp: timestamp
            })
        ];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart && onSessionStart(event, $2ef01b44f183dc73$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $29c678fcd20f76f7$export$a4627e546088548d)((0, $0bac0becffd44d3d$export$fcff2e64e6676b81)(window, "pointermove", this.handlePointerMove), (0, $0bac0becffd44d3d$export$fcff2e64e6676b81)(window, "pointerup", this.handlePointerUp), (0, $0bac0becffd44d3d$export$fcff2e64e6676b81)(window, "pointercancel", this.handlePointerUp));
    }
    PanSession.prototype.updateHandlers = function(handlers) {
        this.handlers = handlers;
    };
    PanSession.prototype.end = function() {
        this.removeListeners && this.removeListeners();
        (0, $2e071b817ebd59af$export$d93e9c1fe0553512).update(this.updatePoint);
    };
    return PanSession;
}();
function $2ef01b44f183dc73$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $2ef01b44f183dc73$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $2ef01b44f183dc73$var$getPanInfo(_a, history) {
    var point = _a.point;
    return {
        point: point,
        delta: $2ef01b44f183dc73$var$subtractPoint(point, $2ef01b44f183dc73$var$lastDevicePoint(history)),
        offset: $2ef01b44f183dc73$var$subtractPoint(point, $2ef01b44f183dc73$var$startDevicePoint(history)),
        velocity: $2ef01b44f183dc73$var$getVelocity(history, 0.1)
    };
}
function $2ef01b44f183dc73$var$startDevicePoint(history) {
    return history[0];
}
function $2ef01b44f183dc73$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $2ef01b44f183dc73$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $2ef01b44f183dc73$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}








function $a1e42a4af2333fb7$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $a1e42a4af2333fb7$export$28d0384c4b79bde2(value, target, maxDistance) {
    if (target === void 0) target = 0;
    if (maxDistance === void 0) maxDistance = 0.01;
    return (0, $f0517dd85cb4097b$export$9f17032d917177de)(value, target) < maxDistance;
}
function $a1e42a4af2333fb7$export$e90fc1ae5e3e48ed(delta, source, target, origin) {
    if (origin === void 0) origin = 0.5;
    delta.origin = origin;
    delta.originPoint = (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $a1e42a4af2333fb7$export$c1c127004b72a37(target) / $a1e42a4af2333fb7$export$c1c127004b72a37(source);
    if ($a1e42a4af2333fb7$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($a1e42a4af2333fb7$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $a1e42a4af2333fb7$export$c0d25e96fc67d310(delta, source, target, origin) {
    $a1e42a4af2333fb7$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin === null || origin === void 0 ? void 0 : origin.originX);
    $a1e42a4af2333fb7$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin === null || origin === void 0 ? void 0 : origin.originY);
}
function $a1e42a4af2333fb7$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $a1e42a4af2333fb7$export$c1c127004b72a37(relative);
}
function $a1e42a4af2333fb7$export$426154f9d100f99(target, relative, parent) {
    $a1e42a4af2333fb7$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $a1e42a4af2333fb7$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $a1e42a4af2333fb7$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $a1e42a4af2333fb7$export$c1c127004b72a37(layout);
}
function $a1e42a4af2333fb7$export$2785bfcc929c5650(target, layout, parent) {
    $a1e42a4af2333fb7$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $a1e42a4af2333fb7$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}


/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $80b0c15e89836697$export$b3c764d3fca3ffe3(point, _a, elastic) {
    var min = _a.min, max = _a.max;
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $80b0c15e89836697$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $80b0c15e89836697$export$4e9195bf7793bc78(layoutBox, _a) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    return {
        x: $80b0c15e89836697$export$690c180aa5775042(layoutBox.x, left, right),
        y: $80b0c15e89836697$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $80b0c15e89836697$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    var _a;
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) _a = (0, $3433e5a3eb89c040$export$8d051b38c9118094)([
        max,
        min
    ], 2), min = _a[0], max = _a[1];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $80b0c15e89836697$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $80b0c15e89836697$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $80b0c15e89836697$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $80b0c15e89836697$export$13abbfca044ca46d(source, target) {
    var origin = 0.5;
    var sourceLength = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(source);
    var targetLength = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $495f4f72f02e3374$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $495f4f72f02e3374$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $4b2c08a9f3cbcf29$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $80b0c15e89836697$export$e9672cc4c36a8b87(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
var $80b0c15e89836697$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $80b0c15e89836697$export$7c5eaef8f4723d22(dragElastic) {
    if (dragElastic === void 0) dragElastic = $80b0c15e89836697$export$a3366d3bac43a742;
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $80b0c15e89836697$export$a3366d3bac43a742;
    return {
        x: $80b0c15e89836697$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $80b0c15e89836697$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $80b0c15e89836697$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $80b0c15e89836697$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $80b0c15e89836697$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $80b0c15e89836697$export$bbbc10b82e6c0afb(dragElastic, label) {
    var _a;
    return typeof dragElastic === "number" ? dragElastic : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}



var $704cbd53c53f9d5c$export$ff25708b37f72782 = function() {
    return {
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    };
};
var $704cbd53c53f9d5c$export$3d227df54007d73a = function() {
    return {
        x: $704cbd53c53f9d5c$export$ff25708b37f72782(),
        y: $704cbd53c53f9d5c$export$ff25708b37f72782()
    };
};
var $704cbd53c53f9d5c$export$6db76765312617ac = function() {
    return {
        min: 0,
        max: 0
    };
};
var $704cbd53c53f9d5c$export$6459fc9e86be362e = function() {
    return {
        x: $704cbd53c53f9d5c$export$6db76765312617ac(),
        y: $704cbd53c53f9d5c$export$6db76765312617ac()
    };
};


function $2c62bc0ac9269350$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $51f4355a9b48a0fa$export$d3955c6a8f65a36b(_a) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $51f4355a9b48a0fa$export$b6b9cd4198191a47(_a) {
    var x = _a.x, y = _a.y;
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $51f4355a9b48a0fa$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    var topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    var bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}




function $43492ab836cff22d$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $43492ab836cff22d$export$bdf30dca883ea463(_a) {
    var scale = _a.scale, scaleX = _a.scaleX, scaleY = _a.scaleY;
    return !$43492ab836cff22d$var$isIdentityScale(scale) || !$43492ab836cff22d$var$isIdentityScale(scaleX) || !$43492ab836cff22d$var$isIdentityScale(scaleY);
}
function $43492ab836cff22d$export$a545127cf1fbb600(values) {
    return $43492ab836cff22d$export$bdf30dca883ea463(values) || $43492ab836cff22d$var$hasTranslate(values.x) || $43492ab836cff22d$var$hasTranslate(values.y) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $43492ab836cff22d$var$hasTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $3cadfa9c5538c02d$export$2290ec7febe36dd6(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $3cadfa9c5538c02d$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $3cadfa9c5538c02d$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $3cadfa9c5538c02d$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $3cadfa9c5538c02d$export$e8e3a712e9ebf422(axis, translate, scale, originPoint, boxScale) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    axis.min = $3cadfa9c5538c02d$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $3cadfa9c5538c02d$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $3cadfa9c5538c02d$export$d80074982803af5c(box, _a) {
    var x = _a.x, y = _a.y;
    $3cadfa9c5538c02d$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $3cadfa9c5538c02d$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $3cadfa9c5538c02d$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition) {
    var _a, _b;
    if (isSharedTransition === void 0) isSharedTransition = false;
    var treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for(var i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        if (((_b = (_a = node.instance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.display) === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $3cadfa9c5538c02d$export$58b16271041fbfb(box, {
            x: -node.scroll.x,
            y: -node.scroll.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $3cadfa9c5538c02d$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $43492ab836cff22d$export$a545127cf1fbb600)(node.latestValues)) $3cadfa9c5538c02d$export$58b16271041fbfb(box, node.latestValues);
    }
}
function $3cadfa9c5538c02d$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $3cadfa9c5538c02d$export$625f1dd140a2f5e7(axis, transforms, _a) {
    var _b = (0, $3433e5a3eb89c040$export$8d051b38c9118094)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    var originPoint = (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $3cadfa9c5538c02d$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var $3cadfa9c5538c02d$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
var $3cadfa9c5538c02d$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $3cadfa9c5538c02d$export$58b16271041fbfb(box, transform) {
    $3cadfa9c5538c02d$export$625f1dd140a2f5e7(box.x, transform, $3cadfa9c5538c02d$var$xKeys);
    $3cadfa9c5538c02d$export$625f1dd140a2f5e7(box.y, transform, $3cadfa9c5538c02d$var$yKeys);
}


function $5df6dc38d07b7e46$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $51f4355a9b48a0fa$export$d3955c6a8f65a36b)((0, $51f4355a9b48a0fa$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $5df6dc38d07b7e46$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    var viewportBox = $5df6dc38d07b7e46$export$d8718b6a7e5c624e(element, transformPagePoint);
    var scroll = rootProjectionNode.scroll;
    if (scroll) {
        (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(viewportBox.x, scroll.x);
        (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(viewportBox.y, scroll.y);
    }
    return viewportBox;
}









var $8c2f26a6b37d6dc9$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: AnyPointerEvent
var $8c2f26a6b37d6dc9$export$86bff71f18910307 = /** @class */ function() {
    function VisualElementDragControls(visualElement) {
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    VisualElementDragControls.prototype.start = function(originEvent, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c;
        /**
         * Don't start dragging if this component is exiting
         */ if (this.visualElement.isPresent === false) return;
        var onSessionStart = function(event) {
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            _this.stopAnimation();
            if (snapToCursor) _this.snapToCursor((0, $19290b72856733e8$export$12f84bb882d06e1a)(event, "page").point);
        };
        var onStart = function(event, info) {
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            var _b = _this.getProps(), drag = _b.drag, dragPropagation = _b.dragPropagation, onDragStart = _b.onDragStart;
            if (drag && !dragPropagation) {
                if (_this.openGlobalLock) _this.openGlobalLock();
                _this.openGlobalLock = (0, $96522e0a3b96b9e4$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!_this.openGlobalLock) return;
            }
            _this.isDragging = true;
            _this.currentDirection = null;
            _this.resolveConstraints();
            if (_this.visualElement.projection) {
                _this.visualElement.projection.isAnimationBlocked = true;
                _this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $2c62bc0ac9269350$export$b789de563eb43b1)(function(axis) {
                var _a, _b;
                var current = _this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $0d8007420b761bba$export$626336c2cd4b14de).test(current)) {
                    var measuredAxis = (_b = (_a = _this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.actual[axis];
                    if (measuredAxis) {
                        var length_1 = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(measuredAxis);
                        current = length_1 * (parseFloat(current) / 100);
                    }
                }
                _this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            onDragStart === null || onDragStart === void 0 || onDragStart(event, info);
            (_a = _this.visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Drag, true);
        };
        var onMove = function(event, info) {
            // latestPointerEvent = event
            var _a = _this.getProps(), dragPropagation = _a.dragPropagation, dragDirectionLock = _a.dragDirectionLock, onDirectionLock = _a.onDirectionLock, onDrag = _a.onDrag;
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !_this.openGlobalLock) return;
            var offset = info.offset;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && _this.currentDirection === null) {
                _this.currentDirection = $8c2f26a6b37d6dc9$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (_this.currentDirection !== null) onDirectionLock === null || onDirectionLock === void 0 || onDirectionLock(_this.currentDirection);
                return;
            }
            // Update each point with the latest position
            _this.updateAxis("x", info.point, offset);
            _this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ _this.visualElement.syncRender();
            /**
             * This must fire after the syncRender call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag === null || onDrag === void 0 || onDrag(event, info);
        };
        var onSessionEnd = function(event, info) {
            return _this.stop(event, info);
        };
        this.panSession = new (0, $2ef01b44f183dc73$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint()
        });
    };
    VisualElementDragControls.prototype.stop = function(event, info) {
        var isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        var velocity = info.velocity;
        this.startAnimation(velocity);
        var onDragEnd = this.getProps().onDragEnd;
        onDragEnd === null || onDragEnd === void 0 || onDragEnd(event, info);
    };
    VisualElementDragControls.prototype.cancel = function() {
        var _a, _b;
        this.isDragging = false;
        if (this.visualElement.projection) this.visualElement.projection.isAnimationBlocked = false;
        (_a = this.panSession) === null || _a === void 0 || _a.end();
        this.panSession = undefined;
        var dragPropagation = this.getProps().dragPropagation;
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 || _b.setActive((0, $8f246e49b2cb6bd7$export$2deb71ebd3734d23).Drag, false);
    };
    VisualElementDragControls.prototype.updateAxis = function(axis, _point, offset) {
        var drag = this.getProps().drag;
        // If we're not dragging this axis, do an early return.
        if (!offset || !$8c2f26a6b37d6dc9$var$shouldDrag(axis, drag, this.currentDirection)) return;
        var axisValue = this.getAxisMotionValue(axis);
        var next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $80b0c15e89836697$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    };
    VisualElementDragControls.prototype.resolveConstraints = function() {
        var _this = this;
        var _a = this.getProps(), dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
        var layout = (this.visualElement.projection || {}).layout;
        var prevConstraints = this.constraints;
        if (dragConstraints && (0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $80b0c15e89836697$export$4e9195bf7793bc78)(layout.actual, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $80b0c15e89836697$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $2c62bc0ac9269350$export$b789de563eb43b1)(function(axis) {
            if (_this.getAxisMotionValue(axis)) _this.constraints[axis] = (0, $80b0c15e89836697$export$e9672cc4c36a8b87)(layout.actual[axis], _this.constraints[axis]);
        });
    };
    VisualElementDragControls.prototype.resolveRefConstraints = function() {
        var _a = this.getProps(), constraints = _a.dragConstraints, onMeasureDragConstraints = _a.onMeasureDragConstraints;
        if (!constraints || !(0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(constraints)) return false;
        var constraintsElement = constraints.current;
        (0, $8494256d1df1e442$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        var projection = this.visualElement.projection;
        // TODO
        if (!projection || !projection.layout) return false;
        var constraintsBox = (0, $5df6dc38d07b7e46$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        var measuredConstraints = (0, $80b0c15e89836697$export$4228500f19d4cdf7)(projection.layout.actual, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            var userConstraints = onMeasureDragConstraints((0, $51f4355a9b48a0fa$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $51f4355a9b48a0fa$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    };
    VisualElementDragControls.prototype.startAnimation = function(velocity) {
        var _this = this;
        var _a = this.getProps(), drag = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition, dragSnapToOrigin = _a.dragSnapToOrigin, onDragTransitionEnd = _a.onDragTransitionEnd;
        var constraints = this.constraints || {};
        var momentumAnimations = (0, $2c62bc0ac9269350$export$b789de563eb43b1)(function(axis) {
            var _a;
            if (!$8c2f26a6b37d6dc9$var$shouldDrag(axis, drag, _this.currentDirection)) return;
            var transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ var bounceStiffness = dragElastic ? 200 : 1000000;
            var bounceDamping = dragElastic ? 40 : 10000000;
            var inertia = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10
            }, dragTransition), transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return _this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    };
    VisualElementDragControls.prototype.startAxisValueAnimation = function(axis, transition) {
        var axisValue = this.getAxisMotionValue(axis);
        return (0, $1d127c5bbdfabc9c$export$592dbd515a49cf1b)(axis, axisValue, 0, transition);
    };
    VisualElementDragControls.prototype.stopAnimation = function() {
        var _this = this;
        (0, $2c62bc0ac9269350$export$b789de563eb43b1)(function(axis) {
            return _this.getAxisMotionValue(axis).stop();
        });
    };
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ VisualElementDragControls.prototype.getAxisMotionValue = function(axis) {
        var _a, _b;
        var dragKey = "_drag" + axis.toUpperCase();
        var externalMotionValue = this.visualElement.getProps()[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (_b = (_a = this.visualElement.getProps().initial) === null || _a === void 0 ? void 0 : _a[axis]) !== null && _b !== void 0 ? _b : 0);
    };
    VisualElementDragControls.prototype.snapToCursor = function(point) {
        var _this = this;
        (0, $2c62bc0ac9269350$export$b789de563eb43b1)(function(axis) {
            var drag = _this.getProps().drag;
            // If we're not dragging this axis, do an early return.
            if (!$8c2f26a6b37d6dc9$var$shouldDrag(axis, drag, _this.currentDirection)) return;
            var projection = _this.visualElement.projection;
            var axisValue = _this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                var _a = projection.layout.actual[axis], min = _a.min, max = _a.max;
                axisValue.set(point[axis] - (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    };
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ VisualElementDragControls.prototype.scalePositionWithinConstraints = function() {
        var _this = this;
        var _a;
        var _b = this.getProps(), drag = _b.drag, dragConstraints = _b.dragConstraints;
        var projection = this.visualElement.projection;
        if (!(0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ var boxProgress = {
            x: 0,
            y: 0
        };
        (0, $2c62bc0ac9269350$export$b789de563eb43b1)(function(axis) {
            var axisValue = _this.getAxisMotionValue(axis);
            if (axisValue) {
                var latest = axisValue.get();
                boxProgress[axis] = (0, $80b0c15e89836697$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, _this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ var transformTemplate = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        (_a = projection.root) === null || _a === void 0 || _a.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $2c62bc0ac9269350$export$b789de563eb43b1)(function(axis) {
            if (!$8c2f26a6b37d6dc9$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ var axisValue = _this.getAxisMotionValue(axis);
            var _a = _this.constraints[axis], min = _a.min, max = _a.max;
            axisValue.set((0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    };
    VisualElementDragControls.prototype.addListeners = function() {
        var _this = this;
        var _a;
        $8c2f26a6b37d6dc9$export$f0a15892c27dc07c.set(this.visualElement, this);
        var element = this.visualElement.getInstance();
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ var stopPointerListener = (0, $0bac0becffd44d3d$export$fcff2e64e6676b81)(element, "pointerdown", function(event) {
            var _a = _this.getProps(), drag = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
            drag && dragListener && _this.start(event);
        });
        var measureDragConstraints = function() {
            var dragConstraints = _this.getProps().dragConstraints;
            if ((0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(dragConstraints)) _this.constraints = _this.resolveRefConstraints();
        };
        var projection = this.visualElement.projection;
        var stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            (_a = projection.root) === null || _a === void 0 || _a.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ var stopResizeListener = (0, $2bb083316bee0fb8$export$b1d829ddf82884aa)(window, "resize", function() {
            return _this.scalePositionWithinConstraints();
        });
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ projection.addEventListener("didUpdate", function(_a) {
            var delta = _a.delta, hasLayoutChanged = _a.hasLayoutChanged;
            if (_this.isDragging && hasLayoutChanged) {
                (0, $2c62bc0ac9269350$export$b789de563eb43b1)(function(axis) {
                    var motionValue = _this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    _this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                _this.visualElement.syncRender();
            }
        });
        return function() {
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
        };
    };
    VisualElementDragControls.prototype.getProps = function() {
        var props = this.visualElement.getProps();
        var _a = props.drag, drag = _a === void 0 ? false : _a, _b = props.dragDirectionLock, dragDirectionLock = _b === void 0 ? false : _b, _c = props.dragPropagation, dragPropagation = _c === void 0 ? false : _c, _d = props.dragConstraints, dragConstraints = _d === void 0 ? false : _d, _e = props.dragElastic, dragElastic = _e === void 0 ? (0, $80b0c15e89836697$export$a3366d3bac43a742) : _e, _f = props.dragMomentum, dragMomentum = _f === void 0 ? true : _f;
        return (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, props), {
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        });
    };
    return VisualElementDragControls;
}();
function $8c2f26a6b37d6dc9$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $8c2f26a6b37d6dc9$var$getCurrentDirection(offset, lockThreshold) {
    if (lockThreshold === void 0) lockThreshold = 10;
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}



/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */ function $ab1376be66491602$export$7941f8aafa4b6021(props) {
    var groupDragControls = props.dragControls, visualElement = props.visualElement;
    var dragControls = (0, $73d7e626f45c1838$export$fe4300aa8eebea86)(function() {
        return new (0, $8c2f26a6b37d6dc9$export$86bff71f18910307)(visualElement);
    });
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    (0, $exYeM.useEffect)(function() {
        return groupDragControls && groupDragControls.subscribe(dragControls);
    }, [
        dragControls,
        groupDragControls
    ]);
    // Apply the event listeners to the element
    (0, $exYeM.useEffect)(function() {
        return dragControls.addListeners();
    }, [
        dragControls
    ]);
}



var $exYeM = parcelRequire("exYeM");




/**
 *
 * @param handlers -
 * @param ref -
 *
 * @privateRemarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */ function $d8a505a1700bddf6$export$eb0f62174cac1aec(_a) {
    var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement = _a.visualElement;
    var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    var panSession = (0, $exYeM.useRef)(null);
    var transformPagePoint = (0, $exYeM.useContext)((0, $2d642de93cca1124$export$22a697fb29aac98d)).transformPagePoint;
    var handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: function(event, info) {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        }
    };
    (0, $exYeM.useEffect)(function() {
        if (panSession.current !== null) panSession.current.updateHandlers(handlers);
    });
    function onPointerDown(event) {
        panSession.current = new (0, $2ef01b44f183dc73$export$d9c66232c9c4689c)(event, handlers, {
            transformPagePoint: transformPagePoint
        });
    }
    (0, $0bac0becffd44d3d$export$734d04395f5243cd)(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    (0, $5575fd4776144082$export$f3a192d0cbd30b96)(function() {
        return panSession.current && panSession.current.end();
    });
}



var $be25e9ea22024a07$export$d7d5d435647ed5a0 = {
    pan: (0, $758545c245c88998$export$46d1d6d046f826e4)((0, $d8a505a1700bddf6$export$eb0f62174cac1aec)),
    drag: (0, $758545c245c88998$export$46d1d6d046f826e4)((0, $ab1376be66491602$export$7941f8aafa4b6021))
};










var $b80ed8a1c899875b$var$names = [
    "LayoutMeasure",
    "BeforeLayoutMeasure",
    "LayoutUpdate",
    "ViewportBoxUpdate",
    "Update",
    "Render",
    "AnimationComplete",
    "LayoutAnimationComplete",
    "AnimationStart",
    "LayoutAnimationStart",
    "SetAxisTarget",
    "Unmount"
];
function $b80ed8a1c899875b$export$f6841af6ea5003ab() {
    var managers = $b80ed8a1c899875b$var$names.map(function() {
        return new (0, $97358bb0f01597b3$export$e7dff9482a5fd23c)();
    });
    var propSubscriptions = {};
    var lifecycles = {
        clearAllListeners: function() {
            return managers.forEach(function(manager) {
                return manager.clear();
            });
        },
        updatePropListeners: function(props) {
            $b80ed8a1c899875b$var$names.forEach(function(name) {
                var _a;
                var on = "on" + name;
                var propListener = props[on];
                // Unsubscribe existing subscription
                (_a = propSubscriptions[name]) === null || _a === void 0 || _a.call(propSubscriptions);
                // Add new subscription
                if (propListener) propSubscriptions[name] = lifecycles[on](propListener);
            });
        }
    };
    managers.forEach(function(manager, i) {
        lifecycles["on" + $b80ed8a1c899875b$var$names[i]] = function(handler) {
            return manager.add(handler);
        };
        lifecycles["notify" + $b80ed8a1c899875b$var$names[i]] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return manager.notify.apply(manager, (0, $3433e5a3eb89c040$export$1216008129fb82ed)([], (0, $3433e5a3eb89c040$export$8d051b38c9118094)(args), false));
        };
    });
    return lifecycles;
}





function $36e186eef14354e1$export$9a552858d5197f6e(element, next, prev) {
    var _a;
    for(var key in next){
        var nextValue = next[key];
        var prevValue = prev[key];
        if ((0, $65e8d3d378a9947e$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $65e8d3d378a9947e$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping to a new motion value, create a new motion value
             * from that
             */ element.addValue(key, (0, $4b2846f88af5423d$export$ce8bdc721e76545f)(nextValue));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else element.addValue(key, (0, $4b2846f88af5423d$export$ce8bdc721e76545f)((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
        }
    }
    // Handle removed values
    for(var key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}



var $5ddea9451f7da6f0$export$5ad594e944c33d76 = function(_a) {
    var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps;
    return function(_a, options) {
        var parent = _a.parent, props = _a.props, presenceId = _a.presenceId, blockInitialAnimation = _a.blockInitialAnimation, visualState = _a.visualState, shouldReduceMotion = _a.shouldReduceMotion;
        if (options === void 0) options = {};
        var isMounted = false;
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        /**
         * The instance of the render-specific node that will be hydrated by the
         * exposed React ref. So for example, this visual element can host a
         * HTMLElement, plain object, or Three.js object. The functions provided
         * in VisualElementConfig allow us to interface with this instance.
         */ var instance;
        /**
         * Manages the subscriptions for a visual element's lifecycle, for instance
         * onRender
         */ var lifecycles = (0, $b80ed8a1c899875b$export$f6841af6ea5003ab)();
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ var values = new Map();
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ var valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ var prevMotionValues = {};
        /**
         * When values are removed from all animation props we need to search
         * for a fallback value to animate to. These values are tracked in baseTarget.
         */ var baseTarget = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, latestValues);
        // Internal methods ========================
        /**
         * On mount, this will be hydrated with a callback to disconnect
         * this visual element from its parent on unmount.
         */ var removeFromVariantTree;
        /**
         * Render the element with the latest styles outside of the React
         * render lifecycle
         */ function render() {
            if (!instance || !isMounted) return;
            triggerBuild();
            renderInstance(instance, renderState, props.style, element.projection);
        }
        function triggerBuild() {
            build(element, renderState, latestValues, options, props);
        }
        function update() {
            lifecycles.notifyUpdate(latestValues);
        }
        /**
         *
         */ function bindToMotionValue(key, value) {
            var removeOnChange = value.onChange(function(latestValue) {
                latestValues[key] = latestValue;
                props.onUpdate && (0, $2e071b817ebd59af$export$2e2bcd8739ae039).update(update, false, true);
            });
            var removeOnRenderRequest = value.onRenderRequest(element.scheduleRender);
            valueSubscriptions.set(key, function() {
                removeOnChange();
                removeOnRenderRequest();
            });
        }
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ var initialMotionValues = scrapeMotionValuesFromProps(props);
        for(var key in initialMotionValues){
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $65e8d3d378a9947e$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
        /**
         * Determine what role this visual element should take in the variant tree.
         */ var isControllingVariants = (0, $70145b2788b65a38$export$cf3a7bd331c35bf0)(props);
        var isVariantNode = (0, $70145b2788b65a38$export$c0eba02279c18fea)(props);
        var element = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({
            treeType: treeType,
            /**
             * This is a mirror of the internal instance prop, which keeps
             * VisualElement type-compatible with React's RefObject.
             */ current: null,
            /**
             * The depth of this visual element within the visual element tree.
             */ depth: parent ? parent.depth + 1 : 0,
            parent: parent,
            children: new Set(),
            /**
             *
             */ presenceId: presenceId,
            shouldReduceMotion: shouldReduceMotion,
            /**
             * If this component is part of the variant tree, it should track
             * any children that are also part of the tree. This is essentially
             * a shadow tree to simplify logic around how to stagger over children.
             */ variantChildren: isVariantNode ? new Set() : undefined,
            /**
             * Whether this instance is visible. This can be changed imperatively
             * by the projection tree, is analogous to CSS's visibility in that
             * hidden elements should take up layout, and needs enacting by the configured
             * render function.
             */ isVisible: undefined,
            /**
             * Normally, if a component is controlled by a parent's variants, it can
             * rely on that ancestor to trigger animations further down the tree.
             * However, if a component is created after its parent is mounted, the parent
             * won't trigger that mount animation so the child needs to.
             *
             * TODO: This might be better replaced with a method isParentMounted
             */ manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()),
            /**
             * This can be set by AnimatePresence to force components that mount
             * at the same time as it to mount as if they have initial={false} set.
             */ blockInitialAnimation: blockInitialAnimation,
            /**
             * Determine whether this component has mounted yet. This is mostly used
             * by variant children to determine whether they need to trigger their
             * own animations on mount.
             */ isMounted: function() {
                return Boolean(instance);
            },
            mount: function(newInstance) {
                isMounted = true;
                instance = element.current = newInstance;
                if (element.projection) element.projection.mount(newInstance);
                if (isVariantNode && parent && !isControllingVariants) removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
                values.forEach(function(value, key) {
                    return bindToMotionValue(key, value);
                });
                parent === null || parent === void 0 || parent.children.add(element);
                element.setProps(props);
            },
            /**
             *
             */ unmount: function() {
                var _a;
                (_a = element.projection) === null || _a === void 0 || _a.unmount();
                (0, $2e071b817ebd59af$export$d93e9c1fe0553512).update(update);
                (0, $2e071b817ebd59af$export$d93e9c1fe0553512).render(render);
                valueSubscriptions.forEach(function(remove) {
                    return remove();
                });
                removeFromVariantTree === null || removeFromVariantTree === void 0 || removeFromVariantTree();
                parent === null || parent === void 0 || parent.children.delete(element);
                lifecycles.clearAllListeners();
                instance = undefined;
                isMounted = false;
            },
            /**
             * Add a child visual element to our set of children.
             */ addVariantChild: function(child) {
                var _a;
                var closestVariantNode = element.getClosestVariantNode();
                if (closestVariantNode) {
                    (_a = closestVariantNode.variantChildren) === null || _a === void 0 || _a.add(child);
                    return function() {
                        return closestVariantNode.variantChildren.delete(child);
                    };
                }
            },
            sortNodePosition: function(other) {
                /**
                 * If these nodes aren't even of the same type we can't compare their depth.
                 */ if (!sortNodePosition || treeType !== other.treeType) return 0;
                return sortNodePosition(element.getInstance(), other.getInstance());
            },
            /**
             * Returns the closest variant node in the tree starting from
             * this visual element.
             */ getClosestVariantNode: function() {
                return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
            },
            /**
             * Expose the latest layoutId prop.
             */ getLayoutId: function() {
                return props.layoutId;
            },
            /**
             * Returns the current instance.
             */ getInstance: function() {
                return instance;
            },
            /**
             * Get/set the latest static values.
             */ getStaticValue: function(key) {
                return latestValues[key];
            },
            setStaticValue: function(key, value) {
                return latestValues[key] = value;
            },
            /**
             * Returns the latest motion value state. Currently only used to take
             * a snapshot of the visual element - perhaps this can return the whole
             * visual state
             */ getLatestValues: function() {
                return latestValues;
            },
            /**
             * Set the visiblity of the visual element. If it's changed, schedule
             * a render to reflect these changes.
             */ setVisibility: function(visibility) {
                if (element.isVisible === visibility) return;
                element.isVisible = visibility;
                element.scheduleRender();
            },
            /**
             * Make a target animatable by Popmotion. For instance, if we're
             * trying to animate width from 100px to 100vw we need to measure 100vw
             * in pixels to determine what we really need to animate to. This is also
             * pluggable to support Framer's custom value types like Color,
             * and CSS variables.
             */ makeTargetAnimatable: function(target, canMutate) {
                if (canMutate === void 0) canMutate = true;
                return makeTargetAnimatable(element, target, props, canMutate);
            },
            /**
             * Measure the current viewport box with or without transforms.
             * Only measures axis-aligned boxes, rotate and skew must be manually
             * removed with a re-render to work.
             */ measureViewportBox: function() {
                return measureViewportBox(instance, props);
            },
            // Motion values ========================
            /**
             * Add a motion value and bind it to this visual element.
             */ addValue: function(key, value) {
                // Remove existing value if it exists
                if (element.hasValue(key)) element.removeValue(key);
                values.set(key, value);
                latestValues[key] = value.get();
                bindToMotionValue(key, value);
            },
            /**
             * Remove a motion value and unbind any active subscriptions.
             */ removeValue: function(key) {
                var _a;
                values.delete(key);
                (_a = valueSubscriptions.get(key)) === null || _a === void 0 || _a();
                valueSubscriptions.delete(key);
                delete latestValues[key];
                removeValueFromRenderState(key, renderState);
            },
            /**
             * Check whether we have a motion value for this key
             */ hasValue: function(key) {
                return values.has(key);
            },
            /**
             * Get a motion value for this key. If called with a default
             * value, we'll create one if none exists.
             */ getValue: function(key, defaultValue) {
                var value = values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = (0, $4b2846f88af5423d$export$ce8bdc721e76545f)(defaultValue);
                    element.addValue(key, value);
                }
                return value;
            },
            /**
             * Iterate over our motion values.
             */ forEachValue: function(callback) {
                return values.forEach(callback);
            },
            /**
             * If we're trying to animate to a previously unencountered value,
             * we need to check for it in our state and as a last resort read it
             * directly from the instance (which might have performance implications).
             */ readValue: function(key) {
                var _a;
                return (_a = latestValues[key]) !== null && _a !== void 0 ? _a : readValueFromInstance(instance, key, options);
            },
            /**
             * Set the base target to later animate back to. This is currently
             * only hydrated on creation and when we first read a value.
             */ setBaseTarget: function(key, value) {
                baseTarget[key] = value;
            },
            /**
             * Find the base target for a value thats been removed from all animation
             * props.
             */ getBaseTarget: function(key) {
                if (getBaseTarget) {
                    var target = getBaseTarget(props, key);
                    if (target !== undefined && !(0, $65e8d3d378a9947e$export$605d60a2578142d3)(target)) return target;
                }
                return baseTarget[key];
            }
        }, lifecycles), {
            /**
             * Build the renderer state based on the latest visual state.
             */ build: function() {
                triggerBuild();
                return renderState;
            },
            /**
             * Schedule a render on the next animation frame.
             */ scheduleRender: function() {
                (0, $2e071b817ebd59af$export$2e2bcd8739ae039).render(render, false, true);
            },
            /**
             * Synchronously fire render. It's prefered that we batch renders but
             * in many circumstances, like layout measurement, we need to run this
             * synchronously. However in those instances other measures should be taken
             * to batch reads/writes.
             */ syncRender: render,
            /**
             * Update the provided props. Ensure any newly-added motion values are
             * added to our map, old ones removed, and listeners updated.
             */ setProps: function(newProps) {
                if (newProps.transformTemplate || props.transformTemplate) element.scheduleRender();
                props = newProps;
                lifecycles.updatePropListeners(newProps);
                prevMotionValues = (0, $36e186eef14354e1$export$9a552858d5197f6e)(element, scrapeMotionValuesFromProps(props), prevMotionValues);
            },
            getProps: function() {
                return props;
            },
            // Variants ==============================
            /**
             * Returns the variant definition with a given name.
             */ getVariant: function(name) {
                var _a;
                return (_a = props.variants) === null || _a === void 0 ? void 0 : _a[name];
            },
            /**
             * Returns the defined default transition on this component.
             */ getDefaultTransition: function() {
                return props.transition;
            },
            getTransformPagePoint: function() {
                return props.transformPagePoint;
            },
            /**
             * Used by child variant nodes to get the closest ancestor variant props.
             */ getVariantContext: function(startAtParent) {
                if (startAtParent === void 0) startAtParent = false;
                if (startAtParent) return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
                if (!isControllingVariants) {
                    var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
                    if (props.initial !== undefined) context_1.initial = props.initial;
                    return context_1;
                }
                var context = {};
                for(var i = 0; i < $5ddea9451f7da6f0$var$numVariantProps; i++){
                    var name_1 = $5ddea9451f7da6f0$var$variantProps[i];
                    var prop = props[name_1];
                    if ((0, $70145b2788b65a38$export$720b90e312cea233)(prop) || prop === false) context[name_1] = prop;
                }
                return context;
            }
        });
        return element;
    };
};
var $5ddea9451f7da6f0$var$variantProps = (0, $3433e5a3eb89c040$export$1216008129fb82ed)([
    "initial"
], (0, $3433e5a3eb89c040$export$8d051b38c9118094)((0, $b147b3fbcf8b2fc8$export$16e45afcc206d3a8)), false);
var $5ddea9451f7da6f0$var$numVariantProps = $5ddea9451f7da6f0$var$variantProps.length;







function $43d08db277fd08bd$var$isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ var $43d08db277fd08bd$export$f7c0a352d8ef6313 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $43d08db277fd08bd$export$b9f0c1f373aee2b0(current) {
    var match = $43d08db277fd08bd$export$f7c0a352d8ef6313.exec(current);
    if (!match) return [
        , 
    ];
    var _a = (0, $3433e5a3eb89c040$export$8d051b38c9118094)(match, 3), token = _a[1], fallback = _a[2];
    return [
        token,
        fallback
    ];
}
var $43d08db277fd08bd$var$maxDepth = 4;
function $43d08db277fd08bd$var$getVariableValue(current, element, depth) {
    if (depth === void 0) depth = 1;
    (0, $8494256d1df1e442$export$f5708dca728d7177)(depth <= $43d08db277fd08bd$var$maxDepth, 'Max CSS variable fallback depth detected in property "'.concat(current, '". This may indicate a circular fallback dependency.'));
    var _a = (0, $3433e5a3eb89c040$export$8d051b38c9118094)($43d08db277fd08bd$export$b9f0c1f373aee2b0(current), 2), token = _a[0], fallback = _a[1];
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) return resolved.trim();
    else if ($43d08db277fd08bd$var$isCSSVariable(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $43d08db277fd08bd$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $43d08db277fd08bd$export$669319b042b57350(visualElement, _a, transitionEnd) {
    var _b;
    var target = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(_a, []);
    var element = visualElement.getInstance();
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, transitionEnd);
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.forEachValue(function(value) {
        var current = value.get();
        if (!$43d08db277fd08bd$var$isCSSVariable(current)) return;
        var resolved = $43d08db277fd08bd$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(var key in target){
        var current = target[key];
        if (!$43d08db277fd08bd$var$isCSSVariable(current)) continue;
        var resolved = $43d08db277fd08bd$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd) (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}








var $c21fcd3807f5d2f0$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y"
]);
var $c21fcd3807f5d2f0$var$isPositionalKey = function(key) {
    return $c21fcd3807f5d2f0$var$positionalKeys.has(key);
};
var $c21fcd3807f5d2f0$var$hasPositionalKey = function(target) {
    return Object.keys(target).some($c21fcd3807f5d2f0$var$isPositionalKey);
};
var $c21fcd3807f5d2f0$var$setAndResetVelocity = function(value, to) {
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
var $c21fcd3807f5d2f0$var$isNumOrPxType = function(v) {
    return v === (0, $5e966ba53bca97ed$export$98e628dec113755e) || v === (0, $0d8007420b761bba$export$91c0eda1d06bf008);
};
var $c21fcd3807f5d2f0$export$d0c75e4fa9e69db8;
(function(BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})($c21fcd3807f5d2f0$export$d0c75e4fa9e69db8 || ($c21fcd3807f5d2f0$export$d0c75e4fa9e69db8 = {}));
var $c21fcd3807f5d2f0$var$getPosFromMatrix = function(matrix, pos) {
    return parseFloat(matrix.split(", ")[pos]);
};
var $c21fcd3807f5d2f0$var$getTranslateFromMatrix = function(pos2, pos3) {
    return function(_bbox, _a) {
        var transform = _a.transform;
        if (transform === "none" || !transform) return 0;
        var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $c21fcd3807f5d2f0$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            var matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $c21fcd3807f5d2f0$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
};
var $c21fcd3807f5d2f0$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
var $c21fcd3807f5d2f0$var$nonTranslationalTransformKeys = (0, $da211e07316d6e39$export$7b42a0094fb00b6e).filter(function(key) {
    return !$c21fcd3807f5d2f0$var$transformKeys.has(key);
});
function $c21fcd3807f5d2f0$var$removeNonTranslationalTransform(visualElement) {
    var removedTransforms = [];
    $c21fcd3807f5d2f0$var$nonTranslationalTransformKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.syncRender();
    return removedTransforms;
}
var $c21fcd3807f5d2f0$export$781d46a8aa670d52 = {
    // Dimensions
    width: function(_a, _b) {
        var x = _a.x;
        var _c = _b.paddingLeft, paddingLeft = _c === void 0 ? "0" : _c, _d = _b.paddingRight, paddingRight = _d === void 0 ? "0" : _d;
        return x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: function(_a, _b) {
        var y = _a.y;
        var _c = _b.paddingTop, paddingTop = _c === void 0 ? "0" : _c, _d = _b.paddingBottom, paddingBottom = _d === void 0 ? "0" : _d;
        return y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: function(_bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function(_bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function(_a, _b) {
        var y = _a.y;
        var top = _b.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function(_a, _b) {
        var x = _a.x;
        var left = _b.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: $c21fcd3807f5d2f0$var$getTranslateFromMatrix(4, 13),
    y: $c21fcd3807f5d2f0$var$getTranslateFromMatrix(5, 14)
};
var $c21fcd3807f5d2f0$var$convertChangedValueTypes = function(target, visualElement, changedKeys) {
    var originBbox = visualElement.measureViewportBox();
    var element = visualElement.getInstance();
    var elementComputedStyle = getComputedStyle(element);
    var display = elementComputedStyle.display;
    var origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach(function(key) {
        origin[key] = $c21fcd3807f5d2f0$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.syncRender();
    var targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach(function(key) {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        var value = visualElement.getValue(key);
        $c21fcd3807f5d2f0$var$setAndResetVelocity(value, origin[key]);
        target[key] = $c21fcd3807f5d2f0$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
var $c21fcd3807f5d2f0$var$checkAndConvertChangedValueTypes = function(visualElement, target, origin, transitionEnd) {
    if (origin === void 0) origin = {};
    if (transitionEnd === void 0) transitionEnd = {};
    target = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, target);
    transitionEnd = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, transitionEnd);
    var targetPositionalKeys = Object.keys(target).filter($c21fcd3807f5d2f0$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    var removedTransformValues = [];
    var hasAttemptedToRemoveTransformValues = false;
    var changedValueTypeKeys = [];
    targetPositionalKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        var from = origin[key];
        var fromType = (0, $b2fd586ec5020ed9$export$eefdd52e3ccae428)(from);
        var to = target[key];
        var toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $6f683bc80c6d969e$export$9153ad4c4999f4a0)(to)) {
            var numKeyframes = to.length;
            var fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $b2fd586ec5020ed9$export$eefdd52e3ccae428)(from);
            for(var i = fromIndex; i < numKeyframes; i++)if (!toType) {
                toType = (0, $b2fd586ec5020ed9$export$eefdd52e3ccae428)(to[i]);
                (0, $8494256d1df1e442$export$f5708dca728d7177)(toType === fromType || $c21fcd3807f5d2f0$var$isNumOrPxType(fromType) && $c21fcd3807f5d2f0$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
            } else (0, $8494256d1df1e442$export$f5708dca728d7177)((0, $b2fd586ec5020ed9$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
        } else toType = (0, $b2fd586ec5020ed9$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($c21fcd3807f5d2f0$var$isNumOrPxType(fromType) && $c21fcd3807f5d2f0$var$isNumOrPxType(toType)) {
                var current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $0d8007420b761bba$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $c21fcd3807f5d2f0$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                $c21fcd3807f5d2f0$var$setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        var scrollY_1 = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        var convertedTarget = $c21fcd3807f5d2f0$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(function(_a) {
            var _b = (0, $3433e5a3eb89c040$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.syncRender();
        // Restore scroll position
        if (scrollY_1 !== null) window.scrollTo({
            top: scrollY_1
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $c21fcd3807f5d2f0$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $c21fcd3807f5d2f0$var$hasPositionalKey(target) ? $c21fcd3807f5d2f0$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ var $a795b5f9e1a26998$export$5849e743e29831d6 = function(visualElement, target, origin, transitionEnd) {
    var resolved = (0, $43d08db277fd08bd$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $c21fcd3807f5d2f0$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};







function $4dc9b9c59ad429d3$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
var $4dc9b9c59ad429d3$export$985b1494d4aeee90 = {
    treeType: "dom",
    readValueFromInstance: function(domElement, key) {
        if ((0, $da211e07316d6e39$export$15240a8a4379d8de)(key)) {
            var defaultType = (0, $10ea5fd01401393b$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            var computedStyle = $4dc9b9c59ad429d3$export$3735103072e4a80(domElement);
            return ((0, $7788fac55eb8bc79$export$451bc42768436155)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
        }
    },
    sortNodePosition: function(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    },
    getBaseTarget: function(props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    },
    measureViewportBox: function(element, _a) {
        var transformPagePoint = _a.transformPagePoint;
        return (0, $5df6dc38d07b7e46$export$d8718b6a7e5c624e)(element, transformPagePoint);
    },
    /**
     * Reset the transform on the current Element. This is called as part
     * of a batched process across the entire layout tree. To remove this write
     * cycle it'd be interesting to see if it's possible to "undo" all the current
     * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
     * works
     */ resetTransform: function(element, domElement, props) {
        var transformTemplate = props.transformTemplate;
        domElement.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        // Ensure that whatever happens next, we restore our transform on the next frame
        element.scheduleRender();
    },
    restoreTransform: function(instance, mutableState) {
        instance.style.transform = mutableState.style.transform;
    },
    removeValueFromRenderState: function(key, _a) {
        var vars = _a.vars, style = _a.style;
        delete vars[key];
        delete style[key];
    },
    /**
     * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
     * can be animated by Motion.
     */ makeTargetAnimatable: function(element, _a, _b, isMounted) {
        var transformValues = _b.transformValues;
        if (isMounted === void 0) isMounted = true;
        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(_a, [
            "transition",
            "transitionEnd"
        ]);
        var origin = (0, $e4befcaa41a4f540$export$5a759dc7a1cfb72a)(target, transition || {}, element);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $e4befcaa41a4f540$export$6afbed164019a54c)(element, target, origin);
            var parsed = (0, $a795b5f9e1a26998$export$5849e743e29831d6)(element, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({
            transition: transition,
            transitionEnd: transitionEnd
        }, target);
    },
    scrapeMotionValuesFromProps: (0, $e87aa36d3552d0b1$export$16da615486abaa45),
    build: function(element, renderState, latestValues, options, props) {
        if (element.isVisible !== undefined) renderState.style.visibility = element.isVisible ? "visible" : "hidden";
        (0, $d5a7ccaf3657bbce$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    },
    render: (0, $4d3a9c3652fbcbe3$export$1a32bf6229c258c0)
};
var $4dc9b9c59ad429d3$export$9509f7c142585e92 = (0, $5ddea9451f7da6f0$export$5ad594e944c33d76)($4dc9b9c59ad429d3$export$985b1494d4aeee90);












var $aeb9ecaa88c7d06d$export$3ba8992de7b705bc = (0, $5ddea9451f7da6f0$export$5ad594e944c33d76)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, (0, $4dc9b9c59ad429d3$export$985b1494d4aeee90)), {
    getBaseTarget: function(props, key) {
        return props[key];
    },
    readValueFromInstance: function(domElement, key) {
        var _a;
        if ((0, $da211e07316d6e39$export$15240a8a4379d8de)(key)) return ((_a = (0, $10ea5fd01401393b$export$67d1babe0338d23b)(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        key = !(0, $53f5831d8ff6fe26$export$28931db5d57958e5).has(key) ? (0, $ccc055b4a72c1347$export$9fd24a634729c672)(key) : key;
        return domElement.getAttribute(key);
    },
    scrapeMotionValuesFromProps: (0, $4c74588f3910fe04$export$16da615486abaa45),
    build: function(_element, renderState, latestValues, options, props) {
        (0, $22afbc6679b4fb16$export$5475d24f125d7053)(renderState, latestValues, options, props.transformTemplate);
    },
    render: (0, $6ecc69af052e005d$export$c5f8399d19a7394b)
}));



var $38a6ac1b54bc169a$export$56ba0183203348f5 = function(Component, options) {
    return (0, $9c5a7490b01b42fd$export$88f3fc2fd3766989)(Component) ? (0, $aeb9ecaa88c7d06d$export$3ba8992de7b705bc)(options, {
        enableHardwareAcceleration: false
    }) : (0, $4dc9b9c59ad429d3$export$9509f7c142585e92)(options, {
        enableHardwareAcceleration: true
    });
};





var $exYeM = parcelRequire("exYeM");





function $58b16b9942e44958$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ var $58b16b9942e44958$export$5eafb6257a5844c = {
    correct: function(latest, node) {
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $0d8007420b761bba$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ var x = $58b16b9942e44958$export$fafff692be55225d(latest, node.target.x);
        var y = $58b16b9942e44958$export$fafff692be55225d(latest, node.target.y);
        return "".concat(x, "% ").concat(y, "%");
    }
};





var $011a5e472cdf5fa8$var$varToken = "_$css";
var $011a5e472cdf5fa8$export$eb0bc629e74dcf8 = {
    correct: function(latest, _a) {
        var treeScale = _a.treeScale, projectionDelta = _a.projectionDelta;
        var original = latest;
        /**
         * We need to first strip and store CSS variables from the string.
         */ var containsCSSVariables = latest.includes("var(");
        var cssVariables = [];
        if (containsCSSVariables) latest = latest.replace((0, $43d08db277fd08bd$export$f7c0a352d8ef6313), function(match) {
            cssVariables.push(match);
            return $011a5e472cdf5fa8$var$varToken;
        });
        var shadow = (0, $dd5b1de03e779230$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        var template = (0, $dd5b1de03e779230$export$83a0e34f1302825b).createTransformer(latest);
        var offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        var xScale = projectionDelta.x.scale * treeScale.x;
        var yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ var averageScale = (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        var output = template(shadow);
        if (containsCSSVariables) {
            var i_1 = 0;
            output = output.replace($011a5e472cdf5fa8$var$varToken, function() {
                var cssVariable = cssVariables[i_1];
                i_1++;
                return cssVariable;
            });
        }
        return output;
    }
};



var $c3c24be56499347e$var$MeasureLayoutWithContext = /** @class */ function(_super) {
    (0, $3433e5a3eb89c040$export$a8ba968b8961cb8a)(MeasureLayoutWithContext, _super);
    function MeasureLayoutWithContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ MeasureLayoutWithContext.prototype.componentDidMount = function() {
        var _this = this;
        var _a = this.props, visualElement = _a.visualElement, layoutGroup = _a.layoutGroup, switchLayoutGroup = _a.switchLayoutGroup, layoutId = _a.layoutId;
        var projection = visualElement.projection;
        (0, $93099dc5c3aa7524$export$de9e7791c71225fd)($c3c24be56499347e$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group) layoutGroup.group.add(projection);
            if ((switchLayoutGroup === null || switchLayoutGroup === void 0 ? void 0 : switchLayoutGroup.register) && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", function() {
                _this.safeToRemove();
            });
            projection.setOptions((0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, projection.options), {
                onExitComplete: function() {
                    return _this.safeToRemove();
                }
            }));
        }
        (0, $d92fcbc1a711d121$export$97db156a3ed1593b).hasEverUpdated = true;
    };
    MeasureLayoutWithContext.prototype.getSnapshotBeforeUpdate = function(prevProps) {
        var _this = this;
        var _a = this.props, layoutDependency = _a.layoutDependency, visualElement = _a.visualElement, drag = _a.drag, isPresent = _a.isPresent;
        var projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $2e071b817ebd59af$export$2e2bcd8739ae039).postRender(function() {
                var _a;
                if (!((_a = projection.getStack()) === null || _a === void 0 ? void 0 : _a.members.length)) _this.safeToRemove();
            });
        }
        return null;
    };
    MeasureLayoutWithContext.prototype.componentDidUpdate = function() {
        var projection = this.props.visualElement.projection;
        if (projection) {
            projection.root.didUpdate();
            if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
        }
    };
    MeasureLayoutWithContext.prototype.componentWillUnmount = function() {
        var _a = this.props, visualElement = _a.visualElement, layoutGroup = _a.layoutGroup, promoteContext = _a.switchLayoutGroup;
        var projection = visualElement.projection;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext === null || promoteContext === void 0 ? void 0 : promoteContext.deregister) promoteContext.deregister(projection);
        }
    };
    MeasureLayoutWithContext.prototype.safeToRemove = function() {
        var safeToRemove = this.props.safeToRemove;
        safeToRemove === null || safeToRemove === void 0 || safeToRemove();
    };
    MeasureLayoutWithContext.prototype.render = function() {
        return null;
    };
    return MeasureLayoutWithContext;
}((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Component);
function $c3c24be56499347e$export$779f5fb01ad751cd(props) {
    var _a = (0, $3433e5a3eb89c040$export$8d051b38c9118094)((0, $eecb2e495db1f2fd$export$2a8c16d82a0a0e26)(), 2), isPresent = _a[0], safeToRemove = _a[1];
    var layoutGroup = (0, $exYeM.useContext)((0, $0d8fa753a19a110b$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($c3c24be56499347e$var$MeasureLayoutWithContext, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, props, {
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $exYeM.useContext)((0, $df9c3e45a16d5ebc$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    }));
}
var $c3c24be56499347e$var$defaultScaleCorrectors = {
    borderRadius: (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, (0, $58b16b9942e44958$export$5eafb6257a5844c)), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: (0, $58b16b9942e44958$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $58b16b9942e44958$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $58b16b9942e44958$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $58b16b9942e44958$export$5eafb6257a5844c),
    boxShadow: (0, $011a5e472cdf5fa8$export$eb0bc629e74dcf8)
};


var $4fe7f37a77a2820b$export$518df03f164c507 = {
    measureLayout: (0, $c3c24be56499347e$export$779f5fb01ad751cd)
};








/**
 * Animate a single value or a `MotionValue`.
 *
 * The first argument is either a `MotionValue` to animate, or an initial animation value.
 *
 * The second is either a value to animate to, or an array of keyframes to animate through.
 *
 * The third argument can be either tween or spring options, and optional lifecycle methods: `onUpdate`, `onPlay`, `onComplete`, `onRepeat` and `onStop`.
 *
 * Returns `AnimationPlaybackControls`, currently just a `stop` method.
 *
 * ```javascript
 * const x = useMotionValue(0)
 *
 * useEffect(() => {
 *   const controls = animate(x, 100, {
 *     type: "spring",
 *     stiffness: 2000,
 *     onComplete: v => {}
 *   })
 *
 *   return controls.stop
 * })
 * ```
 *
 * @public
 */ function $c4ccd7e590d8f350$export$e3607ec2d7a891c4(from, to, transition) {
    if (transition === void 0) transition = {};
    var value = (0, $65e8d3d378a9947e$export$605d60a2578142d3)(from) ? from : (0, $4b2846f88af5423d$export$ce8bdc721e76545f)(from);
    (0, $1d127c5bbdfabc9c$export$592dbd515a49cf1b)("", value, to, transition);
    return {
        stop: function() {
            return value.stop();
        },
        isAnimating: function() {
            return value.isAnimating();
        }
    };
}





var $b0eff65bd8993999$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
var $b0eff65bd8993999$var$numBorders = $b0eff65bd8993999$var$borders.length;
var $b0eff65bd8993999$var$asNumber = function(value) {
    return typeof value === "string" ? parseFloat(value) : value;
};
var $b0eff65bd8993999$var$isPx = function(value) {
    return typeof value === "number" || (0, $0d8007420b761bba$export$91c0eda1d06bf008).test(value);
};
function $b0eff65bd8993999$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    var _a, _b, _c, _d;
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(0, // (follow?.opacity as number) ?? 0,
        // TODO Reinstate this if only child
        (_a = lead.opacity) !== null && _a !== void 0 ? _a : 1, $b0eff65bd8993999$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)((_b = follow.opacity) !== null && _b !== void 0 ? _b : 1, 0, $b0eff65bd8993999$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)((_c = follow.opacity) !== null && _c !== void 0 ? _c : 1, (_d = lead.opacity) !== null && _d !== void 0 ? _d : 1, progress);
    /**
     * Mix border radius
     */ for(var i = 0; i < $b0eff65bd8993999$var$numBorders; i++){
        var borderLabel = "border".concat($b0eff65bd8993999$var$borders[i], "Radius");
        var followRadius = $b0eff65bd8993999$var$getRadius(follow, borderLabel);
        var leadRadius = $b0eff65bd8993999$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        var canMix = followRadius === 0 || leadRadius === 0 || $b0eff65bd8993999$var$isPx(followRadius) === $b0eff65bd8993999$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $3318cde9c86c9824$export$2c9e8a9632a706b2)($b0eff65bd8993999$var$asNumber(followRadius), $b0eff65bd8993999$var$asNumber(leadRadius), progress), 0);
            if ((0, $0d8007420b761bba$export$626336c2cd4b14de).test(leadRadius) || (0, $0d8007420b761bba$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $b0eff65bd8993999$var$getRadius(values, radiusName) {
    var _a;
    return (_a = values[radiusName]) !== null && _a !== void 0 ? _a : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
var $b0eff65bd8993999$var$easeCrossfadeIn = $b0eff65bd8993999$var$compress(0, 0.5, (0, $103ab17de5093dac$export$c8d67a19199d1a50));
var $b0eff65bd8993999$var$easeCrossfadeOut = $b0eff65bd8993999$var$compress(0.5, 0.95, (0, $103ab17de5093dac$export$45db2fc2f15997e7));
function $b0eff65bd8993999$var$compress(min, max, easing) {
    return function(p) {
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $495f4f72f02e3374$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $350541e2d10af992$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $350541e2d10af992$export$c53fd88f45d77e4b(box, originBox) {
    $350541e2d10af992$export$a0230ae482601ae8(box.x, originBox.x);
    $350541e2d10af992$export$a0230ae482601ae8(box.y, originBox.y);
}








/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $e3be0578d1881dff$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $3cadfa9c5538c02d$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $3cadfa9c5538c02d$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $e3be0578d1881dff$export$cc12a0672fae5b4a(axis, translate, scale, origin, boxScale, originAxis, sourceAxis) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    if (origin === void 0) origin = 0.5;
    if (originAxis === void 0) originAxis = axis;
    if (sourceAxis === void 0) sourceAxis = axis;
    if ((0, $0d8007420b761bba$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        var relativeProgress = (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    var originPoint = (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $e3be0578d1881dff$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $e3be0578d1881dff$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $e3be0578d1881dff$export$42b76f1d0d16d5b(axis, transforms, _a, origin, sourceAxis) {
    var _b = (0, $3433e5a3eb89c040$export$8d051b38c9118094)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    $e3be0578d1881dff$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var $e3be0578d1881dff$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
var $e3be0578d1881dff$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $e3be0578d1881dff$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $e3be0578d1881dff$export$42b76f1d0d16d5b(box.x, transforms, $e3be0578d1881dff$var$xKeys, originBox === null || originBox === void 0 ? void 0 : originBox.x, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.x);
    $e3be0578d1881dff$export$42b76f1d0d16d5b(box.y, transforms, $e3be0578d1881dff$var$yKeys, originBox === null || originBox === void 0 ? void 0 : originBox.y, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.y);
}




function $62d95540b2cf82c6$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $62d95540b2cf82c6$export$a7ec7642fe550fb6(delta) {
    return $62d95540b2cf82c6$var$isAxisDeltaZero(delta.x) && $62d95540b2cf82c6$var$isAxisDeltaZero(delta.y);
}
function $62d95540b2cf82c6$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}



var $b677bc2ebc452ee9$export$39be5b2d82fc9dc7 = /** @class */ function() {
    function NodeStack() {
        this.members = [];
    }
    NodeStack.prototype.add = function(node) {
        (0, $d2a9bfd104bd5453$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    };
    NodeStack.prototype.remove = function(node) {
        (0, $d2a9bfd104bd5453$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            var prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    };
    NodeStack.prototype.relegate = function(node) {
        var indexOfNode = this.members.findIndex(function(member) {
            return node === member;
        });
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ var prevLead;
        for(var i = indexOfNode; i >= 0; i--){
            var member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    };
    NodeStack.prototype.promote = function(node, preserveFollowOpacity) {
        var _a;
        var prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
                node.snapshot.isShared = true;
            }
            if ((_a = node.root) === null || _a === void 0 ? void 0 : _a.isUpdating) node.isLayoutDirty = true;
            var crossfade = node.options.crossfade;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    };
    NodeStack.prototype.exitAnimationComplete = function() {
        this.members.forEach(function(node) {
            var _a, _b, _c, _d, _e;
            (_b = (_a = node.options).onExitComplete) === null || _b === void 0 || _b.call(_a);
            (_e = (_c = node.resumingFrom) === null || _c === void 0 ? void 0 : (_d = _c.options).onExitComplete) === null || _e === void 0 || _e.call(_d);
        });
    };
    NodeStack.prototype.scheduleRender = function() {
        this.members.forEach(function(node) {
            node.instance && node.scheduleRender(false);
        });
    };
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ NodeStack.prototype.removeLeadSnapshot = function() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    };
    return NodeStack;
}();



var $e1a92a4c0809d32f$export$f6730f82d2dcfda3 = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function $e1a92a4c0809d32f$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ var xTranslate = delta.x.translate / treeScale.x;
    var yTranslate = delta.y.translate / treeScale.y;
    var transform = "translate3d(".concat(xTranslate, "px, ").concat(yTranslate, "px, 0) ");
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ transform += "scale(".concat(1 / treeScale.x, ", ").concat(1 / treeScale.y, ") ");
    if (latestTransform) {
        var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
        if (rotate) transform += "rotate(".concat(rotate, "deg) ");
        if (rotateX) transform += "rotateX(".concat(rotateX, "deg) ");
        if (rotateY) transform += "rotateY(".concat(rotateY, "deg) ");
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ var elementScaleX = delta.x.scale * treeScale.x;
    var elementScaleY = delta.y.scale * treeScale.y;
    transform += "scale(".concat(elementScaleX, ", ").concat(elementScaleY, ")");
    return transform === $e1a92a4c0809d32f$export$f6730f82d2dcfda3 ? "none" : transform;
}






var $80818efe87296e52$export$d689d9dec5ad338 = function(a, b) {
    return a.depth - b.depth;
};


var $06918006e178146a$export$1465d17e3de78a96 = /** @class */ function() {
    function FlatTree() {
        this.children = [];
        this.isDirty = false;
    }
    FlatTree.prototype.add = function(child) {
        (0, $d2a9bfd104bd5453$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.remove = function(child) {
        (0, $d2a9bfd104bd5453$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.forEach = function(callback) {
        this.isDirty && this.children.sort((0, $80818efe87296e52$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    };
    return FlatTree;
}();




/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ var $691a2a8b4741efa1$var$animationTarget = 1000;
function $691a2a8b4741efa1$export$a84b61f69daa9da0(_a) {
    var attachResizeListener = _a.attachResizeListener, defaultParent = _a.defaultParent, measureScroll = _a.measureScroll, checkIsScrollRoot = _a.checkIsScrollRoot, resetTransform = _a.resetTransform;
    return /** @class */ function() {
        function ProjectionNode(id, latestValues, parent) {
            var _this = this;
            if (latestValues === void 0) latestValues = {};
            if (parent === void 0) parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent();
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to actually
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            // Note: Currently only running on root node
            this.potentialNodes = new Map();
            this.checkUpdateFailed = function() {
                if (_this.isUpdating) {
                    _this.isUpdating = false;
                    _this.clearAllSnapshots();
                }
            };
            this.updateProjection = function() {
                _this.nodes.forEach($691a2a8b4741efa1$var$resolveTargetDelta);
                _this.nodes.forEach($691a2a8b4741efa1$var$calcProjection);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.id = id;
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? (0, $3433e5a3eb89c040$export$1216008129fb82ed)((0, $3433e5a3eb89c040$export$1216008129fb82ed)([], (0, $3433e5a3eb89c040$export$8d051b38c9118094)(parent.path), false), [
                parent
            ], false) : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            id && this.root.registerPotentialNode(id, this);
            for(var i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $06918006e178146a$export$1465d17e3de78a96)();
        }
        ProjectionNode.prototype.addEventListener = function(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $97358bb0f01597b3$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        };
        ProjectionNode.prototype.notifyListeners = function(name) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            var subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager === null || subscriptionManager === void 0 || subscriptionManager.notify.apply(subscriptionManager, (0, $3433e5a3eb89c040$export$1216008129fb82ed)([], (0, $3433e5a3eb89c040$export$8d051b38c9118094)(args), false));
        };
        ProjectionNode.prototype.hasListeners = function(name) {
            return this.eventHandlers.has(name);
        };
        ProjectionNode.prototype.registerPotentialNode = function(id, node) {
            this.potentialNodes.set(id, node);
        };
        /**
         * Lifecycles
         */ ProjectionNode.prototype.mount = function(instance, isLayoutDirty) {
            var _this = this;
            var _a;
            if (isLayoutDirty === void 0) isLayoutDirty = false;
            if (this.instance) return;
            this.isSVG = instance instanceof SVGElement && instance.tagName !== "svg";
            this.instance = instance;
            var _b = this.options, layoutId = _b.layoutId, layout = _b.layout, visualElement = _b.visualElement;
            if (visualElement && !visualElement.getInstance()) visualElement.mount(instance);
            this.root.nodes.add(this);
            (_a = this.parent) === null || _a === void 0 || _a.children.add(this);
            this.id && this.root.potentialNodes.delete(this.id);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                var unblockTimeout_1;
                var resizeUnblockUpdate_1 = function() {
                    return _this.root.updateBlockedByResize = false;
                };
                attachResizeListener(instance, function() {
                    _this.root.updateBlockedByResize = true;
                    clearTimeout(unblockTimeout_1);
                    unblockTimeout_1 = window.setTimeout(resizeUnblockUpdate_1, 250);
                    if ((0, $d92fcbc1a711d121$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $d92fcbc1a711d121$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        _this.nodes.forEach($691a2a8b4741efa1$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", function(_a) {
                var _b, _c, _d, _e, _f;
                var delta = _a.delta, hasLayoutChanged = _a.hasLayoutChanged, hasRelativeTargetChanged = _a.hasRelativeTargetChanged, newLayout = _a.layout;
                if (_this.isTreeAnimationBlocked()) {
                    _this.target = undefined;
                    _this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                var layoutTransition = (_c = (_b = _this.options.transition) !== null && _b !== void 0 ? _b : visualElement.getDefaultTransition()) !== null && _c !== void 0 ? _c : $691a2a8b4741efa1$var$defaultLayoutTransition;
                var _g = visualElement.getProps(), onLayoutAnimationStart = _g.onLayoutAnimationStart, onLayoutAnimationComplete = _g.onLayoutAnimationComplete;
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ var targetChanged = !_this.targetLayout || !(0, $62d95540b2cf82c6$export$8d5cf76bb7daff09)(_this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ var hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (((_d = _this.resumeFrom) === null || _d === void 0 ? void 0 : _d.instance) || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !_this.currentAnimation)) {
                    if (_this.resumeFrom) {
                        _this.resumingFrom = _this.resumeFrom;
                        _this.resumingFrom.resumingFrom = undefined;
                    }
                    _this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    var animationOptions = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, (0, $1d127c5bbdfabc9c$export$7c1391340308742e)(layoutTransition, "layout")), {
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    });
                    if (visualElement.shouldReduceMotion) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    _this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged && _this.animationProgress === 0) _this.finishAnimation();
                    _this.isLead() && ((_f = (_e = _this.options).onExitComplete) === null || _f === void 0 || _f.call(_e));
                }
                _this.targetLayout = newLayout;
            });
        };
        ProjectionNode.prototype.unmount = function() {
            var _a, _b;
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            (_a = this.getStack()) === null || _a === void 0 || _a.remove(this);
            (_b = this.parent) === null || _b === void 0 || _b.children.delete(this);
            this.instance = undefined;
            (0, $2e071b817ebd59af$export$d93e9c1fe0553512).preRender(this.updateProjection);
        };
        // only on the root
        ProjectionNode.prototype.blockUpdate = function() {
            this.updateManuallyBlocked = true;
        };
        ProjectionNode.prototype.unblockUpdate = function() {
            this.updateManuallyBlocked = false;
        };
        ProjectionNode.prototype.isUpdateBlocked = function() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        };
        ProjectionNode.prototype.isTreeAnimationBlocked = function() {
            var _a;
            return this.isAnimationBlocked || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimationBlocked()) || false;
        };
        // Note: currently only running on root node
        ProjectionNode.prototype.startUpdate = function() {
            var _a;
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            (_a = this.nodes) === null || _a === void 0 || _a.forEach($691a2a8b4741efa1$var$resetRotation);
        };
        ProjectionNode.prototype.willUpdate = function(shouldNotifyListeners) {
            var _a, _b, _c;
            if (shouldNotifyListeners === void 0) shouldNotifyListeners = true;
            if (this.root.isUpdateBlocked()) {
                (_b = (_a = this.options).onExitComplete) === null || _b === void 0 || _b.call(_a);
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                node.shouldResetTransform = true;
                /**
                 * TODO: Check we haven't updated the scroll
                 * since the last didUpdate
                 */ node.updateScroll();
            }
            var _d = this.options, layoutId = _d.layoutId, layout = _d.layout;
            if (layoutId === undefined && !layout) return;
            var transformTemplate = (_c = this.options.visualElement) === null || _c === void 0 ? void 0 : _c.getProps().transformTemplate;
            this.prevTransformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        };
        // Note: Currently only running on root node
        ProjectionNode.prototype.didUpdate = function() {
            var updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($691a2a8b4741efa1$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) return;
            this.isUpdating = false;
            /**
             * Search for and mount newly-added projection elements.
             *
             * TODO: Every time a new component is rendered we could search up the tree for
             * the closest mounted node and query from there rather than document.
             */ if (this.potentialNodes.size) {
                this.potentialNodes.forEach($691a2a8b4741efa1$var$mountNodeEarly);
                this.potentialNodes.clear();
            }
            /**
             * Write
             */ this.nodes.forEach($691a2a8b4741efa1$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($691a2a8b4741efa1$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($691a2a8b4741efa1$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            // Flush any scheduled updates
            (0, $2e071b817ebd59af$export$cd75ccfd720a3cd4).update();
            (0, $2e071b817ebd59af$export$cd75ccfd720a3cd4).preRender();
            (0, $2e071b817ebd59af$export$cd75ccfd720a3cd4).render();
        };
        ProjectionNode.prototype.clearAllSnapshots = function() {
            this.nodes.forEach($691a2a8b4741efa1$var$clearSnapshot);
            this.sharedNodes.forEach($691a2a8b4741efa1$var$removeLeadSnapshots);
        };
        ProjectionNode.prototype.scheduleUpdateProjection = function() {
            (0, $2e071b817ebd59af$export$2e2bcd8739ae039).preRender(this.updateProjection, false, true);
        };
        ProjectionNode.prototype.scheduleCheckAfterUnmount = function() {
            var _this = this;
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $2e071b817ebd59af$export$2e2bcd8739ae039).postRender(function() {
                if (_this.isLayoutDirty) _this.root.didUpdate();
                else _this.root.checkUpdateFailed();
            });
        };
        /**
         * Update measurements
         */ ProjectionNode.prototype.updateSnapshot = function() {
            if (this.snapshot || !this.instance) return;
            var measured = this.measure();
            var layout = this.removeTransform(this.removeElementScroll(measured));
            $691a2a8b4741efa1$var$roundBox(layout);
            this.snapshot = {
                measured: measured,
                layout: layout,
                latestValues: {}
            };
        };
        ProjectionNode.prototype.updateLayout = function() {
            var _a;
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                node.updateScroll();
            }
            var measured = this.measure();
            $691a2a8b4741efa1$var$roundBox(measured);
            var prevLayout = this.layout;
            this.layout = {
                measured: measured,
                actual: this.removeElementScroll(measured)
            };
            this.layoutCorrected = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.actual);
            (_a = this.options.visualElement) === null || _a === void 0 || _a.notifyLayoutMeasure(this.layout.actual, prevLayout === null || prevLayout === void 0 ? void 0 : prevLayout.actual);
        };
        ProjectionNode.prototype.updateScroll = function() {
            if (this.options.layoutScroll && this.instance) {
                this.isScrollRoot = checkIsScrollRoot(this.instance);
                this.scroll = measureScroll(this.instance);
            }
        };
        ProjectionNode.prototype.resetTransform = function() {
            var _a;
            if (!resetTransform) return;
            var isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            var hasProjection = this.projectionDelta && !(0, $62d95540b2cf82c6$export$a7ec7642fe550fb6)(this.projectionDelta);
            var transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            var transformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            var transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $43492ab836cff22d$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        };
        ProjectionNode.prototype.measure = function() {
            var visualElement = this.options.visualElement;
            if (!visualElement) return (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            var box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            var scroll = this.root.scroll;
            if (scroll) {
                (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(box.x, scroll.x);
                (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(box.y, scroll.y);
            }
            return box;
        };
        ProjectionNode.prototype.removeElementScroll = function(box) {
            var boxWithoutScroll = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            (0, $350541e2d10af992$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                var scroll_1 = node.scroll, options = node.options, isScrollRoot = node.isScrollRoot;
                if (node !== this.root && scroll_1 && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (isScrollRoot) {
                        (0, $350541e2d10af992$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        var rootScroll = this.root.scroll;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.x);
                            (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.y);
                        }
                    }
                    (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll_1.x);
                    (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll_1.y);
                }
            }
            return boxWithoutScroll;
        };
        ProjectionNode.prototype.applyTransform = function(box, transformOnly) {
            if (transformOnly === void 0) transformOnly = false;
            var withTransforms = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            (0, $350541e2d10af992$export$c53fd88f45d77e4b)(withTransforms, box);
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $3cadfa9c5538c02d$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.x,
                    y: -node.scroll.y
                });
                if (!(0, $43492ab836cff22d$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $3cadfa9c5538c02d$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $43492ab836cff22d$export$a545127cf1fbb600)(this.latestValues)) (0, $3cadfa9c5538c02d$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        };
        ProjectionNode.prototype.removeTransform = function(box) {
            var _a;
            var boxWithoutTransform = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            (0, $350541e2d10af992$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $43492ab836cff22d$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $43492ab836cff22d$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                var sourceBox = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                var nodeBox = node.measure();
                (0, $350541e2d10af992$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $e3be0578d1881dff$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, (_a = node.snapshot) === null || _a === void 0 ? void 0 : _a.layout, sourceBox);
            }
            if ((0, $43492ab836cff22d$export$a545127cf1fbb600)(this.latestValues)) (0, $e3be0578d1881dff$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        };
        /**
         *
         */ ProjectionNode.prototype.setTargetDelta = function(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
        };
        ProjectionNode.prototype.setOptions = function(options) {
            var _a;
            this.options = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, this.options), options), {
                crossfade: (_a = options.crossfade) !== null && _a !== void 0 ? _a : true
            });
        };
        ProjectionNode.prototype.clearMeasurements = function() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        };
        /**
         * Frame calculations
         */ ProjectionNode.prototype.resolveTargetDelta = function() {
            var _a;
            var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent && this.relativeParent.layout) {
                    this.relativeTarget = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    (0, $a1e42a4af2333fb7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual);
                    (0, $350541e2d10af992$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.target)) (0, $a1e42a4af2333fb7$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.actual);
                else (0, $350541e2d10af992$export$c53fd88f45d77e4b)(this.target, this.layout.actual);
                (0, $3cadfa9c5538c02d$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $350541e2d10af992$export$c53fd88f45d77e4b)(this.target, this.layout.actual);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent && Boolean(this.relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !this.relativeParent.options.layoutScroll && this.relativeParent.target) {
                    this.relativeTarget = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    (0, $a1e42a4af2333fb7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, this.relativeParent.target);
                    (0, $350541e2d10af992$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
        };
        ProjectionNode.prototype.getClosestProjectingParent = function() {
            if (!this.parent || (0, $43492ab836cff22d$export$a545127cf1fbb600)(this.parent.latestValues)) return undefined;
            if ((this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout) return this.parent;
            else return this.parent.getClosestProjectingParent();
        };
        ProjectionNode.prototype.calcProjection = function() {
            var _a;
            var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimating) || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            var lead = this.getLead();
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $350541e2d10af992$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.actual);
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $3cadfa9c5538c02d$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, Boolean(this.resumingFrom) || this !== lead);
            var target = lead.target;
            if (!target) return;
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $704cbd53c53f9d5c$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $704cbd53c53f9d5c$export$3d227df54007d73a)();
            }
            var prevTreeScaleX = this.treeScale.x;
            var prevTreeScaleY = this.treeScale.y;
            var prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $a1e42a4af2333fb7$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $e1a92a4c0809d32f$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
        };
        ProjectionNode.prototype.hide = function() {
            this.isVisible = false;
        // TODO: Schedule render
        };
        ProjectionNode.prototype.show = function() {
            this.isVisible = true;
        // TODO: Schedule render
        };
        ProjectionNode.prototype.scheduleRender = function(notifyAll) {
            var _a, _b, _c;
            if (notifyAll === void 0) notifyAll = true;
            (_b = (_a = this.options).scheduleRender) === null || _b === void 0 || _b.call(_a);
            notifyAll && ((_c = this.getStack()) === null || _c === void 0 || _c.scheduleRender());
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        };
        ProjectionNode.prototype.setAnimationOrigin = function(delta, hasOnlyRelativeTargetChanged) {
            var _this = this;
            var _a;
            if (hasOnlyRelativeTargetChanged === void 0) hasOnlyRelativeTargetChanged = false;
            var snapshot = this.snapshot;
            var snapshotLatestValues = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.latestValues) || {};
            var mixedValues = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, this.latestValues);
            var targetDelta = (0, $704cbd53c53f9d5c$export$3d227df54007d73a)();
            this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            var relativeLayout = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            var isSharedLayoutAnimation = snapshot === null || snapshot === void 0 ? void 0 : snapshot.isShared;
            var isOnlyMember = (((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.members.length) || 0) <= 1;
            var shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($691a2a8b4741efa1$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            this.mixTargetDelta = function(latest) {
                var _a;
                var progress = latest / 1000;
                $691a2a8b4741efa1$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $691a2a8b4741efa1$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                _this.setTargetDelta(targetDelta);
                if (_this.relativeTarget && _this.relativeTargetOrigin && _this.layout && ((_a = _this.relativeParent) === null || _a === void 0 ? void 0 : _a.layout)) {
                    (0, $a1e42a4af2333fb7$export$2785bfcc929c5650)(relativeLayout, _this.layout.actual, _this.relativeParent.layout.actual);
                    $691a2a8b4741efa1$export$6ffd3e6ae339a132(_this.relativeTarget, _this.relativeTargetOrigin, relativeLayout, progress);
                }
                if (isSharedLayoutAnimation) {
                    _this.animationValues = mixedValues;
                    (0, $b0eff65bd8993999$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, _this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                _this.root.scheduleUpdateProjection();
                _this.scheduleRender();
                _this.animationProgress = progress;
            };
            this.mixTargetDelta(0);
        };
        ProjectionNode.prototype.startAnimation = function(options) {
            var _this = this;
            var _a, _b;
            this.notifyListeners("animationStart");
            (_a = this.currentAnimation) === null || _a === void 0 || _a.stop();
            if (this.resumingFrom) (_b = this.resumingFrom.currentAnimation) === null || _b === void 0 || _b.stop();
            if (this.pendingAnimation) {
                (0, $2e071b817ebd59af$export$d93e9c1fe0553512).update(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $2e071b817ebd59af$export$2e2bcd8739ae039).update(function() {
                (0, $d92fcbc1a711d121$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                _this.currentAnimation = (0, $c4ccd7e590d8f350$export$e3607ec2d7a891c4)(0, $691a2a8b4741efa1$var$animationTarget, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, options), {
                    onUpdate: function(latest) {
                        var _a;
                        _this.mixTargetDelta(latest);
                        (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, latest);
                    },
                    onComplete: function() {
                        var _a;
                        (_a = options.onComplete) === null || _a === void 0 || _a.call(options);
                        _this.completeAnimation();
                    }
                }));
                if (_this.resumingFrom) _this.resumingFrom.currentAnimation = _this.currentAnimation;
                _this.pendingAnimation = undefined;
            });
        };
        ProjectionNode.prototype.completeAnimation = function() {
            var _a;
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            (_a = this.getStack()) === null || _a === void 0 || _a.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        };
        ProjectionNode.prototype.finishAnimation = function() {
            var _a;
            if (this.currentAnimation) {
                (_a = this.mixTargetDelta) === null || _a === void 0 || _a.call(this, $691a2a8b4741efa1$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        };
        ProjectionNode.prototype.applyTransformsToTarget = function() {
            var _a = this.getLead(), targetWithTransforms = _a.targetWithTransforms, target = _a.target, layout = _a.layout, latestValues = _a.latestValues;
            if (!targetWithTransforms || !target || !layout) return;
            (0, $350541e2d10af992$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $3cadfa9c5538c02d$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its actual layout
             * into the desired bounding box.
             */ (0, $a1e42a4af2333fb7$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        };
        ProjectionNode.prototype.registerSharedNode = function(layoutId, node) {
            var _a, _b, _c;
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $b677bc2ebc452ee9$export$39be5b2d82fc9dc7)());
            var stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            node.promote({
                transition: (_a = node.options.initialPromotionConfig) === null || _a === void 0 ? void 0 : _a.transition,
                preserveFollowOpacity: (_c = (_b = node.options.initialPromotionConfig) === null || _b === void 0 ? void 0 : _b.shouldPreserveFollowOpacity) === null || _c === void 0 ? void 0 : _c.call(_b, node)
            });
        };
        ProjectionNode.prototype.isLead = function() {
            var stack = this.getStack();
            return stack ? stack.lead === this : true;
        };
        ProjectionNode.prototype.getLead = function() {
            var _a;
            var layoutId = this.options.layoutId;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        };
        ProjectionNode.prototype.getPrevLead = function() {
            var _a;
            var layoutId = this.options.layoutId;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        };
        ProjectionNode.prototype.getStack = function() {
            var layoutId = this.options.layoutId;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        };
        ProjectionNode.prototype.promote = function(_a) {
            var _b = _a === void 0 ? {} : _a, needsReset = _b.needsReset, transition = _b.transition, preserveFollowOpacity = _b.preserveFollowOpacity;
            var stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        };
        ProjectionNode.prototype.relegate = function() {
            var stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        };
        ProjectionNode.prototype.resetRotation = function() {
            var visualElement = this.options.visualElement;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            var hasRotate = false;
            // Keep a record of all the values we've reset
            var resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(var i = 0; i < (0, $da211e07316d6e39$export$67cd428da31419e1).length; i++){
                var axis = (0, $da211e07316d6e39$export$67cd428da31419e1)[i];
                var key = "rotate" + axis;
                // If this rotation doesn't exist as a motion value, then we don't
                // need to reset it
                if (!visualElement.getStaticValue(key)) continue;
                hasRotate = true;
                // Record the rotation and then temporarily set it to 0
                resetValues[key] = visualElement.getStaticValue(key);
                visualElement.setStaticValue(key, 0);
            }
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement === null || visualElement === void 0 || visualElement.syncRender();
            // Put back all the values we reset
            for(var key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        };
        ProjectionNode.prototype.getProjectionStyles = function(styleProp) {
            var _a, _b, _c, _d, _e, _f;
            if (styleProp === void 0) styleProp = {};
            // TODO: Return lifecycle-persistent object
            var styles = {};
            if (!this.instance || this.isSVG) return styles;
            if (!this.isVisible) return {
                visibility: "hidden"
            };
            else styles.visibility = "";
            var transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $a6687c7d507e2d36$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            var lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                var emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = (_b = this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1;
                    emptyStyles.pointerEvents = (0, $a6687c7d507e2d36$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $43492ab836cff22d$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            var valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $e1a92a4c0809d32f$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            var _g = this.projectionDelta, x = _g.x, y = _g.y;
            styles.transformOrigin = "".concat(x.origin * 100, "% ").concat(y.origin * 100, "% 0");
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_d = (_c = valuesToRender.opacity) !== null && _c !== void 0 ? _c : this.latestValues.opacity) !== null && _d !== void 0 ? _d : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its actual
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? (_e = valuesToRender.opacity) !== null && _e !== void 0 ? _e : "" : (_f = valuesToRender.opacityExit) !== null && _f !== void 0 ? _f : 0;
            /**
             * Apply scale correction
             */ for(var key in 0, $93099dc5c3aa7524$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                var _h = (0, $93099dc5c3aa7524$export$91ddd985b97788d1)[key], correct = _h.correct, applyTo = _h.applyTo;
                var corrected = correct(valuesToRender[key], lead);
                if (applyTo) {
                    var num = applyTo.length;
                    for(var i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $a6687c7d507e2d36$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "" : "none";
            return styles;
        };
        ProjectionNode.prototype.clearSnapshot = function() {
            this.resumeFrom = this.snapshot = undefined;
        };
        // Only run on root
        ProjectionNode.prototype.resetTree = function() {
            this.root.nodes.forEach(function(node) {
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($691a2a8b4741efa1$var$clearMeasurements);
            this.root.sharedNodes.clear();
        };
        return ProjectionNode;
    }();
}
function $691a2a8b4741efa1$var$updateLayout(node) {
    node.updateLayout();
}
function $691a2a8b4741efa1$var$notifyLayoutUpdate(node) {
    var _a, _b, _c, _d;
    var snapshot = (_b = (_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) !== null && _b !== void 0 ? _b : node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        var _e = node.layout, layout_1 = _e.actual, measuredLayout = _e.measured;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (node.options.animationType === "size") (0, $2c62bc0ac9269350$export$b789de563eb43b1)(function(axis) {
            var axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
            var length = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout_1[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if (node.options.animationType === "position") (0, $2c62bc0ac9269350$export$b789de563eb43b1)(function(axis) {
            var axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
            var length = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(layout_1[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
        });
        var layoutDelta = (0, $704cbd53c53f9d5c$export$3d227df54007d73a)();
        (0, $a1e42a4af2333fb7$export$c0d25e96fc67d310)(layoutDelta, layout_1, snapshot.layout);
        var visualDelta = (0, $704cbd53c53f9d5c$export$3d227df54007d73a)();
        if (snapshot.isShared) (0, $a1e42a4af2333fb7$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measured);
        else (0, $a1e42a4af2333fb7$export$c0d25e96fc67d310)(visualDelta, layout_1, snapshot.layout);
        var hasLayoutChanged = !(0, $62d95540b2cf82c6$export$a7ec7642fe550fb6)(layoutDelta);
        var hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            node.relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (node.relativeParent && !node.relativeParent.resumeFrom) {
                var _f = node.relativeParent, parentSnapshot = _f.snapshot, parentLayout = _f.layout;
                if (parentSnapshot && parentLayout) {
                    var relativeSnapshot = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    (0, $a1e42a4af2333fb7$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layout, parentSnapshot.layout);
                    var relativeLayout = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    (0, $a1e42a4af2333fb7$export$2785bfcc929c5650)(relativeLayout, layout_1, parentLayout.actual);
                    if (!(0, $62d95540b2cf82c6$export$8d5cf76bb7daff09)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout_1,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) (_d = (_c = node.options).onExitComplete) === null || _d === void 0 || _d.call(_c);
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $691a2a8b4741efa1$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $691a2a8b4741efa1$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $691a2a8b4741efa1$var$resetTransformStyle(node) {
    var visualElement = node.options.visualElement;
    if (visualElement === null || visualElement === void 0 ? void 0 : visualElement.getProps().onBeforeLayoutMeasure) visualElement.notifyBeforeLayoutMeasure();
    node.resetTransform();
}
function $691a2a8b4741efa1$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
}
function $691a2a8b4741efa1$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $691a2a8b4741efa1$var$calcProjection(node) {
    node.calcProjection();
}
function $691a2a8b4741efa1$var$resetRotation(node) {
    node.resetRotation();
}
function $691a2a8b4741efa1$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $691a2a8b4741efa1$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $691a2a8b4741efa1$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $3318cde9c86c9824$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $691a2a8b4741efa1$export$6ffd3e6ae339a132(output, from, to, p) {
    $691a2a8b4741efa1$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $691a2a8b4741efa1$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $691a2a8b4741efa1$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
var $691a2a8b4741efa1$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
function $691a2a8b4741efa1$var$mountNodeEarly(node, id) {
    /**
     * Rather than searching the DOM from document we can search the
     * path for the deepest mounted ancestor and search from there
     */ var searchNode = node.root;
    for(var i = node.path.length - 1; i >= 0; i--)if (Boolean(node.path[i].instance)) {
        searchNode = node.path[i];
        break;
    }
    var searchElement = searchNode && searchNode !== node.root ? searchNode.instance : document;
    var element = searchElement.querySelector('[data-projection-id="'.concat(id, '"]'));
    if (element) node.mount(element, true);
}
function $691a2a8b4741efa1$var$roundAxis(axis) {
    axis.min = Math.round(axis.min);
    axis.max = Math.round(axis.max);
}
function $691a2a8b4741efa1$var$roundBox(box) {
    $691a2a8b4741efa1$var$roundAxis(box.x);
    $691a2a8b4741efa1$var$roundAxis(box.y);
}




var $26dc2139c924a231$export$2d029a49a09b6177 = (0, $691a2a8b4741efa1$export$a84b61f69daa9da0)({
    attachResizeListener: function(ref, notify) {
        return (0, $2bb083316bee0fb8$export$b1d829ddf82884aa)(ref, "resize", notify);
    },
    measureScroll: function() {
        return {
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        };
    },
    checkIsScrollRoot: function() {
        return true;
    }
});


var $89f9370edb229af5$export$b91509fcf893b648 = {
    current: undefined
};
var $89f9370edb229af5$export$b61a9eb3dbde8858 = (0, $691a2a8b4741efa1$export$a84b61f69daa9da0)({
    measureScroll: function(instance) {
        return {
            x: instance.scrollLeft,
            y: instance.scrollTop
        };
    },
    defaultParent: function() {
        if (!$89f9370edb229af5$export$b91509fcf893b648.current) {
            var documentNode = new (0, $26dc2139c924a231$export$2d029a49a09b6177)(0, {});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $89f9370edb229af5$export$b91509fcf893b648.current = documentNode;
        }
        return $89f9370edb229af5$export$b91509fcf893b648.current;
    },
    resetTransform: function(instance, value) {
        instance.style.transform = value !== null && value !== void 0 ? value : "none";
    },
    checkIsScrollRoot: function(instance) {
        return Boolean(window.getComputedStyle(instance).position === "fixed");
    }
});


var $8667dd4cd334d17b$var$featureBundle = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, (0, $7170ce59c2debd45$export$7f9953c70dacfd7f)), (0, $60b1baafc37a77f3$export$e5b72898e5a201f1)), (0, $be25e9ea22024a07$export$d7d5d435647ed5a0)), (0, $4fe7f37a77a2820b$export$518df03f164c507));
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ var $8667dd4cd334d17b$export$e25e478948902b8b = /*@__PURE__*/ (0, $6b2ebacab9b54f79$export$a28d6df673050e18)(function(Component, config) {
    return (0, $e939d64425c6240c$export$732916c0e88175fb)(Component, config, $8667dd4cd334d17b$var$featureBundle, (0, $38a6ac1b54bc169a$export$56ba0183203348f5), (0, $89f9370edb229af5$export$b61a9eb3dbde8858));
});
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $8667dd4cd334d17b$export$546614c4a05701f9(key) {
    return (0, $002ee5308395fa07$export$46b7e4b9dc6110c3)((0, $e939d64425c6240c$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $8667dd4cd334d17b$var$featureBundle, (0, $38a6ac1b54bc169a$export$56ba0183203348f5), (0, $89f9370edb229af5$export$b61a9eb3dbde8858)));
}



parcelRequire("exYeM");
const $90480b65d11e1162$export$696f6b7c51637c51 = {
    icons: {
        check: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M2.77778 7.93056C2.63889 7.93056 2.5463 7.88426 2.5 7.79167L0.138889 5.43056C0.0462963 5.38426 0 5.31481 0 5.22222C0 5.08333 0.0231481 4.99074 0.0694444 4.94444C0.162037 4.85185 0.25463 4.80556 0.347222 4.80556C0.486111 4.80556 0.578704 4.8287 0.625 4.875L2.77778 7.02778L9.30556 0.430555C9.39815 0.337963 9.49074 0.291667 9.58333 0.291667C9.72222 0.291667 9.81481 0.337963 9.86111 0.430555C9.9537 0.476852 10 0.569444 10 0.708333C10 0.800926 9.9537 0.893518 9.86111 0.986111L3.05556 7.79167C2.96296 7.88426 2.87037 7.93056 2.77778 7.93056Z"
            }),
            viewBox: "0 0 10 8"
        },
        minusCircle: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M4 6.83333C3.83333 6.83333 3.69444 6.80556 3.58333 6.75C3.52778 6.63889 3.5 6.5 3.5 6.33333C3.5 6.16667 3.52778 6.05556 3.58333 6C3.69444 5.88889 3.83333 5.83333 4 5.83333H8C8.16667 5.83333 8.27778 5.88889 8.33333 6C8.44444 6.05556 8.5 6.16667 8.5 6.33333C8.5 6.5 8.44444 6.63889 8.33333 6.75C8.27778 6.80556 8.16667 6.83333 8 6.83333H4ZM6 12.3333C4.94444 12.3333 3.94444 12.0556 3 11.5C2.05556 11 1.30556 10.2778 0.75 9.33333C0.25 8.38889 0 7.38889 0 6.33333C0 5.27778 0.25 4.27778 0.75 3.33333C1.30556 2.38889 2.05556 1.66667 3 1.16667C3.94444 0.611111 4.94444 0.333333 6 0.333333C7.05556 0.333333 8.05556 0.611111 9 1.16667C9.94444 1.66667 10.6667 2.38889 11.1667 3.33333C11.7222 4.27778 12 5.27778 12 6.33333C12 7.38889 11.7222 8.38889 11.1667 9.33333C10.6667 10.2778 9.94444 11 9 11.5C8.05556 12.0556 7.05556 12.3333 6 12.3333ZM6 1.33333C5.11111 1.33333 4.27778 1.55556 3.5 2C2.72222 2.44444 2.11111 3.05556 1.66667 3.83333C1.22222 4.61111 1 5.44444 1 6.33333C1 7.22222 1.22222 8.05556 1.66667 8.83333C2.11111 9.61111 2.72222 10.2222 3.5 10.6667C4.27778 11.1111 5.11111 11.3333 6 11.3333C6.88889 11.3333 7.72222 11.1111 8.5 10.6667C9.27778 10.2222 9.88889 9.61111 10.3333 8.83333C10.7778 8.05556 11 7.22222 11 6.33333C11 5.44444 10.7778 4.61111 10.3333 3.83333C9.88889 3.05556 9.27778 2.44444 8.5 2C7.72222 1.55556 6.88889 1.33333 6 1.33333Z"
            }),
            viewBox: "0 0 12 13"
        },
        plusCircle: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M8 5.83333H6.5V4.33333C6.5 4.16667 6.44444 4.05556 6.33333 4C6.27778 3.88889 6.16667 3.83333 6 3.83333C5.83333 3.83333 5.69444 3.88889 5.58333 4C5.52778 4.05556 5.5 4.16667 5.5 4.33333V5.83333H4C3.83333 5.83333 3.69444 5.88889 3.58333 6C3.52778 6.05556 3.5 6.16667 3.5 6.33333C3.5 6.5 3.52778 6.63889 3.58333 6.75C3.69444 6.80556 3.83333 6.83333 4 6.83333H5.5V8.33333C5.5 8.5 5.52778 8.63889 5.58333 8.75C5.69444 8.80556 5.83333 8.83333 6 8.83333C6.16667 8.83333 6.27778 8.80556 6.33333 8.75C6.44444 8.63889 6.5 8.5 6.5 8.33333V6.83333H8C8.16667 6.83333 8.27778 6.80556 8.33333 6.75C8.44444 6.63889 8.5 6.5 8.5 6.33333C8.5 6.16667 8.44444 6.05556 8.33333 6C8.27778 5.88889 8.16667 5.83333 8 5.83333ZM6 0.333333C4.94444 0.333333 3.94444 0.611111 3 1.16667C2.05556 1.66667 1.30556 2.38889 0.75 3.33333C0.25 4.27778 0 5.27778 0 6.33333C0 7.38889 0.25 8.38889 0.75 9.33333C1.30556 10.2778 2.05556 11 3 11.5C3.94444 12.0556 4.94444 12.3333 6 12.3333C7.05556 12.3333 8.05556 12.0556 9 11.5C9.94444 11 10.6667 10.2778 11.1667 9.33333C11.7222 8.38889 12 7.38889 12 6.33333C12 5.27778 11.7222 4.27778 11.1667 3.33333C10.6667 2.38889 9.94444 1.66667 9 1.16667C8.05556 0.611111 7.05556 0.333333 6 0.333333ZM6 11.3333C5.11111 11.3333 4.27778 11.1111 3.5 10.6667C2.72222 10.2222 2.11111 9.61111 1.66667 8.83333C1.22222 8.05556 1 7.22222 1 6.33333C1 5.44444 1.22222 4.61111 1.66667 3.83333C2.11111 3.05556 2.72222 2.44444 3.5 2C4.27778 1.55556 5.11111 1.33333 6 1.33333C6.88889 1.33333 7.72222 1.55556 8.5 2C9.27778 2.44444 9.88889 3.05556 10.3333 3.83333C10.7778 4.61111 11 5.44444 11 6.33333C11 7.22222 10.7778 8.05556 10.3333 8.83333C9.88889 9.61111 9.27778 10.2222 8.5 10.6667C7.72222 11.1111 6.88889 11.3333 6 11.3333Z"
            }),
            viewBox: "0 0 12 13"
        },
        close: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z",
                fill: "currentColor"
            }),
            viewBox: "0 0 20 20"
        },
        left: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M3.82482 6.20124L1.13869 3.5L3.82482 0.798755C4.05839 0.585754 4.05839 0.372752 3.82482 0.159751C3.61071 -0.0532503 3.39659 -0.0532504 3.18248 0.159751L0.145986 3.1805C0.0486619 3.25795 -4.01207e-08 3.36445 -4.17371e-08 3.5C-4.33535e-08 3.63555 0.0486617 3.74205 0.145985 3.8195L3.18248 6.84025C3.39659 7.05325 3.61071 7.05325 3.82482 6.84025C4.05839 6.62725 4.05839 6.41425 3.82482 6.20124Z",
                fill: "currentColor"
            }),
            viewBox: "0 0 4 7"
        },
        right: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M0.175183 6.20124L2.86131 3.5L0.175183 0.798755C-0.0583941 0.585754 -0.0583941 0.372752 0.175183 0.159751C0.389294 -0.0532503 0.603406 -0.0532504 0.817518 0.159751L3.85401 3.1805C3.95134 3.25795 4 3.36445 4 3.5C4 3.63555 3.95134 3.74205 3.85401 3.8195L0.817518 6.84025C0.603406 7.05325 0.389295 7.05325 0.175183 6.84025C-0.0583941 6.62725 -0.0583941 6.41425 0.175183 6.20124Z",
                fill: "currentColor"
            }),
            viewBox: "0 0 4 7"
        },
        bottom: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M6.20124 0.175182L3.5 2.86131L0.798755 0.175183C0.585754 -0.0583941 0.372752 -0.0583941 0.159751 0.175183C-0.0532503 0.389294 -0.0532504 0.603406 0.159751 0.817518L3.1805 3.85401C3.25795 3.95134 3.36445 4 3.5 4C3.63555 4 3.74205 3.95134 3.8195 3.85401L6.84025 0.817518C7.05325 0.603406 7.05325 0.389294 6.84025 0.175182C6.62725 -0.0583942 6.41425 -0.0583942 6.20124 0.175182Z",
                fill: "currentColor"
            }),
            viewBox: "0 0 4 7"
        },
        top: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M0.798755 3.82482L3.5 1.13869L6.20124 3.82482C6.41425 4.05839 6.62725 4.05839 6.84025 3.82482C7.05325 3.61071 7.05325 3.39659 6.84025 3.18248L3.8195 0.145986C3.74205 0.0486619 3.63555 0 3.5 0C3.36445 0 3.25795 0.0486617 3.1805 0.145985L0.159751 3.18248C-0.0532508 3.39659 -0.0532508 3.61071 0.159751 3.82482C0.372752 4.05839 0.585754 4.05839 0.798755 3.82482Z",
                fill: "currentColor"
            }),
            viewBox: "0 0 4 7"
        },
        filter: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M0 0.583333H14V1.75H0V0.583333Z",
                        fill: "#161A21"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M0 12.25H14V13.4167H0V12.25Z",
                        fill: "#161A21"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M0 6.41667H14V7.58333H0V6.41667Z",
                        fill: "#161A21"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M0 0H3.65217V2.33333H0V0Z",
                        fill: "#161A21"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M10.3478 11.6667H14V14H10.3478V11.6667Z",
                        fill: "#161A21"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M5.17391 5.83333H8.82609V8.16667H5.17391V5.83333Z",
                        fill: "#161A21"
                    })
                ]
            }),
            viewBox: "0 0 14 14"
        },
        line_right: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M0.125 2.70484C0.0416667 2.77556 0 2.87279 0 2.99654C0 3.12029 0.0416667 3.22636 0.125 3.31476C0.229167 3.38547 0.354167 3.42083 0.5 3.42083H10.2812L8.15625 5.25058C7.90625 5.44504 7.89583 5.64835 8.125 5.86049C8.375 6.05496 8.61458 6.04612 8.84375 5.83397L11.8438 3.28824C11.9063 3.25288 11.9479 3.20869 11.9688 3.15565C11.9896 3.10261 12 3.04958 12 2.99654C12 2.94351 11.9896 2.89047 11.9688 2.83743C11.9479 2.7844 11.9063 2.7402 11.8438 2.70484L8.84375 0.159108C8.61458 -0.0530361 8.375 -0.0530361 8.125 0.159108C7.89583 0.353574 7.90625 0.54804 8.15625 0.742506L10.2812 2.57225H0.5C0.354167 2.57225 0.229167 2.61645 0.125 2.70484Z"
            }),
            viewBox: "0 0 12 6"
        },
        line_left: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M11.875 2.70484C11.9583 2.77556 12 2.87279 12 2.99654C12 3.12029 11.9583 3.22636 11.875 3.31476C11.7708 3.38547 11.6458 3.42083 11.5 3.42083H1.71875L3.84375 5.25058C4.09375 5.44504 4.10417 5.64835 3.875 5.86049C3.625 6.05496 3.38542 6.04612 3.15625 5.83397L0.15625 3.28824C0.09375 3.25288 0.0520833 3.20869 0.03125 3.15565C0.0104167 3.10261 0 3.04958 0 2.99654C0 2.9435 0.0104167 2.89047 0.03125 2.83743C0.0520833 2.7844 0.09375 2.7402 0.15625 2.70484L3.15625 0.159108C3.38542 -0.0530361 3.625 -0.0530361 3.875 0.159108C4.10417 0.353574 4.09375 0.54804 3.84375 0.742506L1.71875 2.57225H11.5C11.6458 2.57225 11.7708 2.61645 11.875 2.70484Z"
            }),
            viewBox: "0 0 12 6"
        },
        search: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M2.13619 2.13619C3.56031 0.712062 5.27626 0 7.28405 0C9.29183 0 11.0078 0.712062 12.4319 2.13619C13.856 3.56031 14.5681 5.27626 14.5681 7.28405C14.5681 8.98833 14.0311 10.5175 12.9572 11.8716L17.7549 16.6693C17.9183 16.8093 18 16.9844 18 17.1946C18 17.428 17.93 17.6148 17.7899 17.7549C17.6265 17.9183 17.4397 18 17.2296 18C16.9961 18 16.8093 17.9183 16.6693 17.7549L11.8716 12.9572C10.5175 14.0311 8.98833 14.5681 7.28405 14.5681C5.27626 14.5681 3.56031 13.856 2.13619 12.4319C0.712063 11.0078 0 9.29183 0 7.28405C0 5.27626 0.712063 3.56031 2.13619 2.13619ZM2.94163 11.6615C4.1323 12.8521 5.57977 13.4475 7.28405 13.4475C8.98833 13.4475 10.4475 12.8521 11.6615 11.6615C12.8521 10.4475 13.4475 8.98833 13.4475 7.28405C13.4475 5.57977 12.8521 4.1323 11.6615 2.94163C10.4475 1.72763 8.98833 1.12062 7.28405 1.12062C5.57977 1.12062 4.1323 1.72763 2.94163 2.94163C1.72763 4.1323 1.12062 5.57977 1.12062 7.28405C1.12062 8.98833 1.72763 10.4475 2.94163 11.6615Z",
                fill: "currentColor"
            }),
            viewBox: "0 0 18 18"
        },
        cart: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M1.16667 18H12.8333C13.1493 18 13.4167 17.8828 13.6354 17.6484C13.8785 17.4375 14 17.1797 14 16.875V4.5C14 4.19531 13.8785 3.9375 13.6354 3.72656C13.4167 3.49219 13.1493 3.375 12.8333 3.375H10.5C10.4757 2.4375 10.1233 1.64062 9.44271 0.984375C8.76215 0.328125 7.94792 0 7 0C6.05208 0 5.23785 0.328125 4.55729 0.984375C3.87674 1.64062 3.52431 2.4375 3.5 3.375H1.16667C0.850694 3.375 0.571181 3.49219 0.328125 3.72656C0.109375 3.9375 0 4.19531 0 4.5V16.875C0 17.1797 0.109375 17.4375 0.328125 17.6484C0.571181 17.8828 0.850694 18 1.16667 18ZM12.8333 4.5V16.875H1.16667V4.5H12.8333ZM5.35938 1.79297C5.82118 1.34766 6.36806 1.125 7 1.125C7.63194 1.125 8.16667 1.34766 8.60417 1.79297C9.06597 2.21484 9.30903 2.74219 9.33333 3.375H4.66667C4.69097 2.74219 4.92188 2.21484 5.35938 1.79297ZM5.25 6.75H8.75C8.92014 6.75 9.05382 6.70312 9.15104 6.60938C9.27257 6.49219 9.33333 6.35156 9.33333 6.1875C9.33333 6.02344 9.27257 5.89453 9.15104 5.80078C9.05382 5.68359 8.92014 5.625 8.75 5.625H5.25C5.07986 5.625 4.93403 5.68359 4.8125 5.80078C4.71528 5.89453 4.66667 6.02344 4.66667 6.1875C4.66667 6.35156 4.71528 6.49219 4.8125 6.60938C4.93403 6.70312 5.07986 6.75 5.25 6.75Z",
                fill: "currentColor"
            }),
            viewBox: "0 0 14 18"
        },
        menu: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M0 0H24V2H0V0Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M0 8H20V10H0V8Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M0 16H16V18H0V16Z",
                        fill: "currentColor"
                    })
                ]
            }),
            viewBox: "0 0 24 18"
        },
        expand_bottom: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M5.44574 5.8125C5.44574 5.8125 5.44574 5.8 5.44574 5.775L9.78682 1.1625C10.0711 0.8375 10.0711 0.525 9.78682 0.225V0.1875C9.65762 0.0625 9.50258 0 9.32171 0H0.678295C0.497416 0 0.342377 0.075 0.213178 0.225C-0.0710594 0.525 -0.0710594 0.8375 0.213178 1.1625L4.55426 5.8125C4.68346 5.9375 4.82558 6 4.98062 6C5.1615 6 5.31654 5.9375 5.44574 5.8125Z"
            }),
            viewBox: "0 0 10 6"
        },
        expand_up: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M5.44574 0.1875C5.44574 0.1875 5.44574 0.2 5.44574 0.225L9.78682 4.8375C10.0711 5.1625 10.0711 5.475 9.78682 5.775V5.8125C9.65762 5.9375 9.50258 6 9.32171 6H0.678295C0.497416 6 0.342377 5.925 0.213178 5.775C-0.0710594 5.475 -0.0710594 5.1625 0.213178 4.8375L4.55426 0.1875C4.68346 0.0625 4.82558 0 4.98062 0C5.1615 0 5.31654 0.0625 5.44574 0.1875Z"
            }),
            viewBox: "0 0 10 6"
        },
        minus: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M10.225 1.775C9.05833 0.591667 7.65 0 6 0C4.35 0 2.93333 0.591667 1.75 1.775C0.583333 2.94167 0 4.35 0 6C0 7.65 0.583333 9.06667 1.75 10.25C2.93333 11.4167 4.35 12 6 12C7.65 12 9.05833 11.4167 10.225 10.25C11.4083 9.06667 12 7.65 12 6C12 4.35 11.4083 2.94167 10.225 1.775ZM9.2 6.4H2.8C2.68333 6.4 2.58333 6.36667 2.5 6.3C2.43333 6.21667 2.4 6.11667 2.4 6C2.4 5.88333 2.43333 5.79167 2.5 5.725C2.58333 5.64167 2.68333 5.6 2.8 5.6H9.2C9.31667 5.6 9.40833 5.64167 9.475 5.725C9.55833 5.79167 9.6 5.88333 9.6 6C9.6 6.11667 9.55833 6.21667 9.475 6.3C9.40833 6.36667 9.31667 6.4 9.2 6.4Z"
            }),
            viewBox: "0 0 12 12"
        },
        plus: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M10.225 1.775C9.05833 0.591667 7.65 0 6 0C4.35 0 2.93333 0.591667 1.75 1.775C0.583333 2.94167 0 4.35 0 6C0 7.65 0.583333 9.06667 1.75 10.25C2.93333 11.4167 4.35 12 6 12C7.65 12 9.05833 11.4167 10.225 10.25C11.4083 9.06667 12 7.65 12 6C12 4.35 11.4083 2.94167 10.225 1.775ZM9.2 6.4H6.4V9.2C6.4 9.31667 6.35833 9.41667 6.275 9.5C6.20833 9.56667 6.11667 9.6 6 9.6C5.88333 9.6 5.78333 9.56667 5.7 9.5C5.63333 9.41667 5.6 9.31667 5.6 9.2V6.4H2.8C2.68333 6.4 2.58333 6.36667 2.5 6.3C2.43333 6.21667 2.4 6.11667 2.4 6C2.4 5.88333 2.43333 5.79167 2.5 5.725C2.58333 5.64167 2.68333 5.6 2.8 5.6H5.6V2.8C5.6 2.68333 5.63333 2.59167 5.7 2.525C5.78333 2.44167 5.88333 2.4 6 2.4C6.11667 2.4 6.20833 2.44167 6.275 2.525C6.35833 2.59167 6.4 2.68333 6.4 2.8V5.6H9.2C9.31667 5.6 9.40833 5.64167 9.475 5.725C9.55833 5.79167 9.6 5.88333 9.6 6C9.6 6.11667 9.55833 6.21667 9.475 6.3C9.40833 6.36667 9.31667 6.4 9.2 6.4Z"
            }),
            viewBox: "0 0 12 12"
        },
        discount: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M20.4039 0C21.2366 0 21.9197 0.798375 21.9934 1.81767L22 2.00141V4.1428C20.6052 4.41294 19.5558 5.58972 19.5558 7.00055C19.5558 8.41137 20.6052 9.58816 22 9.85829V11.9997C22 13.043 21.362 13.8994 20.548 13.9923L20.4039 14H1.5972C0.7645 14 0.0803 13.2016 0.0066 12.1823L0.0011 11.9997L0 9.8572C1.3948 9.58816 2.4453 8.41028 2.4453 6.99945C2.4453 5.58863 1.3948 4.41075 0 4.14171V2.00031C0 0.956956 0.638 0.100617 1.452 0.00765562L1.5972 0H20.4039ZM1.6687 1.16475L1.595 1.16694C1.474 1.18006 1.2738 1.43708 1.232 1.84173L1.2232 2.00031L1.221 3.30943L1.32 3.35427C2.6587 4.00062 3.5761 5.29224 3.6608 6.77525L3.6674 6.99945C3.6674 8.57433 2.7247 9.96547 1.32 10.6446L1.221 10.6884L1.2221 11.9592L1.2265 12.1014C1.2562 12.517 1.441 12.7707 1.5565 12.8232L1.5972 12.832L20.3313 12.8342L20.405 12.832C20.526 12.8188 20.7262 12.5618 20.7691 12.1572L20.7779 11.9997L20.7768 10.6873L20.68 10.6435C19.3413 9.99828 18.425 8.70557 18.3403 7.22365L18.3337 6.99945C18.3337 5.42458 19.2753 4.03343 20.68 3.35536L20.7768 3.30943L20.779 2.03968L20.7746 1.89751C20.7438 1.48192 20.5601 1.22819 20.4446 1.17569L20.4039 1.16694L1.6687 1.16475ZM13.75 8.74932C14.256 8.74932 14.6663 9.14085 14.6663 9.62425C14.6663 10.1076 14.256 10.4992 13.75 10.4992C13.244 10.4992 12.8326 10.1076 12.8326 9.62425C12.8326 9.14085 13.2429 8.74932 13.75 8.74932ZM14.2362 3.91094C14.4749 4.13843 14.5002 4.49168 14.3154 4.7476L14.2362 4.83837L8.7362 10.088C8.4678 10.345 8.0322 10.345 7.7638 10.088C7.5251 9.86048 7.4987 9.50723 7.6846 9.25131L7.7638 9.16053L13.2638 3.91094C13.5322 3.65393 13.9678 3.65393 14.2362 3.91094ZM8.25 3.49973C8.756 3.49973 9.1663 3.89126 9.1663 4.37466C9.1663 4.85806 8.756 5.24959 8.25 5.24959C7.744 5.24959 7.3326 4.85806 7.3326 4.37466C7.3326 3.89126 7.744 3.49973 8.25 3.49973Z"
            }),
            viewBox: "0 0 22 14"
        },
        what: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M12.8027 2.19727C11.3379 0.732422 9.57031 0 7.5 0C5.42969 0 3.66211 0.732422 2.19727 2.19727C0.732422 3.66211 0 5.42969 0 7.5C0 9.57031 0.732422 11.3379 2.19727 12.8027C3.66211 14.2676 5.42969 15 7.5 15C9.57031 15 11.3379 14.2676 12.8027 12.8027C14.2676 11.3379 15 9.57031 15 7.5C15 5.42969 14.2676 3.66211 12.8027 2.19727ZM12.1289 12.1582C10.8594 13.4277 9.31641 14.0625 7.5 14.0625C5.68359 14.0625 4.13086 13.4277 2.8418 12.1582C1.57227 10.8691 0.9375 9.31641 0.9375 7.5C0.9375 5.68359 1.57227 4.14062 2.8418 2.87109C4.13086 1.58203 5.68359 0.9375 7.5 0.9375C9.31641 0.9375 10.8594 1.58203 12.1289 2.87109C13.418 4.14062 14.0625 5.68359 14.0625 7.5C14.0625 9.31641 13.418 10.8691 12.1289 12.1582ZM6.73828 11.5137C6.54297 11.709 6.44531 11.9434 6.44531 12.2168C6.44531 12.4707 6.54297 12.6953 6.73828 12.8906C6.93359 13.0664 7.1582 13.1543 7.41211 13.1543C7.68555 13.1543 7.91016 13.0664 8.08594 12.8906C8.28125 12.6953 8.37891 12.4609 8.37891 12.1875C8.37891 11.9336 8.28125 11.709 8.08594 11.5137C7.91016 11.3184 7.68555 11.2207 7.41211 11.2207C7.1582 11.2207 6.93359 11.3184 6.73828 11.5137ZM7.41211 1.875C6.43555 1.875 5.56641 2.2168 4.80469 2.90039C4.04297 3.56445 3.66211 4.48242 3.66211 5.6543C3.66211 5.9082 3.75 6.13281 3.92578 6.32812C4.12109 6.50391 4.3457 6.5918 4.59961 6.5918C4.87305 6.5918 5.09766 6.50391 5.27344 6.32812C5.44922 6.13281 5.53711 5.9082 5.53711 5.6543C5.53711 5.04883 5.72266 4.58008 6.09375 4.24805C6.48438 3.91602 6.92383 3.75 7.41211 3.75C8.66211 3.75 9.28711 4.27734 9.28711 5.33203C9.28711 5.99609 8.93555 6.52344 8.23242 6.91406C7.80273 7.14844 7.40234 7.49023 7.03125 7.93945C6.66016 8.36914 6.47461 8.84766 6.47461 9.375C6.47461 9.62891 6.5625 9.85352 6.73828 10.0488C6.93359 10.2246 7.1582 10.3125 7.41211 10.3125C7.68555 10.3125 7.91016 10.2246 8.08594 10.0488C8.26172 9.85352 8.34961 9.62891 8.34961 9.375C8.34961 9.27734 8.42773 9.14062 8.58398 8.96484C8.75977 8.78906 8.93555 8.65234 9.11133 8.55469C10.4785 7.8125 11.1621 6.73828 11.1621 5.33203C11.1621 4.21875 10.791 3.36914 10.0488 2.7832C9.32617 2.17773 8.44727 1.875 7.41211 1.875Z"
            }),
            viewBox: "0 0 15 15"
        },
        what2: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M3.76106 8.112C3.76106 7.55733 3.88373 7.09867 4.12906 6.736C4.38506 6.37333 4.75306 5.97333 5.23306 5.536C5.58506 5.216 5.84106 4.94933 6.00106 4.736C6.17173 4.512 6.25706 4.26133 6.25706 3.984C6.25706 3.58933 6.09706 3.28 5.77706 3.056C5.46773 2.82133 5.05173 2.704 4.52906 2.704C4.02773 2.704 3.57973 2.81067 3.18506 3.024C2.80106 3.22667 2.47573 3.51467 2.20906 3.888L0.273062 2.752C0.721063 2.06933 1.32373 1.54133 2.08106 1.168C2.84906 0.794666 3.75573 0.608 4.80106 0.608C6.02773 0.608 7.00906 0.869333 7.74506 1.392C8.49173 1.91467 8.86506 2.64 8.86506 3.568C8.86506 4.00533 8.7904 4.38933 8.64106 4.72C8.5024 5.05067 8.3264 5.33333 8.11306 5.568C7.9104 5.792 7.64373 6.05333 7.31306 6.352C6.9184 6.704 6.6304 7.00267 6.44906 7.248C6.26773 7.48267 6.17706 7.77067 6.17706 8.112H3.76106ZM4.97706 12.128C4.53973 12.128 4.17173 11.9893 3.87306 11.712C3.58506 11.424 3.44106 11.0773 3.44106 10.672C3.44106 10.2667 3.58506 9.93067 3.87306 9.664C4.16106 9.38667 4.52906 9.248 4.97706 9.248C5.42506 9.248 5.79306 9.38667 6.08106 9.664C6.36906 9.93067 6.51306 10.2667 6.51306 10.672C6.51306 11.0773 6.36373 11.424 6.06506 11.712C5.77706 11.9893 5.4144 12.128 4.97706 12.128Z"
            }),
            viewBox: "0 0 9 13"
        },
        package: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M18.75 0H1.25C0.911458 0 0.611979 0.14881 0.351562 0.446429C0.117188 0.714286 0 1.04167 0 1.42857V4.28571H20V1.42857C20 1.04167 19.8698 0.714286 19.6094 0.446429C19.375 0.14881 19.0885 0 18.75 0ZM18.75 2.85714H1.25V1.42857H18.75V2.85714ZM1.25 18.5714C1.25 18.9583 1.36719 19.2857 1.60156 19.5536C1.86198 19.8512 2.16146 20 2.5 20H17.5C17.8385 20 18.125 19.8512 18.3594 19.5536C18.6198 19.2857 18.75 18.9583 18.75 18.5714V5.71429H1.25V18.5714ZM2.5 7.14286H17.5V18.5714H2.5V7.14286ZM13.125 8.57143H6.875C6.69271 8.57143 6.53646 8.64583 6.40625 8.79464C6.30208 8.91369 6.25 9.07738 6.25 9.28571C6.25 9.49405 6.30208 9.67262 6.40625 9.82143C6.53646 9.94048 6.69271 10 6.875 10H13.125C13.3073 10 13.4505 9.94048 13.5547 9.82143C13.6849 9.67262 13.75 9.49405 13.75 9.28571C13.75 9.07738 13.6849 8.91369 13.5547 8.79464C13.4505 8.64583 13.3073 8.57143 13.125 8.57143Z"
            }),
            viewBox: "0 0 20 20"
        },
        shield: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M17.0148 3.23851L9.30179 0.0597217C9.10857 -0.0198877 8.89139 -0.0199268 8.69821 0.0597217L0.985248 3.23851C0.691486 3.35961 0.5 3.64429 0.5 3.96004V7.8243C0.5 13.1451 3.7398 17.9313 8.70258 19.9421C8.8932 20.0193 9.10676 20.0193 9.29742 19.9421C14.2601 17.9314 17.5 13.1452 17.5 7.8243V3.96004C17.5 3.64429 17.3086 3.35961 17.0148 3.23851ZM15.9259 7.8243C15.9259 12.3475 13.25 16.5115 9 18.3702C4.86357 16.5611 2.07407 12.4701 2.07407 7.8243V4.4816L9 1.62714L15.9259 4.4816V7.8243ZM8.13009 10.4577L11.5129 7.09973C11.8203 6.79465 12.3186 6.79461 12.626 7.09973C12.9333 7.40485 12.9333 7.89949 12.6259 8.20457L8.6866 12.1149C8.37919 12.4201 7.88087 12.42 7.57357 12.1149L5.37404 9.93157C5.06666 9.62645 5.06666 9.1318 5.37404 8.82672C5.68142 8.52164 6.17973 8.5216 6.48707 8.82672L8.13009 10.4577Z"
            }),
            viewBox: "0 0 18 20"
        },
        truck: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M29.7599 8.47869L28.9312 5.20365C29.1578 5.1561 29.3278 4.9575 29.3278 4.71957V4.19152C29.3278 3.04502 28.3837 2.11231 27.2234 2.11231H23.4489V1.02312C23.4489 0.458945 22.9844 0 22.4134 0H3.17326C2.60226 0 2.13775 0.458945 2.13775 1.02312V10.0001C2.13775 10.2735 2.36207 10.4952 2.63882 10.4952C2.91551 10.4952 3.13988 10.2735 3.13988 10.0001V1.02312C3.13988 1.0049 3.15482 0.990142 3.17326 0.990142H22.4134C22.4318 0.990142 22.4467 1.0049 22.4467 1.02312V10.0002C22.4467 10.2736 22.671 10.4953 22.9478 10.4953C23.2245 10.4953 23.4489 10.2737 23.4489 10.0002V9.43901H29.3594C29.3599 9.43901 29.3603 9.43913 29.3607 9.43913C29.3612 9.43913 29.3617 9.43907 29.3621 9.43907C30.0894 9.43956 30.707 9.91123 30.9191 10.5612H29.3611C29.0844 10.5612 28.8601 10.7828 28.8601 11.0562V12.1123C28.8601 12.9677 29.5643 13.6635 30.43 13.6635H30.9979V15.8417H29.6877C29.2574 14.6139 28.0761 13.7295 26.6889 13.7295C25.3017 13.7295 24.1203 14.6139 23.69 15.8417H23.4487V12.1123C23.4487 11.8389 23.2244 11.6172 22.9477 11.6172C22.671 11.6172 22.4466 11.8388 22.4466 12.1123V15.8416H12.0511C11.6207 14.6138 10.4394 13.7293 9.05221 13.7293C7.66502 13.7293 6.48364 14.6138 6.05332 15.8416H3.17326C3.15482 15.8416 3.13988 15.8268 3.13988 15.8086V14.7195H5.31107C5.58776 14.7195 5.81214 14.4978 5.81214 14.2244C5.81214 13.951 5.58782 13.7293 5.31107 13.7293H0.501064C0.224375 13.7293 0 13.951 0 14.2244C0 14.4978 0.224313 14.7195 0.501064 14.7195H2.13782V15.8086C2.13782 16.3728 2.60232 16.8317 3.17332 16.8317H5.87982C5.8797 16.8427 5.87895 16.8536 5.87895 16.8647C5.87895 18.5935 7.30252 20 9.05221 20C10.8019 20 12.2255 18.5935 12.2255 16.8647C12.2255 16.8536 12.2247 16.8427 12.2246 16.8317H23.5165C23.5164 16.8427 23.5156 16.8536 23.5156 16.8647C23.5156 18.5935 24.9392 20 26.6889 20C28.4386 20 29.8621 18.5935 29.8621 16.8647C29.8621 16.8536 29.8614 16.8427 29.8612 16.8317H31.4989C31.7756 16.8317 32 16.6101 32 16.3367V11.0561C32.0001 9.75241 31.0265 8.6692 29.7599 8.47869ZM23.4489 3.10239H27.2234C27.8312 3.10239 28.3257 3.59098 28.3257 4.19152V4.2245H23.4489V3.10239ZM23.4489 8.44893V5.21458H27.9011L28.7195 8.44893H23.4489ZM9.05221 19.01C7.85502 19.01 6.88101 18.0478 6.88101 16.8648C6.88101 15.6819 7.85502 14.7196 9.05221 14.7196C10.2494 14.7196 11.2234 15.6819 11.2234 16.8648C11.2234 18.0478 10.2494 19.01 9.05221 19.01ZM26.689 19.01C25.4918 19.01 24.5178 18.0478 24.5178 16.8648C24.5178 15.6819 25.4918 14.7196 26.689 14.7196C27.8862 14.7196 28.8602 15.6819 28.8602 16.8648C28.8602 18.0478 27.8862 19.01 26.689 19.01ZM30.998 12.6734H30.4301C30.117 12.6734 29.8622 12.4217 29.8622 12.1123V11.5512H30.9979L30.998 12.6734Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M9.05222 15.8418C8.48122 15.8418 8.01672 16.3007 8.01672 16.8649C8.01672 17.4291 8.48122 17.888 9.05222 17.888C9.62322 17.888 10.0877 17.4291 10.0877 16.8649C10.0877 16.3007 9.62322 15.8418 9.05222 15.8418Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M26.689 15.8418C26.118 15.8418 25.6535 16.3007 25.6535 16.8649C25.6535 17.4291 26.118 17.888 26.689 17.888C27.26 17.888 27.7245 17.4291 27.7245 16.8649C27.7245 16.3007 27.26 15.8418 26.689 15.8418Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M20.81 13.7297H13.3278C13.0511 13.7297 12.8267 13.9514 12.8267 14.2248C12.8267 14.4982 13.051 14.7199 13.3278 14.7199H20.81C21.0867 14.7199 21.3111 14.4982 21.3111 14.2248C21.3111 13.9514 21.0868 13.7297 20.81 13.7297Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M7.98333 11.6172H1.56994C1.29325 11.6172 1.06888 11.8388 1.06888 12.1123C1.06888 12.3857 1.29319 12.6073 1.56994 12.6073H7.98333C8.26002 12.6073 8.48439 12.3857 8.48439 12.1123C8.48439 11.8388 8.26002 11.6172 7.98333 11.6172Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M17.4233 4.89764C17.2276 4.70436 16.9103 4.70436 16.7147 4.8977L12.2589 9.30011L9.94099 7.00989C9.7453 6.81654 9.42805 6.81654 9.23242 7.00989C9.03673 7.20324 9.03673 7.51663 9.23242 7.70998L11.9047 10.3503C12.0025 10.447 12.1307 10.4953 12.2589 10.4953C12.3871 10.4953 12.5154 10.447 12.6132 10.3503L17.4232 5.59779C17.6189 5.40438 17.6189 5.09099 17.4233 4.89764Z",
                        fill: "currentColor"
                    })
                ]
            }),
            viewBox: "0 0 32 20"
        },
        size: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M7 0.777778C7 0.518519 6.90278 0.324074 6.70833 0.194445C6.5787 0.0648148 6.41667 0 6.22222 0H0.777778C0.518519 0.0648146 0.324074 0.162037 0.194445 0.291666C0.0648148 0.421296 0 0.583333 0 0.777778V13.2222C0.0648148 13.4167 0.162037 13.5787 0.291667 13.7083C0.421297 13.9028 0.583333 14 0.777778 14H6.125C6.38426 14 6.5787 13.9028 6.70833 13.7083C6.90278 13.5787 7 13.4167 7 13.2222V0.777778ZM5.83333 12.8333H1.16667V11.6667H2.33333C2.52778 11.6667 2.65741 11.6343 2.72222 11.5694C2.85185 11.4398 2.91667 11.2778 2.91667 11.0833C2.91667 10.8889 2.85185 10.7593 2.72222 10.6944C2.65741 10.5648 2.52778 10.5 2.33333 10.5H1.16667V9.91667H3.5C3.69444 9.91667 3.82407 9.88426 3.88889 9.81944C4.01852 9.68981 4.08333 9.52778 4.08333 9.33333C4.08333 9.13889 4.01852 9.00926 3.88889 8.94444C3.82407 8.81481 3.69444 8.75 3.5 8.75H1.16667V8.16667H2.33333C2.52778 8.16667 2.65741 8.10185 2.72222 7.97222C2.85185 7.84259 2.91667 7.71296 2.91667 7.58333C2.91667 7.38889 2.85185 7.25926 2.72222 7.19444C2.65741 7.06482 2.52778 7 2.33333 7H1.16667V6.31944H3.5C3.69444 6.31944 3.82407 6.28704 3.88889 6.22222C4.01852 6.09259 4.08333 5.96296 4.08333 5.83333C4.08333 5.63889 4.01852 5.47685 3.88889 5.34722C3.82407 5.21759 3.69444 5.15278 3.5 5.15278H1.16667V4.56944H2.33333C2.52778 4.56944 2.65741 4.53704 2.72222 4.47222C2.85185 4.34259 2.91667 4.18056 2.91667 3.98611C2.91667 3.79167 2.85185 3.66204 2.72222 3.59722C2.65741 3.46759 2.52778 3.40278 2.33333 3.40278H1.16667V2.81944H3.5C3.69444 2.81944 3.82407 2.78704 3.88889 2.72222C4.01852 2.59259 4.08333 2.43056 4.08333 2.23611C4.08333 1.91204 3.88889 1.75 3.5 1.75H1.16667V1.16667H5.83333V12.8333Z"
            }),
            viewBox: "0 0 7 14"
        },
        fb: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M2.5 16H5.5V8H8.21875L8.5 5.25H5.5V3.875C5.5 3.45833 5.5625 3.16667 5.6875 3C5.8125 2.83333 6.11458 2.75 6.59375 2.75H8.5V0H5.75C4.5 0 3.64583 0.302083 3.1875 0.90625C2.72917 1.48958 2.5 2.39583 2.5 3.625V5.25H0.5V8H2.5V16Z"
            }),
            viewBox: "0 0 9 16"
        },
        gg: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M16.5 8.19355C16.5 7.67742 16.4344 7.29032 16.3689 6.87097H8.63115V9.6129H13.2213C13.0574 10.8065 11.8443 13.0645 8.63115 13.0645C5.84426 13.0645 3.58197 10.8065 3.58197 8C3.58197 3.51613 8.95902 1.45161 11.8443 4.19355L14.0738 2.09677C12.6639 0.806452 10.7951 0 8.63115 0C4.10656 0 0.5 3.58065 0.5 8C0.5 12.4516 4.10656 16 8.63115 16C13.3197 16 16.5 12.7742 16.5 8.19355Z"
            }),
            viewBox: "0 0 17 16"
        },
        logout: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M1.57746 1.79167V14.2083H8V16H1.57746C1.1518 16 0.776213 15.8194 0.450704 15.4583C0.150235 15.0972 0 14.6806 0 14.2083V1.79167C0 1.31944 0.150235 0.902778 0.450704 0.541667C0.776213 0.180556 1.1518 0 1.57746 0H8V1.79167H1.57746ZM12.0188 3.54167L16 8L12.0188 12.4583L10.892 11.1667L12.9577 8.875H4.80751V7.125H12.9577L10.892 4.79167L12.0188 3.54167Z"
            }),
            viewBox: "0 0 16 16"
        },
        discount_policies: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "M17.0703 2.92969C15.1172 0.976562 12.7604 0 10 0C7.23958 0 4.88281 0.976562 2.92969 2.92969C0.976562 4.88281 0 7.23958 0 10C0 12.7604 0.976562 15.1172 2.92969 17.0703C4.88281 19.0234 7.23958 20 10 20C12.7604 20 15.1172 19.0234 17.0703 17.0703C19.0234 15.1172 20 12.7604 20 10C20 7.23958 19.0234 4.88281 17.0703 2.92969ZM16.1719 16.2109C14.4792 17.9036 12.4219 18.75 10 18.75C7.57812 18.75 5.50781 17.9036 3.78906 16.2109C2.09635 14.4922 1.25 12.4219 1.25 10C1.25 7.57812 2.09635 5.52083 3.78906 3.82812C5.50781 2.10938 7.57812 1.25 10 1.25C12.4219 1.25 14.4792 2.10938 16.1719 3.82812C17.8906 5.52083 18.75 7.57812 18.75 10C18.75 12.4219 17.8906 14.4922 16.1719 16.2109ZM8.24219 8.20312C8.63281 7.8125 8.82812 7.35677 8.82812 6.83594C8.82812 6.3151 8.63281 5.8724 8.24219 5.50781C7.8776 5.11719 7.4349 4.92188 6.91406 4.92188C6.39323 4.92188 5.9375 5.11719 5.54688 5.50781C5.18229 5.8724 5 6.3151 5 6.83594C5 7.35677 5.18229 7.8125 5.54688 8.20312C5.9375 8.56771 6.39323 8.75 6.91406 8.75C7.4349 8.75 7.8776 8.56771 8.24219 8.20312ZM6.44531 7.30469C6.3151 7.17448 6.25 7.01823 6.25 6.83594C6.25 6.65365 6.3151 6.4974 6.44531 6.36719C6.57552 6.23698 6.73177 6.17188 6.91406 6.17188C7.09635 6.17188 7.2526 6.23698 7.38281 6.36719C7.51302 6.4974 7.57812 6.65365 7.57812 6.83594C7.57812 7.01823 7.51302 7.17448 7.38281 7.30469C7.2526 7.4349 7.09635 7.5 6.91406 7.5C6.73177 7.5 6.57552 7.4349 6.44531 7.30469ZM14.4141 11.7578C14.0495 11.3672 13.6068 11.1719 13.0859 11.1719C12.5651 11.1719 12.1094 11.3672 11.7188 11.7578C11.3542 12.1224 11.1719 12.5651 11.1719 13.0859C11.1719 13.6068 11.3542 14.0625 11.7188 14.4531C12.1094 14.8177 12.5651 15 13.0859 15C13.6068 15 14.0495 14.8177 14.4141 14.4531C14.8047 14.0625 15 13.6068 15 13.0859C15 12.5651 14.8047 12.1224 14.4141 11.7578ZM13.5547 13.5547C13.4245 13.6849 13.2682 13.75 13.0859 13.75C12.9036 13.75 12.7474 13.6849 12.6172 13.5547C12.487 13.4245 12.4219 13.2682 12.4219 13.0859C12.4219 12.9036 12.487 12.7474 12.6172 12.6172C12.7474 12.487 12.9036 12.4219 13.0859 12.4219C13.2682 12.4219 13.4245 12.487 13.5547 12.6172C13.6849 12.7474 13.75 12.9036 13.75 13.0859C13.75 13.2682 13.6849 13.4245 13.5547 13.5547ZM14.1797 6.67969C14.4922 6.39323 14.4922 6.10677 14.1797 5.82031C13.8932 5.50781 13.6068 5.50781 13.3203 5.82031L5.82031 13.3203C5.50781 13.6068 5.50781 13.8932 5.82031 14.1797C5.92448 14.3099 6.06771 14.375 6.25 14.375C6.43229 14.375 6.57552 14.3099 6.67969 14.1797L14.1797 6.67969Z"
            }),
            viewBox: "0 0 20 20"
        },
        cross: {
            path: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M1.01541e-05 16.6154L16.6154 -1.52588e-05L18 1.3846L1.38462 18L1.01541e-05 16.6154Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M18 16.6154L1.38461 -1.52588e-05L0 1.3846L16.6154 18L18 16.6154Z",
                        fill: "currentColor"
                    })
                ]
            }),
            viewBox: "0 0 18 18"
        }
    }
};
var $90480b65d11e1162$export$2e2bcd8739ae039 = $90480b65d11e1162$export$696f6b7c51637c51;


const $6be42a1d560aa137$var$iconPaths = (0, $90480b65d11e1162$export$696f6b7c51637c51)["icons"];
const $6be42a1d560aa137$export$f04a61298a47a40f = ({ name: name, classes: propClasses, color: color, svgAttributes: svgAttributes })=>{
    // Fallback in case you pass the wrong name
    const iconFallback = $6be42a1d560aa137$var$iconPaths["search"];
    // const iconFallback = iconPaths["question-outline"];
    const path = $6be42a1d560aa137$var$iconPaths[name] == null ? iconFallback.path : $6be42a1d560aa137$var$iconPaths[name].path;
    const viewBox = ($6be42a1d560aa137$var$iconPaths[name] == null ? iconFallback.viewBox : $6be42a1d560aa137$var$iconPaths[name].viewBox) || "0 0 24 24";
    const classes = Object.assign($472ca6341614a815$exports, propClasses);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).svg, {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        className: classes.root,
        viewBox: svgAttributes?.viewBox ?? viewBox,
        color: color,
        style: {
            width: svgAttributes?.width,
            height: svgAttributes?.height
        },
        children: path
    });
};
var $6be42a1d560aa137$export$2e2bcd8739ae039 = $6be42a1d560aa137$export$f04a61298a47a40f;




function $0c1c12d856ffd7b8$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $0c1c12d856ffd7b8$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $0c1c12d856ffd7b8$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $0c1c12d856ffd7b8$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $0c1c12d856ffd7b8$export$2e2bcd8739ae039 = $0c1c12d856ffd7b8$export$4f5d2d50c9deca37;




var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
"use client";
/**
 * @internal
 */ const $4ac33986d8bd3ff5$var$SkeletonThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({});
/* eslint-disable react/no-array-index-key */ const $4ac33986d8bd3ff5$var$defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function $4ac33986d8bd3ff5$var$styleOptionsToCssProperties({ baseColor: baseColor, highlightColor: highlightColor, width: width, height: height, borderRadius: borderRadius, circle: circle, direction: direction, duration: duration, enableAnimation: enableAnimation = $4ac33986d8bd3ff5$var$defaultEnableAnimation }) {
    const style = {};
    if (direction === "rtl") style["--animation-direction"] = "reverse";
    if (typeof duration === "number") style["--animation-duration"] = `${duration}s`;
    if (!enableAnimation) style["--pseudo-element-display"] = "none";
    if (typeof width === "string" || typeof width === "number") style.width = width;
    if (typeof height === "string" || typeof height === "number") style.height = height;
    if (typeof borderRadius === "string" || typeof borderRadius === "number") style.borderRadius = borderRadius;
    if (circle) style.borderRadius = "50%";
    if (typeof baseColor !== "undefined") style["--base-color"] = baseColor;
    if (typeof highlightColor !== "undefined") style["--highlight-color"] = highlightColor;
    return style;
}
function $4ac33986d8bd3ff5$export$2e2bcd8739ae039({ count: count = 1, wrapper: Wrapper, className: customClassName, containerClassName: containerClassName, containerTestId: containerTestId, circle: circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($4ac33986d8bd3ff5$var$SkeletonThemeContext);
    const propsStyleOptions = {
        ...originalPropsStyleOptions
    };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions))if (typeof value === "undefined") delete propsStyleOptions[key];
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle: circle
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...$4ac33986d8bd3ff5$var$styleOptionsToCssProperties(styleOptions)
    };
    let className = "react-loading-skeleton";
    if (customClassName) className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for(let i = 0; i < countCeil; i++){
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : "100%"; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === "number" ? width * fractionalPart : `calc(${width} * ${fractionalPart})`;
            thisStyle = {
                ...thisStyle,
                width: fractionalWidth
            };
        }
        const skeletonSpan = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("span", {
            className: className,
            style: thisStyle,
            key: i
        }, "\u200C");
        if (inline) elements.push(skeletonSpan);
        else // Without the <br />, the skeleton lines will all run together if
        // `width` is specified
        elements.push((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, {
            key: i
        }, skeletonSpan, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("br", null)));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("span", {
        className: containerClassName,
        "data-testid": containerTestId,
        "aria-live": "polite",
        "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : $4ac33986d8bd3ff5$var$defaultEnableAnimation
    }, Wrapper ? elements.map((el, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Wrapper, {
            key: i
        }, el)) : elements);
}
function $4ac33986d8bd3ff5$export$978f2619783614a7({ children: children, ...styleOptions }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($4ac33986d8bd3ff5$var$SkeletonThemeContext.Provider, {
        value: styleOptions
    }, children);
}




const $3fe8fbdeb6c5afe6$export$bb2658b9ce41183f = (0, $3bf714f6c012ccf2$export$72e4926bf8358653)`
  query category_info($id: Int!) {
    category(id: $id) {
      id
      name
      description
      meta_title
      meta_description
      children_count
      url_path
      mobile_image
      desktop_image
      image
      thumbnail
      thumbnail_image
      collection_image
      banner_image
    }
  }
`;
const $3fe8fbdeb6c5afe6$export$bbd5292ae530dc79 = (0, $3bf714f6c012ccf2$export$72e4926bf8358653)`
  query category_info_with_children($filters: CategoryFilterInput) {
    categoryList(filters: $filters) {
      id
      name
      description
      meta_title
      meta_description
      children_count
      url_path
      mobile_image
      desktop_image
      image
      thumbnail
      thumbnail_image
      collection_image
      banner_image
      children {
        id
        name
        url_path
        thumbnail
        children {
          id
          name
          url_path
          thumbnail
          children {
            id
            name
            url_path
            thumbnail
          }
        }
      }
    }
  }
`;




var $efb0e24dc87c78a8$export$e8e78c978b129247;
var $efb0e24dc87c78a8$export$25d43f273c2fe4ba;
$efb0e24dc87c78a8$export$e8e78c978b129247 = `y4Zxna_root`;
$efb0e24dc87c78a8$export$25d43f273c2fe4ba = `y4Zxna_root_active`;


const $7d8aa723b44ed5d8$var$Mask = (props)=>{
    const { dismiss: dismiss, isActive: isActive, classes: classes, delayedDismiss: delayedDismiss } = props;
    const className = isActive ? $efb0e24dc87c78a8$export$25d43f273c2fe4ba : $efb0e24dc87c78a8$export$e8e78c978b129247;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
        className: (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)(className, classes?.["root"], {
            [classes?.["root_active"]]: isActive
        }),
        onClick: dismiss,
        onMouseOver: delayedDismiss
    });
};
var $7d8aa723b44ed5d8$export$2e2bcd8739ae039 = $7d8aa723b44ed5d8$var$Mask;



var $exYeM = parcelRequire("exYeM");

const $f8ecae7c383fef4f$var$Modal = ({ children: children, selector: selector = "#headerReactModal" })=>{
    const ref = (0, $exYeM.useRef)();
    const [mounted, setMounted] = (0, $exYeM.useState)(false);
    (0, $exYeM.useEffect)(()=>{
        ref.current = document.querySelector(selector);
        setMounted(true);
    }, [
        selector
    ]);
    return mounted ? /*#__PURE__*/ (0, $97dc602bd7e23afa$exports.createPortal)(children, ref.current) : null;
};
var $f8ecae7c383fef4f$export$2e2bcd8739ae039 = $f8ecae7c383fef4f$var$Modal;


var $8d5a3a29a3488caf$export$89da14300d534261;
var $8d5a3a29a3488caf$export$b9b83ece7e6d8cea;
var $8d5a3a29a3488caf$export$b88d0b4b6440c1e8;
var $8d5a3a29a3488caf$export$419338a72b42584d;
var $8d5a3a29a3488caf$export$7061c75fc5af8b7e;
var $8d5a3a29a3488caf$export$bff8506071621221;
var $8d5a3a29a3488caf$export$5c66d75d9e19b083;
var $8d5a3a29a3488caf$export$6ab52428572992d9;
var $8d5a3a29a3488caf$export$871bd626df29da4a;
var $8d5a3a29a3488caf$export$e8e78c978b129247;
var $8d5a3a29a3488caf$export$fb184b623420d9be;
$8d5a3a29a3488caf$export$89da14300d534261 = `EwgL9W_active`;
$8d5a3a29a3488caf$export$b9b83ece7e6d8cea = `EwgL9W_childItems`;
$8d5a3a29a3488caf$export$b88d0b4b6440c1e8 = `EwgL9W_childTitle`;
$8d5a3a29a3488caf$export$419338a72b42584d = `EwgL9W_innerGrid`;
$8d5a3a29a3488caf$export$7061c75fc5af8b7e = `EwgL9W_item`;
$8d5a3a29a3488caf$export$bff8506071621221 = `EwgL9W_leftArea`;
$8d5a3a29a3488caf$export$5c66d75d9e19b083 = `EwgL9W_leftAreaContent`;
$8d5a3a29a3488caf$export$6ab52428572992d9 = `EwgL9W_maskRoot`;
$8d5a3a29a3488caf$export$871bd626df29da4a = `EwgL9W_rightArea`;
$8d5a3a29a3488caf$export$e8e78c978b129247 = `EwgL9W_root`;
$8d5a3a29a3488caf$export$fb184b623420d9be = `EwgL9W_title`;



var $5fdb903257ba77d0$exports = {};

$5fdb903257ba77d0$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "watch.9e64888e.png";




var $exYeM = parcelRequire("exYeM");



const $7c2827959544e1e1$var$absoluteUrl = /^(data|http|https)?:/i;
const $7c2827959544e1e1$export$a1cbf2de32a9fd1 = (url)=>{
    return $7c2827959544e1e1$var$absoluteUrl.test(url);
};
const $7c2827959544e1e1$export$429e4cc9a68d284e = new Map().set("image-product", "catalog/product/").set("image-category", "catalog/category/").set("image-swatch", "attribute/swatch/");
const $7c2827959544e1e1$export$84414c9c11221c8a = new Map().set("image-cms", "");
const $7c2827959544e1e1$var$joinUrls = (base, url)=>(base.endsWith("/") ? base.slice(0, -1) : base) + "/" + (url.startsWith("/") ? url.slice(1) : url);
const $7c2827959544e1e1$var$magentoBackendURL = "https://shop.curnonwatch.com";
const $7c2827959544e1e1$var$mediaBackend = $7c2827959544e1e1$var$magentoBackendURL + "/media/";
const $7c2827959544e1e1$var$cmsBackend = "https://cms.curnonwatch.com";
const $7c2827959544e1e1$export$f8724ced1fbb64f2 = (options)=>{
    const { type: type = "image-product", src: src } = options;
    if (!src) return undefined;
    let baseURL = new URL(src, $7c2827959544e1e1$var$mediaBackend);
    //abs image always no processing
    if ($7c2827959544e1e1$export$a1cbf2de32a9fd1(src)) return src;
    // this is magento based
    if ($7c2827959544e1e1$export$429e4cc9a68d284e.has(type)) {
        const mediaBase = $7c2827959544e1e1$export$429e4cc9a68d284e.get(type);
        if (!baseURL.pathname.includes(mediaBase)) baseURL = new URL($7c2827959544e1e1$var$joinUrls(mediaBase, src), $7c2827959544e1e1$var$mediaBackend);
        const finalUrl = baseURL;
        return finalUrl.toString();
    }
    //this is cms based
    if ($7c2827959544e1e1$export$84414c9c11221c8a.has(type)) {
        const finalUrl = new URL(src, $7c2827959544e1e1$var$cmsBackend);
        return finalUrl.toString();
    }
    //default
    return src;
};





const $43a0856f8016f743$export$7e4d0770b0113ed4 = ({ id: id, title: title, classes: classes, children: children })=>{
    const [{ data: data, fetching: fetching }] = (0, $4806a602ceddc868$export$dd0a697e1782aedd)({
        query: (0, $3fe8fbdeb6c5afe6$export$bb2658b9ce41183f),
        variables: {
            id: id
        }
    });
    if (!data?.category.url_path || fetching) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
        href: "/" + data?.category.url_path,
        className: classes?.root,
        style: {
            textDecoration: "none"
        },
        children: children ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
            children: children
        }) : title ?? data?.category.name
    });
};



var $f82af69775f689de$export$f2120bbfa5450bd2;
var $f82af69775f689de$export$a7db06668cad9adb;
var $f82af69775f689de$export$9624302a33c1c6cb;
var $f82af69775f689de$export$6d59db4903f20f7d;
var $f82af69775f689de$export$7061c75fc5af8b7e;
var $f82af69775f689de$export$cfafda1a15ffa66;
var $f82af69775f689de$export$17a270f97ecda204;
var $f82af69775f689de$export$2d0ef6f7fa516e6d;
var $f82af69775f689de$export$18bae24d94309fb6;
var $f82af69775f689de$export$b945baa4ebaf1f5c;
var $f82af69775f689de$export$c96745152eb2740f;
var $f82af69775f689de$export$aa99a51fa6e62ef3;
var $f82af69775f689de$export$e77609e6ef08541e;
var $f82af69775f689de$export$fb184b623420d9be;
$f82af69775f689de$export$f2120bbfa5450bd2 = `k_OZrq_arrow`;
$f82af69775f689de$export$a7db06668cad9adb = `k_OZrq_content`;
$f82af69775f689de$export$9624302a33c1c6cb = `k_OZrq_ctaButton`;
$f82af69775f689de$export$6d59db4903f20f7d = `k_OZrq_description`;
$f82af69775f689de$export$7061c75fc5af8b7e = `k_OZrq_item`;
$f82af69775f689de$export$cfafda1a15ffa66 = `k_OZrq_itemFullHeight`;
$f82af69775f689de$export$17a270f97ecda204 = `k_OZrq_rootVertical`;
$f82af69775f689de$export$2d0ef6f7fa516e6d = `k_OZrq_rootWithChildren`;
$f82af69775f689de$export$18bae24d94309fb6 = `k_OZrq_rootWithoutChildren`;
$f82af69775f689de$export$b945baa4ebaf1f5c = `k_OZrq_showAllText`;
$f82af69775f689de$export$c96745152eb2740f = `k_OZrq_subtitle`;
$f82af69775f689de$export$aa99a51fa6e62ef3 = `k_OZrq_textLink`;
$f82af69775f689de$export$e77609e6ef08541e = `k_OZrq_thumbnail`;
$f82af69775f689de$export$fb184b623420d9be = `k_OZrq_title`;



var $5NGut = parcelRequire("5NGut");
var $405a4fa4811a9356$exports = {};
"use strict";
var $7e0acac94e75c14b$exports = {};
"use strict";
var $7e0acac94e75c14b$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var $7e0acac94e75c14b$var$createStore = function createStore(createState) {
    return createState ? $7e0acac94e75c14b$var$createStoreImpl(createState) : $7e0acac94e75c14b$var$createStoreImpl;
};
var $7e0acac94e75c14b$var$vanilla = function(createState) {
    return $7e0acac94e75c14b$var$createStore(createState);
};
$7e0acac94e75c14b$exports.createStore = $7e0acac94e75c14b$var$createStore;
$7e0acac94e75c14b$exports.default = $7e0acac94e75c14b$var$vanilla;
$7e0acac94e75c14b$exports = $7e0acac94e75c14b$var$vanilla;
$7e0acac94e75c14b$exports.createStore = $7e0acac94e75c14b$var$createStore;
$7e0acac94e75c14b$exports.default = $7e0acac94e75c14b$exports;



var $exYeM = parcelRequire("exYeM");
var $e0448e6874efea69$exports = {};
"use strict";

$e0448e6874efea69$exports = (parcelRequire("eXtb5"));


var $405a4fa4811a9356$var$useDebugValue = $exYeM.useDebugValue;
var $405a4fa4811a9356$var$useSyncExternalStoreWithSelector = $e0448e6874efea69$exports.useSyncExternalStoreWithSelector;
var $405a4fa4811a9356$var$didWarnAboutEqualityFn = false;
var $405a4fa4811a9356$var$identity = function identity(arg) {
    return arg;
};
function $405a4fa4811a9356$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = $405a4fa4811a9356$var$identity;
    var slice = $405a4fa4811a9356$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $405a4fa4811a9356$var$useDebugValue(slice);
    return slice;
}
var $405a4fa4811a9356$var$createImpl = function createImpl(createState) {
    var api = typeof createState === "function" ? $7e0acac94e75c14b$exports.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $405a4fa4811a9356$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $405a4fa4811a9356$var$create = function create(createState) {
    return createState ? $405a4fa4811a9356$var$createImpl(createState) : $405a4fa4811a9356$var$createImpl;
};
var $405a4fa4811a9356$var$react = function(createState) {
    return $405a4fa4811a9356$var$create(createState);
};
$405a4fa4811a9356$exports.create = $405a4fa4811a9356$var$create;
$405a4fa4811a9356$exports.default = $405a4fa4811a9356$var$react;
$405a4fa4811a9356$exports.useStore = $405a4fa4811a9356$var$useStore;
Object.keys($7e0acac94e75c14b$exports).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call($405a4fa4811a9356$exports, k)) Object.defineProperty($405a4fa4811a9356$exports, k, {
        enumerable: true,
        get: function() {
            return $7e0acac94e75c14b$exports[k];
        }
    });
});
$405a4fa4811a9356$exports = $405a4fa4811a9356$var$react;
$405a4fa4811a9356$exports.create = $405a4fa4811a9356$var$create;
$405a4fa4811a9356$exports.useStore = $405a4fa4811a9356$var$useStore;
$405a4fa4811a9356$exports.createStore = $7e0acac94e75c14b$exports.createStore;
$405a4fa4811a9356$exports.default = $405a4fa4811a9356$exports;


const $4e5e91614e1ce727$export$b7680113a886673e = (0, (/*@__PURE__*/$parcel$interopDefault($405a4fa4811a9356$exports)))()((set)=>({
        isDarkTheme: false,
        isLoading: false,
        modal: "none",
        headerSpacing: 0,
        headerColorInverted: false,
        showHeadlineBanner: 2,
        setModal: (name)=>set((0, $5NGut.default)((state)=>{
                state.modal = name;
            }))
    }));


const $06675fbcbb786293$var$MenuItem = ({ item: item })=>{
    const categoryId = item.CategoryId;
    const [{ data: data, error: error }] = (0, $4806a602ceddc868$export$dd0a697e1782aedd)({
        query: (0, $3fe8fbdeb6c5afe6$export$bb2658b9ce41183f),
        variables: {
            id: categoryId
        }
    });
    const itemImage = item?.Image?.url;
    const categoryImage = data?.category?.thumbnail_image;
    const targetLink = data?.category?.url_path;
    const setShowMenu = (0, $4e5e91614e1ce727$export$b7680113a886673e)((state)=>state.setModal);
    const closeModal = (0, $exYeM.useCallback)(()=>setShowMenu("none"), []);
    if (!targetLink) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("a", {
        href: "#",
        className: $f82af69775f689de$export$7061c75fc5af8b7e,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: $f82af69775f689de$export$e77609e6ef08541e,
                children: "Loading..."
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: $f82af69775f689de$export$fb184b623420d9be,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $4ac33986d8bd3ff5$export$2e2bcd8739ae039), {
                    width: 100
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("a", {
        href: `/${targetLink}`,
        className: $f82af69775f689de$export$7061c75fc5af8b7e,
        onClick: closeModal,
        children: [
            itemImage ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                className: $f82af69775f689de$export$e77609e6ef08541e,
                src: (0, $7c2827959544e1e1$export$f8724ced1fbb64f2)({
                    src: itemImage,
                    type: "image-cms"
                }),
                // loader={resolveImageCDN({ type: 'image-cms', aspectRatio: 1 })}
                alt: "thumbnail",
                width: 100,
                height: 100
            }) : categoryImage ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                className: $f82af69775f689de$export$e77609e6ef08541e,
                src: (0, $7c2827959544e1e1$export$f8724ced1fbb64f2)({
                    src: categoryImage,
                    type: "image-category"
                }),
                alt: "thumbnail",
                width: 100,
                height: 100
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                className: $f82af69775f689de$export$e77609e6ef08541e,
                src: (0, (/*@__PURE__*/$parcel$interopDefault($5fdb903257ba77d0$exports))).src,
                alt: "thumbnail",
                width: 100,
                height: 100
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: $f82af69775f689de$export$fb184b623420d9be,
                children: item.Title
            })
        ]
    }, item.id);
};
const $06675fbcbb786293$var$MenuItemLink = ({ item: item, isFullHeight: isFullHeight })=>{
    const categoryId = item.CategoryId;
    const [{ data: data, error: error }] = (0, $4806a602ceddc868$export$dd0a697e1782aedd)({
        query: (0, $3fe8fbdeb6c5afe6$export$bb2658b9ce41183f),
        variables: {
            id: categoryId
        }
    });
    const setShowMenu = (0, $4e5e91614e1ce727$export$b7680113a886673e)((state)=>state.setModal);
    const closeModal = (0, $exYeM.useCallback)(()=>setShowMenu("none"), []);
    const targetLink = data?.category?.url_path;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
        href: `/${targetLink}`,
        className: (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)($f82af69775f689de$export$7061c75fc5af8b7e, {
            [$f82af69775f689de$export$cfafda1a15ffa66]: isFullHeight
        }),
        onClick: closeModal,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
            className: $f82af69775f689de$export$aa99a51fa6e62ef3,
            style: {
                background: "transparent"
            },
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                    className: $f82af69775f689de$export$b945baa4ebaf1f5c,
                    children: "XEM T\u1EA4T C\u1EA2"
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6be42a1d560aa137$export$f04a61298a47a40f), {
                    classes: {
                        root: $f82af69775f689de$export$f2120bbfa5450bd2
                    },
                    name: "line_right"
                })
            ]
        })
    }, item.id);
};
const $06675fbcbb786293$var$DesktopMenuRightLayoutForChildren = ({ items: items, parentItem: parentItem })=>{
    const shouldVertical = items.length % 2 == 0 && items.length < 5;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)($f82af69775f689de$export$2d0ef6f7fa516e6d, {
            [$f82af69775f689de$export$17a270f97ecda204]: shouldVertical
        }),
        children: [
            items.map((item)=>{
                return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($06675fbcbb786293$var$MenuItem, {
                    item: item
                }, item.id);
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($06675fbcbb786293$var$MenuItemLink, {
                item: parentItem,
                isFullHeight: shouldVertical
            }, "show_all_item")
        ]
    });
};
const $06675fbcbb786293$var$DesktopMenuRightLayoutForNoChildren = ({ parentItem: parentItem })=>{
    const setShowMenu = (0, $4e5e91614e1ce727$export$b7680113a886673e)((state)=>state.setModal);
    const closeModal = (0, $exYeM.useCallback)(()=>setShowMenu("none"), []);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: $f82af69775f689de$export$18bae24d94309fb6,
        children: [
            parentItem?.Image?.url ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                src: (0, $7c2827959544e1e1$export$f8724ced1fbb64f2)({
                    type: "image-cms",
                    src: parentItem?.Image?.url
                }),
                // loader={resolveImageCDN({ type: 'image-cms', aspectRatio: 1 })}
                className: $f82af69775f689de$export$e77609e6ef08541e,
                width: 270,
                height: 270
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                className: $f82af69775f689de$export$e77609e6ef08541e,
                src: (0, (/*@__PURE__*/$parcel$interopDefault($5fdb903257ba77d0$exports))).src,
                // loader={resolveImageCDN({ type: 'image-category', aspectRatio: 1 })}
                alt: "thumbnail",
                width: 270,
                height: 270
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: $f82af69775f689de$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: $f82af69775f689de$export$c96745152eb2740f,
                                children: parentItem.Subtitle
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: $f82af69775f689de$export$6d59db4903f20f7d,
                                children: parentItem.Description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $43a0856f8016f743$export$7e4d0770b0113ed4), {
                            title: parentItem.ButtonTitle,
                            classes: {
                                root: $f82af69775f689de$export$9624302a33c1c6cb
                            },
                            id: parentItem.CategoryId,
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                className: $f82af69775f689de$export$9624302a33c1c6cb,
                                onClick: closeModal,
                                children: parentItem.ButtonTitle
                            })
                        })
                    })
                ]
            })
        ]
    });
};
const $06675fbcbb786293$export$7dee693bbad8158 = (props)=>{
    const { item: item } = props;
    const activeItemNonDirectChildren = item.menu_children.filter((el)=>el.Visible).filter((el)=>!el.ShowUnderParent).sort((a, b)=>a.RelativePosition - b.RelativePosition);
    return activeItemNonDirectChildren.length > 0 ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($06675fbcbb786293$var$DesktopMenuRightLayoutForChildren, {
        parentItem: item,
        items: activeItemNonDirectChildren
    }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($06675fbcbb786293$var$DesktopMenuRightLayoutForNoChildren, {
        parentItem: item
    });
};


const $1a23cb15f08d9c60$var$DesktopMenuLeft = ({ item: item, setActiveItem: setActiveItem })=>{
    const [{ data: data, fetching: fetching }] = (0, $4806a602ceddc868$export$dd0a697e1782aedd)({
        query: (0, $3fe8fbdeb6c5afe6$export$bb2658b9ce41183f),
        variables: {
            id: item.CategoryId
        }
    });
    if (!data) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
        className: $8d5a3a29a3488caf$export$fb184b623420d9be,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $4ac33986d8bd3ff5$export$2e2bcd8739ae039), {
            width: 150,
            height: 40
        })
    });
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
        href: `/${data?.category?.url_path}`,
        className: $8d5a3a29a3488caf$export$fb184b623420d9be,
        onKeyPress: ()=>{
            setActiveItem(item);
        },
        onMouseOver: ()=>{
            setActiveItem(item);
        },
        children: item.Title
    });
};
const $1a23cb15f08d9c60$var$ChildItem = ({ item: item })=>{
    const categoryId = item.CategoryId;
    const [{ data: data, error: error }] = (0, $4806a602ceddc868$export$dd0a697e1782aedd)({
        query: (0, $3fe8fbdeb6c5afe6$export$bb2658b9ce41183f),
        variables: {
            id: categoryId
        }
    });
    const targetLink = data?.category?.url_path;
    if (!targetLink) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
        href: "#",
        className: $8d5a3a29a3488caf$export$b88d0b4b6440c1e8,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $4ac33986d8bd3ff5$export$2e2bcd8739ae039), {
            width: 100
        })
    });
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
        href: `/${targetLink}`,
        className: $8d5a3a29a3488caf$export$b88d0b4b6440c1e8,
        children: item.Title
    }, item.id);
};
const $1a23cb15f08d9c60$export$bf111c537646a397 = (props)=>{
    const { menuData: menuData, isOpen: isOpen, closeModal: closeModal, dimensions: dimensions } = props;
    const [activeItem, setActiveItem] = (0, $exYeM.useState)();
    (0, $exYeM.useEffect)(()=>{
        setActiveItem(menuData.find((el)=>true));
    }, [
        menuData
    ]);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $f8ecae7c383fef4f$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                initial: {
                    height: 0,
                    opacity: 0
                },
                style: {
                    translateY: dimensions.bottom
                },
                variants: {
                    open: {
                        opacity: 1,
                        height: "auto"
                    },
                    closed: {
                        height: 0,
                        zIndex: -1,
                        transition: {
                            delay: 0.5
                        }
                    }
                },
                transition: {
                    ease: "easeIn"
                },
                className: $8d5a3a29a3488caf$export$e8e78c978b129247,
                animate: isOpen ? "open" : "closed",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                    className: $8d5a3a29a3488caf$export$419338a72b42584d,
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: $8d5a3a29a3488caf$export$bff8506071621221,
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: $8d5a3a29a3488caf$export$5c66d75d9e19b083,
                                children: menuData.filter((el)=>el.Visible).sort((a, b)=>a.RelativePosition - b.RelativePosition).map((menuItem)=>{
                                    const directChildren = menuItem.menu_children.filter((el2)=>el2.ShowUnderParent);
                                    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                        className: (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)($8d5a3a29a3488caf$export$7061c75fc5af8b7e, {
                                            [$8d5a3a29a3488caf$export$89da14300d534261]: activeItem?.id == menuItem.id
                                        }),
                                        "data-position": menuItem.RelativePosition,
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($1a23cb15f08d9c60$var$DesktopMenuLeft, {
                                                item: menuItem,
                                                setActiveItem: setActiveItem
                                            }),
                                            directChildren.length > 0 && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                className: $8d5a3a29a3488caf$export$b9b83ece7e6d8cea,
                                                children: directChildren.map((childItem)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($1a23cb15f08d9c60$var$ChildItem, {
                                                        item: childItem
                                                    }, childItem.id))
                                            })
                                        ]
                                    }, menuItem.id);
                                })
                            })
                        }),
                        activeItem && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                            initial: {
                                translateX: 5
                            },
                            animate: {
                                translateX: 0
                            },
                            transition: {
                                duration: 0.3
                            },
                            className: $8d5a3a29a3488caf$export$871bd626df29da4a,
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $06675fbcbb786293$export$7dee693bbad8158), {
                                item: activeItem
                            })
                        }, activeItem.id)
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7d8aa723b44ed5d8$export$2e2bcd8739ae039), {
                isActive: isOpen,
                classes: {
                    root: $8d5a3a29a3488caf$export$6ab52428572992d9
                },
                dismiss: ()=>{
                    closeModal();
                },
                delayedDismiss: ()=>{
                    setTimeout(()=>closeModal(), 350);
                }
            })
        ]
    });
};









var $exYeM = parcelRequire("exYeM");

var $a2c866a284344527$export$2a30d4504c8f5508;
var $a2c866a284344527$export$58c415f8b0eba7af;
var $a2c866a284344527$export$32180ef41b15b513;
var $a2c866a284344527$export$6d0f696456f5be95;
var $a2c866a284344527$export$35f4bb96a8126157;
var $a2c866a284344527$export$67922b06d50e9541;
var $a2c866a284344527$export$807a8e99cc9df581;
var $a2c866a284344527$export$eadc11cc729d90b3;
var $a2c866a284344527$export$a1386e5a0e99f154;
var $a2c866a284344527$export$6cb9466bd0eb4435;
var $a2c866a284344527$export$95ba6cd3098caf0a;
var $a2c866a284344527$export$81b65898cd034378;
var $a2c866a284344527$export$f9f47db273b1c86b;
var $a2c866a284344527$export$4e216048b6088f27;
var $a2c866a284344527$export$6ab52428572992d9;
var $a2c866a284344527$export$c442028fb4460674;
var $a2c866a284344527$export$a5bb2f442e807f9f;
var $a2c866a284344527$export$6cad266addae4346;
var $a2c866a284344527$export$19c2927c65bea31c;
var $a2c866a284344527$export$e367b3913fcb235e;
var $a2c866a284344527$export$b74a11cf10f01166;
var $a2c866a284344527$export$da1e0d5c6f5ed6c;
var $a2c866a284344527$export$f1b4679c105f0066;
var $a2c866a284344527$export$c176f998e71d0f08;
var $a2c866a284344527$export$4cdaeb5d35bab933;
var $a2c866a284344527$export$f7afe837a1791aa6;
var $a2c866a284344527$export$1d63f9bbe96d8dad;
var $a2c866a284344527$export$c60b6f34463a64a4;
var $a2c866a284344527$export$e8e78c978b129247;
$a2c866a284344527$export$2a30d4504c8f5508 = `wqrp3a_activeItem`;
$a2c866a284344527$export$58c415f8b0eba7af = `wqrp3a_backBtn`;
$a2c866a284344527$export$32180ef41b15b513 = `wqrp3a_body`;
$a2c866a284344527$export$6d0f696456f5be95 = `wqrp3a_bottomNav`;
$a2c866a284344527$export$35f4bb96a8126157 = `wqrp3a_bottomNavItem`;
$a2c866a284344527$export$67922b06d50e9541 = `wqrp3a_bottomNavItemList`;
$a2c866a284344527$export$807a8e99cc9df581 = `wqrp3a_bottomNavItemListChild`;
$a2c866a284344527$export$eadc11cc729d90b3 = `wqrp3a_bottomNavTitle`;
$a2c866a284344527$export$a1386e5a0e99f154 = `wqrp3a_bottomNavVerticalLine`;
$a2c866a284344527$export$6cb9466bd0eb4435 = `wqrp3a_closeBtn`;
$a2c866a284344527$export$95ba6cd3098caf0a = `wqrp3a_headerItem`;
$a2c866a284344527$export$81b65898cd034378 = `wqrp3a_headerSpacer`;
$a2c866a284344527$export$f9f47db273b1c86b = `wqrp3a_hlIcon`;
$a2c866a284344527$export$4e216048b6088f27 = `wqrp3a_iconleft`;
$a2c866a284344527$export$6ab52428572992d9 = `wqrp3a_maskRoot`;
$a2c866a284344527$export$c442028fb4460674 = `wqrp3a_maskRootActive`;
$a2c866a284344527$export$a5bb2f442e807f9f = `wqrp3a_menuBody`;
$a2c866a284344527$export$6cad266addae4346 = `wqrp3a_menuBodyLeaf`;
$a2c866a284344527$export$19c2927c65bea31c = `wqrp3a_menuChildItem`;
$a2c866a284344527$export$e367b3913fcb235e = `wqrp3a_menuChildren`;
$a2c866a284344527$export$b74a11cf10f01166 = `wqrp3a_menuFooter`;
$a2c866a284344527$export$da1e0d5c6f5ed6c = `wqrp3a_menuFooterBtn`;
$a2c866a284344527$export$f1b4679c105f0066 = `wqrp3a_menuHeader`;
$a2c866a284344527$export$c176f998e71d0f08 = `wqrp3a_menuItem`;
$a2c866a284344527$export$4cdaeb5d35bab933 = `wqrp3a_menuItemIconRight`;
$a2c866a284344527$export$f7afe837a1791aa6 = `wqrp3a_menuItemTitle`;
$a2c866a284344527$export$1d63f9bbe96d8dad = `wqrp3a_menuRightIcon`;
$a2c866a284344527$export$c60b6f34463a64a4 = `wqrp3a_menuSpacer`;
$a2c866a284344527$export$e8e78c978b129247 = `wqrp3a_root`;




var $exYeM = parcelRequire("exYeM");



var $98f9ac58ba1b183d$export$a7db06668cad9adb;
var $98f9ac58ba1b183d$export$9624302a33c1c6cb;
var $98f9ac58ba1b183d$export$6d59db4903f20f7d;
var $98f9ac58ba1b183d$export$adb608be33961c98;
var $98f9ac58ba1b183d$export$7061c75fc5af8b7e;
var $98f9ac58ba1b183d$export$2d0ef6f7fa516e6d;
var $98f9ac58ba1b183d$export$18bae24d94309fb6;
var $98f9ac58ba1b183d$export$c96745152eb2740f;
var $98f9ac58ba1b183d$export$e77609e6ef08541e;
var $98f9ac58ba1b183d$export$fb184b623420d9be;
$98f9ac58ba1b183d$export$a7db06668cad9adb = `RXwqRa_content`;
$98f9ac58ba1b183d$export$9624302a33c1c6cb = `RXwqRa_ctaButton`;
$98f9ac58ba1b183d$export$6d59db4903f20f7d = `RXwqRa_description`;
$98f9ac58ba1b183d$export$adb608be33961c98 = `RXwqRa_footer`;
$98f9ac58ba1b183d$export$7061c75fc5af8b7e = `RXwqRa_item`;
$98f9ac58ba1b183d$export$2d0ef6f7fa516e6d = `RXwqRa_rootWithChildren`;
$98f9ac58ba1b183d$export$18bae24d94309fb6 = `RXwqRa_rootWithoutChildren`;
$98f9ac58ba1b183d$export$c96745152eb2740f = `RXwqRa_subtitle`;
$98f9ac58ba1b183d$export$e77609e6ef08541e = `RXwqRa_thumbnail`;
$98f9ac58ba1b183d$export$fb184b623420d9be = `RXwqRa_title`;






const $ce1bda0ff99cbe48$var$MenuItem = ({ item: item })=>{
    const categoryId = item.CategoryId;
    const setShowMenu = (0, $4e5e91614e1ce727$export$b7680113a886673e)((state)=>state.setModal);
    const closeModal = (0, $exYeM.useCallback)(()=>setShowMenu("none"), []);
    const [{ data: data, error: error }] = (0, $4806a602ceddc868$export$dd0a697e1782aedd)({
        query: (0, $3fe8fbdeb6c5afe6$export$bb2658b9ce41183f),
        variables: {
            id: categoryId
        }
    });
    const itemImage = item?.Image?.url;
    const categoryImage = data?.category?.thumbnail_image;
    const targetLink = data?.category?.url_path;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).a, {
        href: `/${targetLink}`,
        className: $98f9ac58ba1b183d$export$7061c75fc5af8b7e,
        initial: {
            translateY: 10,
            opacity: 0
        },
        animate: {
            translateY: 0,
            opacity: 1
        },
        onClick: closeModal,
        children: [
            itemImage ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                className: $98f9ac58ba1b183d$export$e77609e6ef08541e,
                src: (0, $7c2827959544e1e1$export$f8724ced1fbb64f2)({
                    src: itemImage,
                    type: "image-cms"
                }),
                // loader={resolveImageCDN({ type: 'image-cms', aspectRatio: 1 })}
                alt: "thumbnail",
                width: 100,
                height: 100
            }) : categoryImage ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                className: $98f9ac58ba1b183d$export$e77609e6ef08541e,
                src: (0, $7c2827959544e1e1$export$f8724ced1fbb64f2)({
                    src: categoryImage,
                    type: "image-category"
                }),
                // loader={resolveImageCDN({ type: 'image-category', aspectRatio: 1 })}
                alt: "thumbnail",
                width: 100,
                height: 100
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                className: $98f9ac58ba1b183d$export$e77609e6ef08541e,
                src: (0, (/*@__PURE__*/$parcel$interopDefault($5fdb903257ba77d0$exports))).src,
                // loader={resolveImageCDN({ type: 'image-category', aspectRatio: 1 })}
                alt: "thumbnail",
                width: 100,
                height: 100
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: $98f9ac58ba1b183d$export$fb184b623420d9be,
                children: item.Title
            })
        ]
    }, item.id);
};
const $ce1bda0ff99cbe48$var$MobileMenuLeafLayoutForChildren = ({ items: items })=>{
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        className: $98f9ac58ba1b183d$export$2d0ef6f7fa516e6d,
        children: items.map((item)=>{
            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($ce1bda0ff99cbe48$var$MenuItem, {
                item: item
            }, item.id);
        })
    });
};
const $ce1bda0ff99cbe48$var$MobileMenuLeafLayoutForNoChildren = ({ parentItem: parentItem })=>{
    const setShowMenu = (0, $4e5e91614e1ce727$export$b7680113a886673e)((state)=>state.setModal);
    const closeModal = (0, $exYeM.useCallback)(()=>setShowMenu("none"), []);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: $98f9ac58ba1b183d$export$18bae24d94309fb6,
        children: [
            parentItem?.Image?.url ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                src: (0, $7c2827959544e1e1$export$f8724ced1fbb64f2)({
                    type: "image-cms",
                    src: parentItem?.Image?.url
                }),
                // loader={resolveImageCDN({ type: 'image-cms', aspectRatio: 1 })}
                className: $98f9ac58ba1b183d$export$e77609e6ef08541e,
                width: 800,
                height: 800
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                className: $98f9ac58ba1b183d$export$e77609e6ef08541e,
                src: (0, (/*@__PURE__*/$parcel$interopDefault($5fdb903257ba77d0$exports))).src,
                // loader={resolveImageCDN({ type: 'image-category', aspectRatio: 1 })}
                alt: "thumbnail",
                width: 800,
                height: 800
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: $98f9ac58ba1b183d$export$a7db06668cad9adb,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: $98f9ac58ba1b183d$export$6d59db4903f20f7d,
                            children: parentItem.Description
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: $98f9ac58ba1b183d$export$c96745152eb2740f,
                            children: parentItem.Subtitle
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: $98f9ac58ba1b183d$export$adb608be33961c98,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $43a0856f8016f743$export$7e4d0770b0113ed4), {
                    title: parentItem.ButtonTitle,
                    classes: {
                        root: $98f9ac58ba1b183d$export$9624302a33c1c6cb
                    },
                    id: parentItem.CategoryId,
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                        className: $98f9ac58ba1b183d$export$9624302a33c1c6cb,
                        onClick: closeModal,
                        children: parentItem.ButtonTitle
                    })
                })
            })
        ]
    });
};
const $ce1bda0ff99cbe48$export$73ad77d5e39b277e = (props)=>{
    const { item: item } = props;
    const activeItemNonDirectChildren = item.menu_children.filter((el)=>el.Visible).filter((el)=>!el.ShowUnderParent).sort((a, b)=>a.RelativePosition - b.RelativePosition);
    return activeItemNonDirectChildren.length > 0 ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($ce1bda0ff99cbe48$var$MobileMenuLeafLayoutForChildren, {
        items: activeItemNonDirectChildren
    }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($ce1bda0ff99cbe48$var$MobileMenuLeafLayoutForNoChildren, {
        parentItem: item
    });
};


var $3806be31bbf36be3$exports = {};

$3806be31bbf36be3$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "highlight.eff4b317.svg";


const $de52307164c2185d$var$HlIcon = new URL($3806be31bbf36be3$exports);
var $eac97693b820ca3b$exports = {};

$eac97693b820ca3b$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "logo.81b4b7c3.svg";


const $de52307164c2185d$var$LogoIcon = new URL($eac97693b820ca3b$exports);
var $02db56a088fcdbab$exports = {};

$02db56a088fcdbab$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "services.04fb93c3.svg";


const $de52307164c2185d$var$ServicesIcon = new URL($02db56a088fcdbab$exports);
var $779b6898f54069e1$exports = {};

$779b6898f54069e1$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "expand.b814e1a1.svg";


const $de52307164c2185d$var$ExpandIcon = new URL($779b6898f54069e1$exports);
var $a9268982acdfd1b3$exports = {};

$a9268982acdfd1b3$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "collapse.22701181.svg";


const $de52307164c2185d$var$CollapseIcon = new URL($a9268982acdfd1b3$exports);
//animation
const $de52307164c2185d$var$containerAnimationVariants = {
    hidden: {
        opacity: 0
    },
    show: {
        opacity: 1,
        transition: {
            staggerChildren: 0.1
        }
    }
};
const $de52307164c2185d$var$listItemAnimationVariants = {
    hidden: {
        translateX: -10,
        opacity: 0
    },
    show: {
        translateX: 0,
        opacity: 1
    }
};
const $de52307164c2185d$export$7ad61323933e01cb = (props)=>{
    const { menuData: menuData, isOpen: isOpen, closeModal: closeModal } = props;
    // useLockBodyScroll({ state: isOpen })
    const [tabIndex, setTabIndex] = (0, $exYeM.useState)("men");
    const [activeItem, setActiveItem] = (0, $exYeM.useState)();
    const [aboutCurnonExpanded, setAboutCurnonExpanded] = (0, $exYeM.useState)(false); //default to hide
    const currentMenuData = (0, $exYeM.useMemo)(()=>{
        if (!menuData) return false;
        if (tabIndex == "men") return menuData.MenMenu;
        return menuData.WomenMenu;
    }, [
        menuData,
        tabIndex
    ]);
    if (!currentMenuData) return null;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $f8ecae7c383fef4f$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                initial: {
                    translateX: "-100vw",
                    opacity: 0
                },
                variants: {
                    open: {
                        translateX: 0,
                        opacity: 1
                    },
                    closed: {
                        translateX: "-100vw",
                        opacity: 0
                    }
                },
                transition: {
                    ease: "easeIn"
                },
                className: $a2c866a284344527$export$e8e78c978b129247,
                animate: isOpen ? "open" : "closed",
                children: [
                    activeItem == undefined && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                        className: $a2c866a284344527$export$32180ef41b15b513,
                        layoutId: "menu_body",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: $a2c866a284344527$export$f1b4679c105f0066,
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                        className: (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)($a2c866a284344527$export$95ba6cd3098caf0a),
                                        onClick: ()=>{
                                            setTabIndex("men");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {}),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                                children: "NAM GI\u1EDAI"
                                            }),
                                            tabIndex == "men" && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).img, {
                                                layoutId: "bottomHl2",
                                                className: $a2c866a284344527$export$f9f47db273b1c86b,
                                                alt: "hl",
                                                src: $de52307164c2185d$var$HlIcon.toString()
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                        className: $a2c866a284344527$export$81b65898cd034378
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                        className: (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)($a2c866a284344527$export$95ba6cd3098caf0a),
                                        onClick: ()=>{
                                            setTabIndex("women");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {}),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                                children: "N\u1EEE GI\u1EDAI"
                                            }),
                                            tabIndex == "women" && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).img, {
                                                layoutId: "bottomHl2",
                                                className: $a2c866a284344527$export$f9f47db273b1c86b,
                                                alt: "hl",
                                                src: $de52307164c2185d$var$HlIcon.toString()
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: $a2c866a284344527$export$c60b6f34463a64a4,
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                                    style: {
                                        width: "50%",
                                        height: 2,
                                        background: "#000",
                                        translateY: -1
                                    },
                                    variants: {
                                        left: {
                                            translateX: 0
                                        },
                                        right: {
                                            translateX: "100%"
                                        }
                                    },
                                    animate: tabIndex == "men" ? "left" : "right",
                                    transition: {
                                        type: "ease",
                                        duration: 0.4
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                                // variants={containerAnimationVariants}
                                // initial="hidden"
                                // animate="show"
                                className: $a2c866a284344527$export$a5bb2f442e807f9f,
                                children: [
                                    currentMenuData.items.filter((el)=>el.Visible).sort((a, b)=>a.RelativePosition - b.RelativePosition).map((menuItem)=>{
                                        const directChildren = menuItem.menu_children.filter((el2)=>el2.ShowUnderParent);
                                        return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                                            className: $a2c866a284344527$export$c176f998e71d0f08,
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                                                    className: $a2c866a284344527$export$f7afe837a1791aa6,
                                                    onClick: ()=>{
                                                        setActiveItem(menuItem);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).span, {
                                                            layoutId: "menuItemTitle_" + menuItem.id,
                                                            children: menuItem.Title
                                                        }),
                                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6be42a1d560aa137$export$f04a61298a47a40f), {
                                                            name: "right",
                                                            classes: {
                                                                root: $a2c866a284344527$export$1d63f9bbe96d8dad
                                                            }
                                                        })
                                                    ]
                                                }),
                                                directChildren.length > 0 && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                    className: $a2c866a284344527$export$e367b3913fcb235e,
                                                    children: directChildren.map((childItem)=>{
                                                        return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                            className: $a2c866a284344527$export$19c2927c65bea31c,
                                                            children: childItem.Title
                                                        }, childItem.id);
                                                    })
                                                })
                                            ]
                                        }, menuItem.id);
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                                        className: $a2c866a284344527$export$6d0f696456f5be95,
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                                                variants: $de52307164c2185d$var$listItemAnimationVariants,
                                                className: $a2c866a284344527$export$35f4bb96a8126157,
                                                children: [
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                                        src: $de52307164c2185d$var$LogoIcon.toString()
                                                    }),
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                                        href: "/policies",
                                                        className: $a2c866a284344527$export$eadc11cc729d90b3,
                                                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                                            children: "D\u1ECACH V\u1EE4 KH\xc1CH H\xc0NG"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                                                className: $a2c866a284344527$export$35f4bb96a8126157,
                                                onClick: ()=>{
                                                    setAboutCurnonExpanded((v)=>!v);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                                        src: $de52307164c2185d$var$LogoIcon.toString()
                                                    }),
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                                        className: $a2c866a284344527$export$eadc11cc729d90b3,
                                                        children: "V\u1EC0 CURNON"
                                                    }),
                                                    !aboutCurnonExpanded ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                                        src: $de52307164c2185d$var$ExpandIcon.toString()
                                                    }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                                        src: $de52307164c2185d$var$CollapseIcon.toString()
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                                                className: $a2c866a284344527$export$35f4bb96a8126157,
                                                variants: {
                                                    closed: {
                                                        opacity: 0
                                                    },
                                                    open: {
                                                        opacity: 1
                                                    }
                                                },
                                                animate: aboutCurnonExpanded ? "open" : "closed",
                                                children: [
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                                        className: $a2c866a284344527$export$a1386e5a0e99f154
                                                    }),
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                                        className: $a2c866a284344527$export$67922b06d50e9541,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                                                href: "/blog",
                                                                className: $a2c866a284344527$export$807a8e99cc9df581,
                                                                children: "Blog"
                                                            }),
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                                                href: "/about",
                                                                className: $a2c866a284344527$export$807a8e99cc9df581,
                                                                children: "V\u1EC1 ch\xfang t\xf4i"
                                                            }),
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                                                href: "https://longandshort.vn",
                                                                className: $a2c866a284344527$export$807a8e99cc9df581,
                                                                children: "Long & Short"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, [
                                        "bottom"
                                    ].join("_"))
                                ]
                            }, [
                                "body"
                            ].join("_"))
                        ]
                    }),
                    activeItem && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                        className: $a2c866a284344527$export$32180ef41b15b513,
                        layoutId: "menu_body",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: $a2c866a284344527$export$f1b4679c105f0066,
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                                    className: $a2c866a284344527$export$58c415f8b0eba7af,
                                    onClick: ()=>{
                                        setActiveItem(undefined);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6be42a1d560aa137$export$f04a61298a47a40f), {
                                            name: "left",
                                            classes: {
                                                root: $a2c866a284344527$export$4e216048b6088f27
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).span, {
                                            style: {
                                                flex: 1
                                            },
                                            layoutId: "menuItemTitle_" + activeItem.id,
                                            children: activeItem.Title
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                            style: {
                                                visibility: "hidden",
                                                width: 24
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: $a2c866a284344527$export$c60b6f34463a64a4
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: $a2c866a284344527$export$6cad266addae4346,
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $ce1bda0ff99cbe48$export$73ad77d5e39b277e), {
                                    item: activeItem
                                })
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: $a2c866a284344527$export$b74a11cf10f01166,
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                        className: $a2c866a284344527$export$c60b6f34463a64a4,
                                        style: {
                                            marginBottom: 16
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $43a0856f8016f743$export$7e4d0770b0113ed4), {
                                        id: activeItem.CategoryId,
                                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("a", {
                                            className: $a2c866a284344527$export$da1e0d5c6f5ed6c,
                                            onClick: closeModal,
                                            children: [
                                                "Xem T\u1EA5t C\u1EA3",
                                                " ",
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6be42a1d560aa137$export$f04a61298a47a40f), {
                                                    name: "line_right",
                                                    classes: {
                                                        root: $a2c866a284344527$export$4cdaeb5d35bab933
                                                    }
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                        className: $a2c866a284344527$export$6cb9466bd0eb4435,
                        onClick: closeModal,
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6be42a1d560aa137$export$f04a61298a47a40f), {
                            name: "cross"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7d8aa723b44ed5d8$export$2e2bcd8739ae039), {
                isActive: isOpen,
                classes: {
                    root_active: $a2c866a284344527$export$c442028fb4460674,
                    root: $a2c866a284344527$export$6ab52428572992d9
                },
                dismiss: closeModal
            })
        ]
    });
};



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
var $ef49d6067efcfc2f$export$8793edee2d425525 = function() {};
function $ef49d6067efcfc2f$export$af631764ddc44097(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
function $ef49d6067efcfc2f$export$8c8705df4a2dcec9(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
var $ef49d6067efcfc2f$export$4e09c449d6c407f7 = typeof window !== "undefined";
var $ef49d6067efcfc2f$export$42e7ac6120dd324e = typeof navigator !== "undefined";


var $1ebd99800c35bbb8$var$useIsomorphicLayoutEffect = (0, $ef49d6067efcfc2f$export$4e09c449d6c407f7) ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);
var $1ebd99800c35bbb8$export$2e2bcd8739ae039 = $1ebd99800c35bbb8$var$useIsomorphicLayoutEffect;


function $732d99c1a0348e40$var$getDimensionObject(node) {
    const rect = node.getBoundingClientRect();
    return {
        width: rect.width,
        height: rect.height,
        top: "x" in rect ? rect.x : rect.top,
        left: "y" in rect ? rect.y : rect.left,
        x: "x" in rect ? rect.x : rect.left,
        y: "y" in rect ? rect.y : rect.top,
        right: rect.right,
        bottom: rect.bottom
    };
}
function $732d99c1a0348e40$var$useDimensions({ liveMeasure: liveMeasure = true, throttleRate: throttleRate = 1000 } = {}) {
    const [dimensions, setDimensions] = (0, $exYeM.useState)({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        x: 0,
        y: 0
    });
    const [node, setNode] = (0, $exYeM.useState)(null);
    const ref = (0, $exYeM.useCallback)((node)=>{
        setNode(node);
    }, []);
    (0, $1ebd99800c35bbb8$export$2e2bcd8739ae039)(()=>{
        if (node) {
            const measure = ()=>window.requestAnimationFrame(()=>setDimensions($732d99c1a0348e40$var$getDimensionObject(node)));
            measure();
            if (liveMeasure) {
                let count = 3000 / throttleRate;
                window.addEventListener("resize", measure);
                window.addEventListener("scroll", measure);
                const resizeObserver = new ResizeObserver(()=>{
                    measure();
                });
                resizeObserver.observe(node);
                const timer = setInterval(()=>{
                    measure();
                // if (count < 0) {
                //   clearInterval(timer)
                // } else {
                //   count--
                // }
                }, throttleRate);
                return ()=>{
                    window.removeEventListener("resize", measure);
                    window.removeEventListener("scroll", measure);
                    clearInterval(timer);
                    resizeObserver.unobserve(node);
                };
            }
        }
    }, [
        liveMeasure,
        node,
        throttleRate
    ]);
    return [
        ref,
        dimensions,
        node
    ];
}
var $732d99c1a0348e40$export$2e2bcd8739ae039 = $732d99c1a0348e40$var$useDimensions;




const $6deaf3f611d65bfb$export$150709981922f059 = (0, $3bf714f6c012ccf2$export$72e4926bf8358653)`
  query siteMenuData {
    CMS {
      siteMenu {
        id
        MenMenu {
          id
          Title
          items {
            id
            Title
            Subtitle
            Description
            CategoryId
            RelativePosition
            Image {
              id
              url
            }
            Visible
            ButtonTitle
            menu_children {
              id
              Title
              Subtitle
              Description
              CategoryId
              ShowUnderParent
              RelativePosition
              Image {
                id
                url
              }
              ButtonTitle
              Visible
            }
          }
        }
        WomenMenu {
          id
          Title
          items {
            id
            Title
            Subtitle
            Description
            CategoryId
            RelativePosition
            Image {
              id
              url
            }
            Visible
            ButtonTitle
            menu_children {
              id
              Title
              Subtitle
              Description
              CategoryId
              ShowUnderParent
              RelativePosition
              Image {
                id
                url
              }
              ButtonTitle
              Visible
            }
          }
        }
      }
    }
  }
`;



var $exYeM = parcelRequire("exYeM");

var $839799496b62fb71$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $839799496b62fb71$var$ReactIs, $839799496b62fb71$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$839799496b62fb71$exports = (parcelRequire("jpdgm"))();


const $d31deb30aaf23220$var$menuContainerClass = "rc-menu-container";
const $d31deb30aaf23220$var$menuClass = "rc-menu";
const $d31deb30aaf23220$var$menuButtonClass = "rc-menu-button";
const $d31deb30aaf23220$var$menuArrowClass = "arrow";
const $d31deb30aaf23220$var$menuItemClass = "item";
const $d31deb30aaf23220$var$menuDividerClass = "divider";
const $d31deb30aaf23220$var$menuHeaderClass = "header";
const $d31deb30aaf23220$var$menuGroupClass = "group";
const $d31deb30aaf23220$var$subMenuClass = "submenu";
const $d31deb30aaf23220$var$radioGroupClass = "radio-group";
const $d31deb30aaf23220$var$initialHoverIndex = -1;
const $d31deb30aaf23220$var$MenuListItemContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({});
const $d31deb30aaf23220$var$MenuListContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({});
const $d31deb30aaf23220$var$EventHandlersContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({});
const $d31deb30aaf23220$var$RadioGroupContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({});
const $d31deb30aaf23220$var$SettingsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({});
const $d31deb30aaf23220$var$ItemSettingsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({});
const $d31deb30aaf23220$var$Keys = Object.freeze({
    "ENTER": "Enter",
    "ESC": "Escape",
    "SPACE": " ",
    "HOME": "Home",
    "END": "End",
    "LEFT": "ArrowLeft",
    "RIGHT": "ArrowRight",
    "UP": "ArrowUp",
    "DOWN": "ArrowDown"
});
const $d31deb30aaf23220$var$HoverIndexActionTypes = Object.freeze({
    "RESET": "HOVER_INDEX_RESET",
    "SET": "HOVER_INDEX_SET",
    "UNSET": "HOVER_INDEX_UNSET",
    "INCREASE": "HOVER_INDEX_INCREASE",
    "DECREASE": "HOVER_INDEX_DECREASE",
    "FIRST": "HOVER_INDEX_FIRST",
    "LAST": "HOVER_INDEX_LAST"
});
const $d31deb30aaf23220$var$SubmenuActionTypes = Object.freeze({
    "OPEN": "SUBMENU_OPEN",
    "CLOSE": "SUBMENU_CLOSE"
});
const $d31deb30aaf23220$var$CloseReason = Object.freeze({
    "CLICK": "click",
    "CANCEL": "cancel",
    "BLUR": "blur",
    "SCROLL": "scroll"
});
const $d31deb30aaf23220$var$batchedUpdates = (0, $97dc602bd7e23afa$exports.unstable_batchedUpdates) || ((callback)=>callback());
const $d31deb30aaf23220$var$defineName = (component, name)=>name ? Object.defineProperty(component, "_reactMenu", {
        value: name,
        writable: false
    }) : component;
const $d31deb30aaf23220$var$getName = (component)=>component && component["_reactMenu"];
const $d31deb30aaf23220$export$809297f6a56d123c = (HOC)=>(...args)=>$d31deb30aaf23220$var$defineName(HOC(...args), $d31deb30aaf23220$var$getName(args[0]));
const $d31deb30aaf23220$export$1363e8a9a9bb11cb = (sourceComponent)=>(wrappedComponent)=>$d31deb30aaf23220$var$defineName(wrappedComponent, $d31deb30aaf23220$var$getName(sourceComponent));
const $d31deb30aaf23220$var$safeCall = (fn, ...args)=>typeof fn === "function" ? fn(...args) : fn;
const $d31deb30aaf23220$var$attachHandlerProps = (handlers, props)=>{
    const result = {};
    for (const handlerName of Object.keys(handlers)){
        const handler = handlers[handlerName];
        const propHandler = props[handlerName];
        let attachedHandler;
        if (typeof propHandler === "function") attachedHandler = (e)=>{
            propHandler(e);
            handler(e);
        };
        else attachedHandler = handler;
        result[handlerName] = attachedHandler;
    }
    return result;
};
const $d31deb30aaf23220$var$parsePadding = (paddingStr)=>{
    if (typeof paddingStr !== "string") return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    const padding = paddingStr.trim().split(/\s+/, 4).map(parseFloat);
    const top = !isNaN(padding[0]) ? padding[0] : 0;
    const right = !isNaN(padding[1]) ? padding[1] : top;
    return {
        top: top,
        right: right,
        bottom: !isNaN(padding[2]) ? padding[2] : top,
        left: !isNaN(padding[3]) ? padding[3] : right
    };
};
const $d31deb30aaf23220$var$useBEM = ({ block: block, element: element, modifiers: modifiers, className: className, externalModifiers: externalModifiers })=>(0, $exYeM.useMemo)(()=>{
        const blockElement = element ? `${block}__${element}` : block;
        let classString = blockElement;
        for (const name of Object.keys(modifiers || {})){
            const value = modifiers[name];
            if (value) {
                classString += ` ${blockElement}--`;
                classString += value === true ? name : `${name}-${value}`;
            }
        }
        let expandedClassName = typeof className === "function" ? className(externalModifiers || modifiers) : className;
        if (typeof expandedClassName === "string") {
            expandedClassName = expandedClassName.trim();
            if (expandedClassName) classString += ` ${expandedClassName}`;
        }
        return classString;
    }, [
        block,
        element,
        modifiers,
        className,
        externalModifiers
    ]);
const $d31deb30aaf23220$var$isObject = (obj)=>obj && typeof obj === "object";
const $d31deb30aaf23220$var$sanitiseKey = (key)=>key.charAt(0) === "$" ? key.slice(1) : key;
const $d31deb30aaf23220$var$useFlatStyles = (styles, modifiers)=>(0, $exYeM.useMemo)(()=>{
        if (typeof styles === "function") return styles(modifiers);
        if (!$d31deb30aaf23220$var$isObject(styles)) return undefined;
        if (!modifiers) return styles;
        const style = {};
        for (const prop of Object.keys(styles)){
            const value = styles[prop];
            if ($d31deb30aaf23220$var$isObject(value)) {
                const modifierValue = modifiers[$d31deb30aaf23220$var$sanitiseKey(prop)];
                if (typeof modifierValue === "string") for (const nestedProp of Object.keys(value)){
                    const nestedValue = value[nestedProp];
                    if ($d31deb30aaf23220$var$isObject(nestedValue)) {
                        if ($d31deb30aaf23220$var$sanitiseKey(nestedProp) === modifierValue) Object.assign(style, nestedValue);
                    } else style[nestedProp] = nestedValue;
                }
                else if (modifierValue) Object.assign(style, value);
            } else style[prop] = value;
        }
        return style;
    }, [
        styles,
        modifiers
    ]);
const $d31deb30aaf23220$var$getScrollAncestor = (node)=>{
    while(node && node !== document.body){
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY } = getComputedStyle(node);
        if (/auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX)) return node;
        node = node.parentNode;
    }
    return window;
};
const $d31deb30aaf23220$var$floatEqual = (a, b, diff = 0.0001)=>Math.abs(a - b) < diff;
const $d31deb30aaf23220$var$isProd = true;
const $d31deb30aaf23220$var$validateChildren = (parent, child, permitted)=>{
    if (!child) return false;
    if (!permitted.includes($d31deb30aaf23220$var$getName(child.type))) {
        !$d31deb30aaf23220$var$isProd && console.warn(`[react-menu] ${child.type || child} is ignored.\n`, `The permitted children inside a ${parent} are ${permitted.join(", ")}.`, "If you create HOC of these components, you can use the applyHOC or applyStatics helper, see more at: https://szhsin.github.io/react-menu/docs#utils-apply-hoc");
        return false;
    }
    return true;
};
const $d31deb30aaf23220$var$cloneChildren = (children, startIndex = 0)=>{
    let index = startIndex;
    let descendOverflow = false;
    const permittedChildren = [
        "MenuDivider",
        "MenuGroup",
        "MenuHeader",
        "MenuItem",
        "FocusableItem",
        "MenuRadioGroup",
        "SubMenu"
    ];
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Children.map(children, (child)=>{
        if (!$d31deb30aaf23220$var$validateChildren("Menu or SubMenu", child, permittedChildren)) return null;
        switch($d31deb30aaf23220$var$getName(child.type)){
            case "MenuDivider":
            case "MenuHeader":
                return child;
            case "MenuRadioGroup":
                {
                    const permittedChildren = [
                        "MenuItem"
                    ];
                    const props = {
                        type: "radio"
                    };
                    const radioItems = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Children.map(child.props.children, (radioChild)=>{
                        if (!$d31deb30aaf23220$var$validateChildren("MenuRadioGroup", radioChild, permittedChildren)) return null;
                        return radioChild.props.disabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).cloneElement(radioChild, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).cloneElement(radioChild, {
                            ...props,
                            index: index++
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).cloneElement(child, {
                        children: radioItems
                    });
                }
            case "MenuGroup":
                {
                    const { items: items, endIndex: endIndex, descendOverflow: descOverflow } = $d31deb30aaf23220$var$cloneChildren(child.props.children, index);
                    index = endIndex;
                    const takeOverflow = Boolean(child.props.takeOverflow);
                    if (!$d31deb30aaf23220$var$isProd && (descendOverflow === descOverflow ? descOverflow : takeOverflow)) throw new Error("[react-menu] Only one MenuGroup in a menu is allowed to have takeOverflow prop.");
                    descendOverflow = descendOverflow || descOverflow || takeOverflow;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).cloneElement(child, {
                        children: items
                    });
                }
            default:
                return child.props.disabled ? child : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).cloneElement(child, {
                    index: index++
                });
        }
    });
    return {
        items: items,
        endIndex: index,
        descendOverflow: descendOverflow
    };
};
const $d31deb30aaf23220$var$stylePropTypes = (name)=>({
        [name ? `${name}ClassName` : "className"]: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).func
        ]),
        [name ? `${name}Styles` : "styles"]: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).func
        ])
    });
const $d31deb30aaf23220$var$sharedMenuPropTypes = {
    ...$d31deb30aaf23220$var$stylePropTypes(),
    ...$d31deb30aaf23220$var$stylePropTypes("arrow"),
    "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).string,
    arrow: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).bool,
    offsetX: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).number,
    offsetY: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).number,
    align: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).oneOf([
        "start",
        "center",
        "end"
    ]),
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).oneOf([
        "left",
        "right",
        "top",
        "bottom"
    ]),
    position: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).oneOf([
        "auto",
        "anchor",
        "initial"
    ]),
    overflow: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).oneOf([
        "auto",
        "visible",
        "hidden"
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).node.isRequired
};
const $d31deb30aaf23220$var$menuPropTypesBase = {
    ...$d31deb30aaf23220$var$sharedMenuPropTypes,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).number
    ]),
    animation: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).bool,
    debugging: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).bool,
    boundingBoxRef: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).object,
    boundingBoxPadding: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).string,
    reposition: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).oneOf([
        "auto",
        "initial"
    ]),
    repositionFlag: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).number
    ]),
    viewScroll: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).oneOf([
        "auto",
        "close",
        "initial"
    ]),
    submenuOpenDelay: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).number,
    submenuCloseDelay: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).number,
    portal: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).bool,
    theming: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).string,
    onItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).func,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).func
};
const $d31deb30aaf23220$var$sharedMenuDefaultProp = {
    offsetX: 0,
    offsetY: 0,
    align: "start",
    direction: "bottom",
    position: "auto",
    overflow: "visible"
};
const $d31deb30aaf23220$var$menuDefaultPropsBase = {
    ...$d31deb30aaf23220$var$sharedMenuDefaultProp,
    animation: true,
    reposition: "auto",
    viewScroll: "initial",
    submenuOpenDelay: 300,
    submenuCloseDelay: 150
};
const $d31deb30aaf23220$var$useActiveState = (isHovering, isDisabled, customKey)=>{
    const [active, setActive] = (0, $exYeM.useState)(false);
    const activeKeys = (0, $exYeM.useMemo)(()=>[
            $d31deb30aaf23220$var$Keys.SPACE,
            $d31deb30aaf23220$var$Keys.ENTER,
            ...customKey ? [
                customKey
            ] : []
        ], [
        customKey
    ]);
    const cancelActive = (0, $exYeM.useCallback)(()=>setActive(false), []);
    return {
        isActive: active,
        onPointerDown: (0, $exYeM.useCallback)(()=>{
            if (!isDisabled) setActive(true);
        }, [
            isDisabled
        ]),
        onPointerUp: cancelActive,
        onPointerLeave: cancelActive,
        onKeyDown: (0, $exYeM.useCallback)((e)=>{
            if (isHovering && !isDisabled && activeKeys.includes(e.key)) setActive(true);
        }, [
            isHovering,
            isDisabled,
            activeKeys
        ]),
        onKeyUp: (0, $exYeM.useCallback)((e)=>{
            if (activeKeys.includes(e.key)) setActive(false);
        }, [
            activeKeys
        ]),
        onBlur: (0, $exYeM.useCallback)((e)=>{
            if (!e.currentTarget.contains(e.relatedTarget)) setActive(false);
        }, [])
    };
};
const $d31deb30aaf23220$var$useItemState = (isDisabled, index)=>{
    const ref = (0, $exYeM.useRef)(null);
    const { submenuCloseDelay: submenuCloseDelay } = (0, $exYeM.useContext)($d31deb30aaf23220$var$ItemSettingsContext);
    const { isParentOpen: isParentOpen, hoverIndex: hoverIndex, isSubmenuOpen: isSubmenuOpen, dispatch: dispatch } = (0, $exYeM.useContext)($d31deb30aaf23220$var$MenuListItemContext);
    const isHovering = hoverIndex === index;
    const timeoutId = (0, $exYeM.useRef)();
    const setHover = (0, $exYeM.useCallback)(()=>{
        if (!isDisabled) dispatch({
            type: $d31deb30aaf23220$var$HoverIndexActionTypes.SET,
            index: index
        });
    }, [
        isDisabled,
        dispatch,
        index
    ]);
    const onBlur = (0, $exYeM.useCallback)((e)=>{
        if (!e.currentTarget.contains(e.relatedTarget)) dispatch({
            type: $d31deb30aaf23220$var$HoverIndexActionTypes.UNSET,
            index: index
        });
    }, [
        dispatch,
        index
    ]);
    const onMouseEnter = (0, $exYeM.useCallback)(()=>{
        if (isSubmenuOpen) timeoutId.current = setTimeout(setHover, submenuCloseDelay);
        else setHover();
    }, [
        isSubmenuOpen,
        submenuCloseDelay,
        setHover
    ]);
    const onMouseLeave = (0, $exYeM.useCallback)((_, keepHover)=>{
        timeoutId.current && clearTimeout(timeoutId.current);
        if (!keepHover) dispatch({
            type: $d31deb30aaf23220$var$HoverIndexActionTypes.UNSET,
            index: index
        });
    }, [
        dispatch,
        index
    ]);
    (0, $exYeM.useEffect)(()=>()=>clearTimeout(timeoutId.current), []);
    (0, $exYeM.useEffect)(()=>{
        if (isHovering && isParentOpen) ref.current && ref.current.focus();
    }, [
        isHovering,
        isParentOpen
    ]);
    return {
        ref: ref,
        isHovering: isHovering,
        setHover: setHover,
        onBlur: onBlur,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    };
};
const $d31deb30aaf23220$var$useMenuChange = (onChange, isOpen)=>{
    const prevOpen = (0, $exYeM.useRef)(isOpen);
    (0, $exYeM.useEffect)(()=>{
        if (prevOpen.current !== isOpen) $d31deb30aaf23220$var$safeCall(onChange, {
            open: isOpen
        });
        prevOpen.current = isOpen;
    }, [
        onChange,
        isOpen
    ]);
};
const $d31deb30aaf23220$var$FocusPositions = Object.freeze({
    "INITIAL": "initial",
    "FIRST": "first",
    "LAST": "last"
});
const $d31deb30aaf23220$var$MenuStates = Object.freeze({
    "UNMOUNTED": 0,
    "CLOSED": 1,
    "OPEN": 2
});
const $d31deb30aaf23220$var$MenuStateActionType = Object.freeze({
    "OPEN": 0,
    "CLOSE": 1,
    "TOGGLE": 2
});
const $d31deb30aaf23220$export$8091e3849c182a6 = (keepMounted = true)=>{
    const [menuItemFocus, setMenuItemFocus] = (0, $exYeM.useState)({
        position: $d31deb30aaf23220$var$FocusPositions.INITIAL
    });
    const [menuState, dispatch] = (0, $exYeM.useReducer)(menuStateReducer, $d31deb30aaf23220$var$MenuStates.UNMOUNTED);
    function menuStateReducer(state, { type: type }) {
        switch(type){
            case $d31deb30aaf23220$var$MenuStateActionType.OPEN:
                return $d31deb30aaf23220$var$MenuStates.OPEN;
            case $d31deb30aaf23220$var$MenuStateActionType.CLOSE:
                if (state === $d31deb30aaf23220$var$MenuStates.OPEN) return keepMounted ? $d31deb30aaf23220$var$MenuStates.CLOSED : $d31deb30aaf23220$var$MenuStates.UNMOUNTED;
                else return state;
            case $d31deb30aaf23220$var$MenuStateActionType.TOGGLE:
                if (state === $d31deb30aaf23220$var$MenuStates.OPEN) return keepMounted ? $d31deb30aaf23220$var$MenuStates.CLOSED : $d31deb30aaf23220$var$MenuStates.UNMOUNTED;
                else return $d31deb30aaf23220$var$MenuStates.OPEN;
            default:
                throw new Error("menuStateReducer: unknown action type");
        }
    }
    return {
        isMounted: menuState !== $d31deb30aaf23220$var$MenuStates.UNMOUNTED,
        isOpen: menuState === $d31deb30aaf23220$var$MenuStates.OPEN,
        menuItemFocus: menuItemFocus,
        openMenu: (0, $exYeM.useCallback)((menuItemFocus = $d31deb30aaf23220$var$FocusPositions.INITIAL)=>{
            setMenuItemFocus({
                position: menuItemFocus
            });
            dispatch({
                type: $d31deb30aaf23220$var$MenuStateActionType.OPEN
            });
        }, []),
        closeMenu: (0, $exYeM.useCallback)(()=>dispatch({
                type: $d31deb30aaf23220$var$MenuStateActionType.CLOSE
            }), []),
        toggleMenu: (0, $exYeM.useCallback)((menuItemFocus = $d31deb30aaf23220$var$FocusPositions.INITIAL)=>{
            setMenuItemFocus({
                position: menuItemFocus
            });
            dispatch({
                type: $d31deb30aaf23220$var$MenuStateActionType.TOGGLE
            });
        }, [])
    };
};
const $d31deb30aaf23220$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);
const $d31deb30aaf23220$export$266a769812832828 = $d31deb30aaf23220$var$defineName(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(function MenuButton({ className: className, styles: styles, isOpen: isOpen, disabled: disabled, children: children, ...restProps }, ref) {
    const modifiers = (0, $exYeM.useMemo)(()=>Object.freeze({
            open: isOpen
        }), [
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("button", Object.assign({
        "aria-haspopup": "true",
        "aria-expanded": isOpen,
        "aria-disabled": disabled || undefined,
        disabled: disabled
    }, restProps, {
        ref: ref,
        className: $d31deb30aaf23220$var$useBEM({
            block: $d31deb30aaf23220$var$menuButtonClass,
            modifiers: modifiers,
            className: className
        }),
        style: $d31deb30aaf23220$var$useFlatStyles(styles, modifiers)
    }), children);
})), "MenuButton");
$d31deb30aaf23220$export$266a769812832828.propTypes = {
    ...$d31deb30aaf23220$var$stylePropTypes(),
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).node.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).func,
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).func
};
const $d31deb30aaf23220$var$MenuList = $d31deb30aaf23220$var$defineName(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function MenuList({ ariaLabel: ariaLabel, className: className, styles: styles, arrowClassName: arrowClassName, arrowStyles: arrowStyles, anchorPoint: anchorPoint, anchorRef: anchorRef, containerRef: containerRef, arrow: arrow, align: align, direction: direction, position: position, overflow: overflow, repositionFlag: repositionFlag, captureFocus: captureFocus = true, isOpen: isOpen, isDisabled: isDisabled, menuItemFocus: menuItemFocus, offsetX: offsetX, offsetY: offsetY, children: children, onClose: onClose, ...restProps }) {
    const [menuPosition, setMenuPosition] = (0, $exYeM.useState)({
        x: 0,
        y: 0
    });
    const [arrowPosition, setArrowPosition] = (0, $exYeM.useState)({});
    const [overflowData, setOverflowData] = (0, $exYeM.useState)();
    const [isClosing, setClosing] = (0, $exYeM.useState)(false);
    const [expandedDirection, setExpandedDirection] = (0, $exYeM.useState)(direction);
    const { animation: animation, boundingBoxRef: boundingBoxRef, boundingBoxPadding: boundingBoxPadding, rootMenuRef: rootMenuRef, rootAnchorRef: rootAnchorRef, scrollingRef: scrollingRef, anchorScrollingRef: anchorScrollingRef, reposition: reposition, viewScroll: viewScroll } = (0, $exYeM.useContext)($d31deb30aaf23220$var$SettingsContext);
    const menuRef = (0, $exYeM.useRef)(null);
    const arrowRef = (0, $exYeM.useRef)(null);
    const menuItemsCount = (0, $exYeM.useRef)(0);
    const latestOpen = (0, $exYeM.useRef)(isOpen);
    const latestMenuSize = (0, $exYeM.useRef)({
        width: 0,
        height: 0
    });
    const latestHandlePosition = (0, $exYeM.useRef)(()=>{});
    const descendOverflowRef = (0, $exYeM.useRef)(false);
    const reposFlag = (0, $exYeM.useContext)($d31deb30aaf23220$var$MenuListContext).reposSubmenu || repositionFlag;
    const [reposSubmenu, forceReposSubmenu] = (0, $exYeM.useReducer)((c)=>c + 1, 1);
    const [{ hoverIndex: hoverIndex, openSubmenuCount: openSubmenuCount }, dispatch] = (0, $exYeM.useReducer)(reducer, {
        hoverIndex: $d31deb30aaf23220$var$initialHoverIndex,
        openSubmenuCount: 0
    });
    function reducer({ hoverIndex: hoverIndex, openSubmenuCount: openSubmenuCount }, action) {
        return {
            hoverIndex: hoverIndexReducer(hoverIndex, action),
            openSubmenuCount: $d31deb30aaf23220$var$submenuCountReducer(openSubmenuCount, action)
        };
    }
    function hoverIndexReducer(state, { type: type, index: index }) {
        switch(type){
            case $d31deb30aaf23220$var$HoverIndexActionTypes.RESET:
                return $d31deb30aaf23220$var$initialHoverIndex;
            case $d31deb30aaf23220$var$HoverIndexActionTypes.SET:
                return index;
            case $d31deb30aaf23220$var$HoverIndexActionTypes.UNSET:
                return state === index ? $d31deb30aaf23220$var$initialHoverIndex : state;
            case $d31deb30aaf23220$var$HoverIndexActionTypes.DECREASE:
                {
                    let i = state;
                    i--;
                    if (i < 0) i = menuItemsCount.current - 1;
                    return i;
                }
            case $d31deb30aaf23220$var$HoverIndexActionTypes.INCREASE:
                {
                    let i = state;
                    i++;
                    if (i >= menuItemsCount.current) i = 0;
                    return i;
                }
            case $d31deb30aaf23220$var$HoverIndexActionTypes.FIRST:
                return menuItemsCount.current > 0 ? 0 : $d31deb30aaf23220$var$initialHoverIndex;
            case $d31deb30aaf23220$var$HoverIndexActionTypes.LAST:
                return menuItemsCount.current > 0 ? menuItemsCount.current - 1 : $d31deb30aaf23220$var$initialHoverIndex;
            default:
                return state;
        }
    }
    const menuItems = (0, $exYeM.useMemo)(()=>{
        const { items: items, endIndex: endIndex, descendOverflow: descendOverflow } = $d31deb30aaf23220$var$cloneChildren(children);
        menuItemsCount.current = endIndex;
        descendOverflowRef.current = descendOverflow;
        return items;
    }, [
        children
    ]);
    const handleKeyDown = (e)=>{
        let handled = false;
        switch(e.key){
            case $d31deb30aaf23220$var$Keys.HOME:
                dispatch({
                    type: $d31deb30aaf23220$var$HoverIndexActionTypes.FIRST
                });
                handled = true;
                break;
            case $d31deb30aaf23220$var$Keys.END:
                dispatch({
                    type: $d31deb30aaf23220$var$HoverIndexActionTypes.LAST
                });
                handled = true;
                break;
            case $d31deb30aaf23220$var$Keys.UP:
                dispatch({
                    type: $d31deb30aaf23220$var$HoverIndexActionTypes.DECREASE
                });
                handled = true;
                break;
            case $d31deb30aaf23220$var$Keys.DOWN:
                dispatch({
                    type: $d31deb30aaf23220$var$HoverIndexActionTypes.INCREASE
                });
                handled = true;
                break;
            case $d31deb30aaf23220$var$Keys.SPACE:
                if (e.target && e.target.className.includes($d31deb30aaf23220$var$menuClass)) e.preventDefault();
                break;
        }
        if (handled) {
            e.preventDefault();
            e.stopPropagation();
        }
    };
    const handleAnimationEnd = ()=>{
        if (isClosing) {
            setClosing(false);
            setOverflowData();
        }
    };
    const positionHelpers = (0, $exYeM.useCallback)(()=>{
        const menuRect = menuRef.current.getBoundingClientRect();
        const containerRect = containerRef.current.getBoundingClientRect();
        const boundingRect = scrollingRef.current === window ? {
            left: 0,
            top: 0,
            right: document.documentElement.clientWidth,
            bottom: window.innerHeight
        } : scrollingRef.current.getBoundingClientRect();
        const padding = $d31deb30aaf23220$var$parsePadding(boundingBoxPadding);
        const getLeftOverflow = (x)=>x + containerRect.left - boundingRect.left - padding.left;
        const getRightOverflow = (x)=>x + containerRect.left + menuRect.width - boundingRect.right + padding.right;
        const getTopOverflow = (y)=>y + containerRect.top - boundingRect.top - padding.top;
        const getBottomOverflow = (y)=>y + containerRect.top + menuRect.height - boundingRect.bottom + padding.bottom;
        const confineHorizontally = (x)=>{
            let leftOverflow = getLeftOverflow(x);
            if (leftOverflow < 0) x -= leftOverflow;
            else {
                const rightOverflow = getRightOverflow(x);
                if (rightOverflow > 0) {
                    x -= rightOverflow;
                    leftOverflow = getLeftOverflow(x);
                    if (leftOverflow < 0) x -= leftOverflow;
                }
            }
            return x;
        };
        const confineVertically = (y)=>{
            let topOverflow = getTopOverflow(y);
            if (topOverflow < 0) y -= topOverflow;
            else {
                const bottomOverflow = getBottomOverflow(y);
                if (bottomOverflow > 0) {
                    y -= bottomOverflow;
                    topOverflow = getTopOverflow(y);
                    if (topOverflow < 0) y -= topOverflow;
                }
            }
            return y;
        };
        return {
            menuRect: menuRect,
            containerRect: containerRect,
            getLeftOverflow: getLeftOverflow,
            getRightOverflow: getRightOverflow,
            getTopOverflow: getTopOverflow,
            getBottomOverflow: getBottomOverflow,
            confineHorizontally: confineHorizontally,
            confineVertically: confineVertically
        };
    }, [
        containerRef,
        scrollingRef,
        boundingBoxPadding
    ]);
    const placeArrowX = (0, $exYeM.useCallback)((menuX, anchorRect, containerRect, menuRect)=>{
        let x = anchorRect.left - containerRect.left - menuX + anchorRect.width / 2;
        const offset = arrowRef.current.offsetWidth * 1.25;
        x = Math.max(offset, x);
        x = Math.min(x, menuRect.width - offset);
        return x;
    }, []);
    const placeArrowY = (0, $exYeM.useCallback)((menuY, anchorRect, containerRect, menuRect)=>{
        let y = anchorRect.top - containerRect.top - menuY + anchorRect.height / 2;
        const offset = arrowRef.current.offsetHeight * 1.25;
        y = Math.max(offset, y);
        y = Math.min(y, menuRect.height - offset);
        return y;
    }, []);
    const placeLeftorRight = (0, $exYeM.useCallback)(({ anchorRect: anchorRect, containerRect: containerRect, menuRect: menuRect }, { placeLeftorRightY: placeLeftorRightY, placeLeftX: placeLeftX, placeRightX: placeRightX }, { getLeftOverflow: getLeftOverflow, getRightOverflow: getRightOverflow, confineHorizontally: confineHorizontally, confineVertically: confineVertically })=>{
        let computedDirection = direction;
        let y = placeLeftorRightY;
        if (position !== "initial") {
            y = confineVertically(y);
            if (position === "anchor") {
                y = Math.min(y, anchorRect.bottom - containerRect.top);
                y = Math.max(y, anchorRect.top - containerRect.top - menuRect.height);
            }
        }
        let x, leftOverflow, rightOverflow;
        if (computedDirection === "left") {
            x = placeLeftX;
            if (position !== "initial") {
                leftOverflow = getLeftOverflow(x);
                if (leftOverflow < 0) {
                    rightOverflow = getRightOverflow(placeRightX);
                    if (rightOverflow <= 0 || -leftOverflow > rightOverflow) {
                        x = placeRightX;
                        computedDirection = "right";
                    }
                }
            }
        } else {
            x = placeRightX;
            if (position !== "initial") {
                rightOverflow = getRightOverflow(x);
                if (rightOverflow > 0) {
                    leftOverflow = getLeftOverflow(placeLeftX);
                    if (leftOverflow >= 0 || -leftOverflow < rightOverflow) {
                        x = placeLeftX;
                        computedDirection = "left";
                    }
                }
            }
        }
        if (position === "auto") x = confineHorizontally(x);
        const arrowY = arrow ? placeArrowY(y, anchorRect, containerRect, menuRect) : undefined;
        return {
            arrowY: arrowY,
            x: x,
            y: y,
            computedDirection: computedDirection
        };
    }, [
        placeArrowY,
        arrow,
        direction,
        position
    ]);
    const placeToporBottom = (0, $exYeM.useCallback)(({ anchorRect: anchorRect, containerRect: containerRect, menuRect: menuRect }, { placeToporBottomX: placeToporBottomX, placeTopY: placeTopY, placeBottomY: placeBottomY }, { getTopOverflow: getTopOverflow, getBottomOverflow: getBottomOverflow, confineHorizontally: confineHorizontally, confineVertically: confineVertically })=>{
        let computedDirection = direction === "top" ? "top" : "bottom";
        let x = placeToporBottomX;
        if (position !== "initial") {
            x = confineHorizontally(x);
            if (position === "anchor") {
                x = Math.min(x, anchorRect.right - containerRect.left);
                x = Math.max(x, anchorRect.left - containerRect.left - menuRect.width);
            }
        }
        let y, topOverflow, bottomOverflow;
        if (computedDirection === "top") {
            y = placeTopY;
            if (position !== "initial") {
                topOverflow = getTopOverflow(y);
                if (topOverflow < 0) {
                    bottomOverflow = getBottomOverflow(placeBottomY);
                    if (bottomOverflow <= 0 || -topOverflow > bottomOverflow) {
                        y = placeBottomY;
                        computedDirection = "bottom";
                    }
                }
            }
        } else {
            y = placeBottomY;
            if (position !== "initial") {
                bottomOverflow = getBottomOverflow(y);
                if (bottomOverflow > 0) {
                    topOverflow = getTopOverflow(placeTopY);
                    if (topOverflow >= 0 || -topOverflow < bottomOverflow) {
                        y = placeTopY;
                        computedDirection = "top";
                    }
                }
            }
        }
        if (position === "auto") y = confineVertically(y);
        const arrowX = arrow ? placeArrowX(x, anchorRect, containerRect, menuRect) : undefined;
        return {
            arrowX: arrowX,
            x: x,
            y: y,
            computedDirection: computedDirection
        };
    }, [
        placeArrowX,
        arrow,
        direction,
        position
    ]);
    const positionMenu = (0, $exYeM.useCallback)((positionHelpers, anchorRef)=>{
        const { menuRect: menuRect, containerRect: containerRect, ...helpers } = positionHelpers;
        let horizontalOffset = offsetX;
        let verticalOffset = offsetY;
        if (arrow) {
            if (direction === "left" || direction === "right") horizontalOffset += arrowRef.current.offsetWidth;
            else verticalOffset += arrowRef.current.offsetHeight;
        }
        const anchorRect = anchorRef.current.getBoundingClientRect();
        const placeLeftX = anchorRect.left - containerRect.left - menuRect.width - horizontalOffset;
        const placeRightX = anchorRect.right - containerRect.left + horizontalOffset;
        const placeTopY = anchorRect.top - containerRect.top - menuRect.height - verticalOffset;
        const placeBottomY = anchorRect.bottom - containerRect.top + verticalOffset;
        let placeToporBottomX, placeLeftorRightY;
        if (align === "end") {
            placeToporBottomX = anchorRect.right - containerRect.left - menuRect.width;
            placeLeftorRightY = anchorRect.bottom - containerRect.top - menuRect.height;
        } else if (align === "center") {
            placeToporBottomX = anchorRect.left - containerRect.left - (menuRect.width - anchorRect.width) / 2;
            placeLeftorRightY = anchorRect.top - containerRect.top - (menuRect.height - anchorRect.height) / 2;
        } else {
            placeToporBottomX = anchorRect.left - containerRect.left;
            placeLeftorRightY = anchorRect.top - containerRect.top;
        }
        placeToporBottomX += horizontalOffset;
        placeLeftorRightY += verticalOffset;
        const rects = {
            anchorRect: anchorRect,
            containerRect: containerRect,
            menuRect: menuRect
        };
        const placements = {
            placeLeftX: placeLeftX,
            placeRightX: placeRightX,
            placeLeftorRightY: placeLeftorRightY,
            placeTopY: placeTopY,
            placeBottomY: placeBottomY,
            placeToporBottomX: placeToporBottomX
        };
        switch(direction){
            case "left":
            case "right":
                return placeLeftorRight(rects, placements, helpers);
            case "top":
            case "bottom":
            default:
                return placeToporBottom(rects, placements, helpers);
        }
    }, [
        arrow,
        align,
        direction,
        offsetX,
        offsetY,
        placeLeftorRight,
        placeToporBottom
    ]);
    const positionContextMenu = (0, $exYeM.useCallback)((positionHelpers, anchorPoint)=>{
        const { menuRect: menuRect, containerRect: containerRect, getLeftOverflow: getLeftOverflow, getRightOverflow: getRightOverflow, getTopOverflow: getTopOverflow, getBottomOverflow: getBottomOverflow, confineHorizontally: confineHorizontally, confineVertically: confineVertically } = positionHelpers;
        let x, y;
        x = anchorPoint.x - containerRect.left;
        y = anchorPoint.y - containerRect.top;
        const rightOverflow = getRightOverflow(x);
        if (rightOverflow > 0) {
            const adjustedX = x - menuRect.width;
            const leftOverflow = getLeftOverflow(adjustedX);
            if (leftOverflow >= 0 || -leftOverflow < rightOverflow) x = adjustedX;
            x = confineHorizontally(x);
        }
        let computedDirection = "bottom";
        const bottomOverflow = getBottomOverflow(y);
        if (bottomOverflow > 0) {
            const adjustedY = y - menuRect.height;
            const topOverflow = getTopOverflow(adjustedY);
            if (topOverflow >= 0 || -topOverflow < bottomOverflow) {
                y = adjustedY;
                computedDirection = "top";
            }
            y = confineVertically(y);
        }
        return {
            x: x,
            y: y,
            computedDirection: computedDirection
        };
    }, []);
    const handlePosition = (0, $exYeM.useCallback)(()=>{
        if (!containerRef.current) {
            if (!$d31deb30aaf23220$var$isProd) throw new Error("[react-menu] Menu cannot be positioned properly as container ref is null. If you initialise isOpen prop to true for ControlledMenu, please see this link for a solution: https://github.com/szhsin/react-menu/issues/2#issuecomment-719166062");
            return;
        }
        if (!scrollingRef.current) scrollingRef.current = boundingBoxRef ? boundingBoxRef.current : $d31deb30aaf23220$var$getScrollAncestor(rootMenuRef.current);
        const helpers = positionHelpers();
        const { menuRect: menuRect } = helpers;
        let results = {
            computedDirection: "bottom"
        };
        if (anchorPoint) results = positionContextMenu(helpers, anchorPoint);
        else if (anchorRef) results = positionMenu(helpers, anchorRef);
        let { arrowX: arrowX, arrowY: arrowY, x: x, y: y, computedDirection: computedDirection } = results;
        let menuHeight = menuRect.height;
        if (overflow !== "visible") {
            const { getTopOverflow: getTopOverflow, getBottomOverflow: getBottomOverflow } = helpers;
            let height, overflowAmt;
            const prevHeight = latestMenuSize.current.height;
            const bottomOverflow = getBottomOverflow(y);
            if (bottomOverflow > 0 || $d31deb30aaf23220$var$floatEqual(bottomOverflow, 0) && $d31deb30aaf23220$var$floatEqual(menuHeight, prevHeight)) {
                height = menuHeight - bottomOverflow;
                overflowAmt = bottomOverflow;
            } else {
                const topOverflow = getTopOverflow(y);
                if (topOverflow < 0 || $d31deb30aaf23220$var$floatEqual(topOverflow, 0) && $d31deb30aaf23220$var$floatEqual(menuHeight, prevHeight)) {
                    height = menuHeight + topOverflow;
                    overflowAmt = 0 - topOverflow;
                    if (height >= 0) y -= topOverflow;
                }
            }
            if (height >= 0) {
                menuHeight = height;
                setOverflowData({
                    height: height,
                    overflowAmt: overflowAmt
                });
            } else setOverflowData();
        }
        if (arrow) setArrowPosition({
            x: arrowX,
            y: arrowY
        });
        setMenuPosition({
            x: x,
            y: y
        });
        setExpandedDirection(computedDirection);
        latestMenuSize.current = {
            width: menuRect.width,
            height: menuHeight
        };
    }, [
        arrow,
        anchorPoint,
        anchorRef,
        containerRef,
        boundingBoxRef,
        rootMenuRef,
        scrollingRef,
        overflow,
        positionHelpers,
        positionMenu,
        positionContextMenu
    ]);
    $d31deb30aaf23220$var$useIsomorphicLayoutEffect(()=>{
        if (isOpen) {
            handlePosition();
            if (latestOpen.current) forceReposSubmenu();
        }
        latestHandlePosition.current = handlePosition;
    }, [
        isOpen,
        handlePosition,
        reposFlag
    ]);
    $d31deb30aaf23220$var$useIsomorphicLayoutEffect(()=>{
        if (overflowData && !descendOverflowRef.current) menuRef.current.scrollTop = 0;
    }, [
        overflowData
    ]);
    $d31deb30aaf23220$var$useIsomorphicLayoutEffect(()=>{
        if (animation) {
            if (isOpen) setClosing(false);
            else if (isOpen !== latestOpen.current) setClosing(true);
        }
        latestOpen.current = isOpen;
    }, [
        animation,
        isOpen
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (!isOpen) return;
        if (!anchorScrollingRef.current && rootAnchorRef && rootAnchorRef.current.tagName) anchorScrollingRef.current = $d31deb30aaf23220$var$getScrollAncestor(rootAnchorRef.current);
        const scrollCurrent = scrollingRef.current;
        const menuScroll = scrollCurrent && scrollCurrent.addEventListener ? scrollCurrent : window;
        const anchorScroll = anchorScrollingRef.current || menuScroll;
        let scroll = viewScroll;
        if (anchorScroll !== menuScroll && scroll === "initial") scroll = "auto";
        if (scroll === "initial") return;
        if (scroll === "auto" && overflow !== "visible") scroll = "close";
        const handleScroll = ()=>{
            if (scroll === "auto") $d31deb30aaf23220$var$batchedUpdates(handlePosition);
            else $d31deb30aaf23220$var$safeCall(onClose, {
                reason: $d31deb30aaf23220$var$CloseReason.SCROLL
            });
        };
        const scrollObservers = anchorScroll !== menuScroll && viewScroll !== "initial" ? [
            anchorScroll,
            menuScroll
        ] : [
            anchorScroll
        ];
        scrollObservers.forEach((o)=>o.addEventListener("scroll", handleScroll));
        return ()=>scrollObservers.forEach((o)=>o.removeEventListener("scroll", handleScroll));
    }, [
        rootAnchorRef,
        anchorScrollingRef,
        scrollingRef,
        isOpen,
        overflow,
        onClose,
        viewScroll,
        handlePosition
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (typeof ResizeObserver !== "function" || reposition === "initial") return;
        const resizeObserver = new ResizeObserver(([entry])=>{
            const { borderBoxSize: borderBoxSize, target: target } = entry;
            let width, height;
            if (borderBoxSize) {
                const { inlineSize: inlineSize, blockSize: blockSize } = borderBoxSize[0] || borderBoxSize;
                width = inlineSize;
                height = blockSize;
            } else {
                const borderRect = target.getBoundingClientRect();
                width = borderRect.width;
                height = borderRect.height;
            }
            if (width === 0 || height === 0) return;
            if ($d31deb30aaf23220$var$floatEqual(width, latestMenuSize.current.width, 1) && $d31deb30aaf23220$var$floatEqual(height, latestMenuSize.current.height, 1)) return;
            $d31deb30aaf23220$var$batchedUpdates(()=>{
                latestHandlePosition.current();
                forceReposSubmenu();
            });
        });
        const observeTarget = menuRef.current;
        resizeObserver.observe(observeTarget, {
            box: "border-box"
        });
        return ()=>resizeObserver.unobserve(observeTarget);
    }, [
        reposition
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (!isOpen) {
            dispatch({
                type: $d31deb30aaf23220$var$HoverIndexActionTypes.RESET
            });
            if (!animation) setOverflowData();
        }
        const id = setTimeout(()=>{
            if (!isOpen || !menuRef.current || menuRef.current.contains(document.activeElement)) return;
            if (captureFocus) menuRef.current.focus();
            if (menuItemFocus.position === $d31deb30aaf23220$var$FocusPositions.FIRST) dispatch({
                type: $d31deb30aaf23220$var$HoverIndexActionTypes.FIRST
            });
            else if (menuItemFocus.position === $d31deb30aaf23220$var$FocusPositions.LAST) dispatch({
                type: $d31deb30aaf23220$var$HoverIndexActionTypes.LAST
            });
        }, animation ? 170 : 100);
        return ()=>clearTimeout(id);
    }, [
        animation,
        captureFocus,
        isOpen,
        menuItemFocus
    ]);
    const isSubmenuOpen = openSubmenuCount > 0;
    const itemContext = (0, $exYeM.useMemo)(()=>({
            isParentOpen: isOpen,
            hoverIndex: hoverIndex,
            isSubmenuOpen: isSubmenuOpen,
            dispatch: dispatch
        }), [
        isOpen,
        hoverIndex,
        isSubmenuOpen
    ]);
    let maxHeight, overflowAmt;
    if (overflowData) descendOverflowRef.current ? overflowAmt = overflowData.overflowAmt : maxHeight = overflowData.height;
    const listContext = (0, $exYeM.useMemo)(()=>({
            reposSubmenu: reposSubmenu,
            overflow: overflow,
            overflowAmt: overflowAmt
        }), [
        reposSubmenu,
        overflow,
        overflowAmt
    ]);
    const overflowStyles = maxHeight >= 0 ? {
        maxHeight: maxHeight,
        overflow: overflow
    } : undefined;
    const modifiers = (0, $exYeM.useMemo)(()=>({
            open: isOpen,
            closing: isClosing,
            animation: animation,
            dir: animation && expandedDirection
        }), [
        isOpen,
        isClosing,
        animation,
        expandedDirection
    ]);
    const externalModifiers = (0, $exYeM.useMemo)(()=>Object.freeze({
            ...modifiers,
            dir: expandedDirection
        }), [
        modifiers,
        expandedDirection
    ]);
    const arrowModifiers = (0, $exYeM.useMemo)(()=>Object.freeze({
            dir: expandedDirection
        }), [
        expandedDirection
    ]);
    const _arrowClass = $d31deb30aaf23220$var$useBEM({
        block: $d31deb30aaf23220$var$menuClass,
        element: $d31deb30aaf23220$var$menuArrowClass,
        modifiers: arrowModifiers,
        className: arrowClassName
    });
    const _arrowStyles = $d31deb30aaf23220$var$useFlatStyles(arrowStyles, arrowModifiers);
    const handlers = $d31deb30aaf23220$var$attachHandlerProps({
        onKeyDown: handleKeyDown,
        onAnimationEnd: handleAnimationEnd
    }, restProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("ul", Object.assign({
        role: "menu",
        tabIndex: "-1",
        "aria-disabled": isDisabled || undefined,
        "aria-label": ariaLabel
    }, restProps, handlers, {
        ref: menuRef,
        className: $d31deb30aaf23220$var$useBEM({
            block: $d31deb30aaf23220$var$menuClass,
            modifiers: modifiers,
            className: className,
            externalModifiers: externalModifiers
        }),
        style: {
            ...$d31deb30aaf23220$var$useFlatStyles(styles, externalModifiers),
            ...overflowStyles,
            left: `${menuPosition.x}px`,
            top: `${menuPosition.y}px`
        }
    }), arrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: _arrowClass,
        style: {
            ..._arrowStyles,
            left: arrowPosition.x && `${arrowPosition.x}px`,
            top: arrowPosition.y && `${arrowPosition.y}px`
        },
        ref: arrowRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d31deb30aaf23220$var$MenuListContext.Provider, {
        value: listContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d31deb30aaf23220$var$MenuListItemContext.Provider, {
        value: itemContext
    }, menuItems)));
}), "MenuList");
function $d31deb30aaf23220$var$submenuCountReducer(state, { type: type }) {
    switch(type){
        case $d31deb30aaf23220$var$SubmenuActionTypes.OPEN:
            return state + 1;
        case $d31deb30aaf23220$var$SubmenuActionTypes.CLOSE:
            return Math.max(state - 1, 0);
        default:
            return state;
    }
}
const $d31deb30aaf23220$var$useMenuList = (menuListProps, { id: id, animation: animation, boundingBoxRef: boundingBoxRef, boundingBoxPadding: boundingBoxPadding, debugging: debugging, reposition: reposition, submenuOpenDelay: submenuOpenDelay, submenuCloseDelay: submenuCloseDelay, viewScroll: viewScroll, portal: portal, theming: theming, isMounted: isMounted, onItemClick: onItemClick, onClick: onClick, onClose: onClose, skipClick: skipClick })=>{
    const containerRef = (0, $exYeM.useRef)(null);
    const scrollingRef = (0, $exYeM.useRef)(null);
    const anchorScrollingRef = (0, $exYeM.useRef)(null);
    const { anchorRef: anchorRef, isOpen: isOpen } = menuListProps;
    const settings = (0, $exYeM.useMemo)(()=>({
            animation: animation,
            boundingBoxRef: boundingBoxRef,
            boundingBoxPadding: boundingBoxPadding,
            rootMenuRef: containerRef,
            rootAnchorRef: anchorRef,
            scrollingRef: scrollingRef,
            anchorScrollingRef: anchorScrollingRef,
            reposition: reposition,
            viewScroll: viewScroll
        }), [
        animation,
        anchorRef,
        boundingBoxRef,
        boundingBoxPadding,
        reposition,
        viewScroll
    ]);
    const itemSettings = (0, $exYeM.useMemo)(()=>({
            debugging: debugging,
            submenuOpenDelay: submenuOpenDelay,
            submenuCloseDelay: submenuCloseDelay
        }), [
        debugging,
        submenuOpenDelay,
        submenuCloseDelay
    ]);
    const eventHandlers = (0, $exYeM.useMemo)(()=>({
            handleClick (event, isStopPropagation, isCheckorRadio) {
                if (!isStopPropagation) $d31deb30aaf23220$var$safeCall(onItemClick || onClick, event);
                let keepOpen = event.keepOpen;
                if (keepOpen === undefined) keepOpen = isCheckorRadio && event.key === $d31deb30aaf23220$var$Keys.SPACE;
                if (!keepOpen) $d31deb30aaf23220$var$safeCall(onClose, {
                    value: event.value,
                    key: event.key,
                    reason: $d31deb30aaf23220$var$CloseReason.CLICK
                });
            },
            handleClose (key) {
                $d31deb30aaf23220$var$safeCall(onClose, {
                    key: key,
                    reason: $d31deb30aaf23220$var$CloseReason.CLICK
                });
            }
        }), [
        onItemClick,
        onClick,
        onClose
    ]);
    const handleKeyDown = ({ key: key })=>{
        switch(key){
            case $d31deb30aaf23220$var$Keys.ESC:
                $d31deb30aaf23220$var$safeCall(onClose, {
                    key: key,
                    reason: $d31deb30aaf23220$var$CloseReason.CANCEL
                });
                break;
        }
    };
    const handleBlur = (e)=>{
        if (isOpen && !e.currentTarget.contains(e.relatedTarget || document.activeElement) && !debugging) {
            $d31deb30aaf23220$var$safeCall(onClose, {
                reason: $d31deb30aaf23220$var$CloseReason.BLUR
            });
            if (skipClick) {
                skipClick.current = true;
                setTimeout(()=>skipClick.current = false, 300);
            }
        }
    };
    const modifiers = (0, $exYeM.useMemo)(()=>({
            theme: theming
        }), [
        theming
    ]);
    const menuList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        id: id,
        className: $d31deb30aaf23220$var$useBEM({
            block: $d31deb30aaf23220$var$menuContainerClass,
            modifiers: modifiers
        }),
        ref: containerRef,
        onKeyDown: handleKeyDown,
        onBlur: handleBlur
    }, isMounted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d31deb30aaf23220$var$SettingsContext.Provider, {
        value: settings
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d31deb30aaf23220$var$ItemSettingsContext.Provider, {
        value: itemSettings
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d31deb30aaf23220$var$EventHandlersContext.Provider, {
        value: eventHandlers
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d31deb30aaf23220$var$MenuList, Object.assign({}, menuListProps, {
        containerRef: containerRef,
        onClose: onClose
    }))))));
    if (portal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($97dc602bd7e23afa$exports))).createPortal(menuList, document.body);
    else return menuList;
};
const $d31deb30aaf23220$export$d9b273488cd8ce6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function Menu({ "aria-label": ariaLabel, id: id, animation: animation, boundingBoxRef: boundingBoxRef, boundingBoxPadding: boundingBoxPadding, captureFocus: _, debugging: debugging, reposition: reposition, viewScroll: viewScroll, keepMounted: keepMounted, menuButton: menuButton, portal: portal, submenuOpenDelay: submenuOpenDelay, submenuCloseDelay: submenuCloseDelay, theming: theming, onItemClick: onItemClick, onClick: onClick, onChange: onChange, ...restProps }) {
    const { isMounted: isMounted, isOpen: isOpen, menuItemFocus: menuItemFocus, openMenu: openMenu, closeMenu: closeMenu } = $d31deb30aaf23220$export$8091e3849c182a6(keepMounted);
    const skipClick = (0, $exYeM.useRef)(false);
    const buttonRef = (0, $exYeM.useRef)(null);
    const button = (0, $exYeM.useMemo)(()=>$d31deb30aaf23220$var$safeCall(menuButton, {
            open: isOpen
        }), [
        menuButton,
        isOpen
    ]);
    if (!button) throw new Error("Menu requires a menuButton prop.");
    const handleClose = (0, $exYeM.useCallback)((e)=>{
        closeMenu();
        if (e.key) buttonRef.current.focus();
    }, [
        closeMenu
    ]);
    const handleClick = (0, $exYeM.useCallback)((e)=>{
        if (skipClick.current) return;
        openMenu(e.detail === 0 ? $d31deb30aaf23220$var$FocusPositions.FIRST : $d31deb30aaf23220$var$FocusPositions.INITIAL);
    }, [
        openMenu
    ]);
    const handleKeyDown = (0, $exYeM.useCallback)((e)=>{
        let handled = false;
        switch(e.key){
            case $d31deb30aaf23220$var$Keys.UP:
                openMenu($d31deb30aaf23220$var$FocusPositions.LAST);
                handled = true;
                break;
            case $d31deb30aaf23220$var$Keys.DOWN:
                openMenu($d31deb30aaf23220$var$FocusPositions.FIRST);
                handled = true;
                break;
        }
        if (handled) e.preventDefault();
    }, [
        openMenu
    ]);
    const renderButton = (0, $exYeM.useMemo)(()=>{
        const buttonProps = {
            ref: buttonRef,
            ...$d31deb30aaf23220$var$attachHandlerProps({
                onClick: handleClick,
                onKeyDown: handleKeyDown
            }, button.props)
        };
        if ($d31deb30aaf23220$var$getName(button.type) === "MenuButton") buttonProps.isOpen = isOpen;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).cloneElement(button, buttonProps);
    }, [
        button,
        isOpen,
        handleClick,
        handleKeyDown
    ]);
    const menuList = $d31deb30aaf23220$var$useMenuList({
        ...restProps,
        ariaLabel: ariaLabel || (typeof button.props.children === "string" ? button.props.children : "Menu"),
        anchorRef: buttonRef,
        isOpen: isOpen,
        menuItemFocus: menuItemFocus
    }, {
        id: id,
        animation: animation,
        boundingBoxRef: boundingBoxRef,
        boundingBoxPadding: boundingBoxPadding,
        debugging: debugging,
        reposition: reposition,
        submenuOpenDelay: submenuOpenDelay,
        submenuCloseDelay: submenuCloseDelay,
        viewScroll: viewScroll,
        portal: portal,
        theming: theming,
        isMounted: isMounted,
        onItemClick: onItemClick,
        onClick: onClick,
        onClose: handleClose,
        skipClick: skipClick
    });
    $d31deb30aaf23220$var$useMenuChange(onChange, isOpen);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, renderButton, menuList);
});
$d31deb30aaf23220$export$d9b273488cd8ce6f.propTypes = {
    ...$d31deb30aaf23220$var$menuPropTypesBase,
    keepMounted: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).bool,
    menuButton: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).func
    ]).isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).func
};
$d31deb30aaf23220$export$d9b273488cd8ce6f.defaultProps = {
    ...$d31deb30aaf23220$var$menuDefaultPropsBase,
    keepMounted: true
};
const $d31deb30aaf23220$export$a5a70f2f059d02ee = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function ControlledMenu({ "aria-label": ariaLabel, id: id, animation: animation, boundingBoxRef: boundingBoxRef, boundingBoxPadding: boundingBoxPadding, debugging: debugging, reposition: reposition, submenuOpenDelay: submenuOpenDelay, submenuCloseDelay: submenuCloseDelay, viewScroll: viewScroll, portal: portal, theming: theming, isMounted: isMounted, onItemClick: onItemClick, onClick: onClick, onClose: onClose, ...restProps }) {
    return $d31deb30aaf23220$var$useMenuList({
        ...restProps,
        ariaLabel: ariaLabel || "Menu"
    }, {
        id: id,
        animation: animation,
        boundingBoxRef: boundingBoxRef,
        boundingBoxPadding: boundingBoxPadding,
        debugging: debugging,
        reposition: reposition,
        submenuOpenDelay: submenuOpenDelay,
        submenuCloseDelay: submenuCloseDelay,
        viewScroll: viewScroll,
        portal: portal,
        theming: theming,
        isMounted: isMounted,
        onItemClick: onItemClick,
        onClick: onClick,
        onClose: onClose
    });
});
$d31deb30aaf23220$export$a5a70f2f059d02ee.propTypes = {
    ...$d31deb30aaf23220$var$menuPropTypesBase,
    anchorPoint: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).exact({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).number,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).number
    }),
    anchorRef: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).object,
    captureFocus: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).bool,
    isMounted: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).bool,
    menuItemFocus: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).exact({
        position: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).string
    }),
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).func
};
$d31deb30aaf23220$export$a5a70f2f059d02ee.defaultProps = {
    ...$d31deb30aaf23220$var$menuDefaultPropsBase,
    captureFocus: true,
    isOpen: false,
    isMounted: true,
    menuItemFocus: {
        position: $d31deb30aaf23220$var$FocusPositions.INITIAL
    }
};
const $d31deb30aaf23220$export$a9c522a6d7beb830 = $d31deb30aaf23220$var$defineName(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function SubMenu({ "aria-label": ariaLabel, itemClassName: itemClassName, itemStyles: itemStyles, disabled: disabled, keepMounted: keepMounted, label: label, index: index, onChange: onChange, captureFocus: _1, repositionFlag: _2, ...restProps }) {
    const { isMounted: isMounted, isOpen: isOpen, menuItemFocus: menuItemFocus, openMenu: openMenu, closeMenu: closeMenu } = $d31deb30aaf23220$export$8091e3849c182a6(keepMounted);
    const { isParentOpen: isParentOpen, hoverIndex: hoverIndex, isSubmenuOpen: isSubmenuOpen, dispatch: dispatch } = (0, $exYeM.useContext)($d31deb30aaf23220$var$MenuListItemContext);
    const { debugging: debugging, submenuOpenDelay: submenuOpenDelay, submenuCloseDelay: submenuCloseDelay } = (0, $exYeM.useContext)($d31deb30aaf23220$var$ItemSettingsContext);
    const isHovering = hoverIndex === index;
    const isDisabled = Boolean(disabled);
    const { isActive: isActive, onKeyUp: onKeyUp, ...activeStateHandlers } = $d31deb30aaf23220$var$useActiveState(isHovering, isDisabled, $d31deb30aaf23220$var$Keys.RIGHT);
    const containerRef = (0, $exYeM.useRef)(null);
    const itemRef = (0, $exYeM.useRef)(null);
    const timeoutId = (0, $exYeM.useRef)();
    const handleClose = (0, $exYeM.useCallback)(()=>{
        closeMenu();
        itemRef.current.focus();
    }, [
        closeMenu
    ]);
    const delayOpen = (delay)=>{
        dispatch({
            type: $d31deb30aaf23220$var$HoverIndexActionTypes.SET,
            index: index
        });
        timeoutId.current = setTimeout(openMenu, Math.max(delay, 0));
    };
    const handleMouseEnter = ()=>{
        if (isDisabled || isOpen) return;
        if (isSubmenuOpen) timeoutId.current = setTimeout(()=>delayOpen(submenuOpenDelay - submenuCloseDelay), submenuCloseDelay);
        else delayOpen(submenuOpenDelay);
    };
    const handleMouseLeave = ()=>{
        clearTimeout(timeoutId.current);
        if (!isOpen) dispatch({
            type: $d31deb30aaf23220$var$HoverIndexActionTypes.UNSET,
            index: index
        });
    };
    const handleClick = ()=>{
        if (isDisabled) return;
        clearTimeout(timeoutId.current);
        openMenu();
    };
    const handleKeyDown = (e)=>{
        let handled = false;
        switch(e.key){
            case $d31deb30aaf23220$var$Keys.LEFT:
                if (isOpen) {
                    handleClose();
                    handled = true;
                }
                break;
            case $d31deb30aaf23220$var$Keys.RIGHT:
                if (!isOpen) handled = true;
                break;
        }
        if (handled) {
            e.preventDefault();
            e.stopPropagation();
        }
    };
    const handleKeyUp = (e)=>{
        if (!isActive) return;
        onKeyUp(e);
        switch(e.key){
            case $d31deb30aaf23220$var$Keys.SPACE:
            case $d31deb30aaf23220$var$Keys.ENTER:
            case $d31deb30aaf23220$var$Keys.RIGHT:
                openMenu($d31deb30aaf23220$var$FocusPositions.FIRST);
                break;
        }
    };
    const handleBlur = (e)=>{
        if (debugging) return;
        const relatedTarget = e.relatedTarget || document.activeElement;
        if (!e.currentTarget.contains(relatedTarget)) {
            closeMenu();
            dispatch({
                type: $d31deb30aaf23220$var$HoverIndexActionTypes.UNSET,
                index: index
            });
        }
    };
    (0, $exYeM.useEffect)(()=>()=>clearTimeout(timeoutId.current), []);
    (0, $exYeM.useEffect)(()=>{
        if (isHovering && isParentOpen) itemRef.current.focus();
        else closeMenu();
    }, [
        isHovering,
        isParentOpen,
        closeMenu
    ]);
    (0, $exYeM.useEffect)(()=>{
        dispatch({
            type: isOpen ? $d31deb30aaf23220$var$SubmenuActionTypes.OPEN : $d31deb30aaf23220$var$SubmenuActionTypes.CLOSE
        });
    }, [
        dispatch,
        isOpen
    ]);
    $d31deb30aaf23220$var$useMenuChange(onChange, isOpen);
    const modifiers = (0, $exYeM.useMemo)(()=>Object.freeze({
            open: isOpen,
            hover: isHovering,
            active: isActive,
            disabled: isDisabled
        }), [
        isOpen,
        isHovering,
        isActive,
        isDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("li", {
        className: $d31deb30aaf23220$var$useBEM({
            block: $d31deb30aaf23220$var$menuClass,
            element: $d31deb30aaf23220$var$subMenuClass
        }),
        role: "presentation",
        ref: containerRef,
        onKeyDown: handleKeyDown,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", Object.assign({
        className: $d31deb30aaf23220$var$useBEM({
            block: $d31deb30aaf23220$var$menuClass,
            element: $d31deb30aaf23220$var$menuItemClass,
            modifiers: modifiers,
            className: itemClassName
        }),
        style: $d31deb30aaf23220$var$useFlatStyles(itemStyles, modifiers),
        role: "menuitem",
        "aria-haspopup": "true",
        "aria-expanded": isOpen,
        "aria-disabled": isDisabled || undefined,
        tabIndex: isHovering && !isOpen ? 0 : -1,
        ref: itemRef,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onMouseDown: ()=>!isHovering && dispatch({
                type: $d31deb30aaf23220$var$HoverIndexActionTypes.SET,
                index: index
            }),
        onClick: handleClick,
        onKeyUp: handleKeyUp
    }, activeStateHandlers), (0, $exYeM.useMemo)(()=>$d31deb30aaf23220$var$safeCall(label, modifiers), [
        label,
        modifiers
    ])), isMounted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d31deb30aaf23220$var$MenuList, Object.assign({}, restProps, {
        ariaLabel: ariaLabel || (typeof label === "string" ? label : "Submenu"),
        anchorRef: itemRef,
        containerRef: containerRef,
        isOpen: isOpen,
        isDisabled: isDisabled,
        menuItemFocus: menuItemFocus
    })));
}), "SubMenu");
$d31deb30aaf23220$export$a9c522a6d7beb830.propTypes = {
    ...$d31deb30aaf23220$var$sharedMenuPropTypes,
    ...$d31deb30aaf23220$var$stylePropTypes("item"),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).bool,
    keepMounted: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).bool,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).func
    ]).isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).func
};
$d31deb30aaf23220$export$a9c522a6d7beb830.defaultProps = {
    ...$d31deb30aaf23220$var$sharedMenuDefaultProp,
    direction: "right",
    keepMounted: true
};
const $d31deb30aaf23220$export$2ce376c2cc3355c8 = $d31deb30aaf23220$var$defineName(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function MenuItem({ className: className, styles: styles, value: value, href: href, type: type, checked: checked, disabled: disabled, index: index, children: children, onClick: onClick, ...restProps }) {
    const isDisabled = Boolean(disabled);
    const { ref: ref, isHovering: isHovering, setHover: setHover, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = $d31deb30aaf23220$var$useItemState(isDisabled, index);
    const eventHandlers = (0, $exYeM.useContext)($d31deb30aaf23220$var$EventHandlersContext);
    const radioGroup = (0, $exYeM.useContext)($d31deb30aaf23220$var$RadioGroupContext);
    const { isActive: isActive, onKeyUp: onKeyUp, onBlur: activeStateBlur, ...activeStateHandlers } = $d31deb30aaf23220$var$useActiveState(isHovering, isDisabled);
    const isRadio = type === "radio";
    const isCheckBox = type === "checkbox";
    const isAnchor = Boolean(href) && !isDisabled && !isRadio && !isCheckBox;
    const isChecked = isRadio ? radioGroup.value === value : isCheckBox ? Boolean(checked) : false;
    const handleClick = (e)=>{
        if (isDisabled) return;
        let isStopPropagation = false;
        const event = {
            value: value,
            syntheticEvent: e
        };
        if (e.key !== undefined) event.key = e.key;
        if (isRadio) {
            event.name = radioGroup.name;
            $d31deb30aaf23220$var$safeCall(radioGroup.onChange, event);
        }
        event.checked = isCheckBox ? !isChecked : false;
        isStopPropagation = $d31deb30aaf23220$var$safeCall(onClick, event) === false;
        eventHandlers.handleClick(event, isStopPropagation, isCheckBox || isRadio);
    };
    const handleKeyUp = (e)=>{
        if (!isActive) return;
        onKeyUp(e);
        switch(e.key){
            case $d31deb30aaf23220$var$Keys.SPACE:
            case $d31deb30aaf23220$var$Keys.ENTER:
                if (isAnchor) ref.current.click();
                else handleClick(e);
                break;
        }
    };
    const handleBlur = (e)=>{
        activeStateBlur(e);
        onBlur(e);
    };
    const modifiers = (0, $exYeM.useMemo)(()=>Object.freeze({
            type: type,
            disabled: isDisabled,
            hover: isHovering,
            active: isActive,
            checked: isChecked,
            anchor: isAnchor
        }), [
        type,
        isDisabled,
        isHovering,
        isActive,
        isChecked,
        isAnchor
    ]);
    const handlers = $d31deb30aaf23220$var$attachHandlerProps({
        ...activeStateHandlers,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: setHover,
        onKeyUp: handleKeyUp,
        onBlur: handleBlur,
        onClick: handleClick
    }, restProps);
    const menuItemProps = {
        role: isRadio ? "menuitemradio" : isCheckBox ? "menuitemcheckbox" : "menuitem",
        "aria-checked": isRadio || isCheckBox ? isChecked : undefined,
        "aria-disabled": isDisabled || undefined,
        tabIndex: isHovering ? 0 : -1,
        ...restProps,
        ...handlers,
        ref: ref,
        className: $d31deb30aaf23220$var$useBEM({
            block: $d31deb30aaf23220$var$menuClass,
            element: $d31deb30aaf23220$var$menuItemClass,
            modifiers: modifiers,
            className: className
        }),
        style: $d31deb30aaf23220$var$useFlatStyles(styles, modifiers)
    };
    const renderChildren = (0, $exYeM.useMemo)(()=>$d31deb30aaf23220$var$safeCall(children, modifiers), [
        children,
        modifiers
    ]);
    if (isAnchor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("li", {
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("a", Object.assign({}, menuItemProps, {
        href: href
    }), renderChildren));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("li", menuItemProps, renderChildren);
}), "MenuItem");
$d31deb30aaf23220$export$2ce376c2cc3355c8.propTypes = {
    ...$d31deb30aaf23220$var$stylePropTypes(),
    value: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).any,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).oneOf([
        "checkbox",
        "radio"
    ]),
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).func
    ]).isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).func
};
const $d31deb30aaf23220$export$133808eb149668a3 = $d31deb30aaf23220$var$defineName(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function FocusableItem({ className: className, styles: styles, disabled: disabled, index: index, children: children, ...restProps }) {
    const isDisabled = Boolean(disabled);
    const { ref: ref, isHovering: isHovering, setHover: setHover, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = $d31deb30aaf23220$var$useItemState(isDisabled, index);
    const { handleClose: handleClose } = (0, $exYeM.useContext)($d31deb30aaf23220$var$EventHandlersContext);
    const modifiers = (0, $exYeM.useMemo)(()=>Object.freeze({
            disabled: isDisabled,
            hover: isHovering,
            focusable: true
        }), [
        isDisabled,
        isHovering
    ]);
    const renderChildren = (0, $exYeM.useMemo)(()=>$d31deb30aaf23220$var$safeCall(children, {
            ...modifiers,
            ref: ref,
            closeMenu: handleClose
        }), [
        ref,
        children,
        modifiers,
        handleClose
    ]);
    const handlers = $d31deb30aaf23220$var$attachHandlerProps({
        onMouseEnter: onMouseEnter,
        onMouseLeave: (e)=>onMouseLeave(e, true),
        onFocus: setHover,
        onBlur: onBlur
    }, restProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("li", Object.assign({
        "aria-disabled": isDisabled || undefined,
        role: "menuitem",
        tabIndex: "-1"
    }, restProps, handlers, {
        className: $d31deb30aaf23220$var$useBEM({
            block: $d31deb30aaf23220$var$menuClass,
            element: $d31deb30aaf23220$var$menuItemClass,
            modifiers: modifiers,
            className: className
        }),
        style: $d31deb30aaf23220$var$useFlatStyles(styles, modifiers)
    }), renderChildren);
}), "FocusableItem");
$d31deb30aaf23220$export$133808eb149668a3.propTypes = {
    ...$d31deb30aaf23220$var$stylePropTypes(),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).func.isRequired
};
const $d31deb30aaf23220$export$acb07b4664ac227c = $d31deb30aaf23220$var$defineName(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function MenuDivider({ className: className, styles: styles, ...restProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("li", Object.assign({
        role: "separator"
    }, restProps, {
        className: $d31deb30aaf23220$var$useBEM({
            block: $d31deb30aaf23220$var$menuClass,
            element: $d31deb30aaf23220$var$menuDividerClass,
            className: className
        }),
        style: $d31deb30aaf23220$var$useFlatStyles(styles)
    }));
}), "MenuDivider");
$d31deb30aaf23220$export$acb07b4664ac227c.propTypes = {
    ...$d31deb30aaf23220$var$stylePropTypes()
};
const $d31deb30aaf23220$export$ba6f0acf5af923bd = $d31deb30aaf23220$var$defineName(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function MenuHeader({ className: className, styles: styles, ...restProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("li", Object.assign({
        role: "presentation"
    }, restProps, {
        className: $d31deb30aaf23220$var$useBEM({
            block: $d31deb30aaf23220$var$menuClass,
            element: $d31deb30aaf23220$var$menuHeaderClass,
            className: className
        }),
        style: $d31deb30aaf23220$var$useFlatStyles(styles)
    }));
}), "MenuHeader");
$d31deb30aaf23220$export$ba6f0acf5af923bd.propTypes = {
    ...$d31deb30aaf23220$var$stylePropTypes()
};
const $d31deb30aaf23220$export$22a631d1f72787bb = $d31deb30aaf23220$var$defineName(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function MenuGroup({ className: className, styles: styles, takeOverflow: takeOverflow, ...restProps }) {
    const ref = (0, $exYeM.useRef)(null);
    const [overflowStyles, setOverflowStyles] = (0, $exYeM.useState)();
    const { overflow: overflow, overflowAmt: overflowAmt } = (0, $exYeM.useContext)($d31deb30aaf23220$var$MenuListContext);
    $d31deb30aaf23220$var$useIsomorphicLayoutEffect(()=>{
        let maxHeight;
        if (takeOverflow && overflowAmt >= 0) {
            maxHeight = ref.current.getBoundingClientRect().height - overflowAmt;
            if (maxHeight < 0) maxHeight = 0;
        }
        setOverflowStyles(maxHeight >= 0 ? {
            maxHeight: maxHeight,
            overflow: overflow
        } : undefined);
    }, [
        takeOverflow,
        overflow,
        overflowAmt
    ]);
    $d31deb30aaf23220$var$useIsomorphicLayoutEffect(()=>{
        if (overflowStyles) ref.current.scrollTop = 0;
    }, [
        overflowStyles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", Object.assign({
        ref: ref
    }, restProps, {
        className: $d31deb30aaf23220$var$useBEM({
            block: $d31deb30aaf23220$var$menuClass,
            element: $d31deb30aaf23220$var$menuGroupClass,
            className: className
        }),
        style: {
            ...$d31deb30aaf23220$var$useFlatStyles(styles),
            ...overflowStyles
        }
    }));
}), "MenuGroup");
$d31deb30aaf23220$export$22a631d1f72787bb.propTypes = {
    ...$d31deb30aaf23220$var$stylePropTypes(),
    takeOverflow: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).bool
};
const $d31deb30aaf23220$export$ea2200c9eee416b3 = $d31deb30aaf23220$var$defineName(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function MenuRadioGroup({ "aria-label": ariaLabel, className: className, styles: styles, name: name, value: value, children: children, onChange: onChange, ...restProps }) {
    const contextValue = (0, $exYeM.useMemo)(()=>({
            name: name,
            value: value,
            onChange: onChange
        }), [
        name,
        value,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("li", {
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("ul", Object.assign({
        role: "group",
        "aria-label": ariaLabel || name || "Radio group"
    }, restProps, {
        className: $d31deb30aaf23220$var$useBEM({
            block: $d31deb30aaf23220$var$menuClass,
            element: $d31deb30aaf23220$var$radioGroupClass,
            className: className
        }),
        style: $d31deb30aaf23220$var$useFlatStyles(styles)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d31deb30aaf23220$var$RadioGroupContext.Provider, {
        value: contextValue
    }, children)));
}), "MenuRadioGroup");
$d31deb30aaf23220$export$ea2200c9eee416b3.propTypes = {
    ...$d31deb30aaf23220$var$stylePropTypes(),
    "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).any,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).node.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($839799496b62fb71$exports))).func
};





const $a0c6ae084e3f44dc$var$logoIcon = new URL($eac97693b820ca3b$exports);

const $a0c6ae084e3f44dc$var$HlIcon = new URL($3806be31bbf36be3$exports);
const $a0c6ae084e3f44dc$export$8b251419efc915eb = ()=>{
    const [{ data: data, fetching: fetching, error: error }, executeQuery] = (0, $4806a602ceddc868$export$dd0a697e1782aedd)({
        query: (0, $6deaf3f611d65bfb$export$150709981922f059)
    });
    const [isMounted, setIsMounted] = (0, $exYeM.useState)(false);
    (0, $exYeM.useEffect)(()=>{
        setIsMounted(true);
    }, []);
    const menItems = (0, $exYeM.useMemo)(()=>{
        return data?.CMS.siteMenu.MenMenu.items ?? [];
    }, [
        data?.CMS.siteMenu.MenMenu.items
    ]);
    const womenItems = (0, $exYeM.useMemo)(()=>{
        return data?.CMS.siteMenu.WomenMenu.items ?? [];
    }, [
        data?.CMS.siteMenu.WomenMenu.items
    ]);
    // cart data
    const aboutBtnRef = (0, $exYeM.useRef)();
    const [headerRef, dimensions, node] = (0, $732d99c1a0348e40$export$2e2bcd8739ae039)({
        liveMeasure: true
    });
    const setShowMenu = (0, $4e5e91614e1ce727$export$b7680113a886673e)((state)=>state.setModal);
    const showMenu = (0, $4e5e91614e1ce727$export$b7680113a886673e)((state)=>state.modal);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: $65f4f8d7e6ac0946$export$e8e78c978b129247,
                ref: headerRef,
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: $65f4f8d7e6ac0946$export$bff8506071621221,
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: $65f4f8d7e6ac0946$export$f1de0d6ae757bad,
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                className: $65f4f8d7e6ac0946$export$2bacab2130704b28,
                                onClick: ()=>{
                                    setShowMenu("mobile");
                                },
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6be42a1d560aa137$export$f04a61298a47a40f), {
                                    classes: {
                                        root: $65f4f8d7e6ac0946$export$8439e0443b88eae
                                    },
                                    name: "menu"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        className: $65f4f8d7e6ac0946$export$fe9093199d63c3a8,
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                                className: $65f4f8d7e6ac0946$export$92d56ee656c0230d,
                                onClick: ()=>{
                                    setShowMenu("men");
                                },
                                onMouseOver: ()=>{
                                    setShowMenu("men");
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                        children: "Nam gi\u1EDBi"
                                    }),
                                    showMenu == "men" && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).img, {
                                        layoutId: "bottomHl",
                                        className: $65f4f8d7e6ac0946$export$f9f47db273b1c86b,
                                        alt: "hl",
                                        src: $a0c6ae084e3f44dc$var$HlIcon.toString()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                                className: $65f4f8d7e6ac0946$export$92d56ee656c0230d,
                                onClick: ()=>{
                                    setShowMenu("women");
                                },
                                onMouseOver: ()=>{
                                    setShowMenu("women");
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                        children: "N\u1EEF gi\u1EDBi"
                                    }),
                                    showMenu == "women" && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).img, {
                                        layoutId: "bottomHl",
                                        className: $65f4f8d7e6ac0946$export$f9f47db273b1c86b,
                                        alt: "hl",
                                        src: $a0c6ae084e3f44dc$var$HlIcon.toString()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                                className: $65f4f8d7e6ac0946$export$92d56ee656c0230d,
                                onMouseOver: ()=>{
                                    setShowMenu("about");
                                },
                                ref: aboutBtnRef,
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                        children: "V\u1EC1 curnon"
                                    }),
                                    showMenu == "about" && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).img, {
                                        layoutId: "bottomHl",
                                        className: $65f4f8d7e6ac0946$export$f9f47db273b1c86b,
                                        alt: "hl",
                                        src: $a0c6ae084e3f44dc$var$HlIcon.toString()
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: $65f4f8d7e6ac0946$export$109a06d8b89cba0,
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                            href: "/",
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                src: $a0c6ae084e3f44dc$var$logoIcon.toString(),
                                className: $65f4f8d7e6ac0946$export$db3c28d99448dcff,
                                alt: "curnon logo"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: $65f4f8d7e6ac0946$export$871bd626df29da4a
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: $65f4f8d7e6ac0946$export$a77fb8b4c930973e
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $1a23cb15f08d9c60$export$bf111c537646a397), {
                        menuData: showMenu == "men" ? menItems : womenItems,
                        isOpen: showMenu == "women" || showMenu == "men",
                        closeModal: ()=>setShowMenu("none"),
                        dimensions: dimensions
                    }, "men-menu"),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $de52307164c2185d$export$7ad61323933e01cb), {
                        menuData: data?.CMS.siteMenu,
                        isOpen: showMenu == "mobile",
                        closeModal: ()=>setShowMenu("none")
                    }, "mobile-menu")
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $d31deb30aaf23220$export$a5a70f2f059d02ee), {
                isOpen: isMounted && showMenu == "about",
                onClose: ()=>{
                    setShowMenu("none");
                },
                direction: "bottom",
                align: "center",
                anchorRef: aboutBtnRef,
                className: $65f4f8d7e6ac0946$export$b06b2c3e1088464c,
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $d31deb30aaf23220$export$2ce376c2cc3355c8), {
                        className: $65f4f8d7e6ac0946$export$f4fced1bb3601104,
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                            href: "/blog",
                            className: $65f4f8d7e6ac0946$export$e1676888100bc422,
                            children: "Blog"
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $d31deb30aaf23220$export$2ce376c2cc3355c8), {
                        className: $65f4f8d7e6ac0946$export$f4fced1bb3601104,
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                            href: "/about",
                            className: $65f4f8d7e6ac0946$export$e1676888100bc422,
                            children: "V\u1EC1 ch\xfang t\xf4i"
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $d31deb30aaf23220$export$2ce376c2cc3355c8), {
                        className: $65f4f8d7e6ac0946$export$f4fced1bb3601104,
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                            href: "https://longandshort.vn",
                            className: $65f4f8d7e6ac0946$export$e1676888100bc422,
                            target: "_blank",
                            children: "Long & Short"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7d8aa723b44ed5d8$export$2e2bcd8739ae039), {
                isActive: showMenu == "about",
                classes: {
                    root: $65f4f8d7e6ac0946$export$6ab52428572992d9
                },
                dismiss: ()=>{
                    setShowMenu("none");
                },
                delayedDismiss: ()=>{
                    setTimeout(()=>setShowMenu("none"), 350);
                }
            })
        ]
    });
};




const $26c28601dd21ca71$var$client = (0, $3bf714f6c012ccf2$export$5d730b7aed1a3eb0)({
    url: "https://graphql.curnonwatch.com/curnon/graphql"
});
function $26c28601dd21ca71$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $4806a602ceddc868$export$2881499e37b75b9a), {
        value: $26c28601dd21ca71$var$client,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a0c6ae084e3f44dc$export$8b251419efc915eb), {})
    });
}


const $b8f9b7833fa37166$var$container = document.getElementById("headerReactApp");
const $b8f9b7833fa37166$var$root = (0, $7bd215913159ea08$export$882461b6382ed46c)($b8f9b7833fa37166$var$container);
$b8f9b7833fa37166$var$root.render(/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $26c28601dd21ca71$export$86fbec116b87613f), {}));

})();
//# sourceMappingURL=index.f4cecd79.js.map
